/* eslint-disable no-tabs */
/* eslint-disable max-len */
export const svgs = {
  svgs_calendarIcon: ({ width = 20, height = 20, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9987 4.1665H4.9987C4.07822 4.1665 3.33203 4.9127 3.33203 5.83317V15.8332C3.33203 16.7536 4.07822 17.4998 4.9987 17.4998H14.9987C15.9192 17.4998 16.6654 16.7536 16.6654 15.8332V5.83317C16.6654 4.9127 15.9192 4.1665 14.9987 4.1665Z"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.332 2.5V5.83333"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66797 2.5V5.83333"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33203 9.1665H16.6654"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_qr: ({
    width = 18, height = 18, fill = "none", strokeFill = "#818181",
  }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M6.00008 2.66797H3.33341C2.96522 2.66797 2.66675 2.96645 2.66675 3.33464V6.0013C2.66675 6.36949 2.96522 6.66797 3.33341 6.66797H6.00008C6.36827 6.66797 6.66675 6.36949 6.66675 6.0013V3.33464C6.66675 2.96645 6.36827 2.66797 6.00008 2.66797Z" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={0.8}/>
      <path d="M4.66675 11.332V11.3387" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={0.8}/>
      <path d="M12.6666 2.66797H9.99992C9.63173 2.66797 9.33325 2.96645 9.33325 3.33464V6.0013C9.33325 6.36949 9.63173 6.66797 9.99992 6.66797H12.6666C13.0348 6.66797 13.3333 6.36949 13.3333 6.0013V3.33464C13.3333 2.96645 13.0348 2.66797 12.6666 2.66797Z" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={0.8}/>
      <path d="M4.66675 4.66797V4.67464" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={0.8}/>
      <path d="M6.00008 9.33203H3.33341C2.96522 9.33203 2.66675 9.63051 2.66675 9.9987V12.6654C2.66675 13.0336 2.96522 13.332 3.33341 13.332H6.00008C6.36827 13.332 6.66675 13.0336 6.66675 12.6654V9.9987C6.66675 9.63051 6.36827 9.33203 6.00008 9.33203Z" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={0.8}/>
      <path d="M11.3333 4.66797V4.67464" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={0.8}/>
      <path d="M9.33325 9.33203H11.3333" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={0.8}/>
      <path d="M13.3333 9.33203V9.3387" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={0.8}/>
      <path d="M9.33325 9.33203V11.332" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={0.8}/>
      <path d="M9.33325 13.332H11.3333" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={0.8}/>
      <path d="M11.3333 11.332H13.3333" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={0.8}/>
      <path d="M13.3333 11.332V13.332" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={0.8}/>
    </svg>
  ),
  svgs_optionQrCodeIcon: ({
    width = 20, height = 20, fill = "none", strokeFill = "#BDBDBD",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.4987 3.3335H4.16536C3.70513 3.3335 3.33203 3.70659 3.33203 4.16683V7.50016C3.33203 7.9604 3.70513 8.3335 4.16536 8.3335H7.4987C7.95894 8.3335 8.33203 7.9604 8.33203 7.50016V4.16683C8.33203 3.70659 7.95894 3.3335 7.4987 3.3335Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83203 14.1665V14.1748"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8346 3.3335H12.5013C12.0411 3.3335 11.668 3.70659 11.668 4.16683V7.50016C11.668 7.9604 12.0411 8.3335 12.5013 8.3335H15.8346C16.2949 8.3335 16.668 7.9604 16.668 7.50016V4.16683C16.668 3.70659 16.2949 3.3335 15.8346 3.3335Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83203 5.8335V5.84183"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.4987 11.6665H4.16536C3.70513 11.6665 3.33203 12.0396 3.33203 12.4998V15.8332C3.33203 16.2934 3.70513 16.6665 4.16536 16.6665H7.4987C7.95894 16.6665 8.33203 16.2934 8.33203 15.8332V12.4998C8.33203 12.0396 7.95894 11.6665 7.4987 11.6665Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.168 5.8335V5.84183"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.668 11.6665H14.168"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.668 11.6665V11.6748"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.668 11.6665V14.1665"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.668 16.6665H14.168"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.168 14.1665H16.668"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.668 14.1665V16.6665"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_optionQrCodeIconBlack: ({ width = 20, height = 20, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.4987 3.3335H4.16536C3.70513 3.3335 3.33203 3.70659 3.33203 4.16683V7.50016C3.33203 7.9604 3.70513 8.3335 4.16536 8.3335H7.4987C7.95894 8.3335 8.33203 7.9604 8.33203 7.50016V4.16683C8.33203 3.70659 7.95894 3.3335 7.4987 3.3335Z"
        stroke="#000000"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83203 14.1665V14.1748"
        stroke="#000000"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8346 3.3335H12.5013C12.0411 3.3335 11.668 3.70659 11.668 4.16683V7.50016C11.668 7.9604 12.0411 8.3335 12.5013 8.3335H15.8346C16.2949 8.3335 16.668 7.9604 16.668 7.50016V4.16683C16.668 3.70659 16.2949 3.3335 15.8346 3.3335Z"
        stroke="#000000"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83203 5.8335V5.84183"
        stroke="#000000"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.4987 11.6665H4.16536C3.70513 11.6665 3.33203 12.0396 3.33203 12.4998V15.8332C3.33203 16.2934 3.70513 16.6665 4.16536 16.6665H7.4987C7.95894 16.6665 8.33203 16.2934 8.33203 15.8332V12.4998C8.33203 12.0396 7.95894 11.6665 7.4987 11.6665Z"
        stroke="#000000"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.168 5.8335V5.84183"
        stroke="#000000"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.668 11.6665H14.168"
        stroke="#000000"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.668 11.6665V11.6748"
        stroke="#000000"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.668 11.6665V14.1665"
        stroke="#000000"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.668 16.6665H14.168"
        stroke="#000000"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.168 14.1665H16.668"
        stroke="#000000"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.668 14.1665V16.6665"
        stroke="#000000"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_duplicatepersonal: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_duplicatebusiness: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 21H21"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 21V7L13 3V21"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 21V11L13 7"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9V9.01"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12V12.01"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 15V15.01"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 18V18.01"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_duplicateboth: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 20H17"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 20V7.55556L10 4V20"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 10L10 8"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 10V10.01"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 13V13.01"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 16V16.01"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 9C19.8807 9 21 7.88071 21 6.5C21 5.11929 19.8807 4 18.5 4C17.1193 4 16 5.11929 16 6.5C16 7.88071 17.1193 9 18.5 9Z"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 16V14.6667C14 13.9594 14.3161 13.2811 14.8787 12.781C15.4413 12.281 16.2044 12 17 12H20C20.7956 12 21.5587 12.281 22.1213 12.781C22.6839 13.2811 23 13.9594 23 14.6667V16"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_customizeTheme: ({ strokeFill = "#828282" }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 9.01509 2.69399 8.03982 3.0709 7.12987C3.44781 6.21993 4.00026 5.39314 4.6967 4.6967C5.39314 4.00026 6.21993 3.44781 7.12987 3.0709C8.03982 2.69399 9.01509 2.5 10 2.5C11.9891 2.5 13.8968 3.20238 15.3033 4.45262C16.7098 5.70286 17.5 7.39856 17.5 9.16667C17.5 10.0507 17.1049 10.8986 16.4016 11.5237C15.6984 12.1488 14.7446 12.5 13.75 12.5H11.6667C11.2949 12.494 10.9318 12.6125 10.6351 12.8367C10.3384 13.0608 10.1252 13.3777 10.0294 13.737C9.93362 14.0963 9.9607 14.4773 10.1064 14.8194C10.252 15.1615 10.5079 15.4451 10.8333 15.625C10.9997 15.7785 11.1138 15.9803 11.1596 16.2021C11.2054 16.4238 11.1806 16.6543 11.0886 16.8612C10.9967 17.068 10.8422 17.2409 10.647 17.3555C10.4517 17.4701 10.2255 17.5206 10 17.5"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.2487 9.16659C6.47882 9.16659 6.66536 8.98004 6.66536 8.74992C6.66536 8.5198 6.47882 8.33325 6.2487 8.33325C6.01858 8.33325 5.83203 8.5198 5.83203 8.74992C5.83203 8.98004 6.01858 9.16659 6.2487 9.16659Z"
        fill="#828282"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.9987 6.66659C10.2288 6.66659 10.4154 6.48004 10.4154 6.24992C10.4154 6.0198 10.2288 5.83325 9.9987 5.83325C9.76858 5.83325 9.58203 6.0198 9.58203 6.24992C9.58203 6.48004 9.76858 6.66659 9.9987 6.66659Z"
        fill="#828282"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7487 9.16659C13.9788 9.16659 14.1654 8.98004 14.1654 8.74992C14.1654 8.5198 13.9788 8.33325 13.7487 8.33325C13.5186 8.33325 13.332 8.5198 13.332 8.74992C13.332 8.98004 13.5186 9.16659 13.7487 9.16659Z"
        fill="#828282"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_optionDeactivateIcon: ({ width = 20, height = 20, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0013 9.16667C11.8423 9.16667 13.3346 7.67428 13.3346 5.83333C13.3346 3.99238 11.8423 2.5 10.0013 2.5C8.16035 2.5 6.66797 3.99238 6.66797 5.83333C6.66797 7.67428 8.16035 9.16667 10.0013 9.16667Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 17.5V15.8333C5 14.9493 5.35119 14.1014 5.97631 13.4763C6.60143 12.8512 7.44928 12.5 8.33333 12.5H11.6667C12.5507 12.5 13.3986 12.8512 14.0237 13.4763C14.6488 14.1014 15 14.9493 15 15.8333V17.5"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 5L17 15"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 5L17 15"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_eye: ({ width = 24, height = 24, fill = "#828282" }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.25 12C19.25 13 17.5 18.25 12 18.25C6.5 18.25 4.75 13 4.75 12C4.75 11 6.5 5.75 12 5.75C17.5 5.75 19.25 11 19.25 12Z" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12Z" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_eyeOff: ({ width = 24, height = 24, fill = "#828282" }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.6247 10C19.0646 10.8986 19.25 11.6745 19.25 12C19.25 13 17.5 18.25 12 18.25C11.2686 18.25 10.6035 18.1572 10 17.9938M7 16.2686C5.36209 14.6693 4.75 12.5914 4.75 12C4.75 11 6.5 5.75 12 5.75C13.7947 5.75 15.1901 6.30902 16.2558 7.09698" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19.25 4.75L4.75 19.25" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.409 13.591C9.53033 12.7123 9.53033 11.2877 10.409 10.409C11.2877 9.53033 12.7123 9.53033 13.591 10.409" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_viewProfile: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.25 12C20.25 13 17.5 18.25 12 18.25C6.5 18.25 3.75 13 3.75 12C3.75 11 6.5 5.75 12 5.75C17.5 5.75 20.25 11 20.25 12Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_duplicateProfile: ({ strokeFill = "#828282" }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.25 8C15.25 9.79493 13.7949 11.25 12 11.25C10.2051 11.25 8.75 9.79493 8.75 8C8.75 6.20507 10.2051 4.75 12 4.75C13.7949 4.75 15.25 6.20507 15.25 8Z"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2502 19.25H6.94974C5.77025 19.25 4.8901 18.2103 5.49106 17.1954C6.36268 15.7234 8.23956 14 12.2502 14"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 14.75V19.25"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 17L14.75 17"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_resetPasswordIcon: ({ strokeFill = "#828282" }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7.6C5 6.71634 5.86455 6 6.93103 6H17.069C18.1354 6 19 6.71634 19 7.6V14.4C19 15.2837 18.1354 16 17.069 16H6.93103C5.86455 16 5 15.2837 5 14.4V7.6Z"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 6.5L10.6749 11.0778C11.4315 11.7471 12.5685 11.7471 13.3251 11.0778L18.5 6.5"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 15L10.5 11M18 15L13.5 11"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeloptiondeactivateiconinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_3users: ({ fill = "#828282", width = "16px", height = "16px" }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.1621 9.41461C13.7569 9.77663 14.2956 11.263 14.4765 12.1523C14.5515 12.5211 14.2553 12.8333 13.879 12.8333H13.1015" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.2458 6.82698C11.2966 6.8312 11.3479 6.83335 11.3998 6.83335C12.4123 6.83335 13.2331 6.01254 13.2331 5.00002C13.2331 3.9875 12.4123 3.16669 11.3998 3.16669C11.3474 3.16669 11.2956 3.16888 11.2444 3.17318" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.82837 9.41461C10.4232 9.77663 10.9619 11.263 11.1427 12.1523C11.2177 12.5211 10.9216 12.8333 10.5453 12.8333H9.76778" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.91278 6.82698C7.96355 6.8312 8.0149 6.83335 8.06676 6.83335C9.07929 6.83335 9.9001 6.01254 9.9001 5.00002C9.9001 3.9875 9.07929 3.16669 8.06676 3.16669C8.01443 3.16669 7.9626 3.16888 7.91138 3.17318" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.25441 12.8333H7.21217C7.5885 12.8333 7.88462 12.521 7.80963 12.1523C7.60259 11.1341 6.92641 9.33325 4.73329 9.33325C2.54017 9.33325 1.86399 11.1341 1.65695 12.1523C1.58196 12.521 1.87808 12.8333 2.25441 12.8333Z" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.56681 5.00002C6.56681 6.01254 5.746 6.83335 4.73348 6.83335C3.72096 6.83335 2.90015 6.01254 2.90015 5.00002C2.90015 3.9875 3.72096 3.16669 4.73348 3.16669C5.746 3.16669 6.56681 3.9875 6.56681 5.00002Z" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  svgs_optionRemoveIcon: ({
    width = 20,
    height = 20,
    fill = "none",
    strokeFill = "#EB5757",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33203 5.8335H16.6654"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33203 9.1665V14.1665"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.668 9.1665V14.1665"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16797 5.8335L5.0013 15.8335C5.0013 16.2755 5.1769 16.6994 5.48946 17.012C5.80202 17.3246 6.22594 17.5002 6.66797 17.5002H13.3346C13.7767 17.5002 14.2006 17.3246 14.5131 17.012C14.8257 16.6994 15.0013 16.2755 15.0013 15.8335L15.8346 5.8335"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_optionEditIcon: ({
    width = 20, height = 20, fill = "none", strokeFill = "#828282",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66797 15.3332H7.33464L14.3346 8.33321C14.6883 7.97959 14.8869 7.49997 14.8869 6.99988C14.8869 6.49978 14.6883 6.02016 14.3346 5.66654C13.981 5.31292 13.5014 5.11426 13.0013 5.11426C12.5012 5.11426 12.0216 5.31292 11.668 5.66654L4.66797 12.6665V15.3332Z"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 6.3335L13.6667 9.00016"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_pencilWithLine: ({
    width = 20, height = 20, fill = "none", strokeFill = "#828282",
  }) => (
    <svg width={width} height={width} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M3.16675 12.8332L6.00008 12.1666L12.1953 5.9713C12.4557 5.71095 12.4557 5.28884 12.1953 5.02849L10.9715 3.80464C10.7111 3.54429 10.289 3.54429 10.0287 3.80464L3.83341 9.9999L3.16675 12.8332Z" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={1}/>
      <path d="M12.8334 12.832H9.16675" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round" strokeWidth={1}/>
    </svg>
  ),
  svgs_assignIcon: ({ width = 20, height = 20, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0013 9.16667C11.8423 9.16667 13.3346 7.67428 13.3346 5.83333C13.3346 3.99238 11.8423 2.5 10.0013 2.5C8.16035 2.5 6.66797 3.99238 6.66797 5.83333C6.66797 7.67428 8.16035 9.16667 10.0013 9.16667Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 17.5V15.8333C5 14.9493 5.35119 14.1014 5.97631 13.4763C6.60143 12.8512 7.44928 12.5 8.33333 12.5H11.6667C12.5507 12.5 13.3986 12.8512 14.0237 13.4763C14.6488 14.1014 15 14.9493 15 15.8333V17.5"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_user: ({
    width = 18, height = 18, fill = "none", strokeFill = "#4F4F4F",
  }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={fill} viewBox="0 0 18 18" >
      <path d="M11.4375 6C11.4375 7.34619 10.3462 8.4375 9 8.4375C7.65381 8.4375 6.5625 7.34619 6.5625 6C6.5625 4.65381 7.65381 3.5625 9 3.5625C10.3462 3.5625 11.4375 4.65381 11.4375 6Z" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.13561 14.4375H12.8644C13.7208 14.4375 14.3805 13.7011 13.9805 12.9438C13.3922 11.8298 12.051 10.5 8.99998 10.5C5.94899 10.5 4.60773 11.8298 4.01941 12.9438C3.61945 13.7011 4.27917 14.4375 5.13561 14.4375Z" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_export: ({ width = 15, height = 15, fill = "#828282" }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 2H14V7" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 8L14.0104 1.98959" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.5 3H3.5C2.67157 3 2 3.67157 2 4.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V10.5" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  svgs_userCheck: ({ width = 24, height = 24, fill = "#ffffff" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.25 8C15.25 9.79493 13.7949 11.25 12 11.25C10.2051 11.25 8.75 9.79493 8.75 8C8.75 6.20507 10.2051 4.75 12 4.75C13.7949 4.75 15.25 6.20507 15.25 8Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 19.25H6.94949C5.77001 19.25 4.88985 18.2103 5.49082 17.1954C6.36244 15.7234 8.23932 14 12.25 14"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.75 17.75L16 19.25L19.25 14.75"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_userPlus: ({ strokeFill = "#828282", width = "16", height = "16" }) => (
    <svg width={width} height={height} viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8716_88592)">
        <path d="M5.99919 7.33333C7.47195 7.33333 8.66585 6.13943 8.66585 4.66667C8.66585 3.19391 7.47195 2 5.99919 2C4.52643 2 3.33252 3.19391 3.33252 4.66667C3.33252 6.13943 4.52643 7.33333 5.99919 7.33333Z" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2 14V12.6667C2 11.9594 2.28095 11.2811 2.78105 10.781C3.28115 10.281 3.95942 10 4.66667 10H7.33333C8.04058 10 8.71885 10.281 9.21895 10.781C9.71905 11.2811 10 11.9594 10 12.6667V14" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13.25 2.75V6.75" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.25 4.75H15.25" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_8716_88592">
          <rect width={width} height={height} fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_restrict: ({ strokeFill = "#828282", width = "16", height = "16" }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10805_8636)">
        <path d="M1.95837 8.00004C1.95837 4.66332 4.66332 1.95837 8.00004 1.95837C11.3368 1.95837 14.0417 4.66332 14.0417 8.00004C14.0417 11.3368 11.3368 14.0417 8.00004 14.0417C4.66332 14.0417 1.95837 11.3368 1.95837 8.00004Z" stroke={strokeFill} strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 3.99996L3.99988 11.9999" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_10805_8636">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_order: ({
    fill = "none", strokeFill = "#BDBDBD", width = "16", height = "16",
  }) => (
    <svg width={width - 2} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.71429 10.3333H10.1429M3 15V2.55556C3 2.143 3.15051 1.74733 3.41842 1.45561C3.68633 1.16389 4.04969 1 4.42857 1H11.5714C11.9503 1 12.3137 1.16389 12.5816 1.45561C12.8495 1.74733 13 2.143 13 2.55556V15L10.8571 13.4444L9.42857 15L8 13.4444L6.57143 15L5.14286 13.4444L3 15ZM5.85714 4.11111H10.1429H5.85714ZM5.85714 7.22222H10.1429H5.85714Z" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_csvicon: ({ width = 42, height = 42 }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="42" height="42" fill="white" />
      <path
        d="M32.8565 12.938L27.1174 7.14486C27.0747 7.09848 27.0228 7.06163 26.9652 7.03669C26.9075 7.01175 26.8453 6.99926 26.7826 7.00003H12.8461C12.3572 7.00257 11.8891 7.19971 11.5435 7.54863C11.1978 7.89754 11.0025 8.37005 11 8.86348V18.1035C11 18.2315 11.0504 18.3543 11.1401 18.4448C11.2298 18.5354 11.3514 18.5862 11.4783 18.5862C11.6051 18.5862 11.7267 18.5354 11.8164 18.4448C11.9061 18.3543 11.9565 18.2315 11.9565 18.1035V8.86348C11.9565 8.62533 12.0502 8.39694 12.2171 8.22855C12.3839 8.06015 12.6102 7.96555 12.8461 7.96555H26.3043V13.2759C26.3043 13.4039 26.3547 13.5267 26.4444 13.6172C26.5341 13.7078 26.6557 13.7586 26.7826 13.7586H32.0434V33.1366C32.0434 33.3747 31.9497 33.6031 31.7829 33.7715C31.6161 33.9399 31.3898 34.0345 31.1539 34.0345H12.8461C12.6102 34.0345 12.3839 33.9399 12.2171 33.7715C12.0502 33.6031 11.9565 33.3747 11.9565 33.1366V30.6552C11.9565 30.5271 11.9061 30.4044 11.8164 30.3138C11.7267 30.2233 11.6051 30.1724 11.4783 30.1724C11.3514 30.1724 11.2298 30.2233 11.1401 30.3138C11.0504 30.4044 11 30.5271 11 30.6552V33.1366C11.0025 33.63 11.1978 34.1025 11.5435 34.4514C11.8891 34.8003 12.3572 34.9975 12.8461 35H31.1539C31.6427 34.9975 32.1108 34.8003 32.4565 34.4514C32.8021 34.1025 32.9975 33.63 33 33.1366V13.2759C33.0007 13.2126 32.9884 13.1498 32.9636 13.0916C32.9389 13.0334 32.9024 12.9811 32.8565 12.938ZM27.2608 8.65107L31.3643 12.7931H27.2608V8.65107Z"
        fill="#828282"
      />
      <path
        d="M29 27.542V21.458C29.0012 21.2662 28.9622 21.0761 28.8851 20.8987C28.808 20.7212 28.6944 20.56 28.5509 20.4244C28.4074 20.2888 28.2368 20.1814 28.049 20.1086C27.8613 20.0357 27.6601 19.9988 27.4571 20H10.5429C10.3399 19.9988 10.1387 20.0357 9.95097 20.1086C9.76321 20.1814 9.59262 20.2888 9.4491 20.4244C9.30558 20.56 9.19198 20.7212 9.1149 20.8987C9.03781 21.0761 8.99877 21.2662 9.00003 21.458V27.542C8.99877 27.7338 9.03781 27.9239 9.1149 28.1013C9.19198 28.2788 9.30558 28.44 9.4491 28.5756C9.59262 28.7112 9.76321 28.8186 9.95097 28.8914C10.1387 28.9643 10.3399 29.0012 10.5429 29H27.4571C27.6601 29.0012 27.8613 28.9643 28.049 28.8914C28.2368 28.8186 28.4074 28.7112 28.5509 28.5756C28.6944 28.44 28.808 28.2788 28.8851 28.1013C28.9622 27.9239 29.0012 27.7338 29 27.542ZM13.2857 25.679C13.4406 25.8318 13.627 25.9529 13.8334 26.035C14.0398 26.117 14.2618 26.1582 14.4857 26.156C14.7279 26.1562 14.9676 26.1103 15.1905 26.021C15.4297 25.9073 15.6483 25.7584 15.8381 25.58L16.381 26.102C16.1465 26.3628 15.8545 26.572 15.5255 26.7151C15.1965 26.8581 14.8384 26.9314 14.4762 26.93C14.126 26.9457 13.7762 26.8931 13.4485 26.7754C13.1208 26.6577 12.8222 26.4775 12.5714 26.246C12.0932 25.7807 11.8257 25.1576 11.8257 24.509C11.8257 23.8604 12.0932 23.2373 12.5714 22.772C12.8229 22.5403 13.1211 22.3587 13.4483 22.2381C13.7756 22.1175 14.1251 22.0604 14.4762 22.07C14.837 22.0657 15.1944 22.136 15.5234 22.2759C15.8524 22.4158 16.1451 22.622 16.381 22.88L15.8476 23.429C15.6583 23.2397 15.4319 23.0869 15.181 22.979C14.9457 22.8873 14.6924 22.8444 14.4381 22.853C14.0077 22.8685 13.598 23.0317 13.2857 23.312C13.1166 23.461 12.9831 23.6425 12.8944 23.8443C12.8057 24.0462 12.7638 24.2636 12.7714 24.482C12.7657 24.7042 12.8084 24.9251 12.8969 25.131C12.9853 25.337 13.1177 25.5235 13.2857 25.679ZM20.3619 26.579C19.9939 26.8444 19.5385 26.9783 19.0762 26.957C18.311 26.9608 17.5726 26.6907 17.0095 26.201L17.5333 25.598C17.9553 25.9797 18.5114 26.2008 19.0952 26.219C19.3238 26.2308 19.5504 26.1741 19.7429 26.057C19.8187 26.0084 19.8803 25.9425 19.9219 25.8654C19.9636 25.7883 19.9839 25.7025 19.9809 25.616C19.9843 25.5329 19.9651 25.4504 19.9251 25.3763C19.885 25.3022 19.8256 25.2391 19.7524 25.193C19.5149 25.0591 19.2534 24.9676 18.981 24.923C18.7005 24.8593 18.4239 24.7812 18.1524 24.689C17.9686 24.6279 17.7977 24.5365 17.6476 24.419C17.4974 24.3041 17.379 24.1564 17.3026 23.9887C17.2263 23.8209 17.1944 23.6381 17.2095 23.456C17.1974 23.2615 17.2372 23.0671 17.3255 22.891C17.4137 22.7148 17.5474 22.5625 17.7143 22.448C18.0748 22.2054 18.51 22.082 18.9524 22.097C19.276 22.0955 19.5978 22.1442 19.9048 22.241C20.2004 22.3325 20.4751 22.476 20.7143 22.664L20.2667 23.258C20.0919 23.1169 19.8874 23.0126 19.6667 22.952C19.4282 22.8711 19.1771 22.8285 18.9238 22.826C18.7138 22.8223 18.5065 22.872 18.3238 22.97C18.2492 23.0148 18.1887 23.0777 18.1485 23.1521C18.1083 23.2265 18.0899 23.3096 18.0952 23.393C18.0904 23.4788 18.1088 23.5644 18.1488 23.6416C18.1889 23.7188 18.2491 23.785 18.3238 23.834C18.6396 23.9854 18.9762 24.0944 19.3238 24.158C19.7424 24.2341 20.1367 24.4004 20.4762 24.644C20.6053 24.7591 20.7069 24.899 20.7742 25.0542C20.8416 25.2094 20.8731 25.3764 20.8667 25.544C20.8689 25.7381 20.8236 25.9301 20.7344 26.1049C20.6452 26.2798 20.5145 26.4328 20.3524 26.552L20.3619 26.579ZM24.1714 26.903H23.219L21.2286 22.214H22.1809L23.7143 25.715L25.2381 22.214H26.1905L24.1714 26.903Z"
        fill="#828282"
      />
    </svg>
  ),
  svgs_salesForce: ({ width = 37, height = 36 }) => (
    <svg width={width} height={height} viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8266_76730)">
        <g clipPath="url(#clip1_8266_76730)">
          <mask id="mask0_8266_76730" maskUnits="userSpaceOnUse" x="0" y="5" width="37" height="25">
            <path d="M0.509888 5.31482H36.378V29.9352H0.509888V5.31482Z" fill="white"/>
          </mask>
          <g mask="url(#mask0_8266_76730)">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.3975 8.01121C16.5553 6.82684 18.1667 6.09341 19.9469 6.09341C22.3205 6.09341 24.3777 7.38922 25.4854 9.31998C26.4686 8.88805 27.5336 8.66506 28.6107 8.6656C32.8832 8.6656 36.3513 12.0995 36.3513 16.3368C36.3513 20.5741 32.8832 24.008 28.6107 24.008C28.0885 24.008 27.5794 23.9564 27.081 23.859C26.1118 25.5565 24.259 26.7098 22.1491 26.7098C21.2901 26.7114 20.4421 26.5199 19.67 26.15C18.6876 28.4176 16.3997 30.0115 13.7359 30.0115C10.9535 30.0115 8.59307 28.2881 7.68318 25.8649C7.27821 25.9489 6.86543 25.9911 6.45154 25.9908C3.14165 25.9908 0.464722 23.3215 0.464722 20.0431C0.464722 17.8402 1.67 15.9224 3.45813 14.8857C3.07878 14.027 2.88351 13.1007 2.8845 12.1645C2.8845 8.38078 6.00978 5.32266 9.86033 5.32266C12.1153 5.32266 14.1329 6.37875 15.3988 8.01795" fill="#00A1E0"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M5.69639 18.1175C5.67384 18.1753 5.70443 18.1873 5.71168 18.1976C5.77907 18.2455 5.84751 18.2802 5.91608 18.3193C6.28267 18.5097 6.62817 18.5655 6.98949 18.5655C7.72531 18.5655 8.18289 18.1806 8.18289 17.5612V17.549C8.18289 16.9763 7.66597 16.7676 7.18333 16.6186L7.12017 16.5985C6.75489 16.4822 6.43973 16.3808 6.43973 16.145V16.133C6.43973 15.9308 6.62434 15.7818 6.90918 15.7818C7.22566 15.7818 7.60281 15.8853 7.84412 16.0163C7.84412 16.0163 7.9156 16.0617 7.94158 15.9939C7.95569 15.9572 8.07872 15.6337 8.09191 15.5974C8.10588 15.5594 8.08136 15.5308 8.05617 15.516C7.77925 15.3502 7.39683 15.2374 7.00122 15.2374L6.92777 15.2377C6.25393 15.2377 5.78316 15.6381 5.78316 16.2108V16.2231C5.78316 16.827 6.30272 17.024 6.78799 17.16L6.86606 17.1839C7.21947 17.2906 7.5254 17.3834 7.5254 17.627V17.6392C7.5254 17.8634 7.32628 18.0305 7.00716 18.0305C6.88307 18.0305 6.4876 18.0285 6.05903 17.7623C6.0072 17.7326 5.97766 17.7113 5.93771 17.6873C5.91661 17.6747 5.86386 17.652 5.84092 17.7199L5.69586 18.1165L5.69639 18.1175ZM16.4695 18.1165C16.4469 18.1742 16.4775 18.1863 16.485 18.1965C16.5522 18.2445 16.6209 18.2792 16.6894 18.3182C17.056 18.5087 17.4015 18.5644 17.7629 18.5644C18.4987 18.5644 18.9563 18.1796 18.9563 17.5602V17.548C18.9563 16.9752 18.4407 16.7666 17.9567 16.6176L17.8935 16.5975C17.5283 16.4811 17.2131 16.3798 17.2131 16.144V16.1319C17.2131 15.9298 17.3977 15.7808 17.6825 15.7808C17.999 15.7808 18.3749 15.8843 18.6175 16.0153C18.6175 16.0153 18.689 16.0607 18.7151 15.9929C18.7291 15.9562 18.8522 15.6326 18.8641 15.5964C18.8782 15.5584 18.8535 15.5298 18.8285 15.515C18.5516 15.3491 18.1691 15.2364 17.7735 15.2364L17.7 15.2366C17.0261 15.2366 16.5553 15.6371 16.5553 16.2098V16.2221C16.5553 16.826 17.0749 17.0229 17.5602 17.159L17.6381 17.1828C17.9928 17.2896 18.2974 17.3824 18.2974 17.626V17.6382C18.2974 17.8623 18.0983 18.0295 17.7792 18.0295C17.6549 18.0295 17.2583 18.0274 16.8311 17.7613C16.7792 17.7316 16.7489 17.7111 16.7096 17.6862C16.6963 17.678 16.6342 17.6541 16.613 17.7189L16.4679 18.1154L16.4695 18.1165ZM23.8262 16.9025C23.8262 17.2524 23.7597 17.5284 23.6297 17.7241C23.4999 17.9172 23.304 18.0118 23.031 18.0118C22.758 18.0118 22.5629 17.9179 22.4349 17.7254C22.3061 17.531 22.2411 17.2537 22.2411 16.9038C22.2411 16.554 22.3065 16.2793 22.4349 16.0862C22.5626 15.8944 22.7567 15.8024 23.031 15.8024C23.3053 15.8024 23.5004 15.8953 23.6297 16.0862C23.7605 16.2793 23.8262 16.554 23.8262 16.9038V16.9025ZM24.4407 16.2546C24.3801 16.0538 24.2864 15.8776 24.1611 15.7298C24.0357 15.5821 23.8776 15.4629 23.689 15.3774C23.5018 15.2912 23.2802 15.2478 23.0297 15.2478C22.7791 15.2478 22.5589 15.2915 22.3703 15.3774C22.1831 15.4634 22.0235 15.5821 21.8982 15.7298C21.7732 15.8776 21.6793 16.0538 21.6187 16.2546C21.5587 16.4542 21.5282 16.6719 21.5282 16.9038C21.5282 17.1358 21.5587 17.3535 21.6187 17.553C21.6789 17.7539 21.773 17.9301 21.8982 18.0778C22.0236 18.2256 22.1831 18.3435 22.3703 18.4277C22.5589 18.5117 22.7804 18.5544 23.0297 18.5544C23.2789 18.5544 23.5004 18.5117 23.6877 18.4277C23.8749 18.3437 24.0345 18.2256 24.1598 18.0778C24.2849 17.9301 24.3787 17.7539 24.4393 17.553C24.4992 17.3535 24.5297 17.1358 24.5297 16.9038C24.5297 16.6732 24.4992 16.4542 24.4393 16.2546H24.4407ZM29.4899 17.9133C29.4697 17.8546 29.4114 17.8767 29.4114 17.8767C29.3222 17.9103 29.2268 17.9414 29.1253 17.9569C29.0229 17.9728 28.909 17.9807 28.789 17.9807C28.4923 17.9807 28.2549 17.8937 28.0862 17.7215C27.916 17.5492 27.8211 17.2718 27.8224 16.8961C27.8233 16.554 27.9075 16.2974 28.0585 16.1004C28.2075 15.9061 28.4369 15.805 28.7402 15.805C28.9934 15.805 29.1873 15.8339 29.3903 15.8963C29.3903 15.8963 29.4385 15.9169 29.4615 15.8546C29.5155 15.7082 29.5553 15.6032 29.6132 15.4426C29.6295 15.3966 29.5894 15.3771 29.5748 15.3715C29.4952 15.341 29.3071 15.2908 29.1647 15.2697C29.0315 15.2497 28.8772 15.2394 28.7032 15.2394C28.4447 15.2394 28.2153 15.2828 28.0188 15.3688C27.8223 15.4547 27.6561 15.5736 27.5243 15.7213C27.3924 15.869 27.2922 16.0452 27.2249 16.2461C27.1583 16.4456 27.1247 16.6646 27.1247 16.8966C27.1247 17.3968 27.2618 17.8024 27.5335 18.0991C27.8051 18.3971 28.2139 18.5474 28.7467 18.5474C29.0618 18.5474 29.3849 18.4849 29.617 18.3945C29.617 18.3945 29.6613 18.3735 29.6421 18.3227L29.4904 17.9133H29.4899ZM30.5651 16.5656C30.5946 16.3713 30.6487 16.2093 30.7339 16.0836C30.8615 15.8918 31.0557 15.7868 31.3287 15.7868C31.6016 15.7868 31.7823 15.8923 31.9115 16.0836C31.9972 16.2099 32.0347 16.3777 32.0487 16.5656L30.5585 16.5654L30.5651 16.5656ZM32.6355 16.138C32.5831 15.9449 32.4535 15.7493 32.3691 15.6599C32.2346 15.5186 32.104 15.4188 31.9735 15.3644C31.785 15.2857 31.5823 15.2452 31.3774 15.2456C31.1177 15.2456 30.8816 15.2887 30.6904 15.3765C30.4992 15.4648 30.3383 15.5851 30.2117 15.7354C30.0853 15.8857 29.9902 16.0632 29.9295 16.2667C29.8689 16.4675 29.8383 16.6878 29.8383 16.9185C29.8383 17.1543 29.8701 17.3733 29.9326 17.5716C29.9957 17.7711 30.0974 17.9461 30.2345 18.0912C30.3717 18.2376 30.5471 18.3516 30.7581 18.432C30.9677 18.5117 31.2222 18.553 31.5137 18.5521C32.115 18.5502 32.4315 18.4186 32.5607 18.3474C32.5838 18.3347 32.6055 18.3128 32.5784 18.2497L32.4426 17.8752C32.4217 17.8193 32.3642 17.8395 32.3642 17.8395C32.2152 17.8942 32.0042 17.9924 31.5097 17.9912C31.1866 17.9906 30.948 17.8969 30.7976 17.7501C30.6447 17.5998 30.5682 17.3808 30.5563 17.0698L32.6398 17.0714C32.6398 17.0714 32.6947 17.0709 32.7004 17.0183C32.7026 16.9965 32.7717 16.5984 32.6382 16.1384L32.6355 16.138ZM13.9102 16.5656C13.9396 16.3713 13.9939 16.2093 14.079 16.0836C14.2066 15.8918 14.4007 15.7868 14.6737 15.7868C14.9467 15.7868 15.1273 15.8923 15.2566 16.0836C15.3421 16.2099 15.3796 16.3777 15.3937 16.5656L13.9036 16.5654L13.9102 16.5656ZM15.9805 16.138C15.9283 15.9449 15.7985 15.7493 15.7141 15.6599C15.5796 15.5186 15.4491 15.4188 15.3185 15.3644C15.1301 15.2857 14.9273 15.2452 14.7225 15.2456C14.4627 15.2456 14.2267 15.2887 14.0355 15.3765C13.8443 15.4648 13.6834 15.5851 13.5568 15.7354C13.4306 15.8857 13.3352 16.0632 13.2746 16.2667C13.2141 16.4675 13.1836 16.6878 13.1836 16.9185C13.1836 17.1543 13.2151 17.3733 13.278 17.5716C13.341 17.7711 13.4429 17.9461 13.5787 18.0912C13.7158 18.2376 13.8912 18.3516 14.1022 18.432C14.3119 18.5117 14.565 18.553 14.8578 18.5521C15.4591 18.5502 15.7756 18.4186 15.9048 18.3474C15.9278 18.3347 15.9497 18.3128 15.9224 18.2497L15.7865 17.8752C15.7656 17.8193 15.7081 17.8395 15.7081 17.8395C15.5591 17.8942 15.3481 17.9924 14.8536 17.9912C14.5318 17.9906 14.2918 17.8969 14.1415 17.7501C13.9885 17.5998 13.912 17.3808 13.9002 17.0698L15.9837 17.0714C15.9837 17.0714 16.0385 17.0709 16.0442 17.0183C16.0465 16.9965 16.1156 16.5984 15.982 16.1384L15.9805 16.138ZM9.41349 17.9003C9.33186 17.8363 9.32052 17.8206 9.29349 17.779C9.25221 17.7164 9.23111 17.6274 9.23111 17.5134C9.23111 17.3346 9.29177 17.205 9.41705 17.1182C9.41573 17.1184 9.59639 16.9653 10.021 16.9704C10.21 16.9738 10.3986 16.9896 10.5854 17.0177V17.9468H10.5857C10.5857 17.9468 10.3219 18.0027 10.0239 18.0203C9.60061 18.0453 9.41336 17.9006 9.41467 17.901L9.41349 17.9003ZM10.2416 16.462C10.1572 16.4559 10.0478 16.4529 9.91722 16.4529C9.7392 16.4529 9.56645 16.4747 9.40558 16.5174C9.24338 16.5604 9.097 16.6271 8.97173 16.7157C8.84611 16.8037 8.74279 16.919 8.66975 17.0526C8.59604 17.1874 8.55845 17.3454 8.55845 17.5243C8.55845 17.7057 8.5905 17.8625 8.6538 17.9908C8.71582 18.118 8.80919 18.228 8.92544 18.3108C9.04109 18.3935 9.18391 18.4547 9.34874 18.4909C9.51226 18.5276 9.69687 18.5461 9.89995 18.5461C10.1136 18.5461 10.3259 18.5285 10.5316 18.4944C10.7068 18.4647 10.8814 18.4314 11.0551 18.3944C11.1245 18.3787 11.2015 18.3581 11.2015 18.3581C11.2529 18.3453 11.249 18.2913 11.249 18.2913L11.2478 16.4253C11.2478 16.0158 11.1365 15.7113 10.9168 15.5234C10.6979 15.3355 10.3774 15.2409 9.96206 15.2409C9.80646 15.2409 9.55459 15.2617 9.40426 15.2913C9.40426 15.2913 8.95063 15.3779 8.76338 15.522C8.76338 15.522 8.72223 15.5469 8.74465 15.6032L8.89235 15.992C8.91067 16.0424 8.96065 16.0251 8.96065 16.0251C8.96065 16.0251 8.97635 16.0191 8.99481 16.0083C9.39437 15.7945 9.90074 15.801 9.90074 15.801C10.1249 15.801 10.299 15.8457 10.415 15.9331C10.5286 16.0188 10.5865 16.1483 10.5865 16.4204V16.5068C10.4084 16.4814 10.2436 16.4668 10.2436 16.4668L10.2416 16.462ZM26.9889 15.4085C26.9919 15.4016 26.9934 15.3943 26.9935 15.3868C26.9935 15.3794 26.9921 15.372 26.9891 15.3652C26.9862 15.3583 26.9819 15.3521 26.9765 15.3469C26.9711 15.3417 26.9647 15.3376 26.9576 15.3349C26.9222 15.3217 26.7453 15.285 26.6095 15.2767C26.3484 15.2606 26.2033 15.3039 26.0728 15.3614C25.9438 15.4186 25.8011 15.5105 25.722 15.6167L25.7218 15.3679C25.7218 15.3337 25.6971 15.3061 25.662 15.3061H25.1293C25.0947 15.3061 25.0697 15.3337 25.0697 15.3679V18.4131C25.0697 18.4295 25.0764 18.4453 25.0882 18.4569C25.1 18.4686 25.1161 18.4751 25.1328 18.4751H25.6788C25.6955 18.4751 25.7115 18.4685 25.7233 18.4569C25.7352 18.4453 25.7418 18.4295 25.7418 18.4131V16.884C25.7418 16.6793 25.7647 16.4758 25.8105 16.3475C25.8556 16.2207 25.9169 16.1195 25.9925 16.0469C26.0646 15.9768 26.1528 15.9248 26.2496 15.8953C26.3405 15.8697 26.4346 15.8567 26.5292 15.8567C26.638 15.8567 26.7573 15.8842 26.7573 15.8842C26.7974 15.8886 26.8197 15.8645 26.8333 15.829C26.869 15.7355 26.9704 15.4558 26.9902 15.4001" fill="#FFFFFE"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M21.8904 14.003C21.8229 13.983 21.7542 13.967 21.6848 13.9551C21.5914 13.9398 21.4968 13.9326 21.4021 13.9336C21.0258 13.9336 20.7293 14.038 20.521 14.2443C20.3143 14.449 20.1736 14.7609 20.103 15.1713L20.0776 15.3098H19.6054C19.6054 15.3098 19.5477 15.3075 19.5356 15.3693L19.4581 15.7943C19.4526 15.835 19.4705 15.8604 19.5258 15.8602H19.9855L19.5191 18.4185C19.4826 18.6245 19.4408 18.794 19.3945 18.9224C19.3489 19.0492 19.3043 19.1441 19.2494 19.2131C19.1963 19.2798 19.1459 19.3289 19.059 19.3576C18.9873 19.3813 18.9047 19.3922 18.8143 19.3922C18.7639 19.3922 18.6969 19.3839 18.6475 19.3742C18.598 19.3646 18.5723 19.3537 18.5352 19.3384C18.5352 19.3384 18.4813 19.3182 18.4601 19.3713C18.4428 19.4147 18.3203 19.7458 18.3058 19.7867C18.291 19.8272 18.3117 19.859 18.3378 19.8682C18.399 19.8898 18.4445 19.9035 18.5279 19.9228C18.6436 19.9496 18.7412 19.9513 18.8326 19.9513C19.0241 19.9513 19.1985 19.9249 19.3432 19.8736C19.4888 19.8219 19.6155 19.7318 19.7276 19.6099C19.8488 19.4783 19.925 19.3406 19.9979 19.1527C20.0701 18.9665 20.1315 18.7353 20.1807 18.4659L20.6494 15.8602H21.3345C21.3345 15.8602 21.3923 15.8622 21.4043 15.8007L21.4818 15.3757C21.4872 15.335 21.4696 15.3096 21.4139 15.3098H20.7489C20.7522 15.2951 20.7824 15.0652 20.8588 14.8488C20.8913 14.7564 20.9526 14.6819 21.0046 14.6307C21.0531 14.582 21.1129 14.5454 21.1788 14.5242C21.2511 14.5022 21.3264 14.4916 21.4021 14.4926C21.4647 14.4926 21.5261 14.5 21.573 14.5096C21.6374 14.523 21.6625 14.5302 21.6794 14.5351C21.7472 14.5554 21.7563 14.5357 21.7696 14.5035L21.9286 14.0743C21.945 14.0282 21.9051 14.0087 21.8904 14.003V14.003ZM12.5971 18.4239C12.5971 18.4581 12.5723 18.486 12.5375 18.486H11.9859C11.9509 18.486 11.9261 18.4581 11.9261 18.4239V14.0612C11.9261 14.0271 11.9509 13.9995 11.9859 13.9995H12.5375C12.5723 13.9995 12.5971 14.0271 12.5971 14.0612V18.4239" fill="#FFFFFE"/>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_8266_76730">
          <rect width="36" height="36" fill="white" transform="translate(0.5)"/>
        </clipPath>
        <clipPath id="clip1_8266_76730">
          <rect width="36" height="24.75" fill="white" transform="translate(0.5 5.25)"/>
        </clipPath>
      </defs>
    </svg>

  ),
  svgs_zoho: ({ width = 36, height = 36 }) => (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8266_76813)">
        <g clipPath="url(#clip1_8266_76813)">
          <g clipPath="url(#clip2_8266_76813)">
            <path d="M35.1429 14.6116V22.7411L34.0179 23.8393V15.8839L35.1429 14.6116Z" fill="#E79225"/>
            <path d="M27.7702 14.6183L26.605 15.8839L26.6652 15.9643L33.9711 15.9375L34.038 15.8839L35.1429 14.6116L27.7702 14.6183Z" fill="#FFF16D"/>
            <path d="M26.605 15.8839H34.038V23.846H26.605V15.8839Z" fill="url(#paint0_linear_8266_76813)"/>
            <path d="M32.9063 18.75C32.759 18.3817 32.538 18.0469 32.25 17.7589C31.9755 17.4777 31.6674 17.2634 31.3192 17.1228C30.9777 16.9821 30.6094 16.9085 30.2076 16.9085C29.8058 16.9085 29.4308 16.9821 29.0893 17.1228C28.7411 17.2634 28.4331 17.4777 28.1585 17.7589C27.8706 18.0469 27.6563 18.3817 27.509 18.75C27.3616 19.1183 27.2947 19.5201 27.2947 19.962C27.2947 20.3906 27.3683 20.7924 27.5157 21.1674C27.662 21.5427 27.883 21.8844 28.1652 22.1719C28.4331 22.4464 28.7411 22.654 29.0826 22.7946C29.4241 22.9353 29.8058 23.0089 30.2143 23.0089C30.6094 23.0089 30.9777 22.9353 31.3192 22.7946C31.6607 22.654 31.9755 22.4464 32.25 22.1719C32.538 21.8772 32.759 21.5424 32.9063 21.1741C33.0536 20.8058 33.1273 20.3973 33.1273 19.9687C33.1273 19.5201 33.0536 19.1183 32.9063 18.75ZM31.3728 21.375C31.0849 21.7165 30.7032 21.8906 30.2076 21.8906C29.7121 21.8906 29.3237 21.7165 29.0357 21.375C28.7478 21.0335 28.6072 20.558 28.6072 19.9554C28.6072 19.3393 28.7545 18.8638 29.0357 18.5156C29.3237 18.1674 29.7054 18 30.2076 18C30.7032 18 31.0849 18.1741 31.3728 18.5156C31.6541 18.8638 31.8014 19.3393 31.8014 19.9554C31.8014 20.558 31.6608 21.0335 31.3728 21.375Z" fill="white"/>
            <path d="M25.875 13.9487V13.9888L26.8259 21.2946L26.2701 22.8348L26.1964 22.7812L25.2188 15.7768L25.2388 15.683L25.8482 13.9888L25.875 13.9487Z" fill="#009ADA"/>
            <path d="M18.5558 14.9665L25.875 13.9487L25.2589 15.7031L25.1719 15.7969L18.3281 16.8013L18.3616 15.5491L18.5558 14.9665Z" fill="#91C9ED"/>
            <path d="M25.2589 15.7031L26.2701 22.8348L19.058 23.846L18.087 16.9554L18.5089 16.6272L25.2589 15.7031Z" fill="url(#paint1_linear_8266_76813)"/>
            <path d="M24.0335 17.0692C24 16.8482 23.9263 16.6808 23.8058 16.567C23.7054 16.4799 23.5848 16.433 23.4442 16.433C23.4107 16.433 23.3705 16.433 23.3304 16.4397C23.1429 16.4665 23.0022 16.5536 22.9152 16.6942C22.8482 16.7946 22.8214 16.9219 22.8214 17.0692C22.8214 17.1228 22.8281 17.183 22.8348 17.2433L23.096 19.0982L21.0201 19.4062L20.7589 17.5513C20.7254 17.337 20.6518 17.1696 20.5312 17.0558C20.4308 16.962 20.3103 16.9152 20.1763 16.9152C20.1429 16.9152 20.1094 16.9152 20.0759 16.9219C19.8817 16.9487 19.7344 17.0357 19.6406 17.1763C19.5737 17.2768 19.5469 17.404 19.5469 17.5513C19.5469 17.6049 19.5536 17.6652 19.5603 17.7321L20.2701 22.5603C20.3036 22.7812 20.3772 22.9487 20.5112 23.0625C20.6116 23.1495 20.7321 23.1897 20.8795 23.1897C20.9196 23.1897 20.9598 23.1897 21 23.183C21.1808 23.1562 21.3147 23.0692 21.4018 22.9286C21.4621 22.8281 21.4888 22.7076 21.4888 22.567C21.4888 22.5134 21.4821 22.4531 21.4754 22.3929L21.1875 20.4844L23.2634 20.1763L23.5513 22.0848C23.5848 22.3058 23.6585 22.4732 23.7857 22.5804C23.8862 22.6674 24.0067 22.7143 24.1473 22.7143C24.1808 22.7143 24.221 22.7143 24.2612 22.7076C24.4487 22.6808 24.5893 22.5937 24.6763 22.4531C24.7366 22.3527 24.7701 22.2321 24.7701 22.0848C24.7701 22.0312 24.7634 21.971 24.7567 21.9107L24.0335 17.0692Z" fill="white"/>
            <path d="M11.7054 12.0871L9.10046 18.2746L9.45537 20.9933L9.47546 20.9866L12.4018 14.404L12.3884 14.2634L11.7589 12.1741L11.7054 12.0871Z" fill="#66BF6B"/>
            <path d="M11.7054 12.0871L12.3952 14.404L18.8371 17.2902L18.8572 17.2768L18.3081 15.1071L11.7054 12.0871Z" fill="#98D0A0"/>
            <path d="M12.3818 14.3571L18.8572 17.2768L15.9309 23.913L9.45544 20.9933L12.3818 14.3571Z" fill="url(#paint2_linear_8266_76813)"/>
            <path d="M16.8951 17.8125C16.7545 17.4375 16.5603 17.1161 16.3058 16.8482C16.0513 16.5804 15.7433 16.3661 15.3817 16.2121C15.0201 16.058 14.6585 15.9844 14.2902 15.9844H14.2701C13.8951 15.9844 13.5268 16.0714 13.1652 16.2321C12.7835 16.3996 12.4554 16.6272 12.1741 16.9286C11.8929 17.2232 11.6652 17.5848 11.4911 18C11.317 18.4085 11.2232 18.8237 11.2031 19.2321V19.3728C11.2031 19.7344 11.2634 20.0893 11.3906 20.4375C11.5246 20.8058 11.7188 21.1205 11.9732 21.3884C12.2277 21.6562 12.5424 21.8705 12.9174 22.0246C13.2723 22.1786 13.6339 22.2522 14.0022 22.2522H14.0089C14.3772 22.2522 14.7455 22.1719 15.1071 22.0179C15.4888 21.8504 15.8237 21.6161 16.1049 21.3147C16.3862 21.0201 16.6205 20.6652 16.7946 20.25C16.9688 19.8348 17.0625 19.4263 17.0826 19.0179V18.8973C17.0893 18.529 17.029 18.1674 16.8951 17.8125ZM15.6027 19.7411C15.3616 20.317 15.0335 20.7121 14.6384 20.9263C14.4241 21.0402 14.2031 21.1004 13.9821 21.1004C13.7879 21.1004 13.5804 21.0536 13.3728 20.9665C12.9174 20.7723 12.6362 20.4643 12.5156 20.0223C12.4754 19.875 12.4554 19.721 12.4554 19.5603C12.4554 19.2388 12.5357 18.8839 12.6964 18.5022C12.9442 17.9129 13.2723 17.5112 13.6674 17.2902C13.8817 17.1696 14.1027 17.1161 14.3237 17.1161C14.5246 17.1161 14.7254 17.1629 14.9397 17.25C15.3884 17.4442 15.6696 17.7522 15.7902 18.1942C15.8304 18.3348 15.8504 18.4888 15.8504 18.6496C15.8504 18.9844 15.7701 19.346 15.6027 19.7411Z" fill="white"/>
            <path d="M8.58482 13.1384L9.64286 20.2232L9.16071 22.7143L9.09375 22.6272L8.0625 15.7835V15.6496L8.51786 13.2589L8.58482 13.1384Z" fill="#760D16"/>
            <path d="M0.857178 16.8013L1.35941 14.2969L8.58486 13.1384L8.09602 15.6897V15.8571L0.944231 16.8683L0.857178 16.8013Z" fill="#EF463E"/>
            <path d="M8.09602 15.6897L9.16075 22.7143L2.00896 23.8326L0.857178 16.8013L8.09602 15.6897Z" fill="url(#paint3_linear_8266_76813)"/>
            <path d="M7.32594 21.596C7.27237 21.529 7.19202 21.4821 7.09827 21.4487C7.00452 21.4152 6.89068 21.4018 6.75005 21.4018C6.62282 21.4018 6.4755 21.4152 6.31478 21.442L4.42639 21.7634C4.44648 21.6161 4.52014 21.4286 4.64737 21.1942C4.788 20.933 5.00228 20.6183 5.27684 20.2567C5.34854 20.1592 5.42221 20.0632 5.49782 19.9688C5.5313 19.9219 5.58487 19.8616 5.65184 19.7746C6.08711 19.2054 6.34827 18.7433 6.45541 18.3817C6.51568 18.1741 6.54916 17.9665 6.56255 17.7589C6.56925 17.6987 6.56925 17.6451 6.56925 17.5915C6.56925 17.4442 6.55586 17.2969 6.52907 17.1496C6.50898 17.0156 6.4755 16.9085 6.42862 16.8214C6.38175 16.7344 6.32818 16.6674 6.26121 16.6272C6.18755 16.5804 6.07371 16.5603 5.93309 16.5603C5.81925 16.5603 5.67862 16.5737 5.51121 16.6005L3.32818 16.9755C3.06702 17.0223 2.86612 17.096 2.74559 17.2165C2.64514 17.3103 2.59827 17.4308 2.59827 17.5647C2.59827 17.5982 2.59827 17.6384 2.60496 17.6786C2.63845 17.8661 2.7322 18 2.88621 18.067C2.97996 18.1071 3.08711 18.1272 3.22103 18.1272C3.30809 18.1272 3.40853 18.1205 3.51568 18.1005L5.33711 17.779C5.33711 17.8125 5.3438 17.846 5.3438 17.8728C5.34392 17.9871 5.3235 18.1005 5.28353 18.2076C5.22996 18.3616 5.09603 18.5759 4.87505 18.8505L4.5938 19.1987C4.09827 19.7946 3.75005 20.3036 3.53577 20.7255C3.38175 21.0201 3.2813 21.3013 3.22103 21.5893C3.18755 21.7567 3.16746 21.9107 3.16746 22.0647C3.16746 22.1719 3.17416 22.279 3.19425 22.3795C3.22103 22.5268 3.25452 22.6473 3.30139 22.7411C3.34827 22.8348 3.41523 22.9085 3.48889 22.9487C3.56255 22.9888 3.663 23.0022 3.81032 23.0022C3.99112 23.0022 4.23889 22.9755 4.55362 22.9219L6.53577 22.5804C6.88398 22.5201 7.13175 22.433 7.27237 22.3192C7.38621 22.2255 7.44648 22.0982 7.44648 21.9509C7.44648 21.9107 7.43978 21.8705 7.43309 21.8304C7.41969 21.7433 7.38621 21.663 7.32594 21.596Z" fill="white"/>
          </g>
        </g>
      </g>
      <defs>
        <linearGradient id="paint0_linear_8266_76813" x1="30.3212" y1="15.9979" x2="30.3212" y2="23.6056" gradientUnits="userSpaceOnUse">
          <stop offset="0.005618" stopColor="#FFE513"/>
          <stop offset="1" stopColor="#FDB924"/>
        </linearGradient>
        <linearGradient id="paint1_linear_8266_76813" x1="18.4563" y1="16.8019" x2="25.916" y2="22.7926" gradientUnits="userSpaceOnUse">
          <stop offset="0.005618" stopColor="#008CD2"/>
          <stop offset="1" stopColor="#00649D"/>
        </linearGradient>
        <linearGradient id="paint2_linear_8266_76813" x1="14.1565" y1="17.0116" x2="14.1565" y2="23.6768" gradientUnits="userSpaceOnUse">
          <stop stopColor="#26A146"/>
          <stop offset="1" stopColor="#008A52"/>
        </linearGradient>
        <linearGradient id="paint3_linear_8266_76813" x1="4.48865" y1="16.3581" x2="5.63535" y2="23.2787" gradientUnits="userSpaceOnUse">
          <stop stopColor="#D92231"/>
          <stop offset="1" stopColor="#BA2234"/>
        </linearGradient>
        <clipPath id="clip0_8266_76813">
          <rect width="36" height="36" fill="white"/>
        </clipPath>
        <clipPath id="clip1_8266_76813">
          <rect width="34.2857" height="34.2857" fill="white" transform="translate(0.857178 0.857147)"/>
        </clipPath>
        <clipPath id="clip2_8266_76813">
          <rect width="34.2857" height="34.2857" fill="white" transform="translate(0.857178 0.857147)"/>
        </clipPath>
      </defs>
    </svg>

  ),
  svgs_hubspot: ({ width = 36, height = 36 }) => (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24.0261 13.9023V11.0443C24.3968 10.8677 24.7106 10.5876 24.9311 10.2364C25.1516 9.88524 25.2697 9.47748 25.2715 9.0606V8.99497C25.2715 7.77949 24.3044 6.79414 23.1114 6.79414H23.047C22.4741 6.79414 21.9247 7.02601 21.5196 7.43875C21.1145 7.85148 20.8869 8.41127 20.8869 8.99497V9.0606C20.8888 9.47748 21.0069 9.88524 21.2274 10.2364C21.4479 10.5876 21.7617 10.8677 22.1324 11.0443V13.9023C21.067 14.0685 20.0636 14.5185 19.2239 15.2069L11.5307 9.10193C11.5856 8.90016 11.6142 8.69272 11.6174 8.48446C11.6183 7.99398 11.4765 7.51424 11.2098 7.1059C10.9431 6.69757 10.5635 6.379 10.1191 6.19049C9.67465 6.00197 9.18532 5.95199 8.713 6.04685C8.24069 6.14171 7.80659 6.37716 7.46563 6.72342C7.12467 7.06967 6.89215 7.51118 6.7975 7.99209C6.70285 8.473 6.75032 8.9717 6.93389 9.42512C7.11746 9.87855 7.42889 10.2663 7.8288 10.5394C8.2287 10.8124 8.69911 10.9585 9.18051 10.9592C9.60168 10.9572 10.015 10.8426 10.3791 10.6269L17.9545 16.633C17.274 17.6805 16.919 18.9126 16.9357 20.1686C16.9525 21.4246 17.3402 22.6464 18.0484 23.6747L15.7443 26.023C15.5581 25.9623 15.364 25.9301 15.1685 25.9274C14.7734 25.9277 14.3872 26.0474 14.0587 26.2712C13.7303 26.4951 13.4744 26.8132 13.3233 27.1852C13.1722 27.5572 13.1328 27.9665 13.2099 28.3614C13.2871 28.7562 13.4774 29.1189 13.7569 29.4036C14.0363 29.6883 14.3922 29.8822 14.7798 29.9608C15.1674 30.0394 15.5691 29.9993 15.9342 29.8453C16.2994 29.6914 16.6115 29.4307 16.8313 29.096C17.051 28.7614 17.1685 28.3679 17.1688 27.9653C17.1662 27.7661 17.1346 27.5684 17.0749 27.3787L19.3543 25.0555C20.0976 25.6385 20.962 26.0404 21.8814 26.2305C22.8007 26.4206 23.7505 26.3938 24.6581 26.1521C25.5656 25.9104 26.4069 25.4602 27.1173 24.8361C27.8277 24.212 28.3885 23.4305 28.7567 22.5515C29.1249 21.6724 29.2908 20.7192 29.2415 19.7648C29.1923 18.8103 28.9293 17.8801 28.4727 17.0452C28.016 16.2103 27.3779 15.493 26.6072 14.9483C25.8364 14.4035 24.9535 14.0457 24.0261 13.9023ZM23.0812 23.3019C22.66 23.3137 22.2406 23.2394 21.8481 23.0833C21.4555 22.9272 21.0976 22.6925 20.7955 22.3931C20.4935 22.0937 20.2534 21.7357 20.0894 21.3402C19.9255 20.9446 19.841 20.5196 19.841 20.0902C19.841 19.6609 19.9255 19.2359 20.0894 18.8403C20.2534 18.4448 20.4935 18.0867 20.7955 17.7873C21.0976 17.4879 21.4555 17.2533 21.8481 17.0972C22.2406 16.9411 22.66 16.8667 23.0812 16.8785C23.8977 16.9077 24.6712 17.2585 25.2388 17.8571C25.8065 18.4558 26.1239 19.2555 26.1243 20.0879C26.1247 20.9202 25.8081 21.7203 25.241 22.3195C24.674 22.9187 23.9008 23.2703 23.0844 23.3003" fill="#FF7A59"/>
    </svg>

  ),
  svgs_okta: () => (
    <svg width="36" height="12" viewBox="0 0 36 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8266_76997)">
        <path d="M32.3903 7.85642C31.3935 7.85642 30.6892 7.07716 30.6892 6.0544C30.6892 5.03164 31.394 4.2524 32.3903 4.2524C33.3867 4.2524 34.0717 5.03164 34.0717 6.0544C34.0717 7.07716 33.3772 7.85642 32.3903 7.85642ZM32.2292 8.92936C33.0349 8.92936 33.7192 8.61576 34.1519 7.95778C34.2324 8.59541 34.6955 8.82849 35.2793 8.82849H35.7424V7.81617H35.5411C35.2089 7.81617 35.1284 7.65414 35.1284 7.27944V3.28083H34.0615V4.10081C33.6992 3.52386 33.0146 3.17944 32.2292 3.17944C30.83 3.17944 29.541 4.35379 29.541 6.0544C29.541 7.75504 30.8295 8.92936 32.2292 8.92936ZM26.7328 7.54234C26.7328 8.45327 27.2967 8.828 27.9709 8.828H29.2697V7.81565H28.3232C27.9308 7.81565 27.8503 7.6636 27.8503 7.27892V4.29265H29.2697V3.28033H27.8503V1.41819H26.7328V7.54234ZM21.649 8.828H22.7665V6.44899H23.1392L25.042 8.828H26.4516L24.0253 5.8114L25.8876 3.28083H24.6293L23.109 5.4168H22.7665V1.41819H21.649V8.828ZM18.0248 3.17944C16.4644 3.17944 15.176 4.35379 15.176 6.0544C15.176 7.75504 16.4644 8.92936 18.0248 8.92936C19.5851 8.92936 20.8736 7.75504 20.8736 6.0544C20.8736 4.35379 19.5851 3.17944 18.0248 3.17944ZM18.0248 7.8559C17.0279 7.8559 16.3236 7.07666 16.3236 6.05391C16.3236 5.03115 17.0284 4.25191 18.0248 4.25191C19.0212 4.25191 19.7259 5.03115 19.7259 6.05391C19.7259 7.07666 19.0212 7.8559 18.0248 7.8559Z" fill="black"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M6.48101 0.192791L6.23942 3.17698C6.12507 3.16312 6.00925 3.15569 5.89091 3.15569C5.7439 3.15569 5.59934 3.16659 5.45822 3.18837L5.3206 1.74132C5.31615 1.69627 5.35228 1.65667 5.39784 1.65716H5.64487L5.52557 0.192791C5.52161 0.147741 5.55725 0.109127 5.60229 0.109127H6.40329C6.44835 0.109127 6.4835 0.147741 6.48003 0.192791H6.48101ZM4.45922 0.340813C4.44734 0.297248 4.4008 0.273485 4.35823 0.288832L3.60524 0.563093C3.56266 0.578439 3.54286 0.626954 3.56168 0.668043L4.17407 2.00321L3.94138 2.08737C3.8988 2.10272 3.87802 2.15172 3.89782 2.19331L4.5216 3.50618C4.74784 3.38144 4.99287 3.28787 5.25181 3.22847L4.45922 0.340813ZM2.61066 1.17201L4.34337 3.61314C4.12357 3.75619 3.92505 3.92846 3.75277 4.12502L2.71661 3.10421C2.68393 3.07203 2.68641 3.01906 2.72106 2.98985L2.91067 2.83143L1.87897 1.78637C1.84728 1.7542 1.84976 1.70222 1.88441 1.67301L2.49779 1.15765C2.53245 1.12844 2.58443 1.13538 2.61066 1.17201ZM1.15717 2.58539C1.12005 2.56014 1.06906 2.57153 1.04628 2.61014L0.645781 3.30421C0.623009 3.34332 0.638849 3.39331 0.679444 3.41262L2.0067 4.04183L1.88243 4.2557C1.85966 4.2953 1.8755 4.3458 1.91709 4.36462L3.23939 4.96909C3.33543 4.72305 3.46317 4.49383 3.6196 4.28689L1.15717 2.58539ZM0.179436 4.47154C0.187357 4.427 0.230923 4.39879 0.274983 4.41018L3.17107 5.1666C3.09632 5.41117 3.05424 5.67008 3.0483 5.93792L1.59827 5.82157C1.55273 5.8181 1.52055 5.77602 1.52847 5.73098L1.57203 5.48789L0.110129 5.35076C0.0650782 5.34631 0.0333946 5.30474 0.0413156 5.26017L0.179932 4.47105L0.179436 4.47154ZM0.0700288 6.42752C0.0249785 6.43197 -0.00670516 6.47357 0.00121578 6.51811L0.140327 7.30723C0.148248 7.35177 0.192308 7.38001 0.235873 7.36862L1.65669 6.99733L1.69926 7.2404C1.70719 7.28543 1.75223 7.31367 1.7958 7.30127L3.19731 6.91414C3.11463 6.67107 3.06364 6.41413 3.05028 6.14682L0.0700288 6.42752ZM0.533402 8.50131C0.510631 8.4622 0.526471 8.4122 0.567065 8.39289L3.27107 7.1107C3.37405 7.35327 3.5102 7.5785 3.67305 7.7805L2.48789 8.62358C2.45076 8.65032 2.39878 8.63844 2.3765 8.59933L2.25323 8.38497L1.04529 9.22014C1.00816 9.24586 0.957171 9.23447 0.9344 9.19536L0.533402 8.50131ZM3.80968 7.93893L1.70619 10.0696C1.67451 10.1018 1.67698 10.1538 1.71164 10.183L2.32551 10.6979C2.36017 10.7271 2.41215 10.7201 2.43838 10.6835L3.28791 9.48546L3.47701 9.64487C3.51167 9.6741 3.56465 9.66716 3.59038 9.62952L4.41514 8.43298C4.19138 8.29634 3.98792 8.1295 3.80968 7.93893ZM3.39434 11.3597C3.35176 11.3444 3.33196 11.2959 3.35078 11.2548L4.59831 8.53299C4.82803 8.65032 5.07554 8.73793 5.33595 8.78941L4.97009 10.1964C4.95874 10.2404 4.91168 10.2652 4.86913 10.2493L4.63693 10.1642L4.24784 11.5806C4.23592 11.6241 4.18942 11.6479 4.14684 11.6325L3.39385 11.3588L3.39434 11.3597ZM5.54289 8.8226L5.30129 11.8073C5.29783 11.8523 5.33297 11.8909 5.37804 11.8909H6.17904C6.2241 11.8909 6.25975 11.8523 6.25579 11.8073L6.13646 10.3434H6.38349C6.42904 10.3439 6.46468 10.3048 6.46072 10.2592L6.32311 8.81219C6.18202 8.8335 6.03746 8.84488 5.89042 8.84488C5.7726 8.84488 5.65675 8.83693 5.5424 8.82309L5.54289 8.8226ZM8.43156 0.744779C8.45038 0.703687 8.43005 0.655669 8.388 0.639826L7.63501 0.366061C7.59292 0.350714 7.54589 0.374476 7.53401 0.418041L7.14489 1.83439L6.91272 1.74924C6.87014 1.7334 6.82311 1.75816 6.81172 1.80222L6.44587 3.20916C6.70628 3.26065 6.95379 3.34827 7.18351 3.4656L8.43156 0.744281V0.744779ZM10.0756 1.93093L7.97213 4.06163C7.79443 3.87057 7.59096 3.70373 7.36668 3.56709L8.19144 2.37054C8.2172 2.33341 8.27015 2.32598 8.30481 2.35569L8.49394 2.51509L9.34344 1.31706C9.36969 1.28043 9.42166 1.2735 9.45632 1.3027L10.0702 1.81756C10.1048 1.84677 10.1073 1.89925 10.0756 1.93093ZM11.2148 3.60767C11.2559 3.58836 11.2712 3.53839 11.2484 3.49928L10.8474 2.8052C10.8247 2.76609 10.7737 2.7547 10.7365 2.78044L9.52861 3.61559L9.40533 3.40123C9.38255 3.36164 9.33058 3.35025 9.29396 3.37699L8.10877 4.22006C8.27165 4.42255 8.4078 4.64729 8.51076 4.88986L11.2148 3.60767ZM11.6415 4.69382L11.7806 5.48294C11.7885 5.52801 11.7564 5.56957 11.7118 5.57353L8.73157 5.85325C8.71819 5.58594 8.6672 5.32899 8.58453 5.08593L9.98604 4.69929C10.0296 4.68689 10.0746 4.71562 10.0826 4.76016L10.1246 5.00323L11.5455 4.63194C11.589 4.62055 11.6331 4.64879 11.641 4.69333L11.6415 4.69382ZM11.5068 7.59038C11.5504 7.60177 11.5945 7.57356 11.6024 7.52902L11.741 6.7399C11.7489 6.69533 11.7168 6.65376 11.6722 6.64931L10.2103 6.51218L10.2538 6.26909C10.2618 6.22405 10.2296 6.18246 10.184 6.1785L8.73403 6.06215C8.7281 6.33048 8.68601 6.5889 8.61127 6.83396L11.5073 7.58989L11.5068 7.59038ZM10.7356 9.39091C10.7128 9.42953 10.6618 9.44091 10.6246 9.41568L8.16127 7.71416C8.3177 7.50722 8.44589 7.27803 8.54146 7.03199L9.86374 7.63692C9.90533 7.65574 9.92167 7.70673 9.8984 7.74584L9.77416 7.95971L11.1014 8.58893C11.142 8.60823 11.1578 8.65824 11.1351 8.69735L10.7345 9.3914L10.7356 9.39091ZM7.43845 8.38742L9.17116 10.829C9.19741 10.8657 9.24889 10.8726 9.28404 10.8434L9.89741 10.3281C9.93207 10.2989 9.93456 10.2464 9.90285 10.2147L8.87115 9.16964L9.06077 9.0112C9.09543 8.98201 9.09789 8.92903 9.06523 8.89735L8.02908 7.87655C7.8568 8.07259 7.65828 8.24486 7.43845 8.38795V8.38742ZM7.42362 11.7117C7.38154 11.7271 7.33451 11.7033 7.32263 11.6598L6.52955 8.77259C6.78845 8.71319 7.03352 8.61913 7.25976 8.49487L7.88351 9.80775C7.90331 9.84883 7.88302 9.89834 7.83995 9.91369L7.60729 9.99787L8.21965 11.333C8.23847 11.3741 8.21818 11.4221 8.17609 11.438L7.42313 11.7122L7.42362 11.7117Z" fill="black"/>
      </g>
      <defs>
        <clipPath id="clip0_8266_76997">
          <rect width="36" height="11.7818" fill="white" transform="translate(0 0.109127)"/>
        </clipPath>
      </defs>
    </svg>

  ),
  svgs_azure_saml: () => (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8266_76979)">
        <path d="M16.3752 0.00340462C16.4091 0.00340462 16.443 0.045803 16.4939 0.122121C16.5363 0.189959 20.1063 4.47225 24.4309 9.63644C28.7556 14.8006 32.2832 19.049 32.2662 19.0744C32.2577 19.0999 28.815 21.9237 24.6175 25.341C20.42 28.7584 16.85 31.6669 16.6889 31.8026C16.4091 32.0316 16.3921 32.04 16.2904 31.9383C16.231 31.8789 12.6525 28.9534 8.33634 25.4343C4.02015 21.9152 0.501046 19.0151 0.518005 18.9727C0.534965 18.9303 4.0795 14.6989 8.41266 9.56012C12.7458 4.42137 16.2904 0.173 16.3073 0.105162C16.3243 0.0373235 16.3497 0.00340462 16.3752 0.00340462Z" fill="#00BEF2"/>
        <path d="M15.7901 26.9098C15.2983 26.7317 14.7047 26.2229 14.4588 25.748C14.1535 25.1629 14.1789 24.2471 14.5181 23.5179C14.781 22.9751 14.781 22.9582 14.6114 22.831C14.5181 22.7632 13.3903 22.1356 12.1184 21.4488C10.8464 20.7619 9.73554 20.1599 9.65922 20.1175C9.55747 20.0581 9.38787 20.1175 9.0826 20.3125C8.09047 20.94 7.05594 20.8722 6.24188 20.1175C5.65678 19.5748 5.48718 19.1932 5.48718 18.413C5.48718 17.6583 5.63982 17.2683 6.12316 16.7849C6.77611 16.132 7.64952 15.9115 8.48902 16.1913C8.94692 16.344 8.9554 16.344 9.24372 16.1235C9.58291 15.8691 12.3049 13.3845 13.6193 12.138L14.5266 11.273L14.2553 10.7049C13.7041 9.56012 13.9839 8.28816 14.9506 7.52498C15.4763 7.10947 15.8664 6.98227 16.6211 6.98227C18.3849 6.98227 19.6145 8.83086 18.953 10.4844C18.775 10.9423 18.775 10.9508 18.9446 11.2306C19.0887 11.4766 21.5394 14.436 22.8368 15.9454C23.0657 16.2083 23.3201 16.4203 23.4049 16.4203C23.4897 16.4203 23.778 16.3355 24.0494 16.2337C25.3129 15.7334 26.6442 16.2931 27.1699 17.5481C27.5091 18.3537 27.2123 19.4391 26.4916 20.092C25.9828 20.5499 25.6097 20.6941 24.9313 20.6941C24.4564 20.6941 24.2783 20.6432 23.778 20.3719C23.4049 20.1683 23.1166 20.0666 22.9979 20.1005C22.7944 20.1514 19.6653 22.2968 18.97 22.8564C18.546 23.2041 18.5121 23.3313 18.7326 23.8486C18.9446 24.3573 18.9191 25.1544 18.6817 25.6548C18.4188 26.2059 17.7659 26.7571 17.1977 26.9267C16.6211 27.0878 16.2734 27.0878 15.7901 26.9098ZM15.9342 17.565V12.7316L15.6629 12.3585C15.5103 12.1549 15.3661 11.9853 15.3407 11.9853C15.2304 11.9853 9.7525 16.963 9.7525 17.0647C9.7525 17.0902 9.8373 17.3446 9.93906 17.6159C10.0408 17.8958 10.1171 18.2943 10.1087 18.5233C10.1002 18.7522 10.1002 19.0066 10.1002 19.0914C10.1087 19.2864 11.9403 20.4566 14.6877 22.0424C15.4424 22.4833 15.7053 22.5936 15.7986 22.5172C15.9088 22.424 15.9342 21.4827 15.9342 17.565ZM18.2577 21.8389C21.887 19.5578 22.5654 19.0999 22.6078 18.9303C22.6333 18.8285 22.6672 18.43 22.6757 18.0314L22.7011 17.3191L20.8525 15.1229C18.8682 12.774 18.139 11.9769 17.9694 11.9769C17.91 11.9769 17.6132 12.1465 17.308 12.35L16.7483 12.7231L16.7737 17.5481C16.7992 21.8728 16.8331 22.602 16.9942 22.602C17.0112 22.6105 17.5878 22.2628 18.2577 21.8389Z" fill="white" stroke="white" strokeWidth="0.104785" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_8266_76979">
          <rect width="31.7567" height="32" fill="white" transform="translate(0.515259 3.43323e-05)"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_envelop: ({
    width = 20, height = 20, fill, strokeFill = "#7c7c7c",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 4.16663H4.16667C3.24619 4.16663 2.5 4.91282 2.5 5.83329V14.1666C2.5 15.0871 3.24619 15.8333 4.16667 15.8333H15.8333C16.7538 15.8333 17.5 15.0871 17.5 14.1666V5.83329C17.5 4.91282 16.7538 4.16663 15.8333 4.16663Z"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 5.83337L10 10.8334L17.5 5.83337"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_optionsIcon: ({ width = 16, height = 16, fill }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="3" cy="8" r="1" fill="#828282" stroke="#828282" />
      <circle cx="8" cy="8" r="1" fill="#828282" stroke="#828282" />
      <circle cx="13" cy="8" r="1" fill="#828282" stroke="#828282" />
    </svg>
  ),
  svgs_star: ({ width = 16, height = 16, fill = "#828282" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 576 512">
      <path fill={fill} d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"/>
    </svg>
  ),
  svgs_stars: ({ width = 16, height = 16, fill = "#828282" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 512 512">
      <path fill={fill} d="M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zM115.7 346.2L75.5 307l55.5-8.1c15.6-2.3 29.2-12.1 36.1-26.3l24.8-50.3 24.8 50.3c7 14.2 20.5 24 36.1 26.3l55.5 8.1-40.2 39.2c-11.3 11-16.4 26.9-13.8 42.4l9.5 55.4-49.5-26.1c-14-7.4-30.7-7.4-44.7 0L120 444l9.5-55.4c2.7-15.6-2.5-31.4-13.8-42.4zm54.7-188.8l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94c-8.8-17.9-34.3-17.9-43.1 0zm258.4 85.8l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z"/>
    </svg>
  ),
  svgs_closeIcon: ({ width = 16, height = 16, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L8 8M15 15L8 8M8 8L15 1M8 8L1 15"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_arrowDown: ({ width = 8, height = 4, fill }) => (
    <svg width={width} height={height} viewBox="0 0 10 6" fill={fill}>
      <path
        d="M1 1L5 5L9 1"
        stroke="#828282"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_cellularConnectionIcon: ({ width = 16, height = 9, fill = "none" }) => (
    <svg width={width} height={height} fill={fill} viewBox="0 0 12 9">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9742 0.966309H10.2968C9.92273 0.966309 9.61948 1.26956 9.61948 1.64365V7.51393C9.61948 7.88801 9.92273 8.19127 10.2968 8.19127H10.9742C11.3482 8.19127 11.6515 7.88801 11.6515 7.51393V1.64365C11.6515 1.26956 11.3482 0.966309 10.9742 0.966309ZM7.13634 2.54688H7.81368C8.18776 2.54688 8.49102 2.85013 8.49102 3.22422V7.51404C8.49102 7.88812 8.18776 8.19138 7.81368 8.19138H7.13634C6.76225 8.19138 6.459 7.88812 6.459 7.51404V3.22422C6.459 2.85013 6.76225 2.54688 7.13634 2.54688ZM4.65188 4.12712H3.97454C3.60045 4.12712 3.2972 4.43037 3.2972 4.80446V7.51382C3.2972 7.8879 3.60045 8.19116 3.97454 8.19116H4.65188C5.02596 8.19116 5.32922 7.8879 5.32922 7.51382V4.80446C5.32922 4.43037 5.02596 4.12712 4.65188 4.12712ZM1.4914 5.4818H0.814059C0.439974 5.4818 0.136719 5.78505 0.136719 6.15914V7.51382C0.136719 7.8879 0.439974 8.19116 0.814059 8.19116H1.4914C1.86548 8.19116 2.16874 7.8879 2.16874 7.51382V6.15914C2.16874 5.78505 1.86548 5.4818 1.4914 5.4818Z"
        fill="black"
      />
    </svg>
  ),
  svgs_wifiIcon: ({ width = 11, height = 8, fill = "none" }) => (
    <svg width={width} height={height} fill={fill}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.23227 2.28614C6.73917 2.2862 8.18845 2.86473 9.28056 3.90214C9.3628 3.98223 9.49425 3.98122 9.57525 3.89987L10.3614 3.10716C10.4024 3.0659 10.4253 3.01001 10.4249 2.95186C10.4246 2.89372 10.4011 2.8381 10.3596 2.79732C7.49312 0.0525852 2.97098 0.0525852 0.104532 2.79732C0.0630094 2.83807 0.0394501 2.89367 0.0390672 2.95182C0.0386844 3.00997 0.0615095 3.06587 0.102492 3.10716L0.888847 3.89987C0.969791 3.98134 1.10134 3.98235 1.18353 3.90214C2.27578 2.86466 3.72523 2.28613 5.23227 2.28614ZM5.23206 4.86522C6.06 4.86516 6.8584 5.17265 7.47212 5.72791C7.55512 5.80672 7.68588 5.80501 7.7668 5.72406L8.55202 4.93135C8.59338 4.88977 8.61632 4.83336 8.61572 4.77475C8.61513 4.71614 8.59104 4.66021 8.54885 4.61948C6.67996 2.8825 3.78574 2.8825 1.91685 4.61948C1.87464 4.66021 1.85055 4.71616 1.85 4.7748C1.84945 4.83343 1.87247 4.88983 1.91391 4.93135L2.6989 5.72406C2.77982 5.80501 2.91058 5.80672 2.99359 5.72791C3.6069 5.17301 4.40466 4.86556 5.23206 4.86522ZM6.80446 6.60047C6.80566 6.65925 6.78254 6.71592 6.74054 6.7571L5.38227 8.12668C5.34246 8.16693 5.28817 8.18958 5.23153 8.18958C5.17489 8.18958 5.1206 8.16693 5.08079 8.12668L3.72229 6.7571C3.68032 6.71589 3.65724 6.6592 3.65848 6.60043C3.65973 6.54165 3.68519 6.48599 3.72886 6.44659C4.59631 5.71352 5.86675 5.71352 6.7342 6.44659C6.77784 6.48602 6.80326 6.5417 6.80446 6.60047Z"
        fill="black"
      />
    </svg>
  ),
  svgs_phoneBatteryIcon: ({ width = 17, height = 8, fill = "none" }) => (
    <svg width={width} height={height} fill={fill}>
      <rect
        opacity="0.35"
        x="1.15117"
        y="1.07939"
        width="14.2241"
        height="6.99918"
        rx="1.46757"
        stroke="black"
        strokeWidth="0.67734"
      />
      <path
        opacity="0.4"
        d="M16.3906 3.22412V5.93348C16.9357 5.70401 17.2902 5.17021 17.2902 4.5788C17.2902 3.98739 16.9357 3.45359 16.3906 3.22412Z"
        fill="black"
      />
      <rect
        x="2.16797"
        y="2.09521"
        width="12.1921"
        height="4.96716"
        rx="0.90312"
        fill="black"
      />
    </svg>
  ),
  svgs_searchIcon: ({ width, height, fill }) => (
    <svg width={width} height={height} fill={fill} viewBox="0 0 16 16">
      <path
        d="M6.66667 11.3333C9.244 11.3333 11.3333 9.244 11.3333 6.66667C11.3333 4.08934 9.244 2 6.66667 2C4.08934 2 2 4.08934 2 6.66667C2 9.244 4.08934 11.3333 6.66667 11.3333Z"
        stroke="#828282"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0911 13.0911L10 10"
        stroke="#828282"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_rocket: ({ width = 16, height = 16, fill = "#828282" }) => (
    <svg width={width} height={height} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="M219.3 292.7c-10-10-21.4-18.1-33.8-24.1C215.6 146.3 269 86.7 321.1 58.1c53.5-29.4 111.4-29.4 154.6-21.8c7.6 43.2 7.7 101.1-21.8 154.6C425.3 243 365.7 296.4 243.4 326.5c-6-12.4-14.1-23.9-24.1-33.8zM256 381.3c0-8.2-.8-16.3-2.4-24.3c37.8-9.5 70.4-21.3 98.4-34.7v80.1c0 12.1-6.8 23.2-17.7 28.6L256 470.1l0-88.9zm128 21.1l0-97.4C515.7 225.1 520.5 102.5 506.7 28.1c-2.2-11.6-11.2-20.7-22.8-22.8C409.5-8.5 286.9-3.7 207 128l-97.4 0c-24.2 0-46.4 13.7-57.2 35.4L1.7 264.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H130.7c24.7 0 48.5 9.8 65.9 27.3s27.3 41.2 27.3 65.9V496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l101.5-50.7c21.7-10.8 35.4-33 35.4-57.2zm-229-144c-7.9-1.6-16.1-2.4-24.3-2.4H41.9L81 177.7c5.4-10.8 16.5-17.7 28.6-17.7h80.1c-13.5 28-25.2 60.5-34.7 98.4zm-11.2 189c-11 11-29.4 19.4-52.6 24.9c-20.6 4.9-42.1 6.8-59 7.4c.6-17 2.5-38.4 7.4-59c5.5-23.2 13.9-41.6 24.9-52.6c21.9-21.9 57.4-21.9 79.3 0s21.9 57.4 0 79.3zM166.5 470c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C7.7 379.7 1 446 .1 483.7c-.4 16 12.2 28.6 28.2 28.2C66 511 132.3 504.3 166.5 470zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"/>
    </svg>
  ),
  svgs_linksIcon: ({ width = 16, height = 16, strokeFill = "#bdbdbd" }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33333 5H2.66667C2.29848 5 2 5.29848 2 5.66667V8.33333C2 8.70152 2.29848 9 2.66667 9H5.33333C5.70152 9 6 8.70152 6 8.33333V5.66667C6 5.29848 5.70152 5 5.33333 5Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33333 11H2.66667C2.29848 11 2 11.2985 2 11.6667V14.3333C2 14.7015 2.29848 15 2.66667 15H5.33333C5.70152 15 6 14.7015 6 14.3333V11.6667C6 11.2985 5.70152 11 5.33333 11Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 5H8.66667C8.29848 5 8 5.29848 8 5.66667V8.33333C8 8.70152 8.29848 9 8.66667 9H11.3333C11.7015 9 12 8.70152 12 8.33333V5.66667C12 5.29848 11.7015 5 11.3333 5Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 11H8.66667C8.29848 11 8 11.2985 8 11.6667V14.3333C8 14.7015 8.29848 15 8.66667 15H11.3333C11.7015 15 12 14.7015 12 14.3333V11.6667C12 11.2985 11.7015 11 11.3333 11Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3333 5H14.6667C14.2985 5 14 5.29848 14 5.66667V8.33333C14 8.70152 14.2985 9 14.6667 9H17.3333C17.7015 9 18 8.70152 18 8.33333V5.66667C18 5.29848 17.7015 5 17.3333 5Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3333 11H14.6667C14.2985 11 14 11.2985 14 11.6667V14.3333C14 14.7015 14.2985 15 14.6667 15H17.3333C17.7015 15 18 14.7015 18 14.3333V11.6667C18 11.2985 17.7015 11 17.3333 11Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_devicesIcon: ({ width = 16, height = 16, strokeFill = "#828282" }) => (
    <svg width={width} height={height} fill="none" viewBox="0 0 16 16">
      <path
        d="M8 8V8.00667"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1211 5.87939C10.6834 6.44192 10.9994 7.20476 10.9994 8.00016C10.9994 8.79557 10.6834 9.55841 10.1211 10.1209"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2422 3.75781C12.7993 4.31491 13.2412 4.97628 13.5428 5.70418C13.8443 6.43207 13.9995 7.21223 13.9995 8.0001C13.9995 8.78797 13.8443 9.56813 13.5428 10.296C13.2412 11.0239 12.7993 11.6853 12.2422 12.2424"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.87436 10.1209C5.31201 9.55841 4.99609 8.79557 4.99609 8.00016C4.99609 7.20476 5.31201 6.44192 5.87436 5.87939"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75337 12.2424C3.19625 11.6853 2.75431 11.0239 2.4528 10.296C2.15128 9.56813 1.99609 8.78797 1.99609 8.0001C1.99609 7.21223 2.15128 6.43207 2.4528 5.70418C2.75431 4.97628 3.19625 4.31491 3.75337 3.75781"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_zoomBgIcon: ({ width = 16, height = 16, strokeFill = "#BDBDBD" }) => (
    <svg width={width} height={height} fill={strokeFill} viewBox="0 0 576 512">
      <path d="M557.6 102.3c-11.53-7.406-25.88-8.391-38.28-2.688L416 147V128c0-35.35-28.65-64-64-64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h288c35.35 0 64-28.65 64-64v-19.02l103.3 47.36c5.344 2.453 11.03 3.672 16.69 3.672c7.531 0 15.02-2.141 21.59-6.359C569.1 402.3 576 389.7 576 375.1V136C576 122.3 569.1 109.8 557.6 102.3zM368 384c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16V128c0-8.822 7.178-16 16-16h288c8.822 0 16 7.178 16 16V384zM528 363.5L416 312.2V199.8l112-51.33V363.5z" />
    </svg>
  ),
  svgs_editableTemplate: ({ width = 16, height = 16, fill = "#828282" }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5525 14 13.0002C14 11.6442 14 9.14497 14 7" stroke={fill} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7 4H4V8H8" stroke="#818181" strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="4" y="10" width="3" height="2" stroke={fill} strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="9" y="10" width="3" height="2" stroke={fill} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.1142 6.56999C11.2047 6.5487 11.2875 6.50258 11.3532 6.43684L14.6696 3.12046C14.995 2.79502 14.995 2.26738 14.6696 1.94194L14.3314 2.28013L14.6696 1.94194L14.0577 1.33002L13.7041 1.68357L14.0577 1.33001C13.7322 1.00458 13.2046 1.00458 12.8792 1.33002L9.56279 4.6464C9.49704 4.71214 9.45093 4.79492 9.42963 4.88543L9.0963 6.3021C9.05664 6.47065 9.10701 6.64773 9.22945 6.77017C9.3519 6.89261 9.52897 6.94298 9.69753 6.90332L11.1142 6.56999Z" stroke="#818181" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.6748 2.34631L13.6748 3.34631" stroke="#818181" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_connectionsIcon: ({
    width = 16, height = 16, fill = "#828282", strokeFill = "#828282",
  }) => (
    <svg width={width} height={height} fill="none" viewBox="0 0 16 15">
      <rect
        x="1.5"
        y="3.58136"
        width="13"
        height="10.0437"
        rx="2"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9511 1.52704H2.58203V1.375C2.58203 0.822715 3.02975 0.375 3.58203 0.375H11.9511C12.5034 0.375 12.9511 0.822715 12.9511 1.375V1.72704Z"
        fill={strokeFill}
        strokeWidth="1"
      />
      <path
        d="M8.00223 9.10522C8.77149 9.10522 9.39509 8.43071 9.39509 7.59866C9.39509 6.76661 8.77149 6.0921 8.00223 6.0921C7.23298 6.0921 6.60938 6.76661 6.60938 7.59866C6.60938 8.43071 7.23298 9.10522 8.00223 9.10522Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.98438 13.6251C4.98438 12.1988 6.1425 11.1142 7.57111 11.1142H8.43335C9.86197 11.1142 11.0201 12.1988 11.0201 13.6251"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_campaingsIcon: ({ strokeFill }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.167 2.98047C11.5477 2.98047 12.667 4.09976 12.667 5.48047L12.667 12.7497C12.667 14.1304 11.5477 15.2497 10.167 15.2497L5.50033 15.2497C4.11961 15.2497 3.00032 14.1304 3.00032 12.7497L3.00033 5.48047C3.00033 4.09976 4.11961 2.98047 5.50033 2.98047L5.97468 2.98047L7.83366 2.98047L9.69263 2.98047L10.167 2.98047Z" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.83303 10.9746C6.37403 10.9746 5.71023 11.8493 5.42555 12.4546C5.29278 12.7369 5.51762 13.0195 5.82958 13.0195H9.8365C10.1485 13.0195 10.3733 12.7369 10.2405 12.4546C9.95584 11.8493 9.29203 10.9746 7.83303 10.9746Z" fill={strokeFill}/>
      <path d="M9.13479 8.92921C9.13479 9.64789 8.55219 10.2305 7.83351 10.2305C7.11483 10.2305 6.53223 9.64789 6.53223 8.92921C6.53223 8.21053 7.11483 7.62793 7.83351 7.62793C8.55219 7.62793 9.13479 8.21053 9.13479 8.92921Z" fill={strokeFill}/>
      <path d="M11.5511 0.75L9.69216 2.98077M7.83318 5.21154L4.11523 0.75" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="7.83316" cy="5.21109" r="1.11538" fill={strokeFill}/>
    </svg>

  ),
  svgs_teamsIcon: ({
    width = 16.5,
    height = 12.5,
    fill = "none",
    strokeFill = "#828282",
  }) => (
    <svg width={width} height={height} fill={fill}>
      <path
        d="M8.99881 6.76315C10.4522 6.76315 11.6304 5.58493 11.6304 4.13153C11.6304 2.67812 10.4522 1.49991 8.99881 1.49991C7.5454 1.49991 6.36719 2.67812 6.36719 4.13153C6.36719 5.58493 7.5454 6.76315 8.99881 6.76315Z"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6055 2.81599C14.0437 2.9282 14.4322 3.18308 14.7095 3.54044C14.9869 3.8978 15.1375 4.33732 15.1375 4.78971C15.1375 5.2421 14.9869 5.68161 14.7095 6.03898C14.4322 6.39634 14.0437 6.65122 13.6055 6.76342"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.39453 2.81599C3.95628 2.9282 3.56784 3.18308 3.29045 3.54044C3.01306 3.8978 2.8625 4.33732 2.8625 4.78971C2.8625 5.2421 3.01306 5.68161 3.29045 6.03898C3.56784 6.39634 3.95628 6.65122 4.39453 6.76342"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.72266 13.9999V13.436C4.72266 11.5673 6.36374 10.0524 8.38813 10.0524H9.60995C11.6343 10.0524 13.2754 11.5673 13.2754 13.436V13.9999"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2207 14V13.4361C17.2207 12.318 16.6331 11.3265 15.7275 10.7105C15.4807 10.5426 15.2104 10.4027 14.9219 10.2956"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.775423 14V13.4361C0.775423 12.318 1.36297 11.3265 2.26862 10.7105C2.51536 10.5426 2.78571 10.4027 3.07422 10.2956"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  svgs_dashBoardPoplIcon: ({ width = 122, height = 25, fill = "none" }) => <svg width={width} height={height} viewBox="0 0 844 197" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_254)">
      <path fillRule="evenodd" clipRule="evenodd" d="M360.487 77.9949C360.487 99.7304 360.487 121.466 360.487 143.325C360.487 144.436 360.611 145.671 360.487 146.783C359.994 151.723 356.289 155.18 351.349 155.18C346.285 155.18 342.704 151.846 342.333 146.783C342.21 145.301 342.21 143.942 342.21 142.46C342.21 99.2364 342.21 56.0125 342.21 12.7886C342.21 11.6771 342.21 10.4421 342.21 9.33064C342.58 4.26727 346.162 0.562359 350.855 0.315365C355.671 0.0683714 359.87 3.77328 360.364 8.96015C360.487 10.1951 360.487 11.5536 360.487 12.7886C360.487 34.4005 360.487 56.2595 360.487 77.9949Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M102.009 96.2725C96.6982 61.0759 56.9322 41.4399 26.1815 59.347C9.75638 68.8562 0.741104 83.4289 0.247117 102.571C-0.123374 116.032 0.12362 129.493 0.12362 142.954C0.12362 157.157 0.12362 171.359 0.12362 185.437C0.12362 186.425 0.12362 187.413 0.12362 188.401C0.494111 192.847 4.07552 196.429 8.39791 196.923C12.4733 197.417 16.7957 194.7 17.9072 190.501C18.4012 188.895 18.4012 187.166 18.4012 185.437C18.4012 173.088 18.4012 160.861 18.4012 148.512C18.4012 147.4 18.4012 146.165 18.4012 145.054C18.4012 144.189 18.7717 143.695 19.6361 144.313C20.6241 144.93 21.4886 145.671 22.4766 146.289C33.5913 154.193 46.0645 156.663 59.1551 154.563C88.4239 149.87 105.96 122.701 102.009 96.2725ZM51.0043 136.656C32.9738 136.656 18.2777 121.713 18.5247 103.682C18.6482 85.6518 33.3443 71.2027 51.4983 71.2027C69.6524 71.2027 84.3485 86.5163 83.8545 104.176C84.3485 119.86 71.2578 136.656 51.0043 136.656Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M329.86 96.1488C324.55 61.0757 284.784 41.3162 254.033 59.2232C237.608 68.7325 228.593 83.3051 228.099 102.447C227.728 115.908 227.975 129.369 227.975 142.831C227.975 157.033 227.975 171.235 227.975 185.314C227.975 186.302 227.975 187.29 227.975 188.278C228.346 192.723 231.927 196.305 236.249 196.799C240.325 197.293 244.647 194.452 245.759 190.377C246.253 188.771 246.253 187.043 246.253 185.314C246.253 172.964 246.253 160.738 246.253 148.388C246.253 147.277 246.253 146.042 246.253 144.93C246.253 143.942 246.747 143.572 247.611 144.189C248.723 144.93 249.711 145.671 250.699 146.412C261.69 154.192 274.04 156.539 287.13 154.439C316.275 149.87 333.812 122.701 329.86 96.1488ZM278.856 136.656C260.825 136.779 246.129 121.713 246.253 103.806C246.376 85.7751 261.072 71.3259 279.226 71.3259C297.504 71.3259 312.2 86.6396 311.706 104.176C312.2 119.86 298.986 136.656 278.856 136.656Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M142.886 84.1697C144.615 85.2812 144.986 87.6276 143.874 89.3566L142.392 91.456C141.281 93.185 138.934 93.5555 137.206 92.444L120.533 82.0703C118.804 80.9588 118.434 78.6123 119.545 76.8834L121.892 73.302C123.003 71.573 125.35 71.2025 127.079 72.314L142.886 84.1697Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M135.106 102.818C137.082 102.571 138.934 104.053 139.181 106.029L139.428 108.499C139.675 110.475 138.193 112.327 136.217 112.574L116.828 115.538C114.852 115.785 113 114.303 112.753 112.327L112.259 108.128C112.012 106.152 113.494 104.3 115.47 104.053L135.106 102.818Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M140.91 122.33C142.269 120.848 144.615 120.725 146.097 122.083L147.949 123.812C149.431 125.171 149.555 127.517 148.196 128.999L135.353 143.819C133.994 145.301 131.648 145.424 130.166 144.066L127.078 141.102C125.596 139.743 125.473 137.397 126.831 135.915L140.91 122.33Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M158.2 133.445C158.323 131.346 160.052 129.864 162.152 129.987L164.745 130.111C166.845 130.234 168.327 131.963 168.203 134.063L167.833 153.699C167.709 155.798 165.98 157.28 163.881 157.156L159.682 156.909C157.582 156.786 156.1 155.057 156.224 152.958L158.2 133.445Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M177.342 131.346C176.107 129.74 176.477 127.394 178.206 126.159L180.306 124.677C181.911 123.442 184.258 123.812 185.493 125.541L197.595 140.978C198.83 142.584 198.46 144.93 196.731 146.165L193.273 148.635C191.668 149.87 189.321 149.5 188.086 147.771L177.342 131.346Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M191.42 116.649C189.444 116.155 188.209 114.179 188.703 112.204L189.321 109.734C189.815 107.758 191.791 106.523 193.767 107.017L213.032 110.969C215.008 111.463 216.243 113.438 215.749 115.414L214.761 119.613C214.267 121.589 212.291 122.824 210.315 122.33L191.42 116.649Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M193.026 96.0257C191.174 96.8902 188.951 96.1492 188.086 94.2967L186.975 91.9503C186.11 90.0979 186.851 87.8749 188.704 87.0104L206.117 77.9952C207.969 77.1307 210.192 77.8717 211.057 79.7241L212.909 83.5525C213.773 85.405 213.032 87.6279 211.18 88.4924L193.026 96.0257Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M181.293 79.2297C180.429 81.0822 178.206 81.9467 176.354 81.0822L174.007 80.0942C172.155 79.2297 171.29 77.0068 172.155 75.1543L179.564 57.0003C180.429 55.1478 182.652 54.2834 184.504 55.1478L188.456 56.8768C190.309 57.7413 191.173 59.8407 190.309 61.8167L181.293 79.2297Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M161.287 74.4135C161.905 76.3895 160.793 78.4889 158.817 78.9829L156.347 79.7239C154.372 80.3414 152.272 79.2299 151.778 77.254L145.48 58.7294C144.862 56.7535 145.974 54.654 147.95 54.16L152.025 52.9251C154.001 52.3076 156.1 53.4191 156.594 55.395L161.287 74.4135Z" fill="black"/>
    </g>
    <path d="M490.046 51.1544H419.74V58.2704H451.051V150.778H458.736V58.2704H490.046V51.1544ZM523.519 78.0529C501.744 78.0529 486.658 94.2773 486.658 115.198C486.658 136.689 502.171 152.344 524.088 152.344C538.178 152.344 549.279 145.939 555.114 136.262L548.852 132.561C544.725 140.104 535.901 145.512 524.231 145.512C508.006 145.512 495.767 134.981 494.059 118.899H558.53C558.53 117.76 558.672 116.622 558.672 115.483C558.672 95.9852 545.152 78.0529 523.519 78.0529ZM523.519 84.8842C537.466 84.8842 549.706 94.562 551.272 111.925H494.059C495.482 96.1275 507.295 84.8842 523.519 84.8842ZM637.925 79.6184V95.7005C631.948 85.0265 620.989 78.0529 607.327 78.0529C587.117 78.0529 570.466 94.135 570.466 115.198C570.466 136.262 587.117 152.344 607.327 152.344C620.989 152.344 631.948 145.37 637.925 134.696V150.778H645.184V79.6184H637.925ZM607.896 145.512C590.96 145.512 577.724 132.134 577.724 115.198C577.724 98.2623 590.96 84.8842 607.896 84.8842C624.832 84.8842 637.925 98.2623 637.925 115.198C637.925 132.134 624.832 145.512 607.896 145.512ZM743.033 78.0529C733.498 78.0529 724.389 82.6071 719.266 92.5695C715.565 83.1764 707.453 78.0529 697.064 78.0529C687.955 78.0529 679.416 82.0378 674.15 91.8579V79.6184H667.034V150.778H674.15V111.071C674.15 92.8541 684.54 84.8842 696.21 84.8842C707.168 84.8842 714.427 92.1425 714.427 105.663V150.778H721.543V111.071C721.543 92.8541 730.936 84.8842 742.891 84.8842C753.992 84.8842 761.819 92.1425 761.819 105.663V150.778H768.935V105.663C768.935 87.8729 758.119 78.0529 743.033 78.0529ZM793.901 98.2623C793.901 89.7231 801.729 84.8842 810.98 84.8842C818.807 84.8842 826.208 88.2999 829.197 95.7005L835.174 92.2849C831.331 83.6033 822.508 78.0529 810.98 78.0529C796.463 78.0529 786.785 87.019 786.785 98.2623C786.785 123.88 829.908 112.779 829.908 132.134C829.908 141.101 821.511 145.512 811.549 145.512C800.875 145.512 793.19 140.674 790.628 132.988L784.508 136.546C787.924 145.655 797.317 152.344 811.549 152.344C826.777 152.344 837.024 143.805 837.024 132.134C837.024 106.09 793.901 117.333 793.901 98.2623Z" fill="black"/>
    <defs>
      <clipPath id="clip0_1_254">
        <rect width="380" height="196.731" fill="white" transform="translate(0 0.191895)"/>
      </clipPath>
    </defs>
  </svg>,
  svgs_dashBoardFreePoplIcon: ({ }) => <svg width="47" height="24" viewBox="0 0 47 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5461_67262)">
      <path fillRule="evenodd" clipRule="evenodd" d="M43.9758 9.4896C43.9758 12.1412 43.9758 14.7928 43.9758 17.4595C43.9758 17.5951 43.9909 17.7457 43.9758 17.8813C43.9156 18.4839 43.4636 18.9058 42.861 18.9058C42.2433 18.9058 41.8064 18.499 41.7612 17.8813C41.7461 17.7005 41.7461 17.5348 41.7461 17.354C41.7461 12.0809 41.7461 6.80787 41.7461 1.5348C41.7461 1.3992 41.7461 1.24855 41.7461 1.11295C41.7913 0.49525 42.2282 0.0432723 42.8007 0.0131405C43.3883 -0.0169913 43.9005 0.434986 43.9608 1.06775C43.9758 1.21841 43.9758 1.38414 43.9758 1.5348C43.9758 4.17133 43.9758 6.838 43.9758 9.4896Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M12.4431 11.7176C11.7953 7.42385 6.94406 5.02837 3.19265 7.21293C1.18889 8.37301 0.0890748 10.1508 0.0288111 12.486C-0.0163866 14.1282 0.0137452 15.7704 0.0137452 17.4126C0.0137452 19.1451 0.0137452 20.8777 0.0137452 22.5952C0.0137452 22.7158 0.0137452 22.8363 0.0137452 22.9568C0.0589429 23.4992 0.495854 23.9361 1.02316 23.9964C1.52034 24.0566 2.04764 23.7252 2.18324 23.2129C2.2435 23.0171 2.2435 22.8062 2.2435 22.5952C2.2435 21.0886 2.2435 19.5971 2.2435 18.0905C2.2435 17.9549 2.2435 17.8043 2.2435 17.6687C2.2435 17.5632 2.2887 17.5029 2.39416 17.5783C2.51469 17.6536 2.62015 17.744 2.74068 17.8193C4.09661 18.7836 5.61826 19.0849 7.21525 18.8287C10.7859 18.2562 12.9252 14.9417 12.4431 11.7176ZM6.2209 16.6442C4.02128 16.6442 2.22843 14.8212 2.25857 12.6216C2.27363 10.422 4.06648 8.65926 6.28116 8.65926C8.49585 8.65926 10.2887 10.5274 10.2284 12.6819C10.2887 14.5952 8.69171 16.6442 6.2209 16.6442Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M40.24 11.7037C39.5922 7.42497 34.7409 5.01443 30.9895 7.19898C28.9858 8.35906 27.8859 10.1368 27.8257 12.4721C27.7805 14.1142 27.8106 15.7564 27.8106 17.3986C27.8106 19.1312 27.8106 20.8638 27.8106 22.5813C27.8106 22.7018 27.8106 22.8223 27.8106 22.9429C27.8558 23.4852 28.2927 23.9221 28.82 23.9824C29.3172 24.0427 29.8445 23.6962 29.9801 23.199C30.0404 23.0031 30.0404 22.7922 30.0404 22.5813C30.0404 21.0747 30.0404 19.5832 30.0404 18.0766C30.0404 17.941 30.0404 17.7903 30.0404 17.6547C30.0404 17.5342 30.1006 17.489 30.2061 17.5643C30.3417 17.6547 30.4622 17.7451 30.5827 17.8355C31.9236 18.7847 33.4302 19.0709 35.0272 18.8148C38.5827 18.2574 40.7221 14.9429 40.24 11.7037ZM34.0178 16.6453C31.8182 16.6604 30.0253 14.8223 30.0404 12.6378C30.0554 10.4382 31.8483 8.67544 34.063 8.67544C36.2927 8.67544 38.0856 10.5436 38.0253 12.683C38.0856 14.5963 36.4735 16.6453 34.0178 16.6453Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M17.4324 10.2422C17.6433 10.3778 17.6885 10.664 17.5529 10.8749L17.3721 11.1311C17.2365 11.342 16.9502 11.3872 16.7393 11.2516L14.7054 9.98604C14.4945 9.85045 14.4493 9.5642 14.5849 9.35327L14.8711 8.91636C15.0067 8.70544 15.293 8.66024 15.5039 8.79583L17.4324 10.2422Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M16.4819 12.5189C16.7229 12.4888 16.9489 12.6696 16.9791 12.9106L17.0092 13.2119C17.0393 13.453 16.8585 13.679 16.6175 13.7091L14.2521 14.0707C14.0111 14.1008 13.7851 13.92 13.755 13.679L13.6947 13.1667C13.6646 12.9257 13.8454 12.6997 14.0864 12.6696L16.4819 12.5189Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M17.1884 14.8995C17.3541 14.7187 17.6404 14.7036 17.8212 14.8693L18.0472 15.0803C18.228 15.246 18.243 15.5322 18.0773 15.713L16.5104 17.5209C16.3447 17.7017 16.0585 17.7168 15.8777 17.5511L15.501 17.1895C15.3202 17.0238 15.3052 16.7375 15.4709 16.5567L17.1884 14.8995Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M19.3005 16.2548C19.3156 15.9986 19.5265 15.8178 19.7826 15.8329L20.099 15.848C20.3551 15.863 20.5359 16.074 20.5209 16.3301L20.4757 18.7256C20.4606 18.9817 20.2497 19.1625 19.9936 19.1474L19.4813 19.1173C19.2252 19.1022 19.0444 18.8913 19.0595 18.6352L19.3005 16.2548Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M21.6356 15.996C21.4849 15.8002 21.5301 15.5139 21.7411 15.3633L21.9972 15.1825C22.193 15.0318 22.4793 15.077 22.6299 15.2879L24.1064 17.1712C24.2571 17.367 24.2119 17.6533 24.0009 17.8039L23.5791 18.1052C23.3832 18.2559 23.097 18.2107 22.9463 17.9998L21.6356 15.996Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M23.3526 14.2041C23.1115 14.1438 22.9608 13.9027 23.0211 13.6617L23.0964 13.3604C23.1567 13.1193 23.3977 12.9686 23.6388 13.0289L25.9891 13.511C26.2301 13.5713 26.3808 13.8123 26.3205 14.0534L26.2 14.5656C26.1397 14.8067 25.8987 14.9573 25.6576 14.8971L23.3526 14.2041Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M23.5477 11.6888C23.3217 11.7942 23.0505 11.7038 22.9451 11.4779L22.8095 11.1916C22.704 10.9656 22.7944 10.6944 23.0204 10.589L25.1447 9.48916C25.3707 9.3837 25.6419 9.47409 25.7473 9.70008L25.9733 10.1671C26.0788 10.3931 25.9884 10.6643 25.7624 10.7698L23.5477 11.6888Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M22.1169 9.6391C22.0114 9.86509 21.7403 9.97055 21.5143 9.86509L21.228 9.74456C21.002 9.6391 20.8966 9.36791 21.002 9.14192L21.906 6.92723C22.0114 6.70124 22.2826 6.59578 22.5086 6.70124L22.9907 6.91217C23.2167 7.01763 23.3222 7.27375 23.2167 7.5148L22.1169 9.6391Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M19.6758 9.05245C19.7512 9.2935 19.6156 9.54962 19.3745 9.60989L19.0732 9.70028C18.8321 9.77561 18.576 9.64002 18.5157 9.39896L17.7474 7.13908C17.6721 6.89802 17.8076 6.6419 18.0487 6.58164L18.5459 6.43098C18.7869 6.35565 19.0431 6.49124 19.1033 6.7323L19.6758 9.05245Z" fill="black"/>
    </g>
    <defs>
      <clipPath id="clip0_5461_67262">
        <rect width="46.3578" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>,

  svgs_dashBoardProfileIcon: ({
    width = 16,
    height = 16,
    fill = "none",
    strokeFill = "#BDBDBD",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9987 7.33333C9.47146 7.33333 10.6654 6.13943 10.6654 4.66667C10.6654 3.19391 9.47146 2 7.9987 2C6.52594 2 5.33203 3.19391 5.33203 4.66667C5.33203 6.13943 6.52594 7.33333 7.9987 7.33333Z"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 14V12.6667C4 11.9594 4.28095 11.2811 4.78105 10.781C5.28115 10.281 5.95942 10 6.66667 10H9.33333C10.0406 10 10.7189 10.281 11.219 10.781C11.719 11.2811 12 11.9594 12 12.6667V14"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  svgs_dashBoardIcon: ({
    width = 16, height = 16, strokeFill = "#BDBDBD", fill = "none",
  }) => (
    <svg
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.7548 10H2.2452C1.83364 10 1.5 10.3298 1.5 10.7367V13.2633C1.5 13.6702 1.83364 14 2.2452 14H3.7548C4.16636 14 4.5 13.6702 4.5 13.2633V10.7367C4.5 10.3298 4.16636 10 3.7548 10Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.7548 6H7.2452C6.83364 6 6.5 6.32982 6.5 6.73667V13.2633C6.5 13.6702 6.83364 14 7.2452 14H8.7548C9.16636 14 9.5 13.6702 9.5 13.2633V6.73667C9.5 6.32982 9.16636 6 8.7548 6Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7548 2H12.2452C11.8336 2 11.5 2.32982 11.5 2.73667V13.2633C11.5 13.6702 11.8336 14 12.2452 14H13.7548C14.1664 14 14.5 13.6702 14.5 13.2633V2.73667C14.5 2.32982 14.1664 2 13.7548 2Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  svgs_dashBoardNotification: ({
    width = 16, height = 16, strokeFill = "#BDBDBD", fill = "none",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.84615 4H3.53846C3.13044 4 2.73912 4.16209 2.4506 4.4506C2.16209 4.73912 2 5.13044 2 5.53846V12.4615C2 12.8696 2.16209 13.2609 2.4506 13.5494C2.73912 13.8379 3.13044 14 3.53846 14H10.4615C10.8696 14 11.2609 13.8379 11.5494 13.5494C11.8379 13.2609 12 12.8696 12 12.4615V9.15385"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  svgs_uploadCloud: ({ fill, width, height }) => (
    <svg
      width={width}
      height={height}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512.056 512.056"
    >
      <g>
        <g>
          <g>
            <path
              fill={fill}
              d="M426.635,188.224C402.969,93.946,307.358,36.704,213.08,60.37C139.404,78.865,85.907,142.542,80.395,218.303
     C28.082,226.93-7.333,276.331,1.294,328.644c7.669,46.507,47.967,80.566,95.101,80.379h80v-32h-80c-35.346,0-64-28.654-64-64
     c0-35.346,28.654-64,64-64c8.837,0,16-7.163,16-16c-0.08-79.529,64.327-144.065,143.856-144.144
     c68.844-0.069,128.107,48.601,141.424,116.144c1.315,6.744,6.788,11.896,13.6,12.8c43.742,6.229,74.151,46.738,67.923,90.479
     c-5.593,39.278-39.129,68.523-78.803,68.721h-64v32h64c61.856-0.187,111.848-50.483,111.66-112.339
     C511.899,245.194,476.655,200.443,426.635,188.224z"
            />
            <path
              fill={fill}
              d="M245.035,253.664l-64,64l22.56,22.56l36.8-36.64v153.44h32v-153.44l36.64,36.64l22.56-22.56l-64-64
     C261.354,247.46,251.276,247.46,245.035,253.664z"
            />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  ),

  svgs_addProfileIcon: ({
    width = 16,
    height = 16,
    fill = "white",
    strokeFill = "white",
  }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill={fill}>
      <path
        d="M8 4V12"
        stroke={strokeFill}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 8H12"
        stroke={strokeFill}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  svgs_verifiedIcon: ({ width = 16, height = 16, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.3148 6.74529C11.6077 6.45239 11.6077 5.97752 11.3148 5.68463C11.0219 5.39174 10.547 5.39174 10.2541 5.68463L7.00076 8.93805L5.80377 7.74106C5.51087 7.44816 5.036 7.44816 4.74311 7.74106C4.45021 8.03395 4.45021 8.50882 4.74311 8.80171L6.47043 10.529C6.61108 10.6697 6.80185 10.7487 7.00076 10.7487C7.19968 10.7487 7.39044 10.6697 7.53109 10.529L11.3148 6.74529Z"
        fill="#448BF4"
      />
    </svg>
  ),

  svgs_dragableIcon: ({ width = 8, height = 16, fill = "#82828290" }) => <svg width={width} height={height} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M0 96C0 69.49 21.49 48 48 48C74.51 48 96 69.49 96 96C96 122.5 74.51 144 48 144C21.49 144 0 122.5 0 96zM0 256C0 229.5 21.49 208 48 208C74.51 208 96 229.5 96 256C96 282.5 74.51 304 48 304C21.49 304 0 282.5 0 256zM96 416C96 442.5 74.51 464 48 464C21.49 464 0 442.5 0 416C0 389.5 21.49 368 48 368C74.51 368 96 389.5 96 416zM160 96C160 69.49 181.5 48 208 48C234.5 48 256 69.49 256 96C256 122.5 234.5 144 208 144C181.5 144 160 122.5 160 96zM256 256C256 282.5 234.5 304 208 304C181.5 304 160 282.5 160 256C160 229.5 181.5 208 208 208C234.5 208 256 229.5 256 256zM160 416C160 389.5 181.5 368 208 368C234.5 368 256 389.5 256 416C256 442.5 234.5 464 208 464C181.5 464 160 442.5 160 416z"/></svg>,
  svgs_poplBlackTextIcon: ({ width = 60, height = 33, fill = "none" }) => <svg width={width} height={height} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 33"><path fillRule="evenodd" clipRule="evenodd" d="M59.9906 23.5561V12.796V2.0563C59.9906 1.85289 59.9906 1.62915 59.97 1.42575C59.8878 0.57145 59.189 -0.0387612 58.3874 0.00191951C57.6063 0.0426003 57.0103 0.652812 56.9486 1.48677V2.0563V23.4137C56.9486 23.6578 56.9486 23.8815 56.9692 24.1256C57.0308 24.9596 57.6269 25.5087 58.4696 25.5087C59.2918 25.5087 59.9084 24.9392 59.9906 24.1256C60.0044 24.0028 59.9997 23.8709 59.9951 23.7421C59.9928 23.6789 59.9906 23.6164 59.9906 23.5561ZM42.2724 9.70443C47.3903 6.75508 54.0087 10.0095 54.8925 15.7862C55.5502 20.1594 52.6316 24.6343 47.7809 25.3869C45.6021 25.7326 43.5468 25.3462 41.7175 24.0647L41.7174 24.0647L41.7174 24.0647L41.7174 24.0647C41.553 23.9426 41.3886 23.8206 41.2036 23.6986C41.0597 23.5969 40.9775 23.6579 40.9775 23.8207V24.3902V30.472C40.9775 30.7567 40.9775 31.0415 40.8953 31.3059C40.7103 31.9771 39.9909 32.445 39.3127 32.3636C38.5933 32.2822 37.9972 31.6924 37.9355 30.9601V30.472V23.4749C37.9355 22.8414 37.9322 22.2079 37.9288 21.5745C37.9204 19.9908 37.9121 18.4072 37.9561 16.8236C38.0383 13.6708 39.5387 11.2706 42.2724 9.70443ZM40.9775 17.0473C40.957 19.9967 43.4029 22.4782 46.4037 22.4578C49.754 22.4578 51.9533 19.6916 51.8711 17.1083C51.9533 14.22 49.5074 11.6978 46.4654 11.6978C43.444 11.6978 40.9981 14.0776 40.9775 17.0473ZM26.4221 12.9574C26.7509 12.876 26.9359 12.5303 26.8331 12.2049L26.0522 9.0728C25.97 8.74739 25.6206 8.56435 25.2918 8.66604L24.6136 8.86942C24.2847 8.95077 24.0998 9.29652 24.2025 9.62192L25.2507 12.6726C25.3329 12.998 25.6822 13.1811 26.0111 13.0794L26.4221 12.9574ZM30.1639 12.9992C30.0201 13.3043 29.6501 13.4467 29.3419 13.3043L28.9514 13.1416C28.6431 12.9992 28.4993 12.6331 28.6431 12.3281L29.8762 9.33837C30.0201 9.0333 30.39 8.89093 30.6983 9.0333L31.3559 9.31803C31.6642 9.4604 31.8081 9.80614 31.6642 10.1316L30.1639 12.9992ZM23.7699 13.8122C24.0576 13.9952 24.1193 14.3817 23.9343 14.6664L23.6877 15.0122C23.5027 15.2969 23.1123 15.3579 22.8245 15.1749L20.0501 13.4665C19.7624 13.2834 19.7007 12.897 19.8857 12.6123L20.2761 12.0225C20.4611 11.7377 20.8516 11.6767 21.1393 11.8598L23.7699 13.8122ZM22.4754 16.8851C22.8042 16.8445 23.1125 17.0885 23.1536 17.4139L23.1947 17.8207C23.2358 18.1461 22.9892 18.4512 22.6604 18.4918L19.4338 18.98C19.1049 19.0206 18.7967 18.7766 18.7556 18.4512L18.6734 17.7597C18.6322 17.4343 18.8789 17.1292 19.2077 17.0885L22.4754 16.8851ZM24.3049 20.0565C24.0583 19.8328 23.6678 19.8532 23.4418 20.0972L21.0989 22.3344C20.8728 22.5785 20.8934 22.9649 21.14 23.1886L21.6538 23.6767C21.9004 23.9004 22.2909 23.8801 22.517 23.636L24.6543 21.1955C24.8804 20.9514 24.8598 20.565 24.6132 20.3413L24.3049 20.0565ZM26.3189 21.9272C26.3395 21.5814 26.6272 21.3373 26.9766 21.3577L27.4081 21.378C27.7575 21.3984 28.0041 21.6831 27.9836 22.0288L27.9219 25.2626C27.9014 25.6083 27.6137 25.8524 27.2643 25.8321L26.5655 25.7914C26.2162 25.771 25.9695 25.4863 25.9901 25.1406L26.3189 21.9272ZM29.6496 20.7276C29.3619 20.931 29.3003 21.3174 29.5058 21.5818L31.2938 24.2868C31.4993 24.5715 31.8898 24.6325 32.1569 24.4291L32.7324 24.0224C33.0201 23.819 33.0817 23.4326 32.8762 23.1682L30.8622 20.6259C30.6567 20.3412 30.2662 20.2802 29.999 20.4836L29.6496 20.7276ZM31.8478 19.1608C31.519 19.0794 31.3135 18.754 31.3957 18.4286L31.4985 18.0218C31.5807 17.6964 31.9095 17.4931 32.2383 17.5744L35.4444 18.2252C35.7732 18.3066 35.9787 18.632 35.8965 18.9574L35.7321 19.6489C35.6499 19.9743 35.3211 20.1777 34.9922 20.0963L31.8478 19.1608ZM31.2928 15.4812C31.4366 15.7863 31.8066 15.9083 32.1148 15.7659L35.1359 14.5253C35.4442 14.3829 35.5675 14.0169 35.4236 13.7118L35.1154 13.0813C34.9715 12.7762 34.6016 12.6542 34.2933 12.7966L31.3955 14.2813C31.0873 14.4236 30.964 14.7897 31.1078 15.0948L31.2928 15.4812ZM4.35029 9.72347C9.46821 6.77412 16.0866 10.0082 16.9704 15.8052C17.6281 20.1581 14.7095 24.633 9.83818 25.4059C7.65947 25.7517 5.58353 25.3449 3.73368 24.0431C3.65146 23.9922 3.57438 23.9363 3.49731 23.8804C3.42023 23.8244 3.34315 23.7685 3.26094 23.7176C3.11706 23.6159 3.0554 23.6973 3.0554 23.8397V24.4092V30.491C3.0554 30.7758 3.0554 31.0605 2.97318 31.3249C2.7882 32.0165 2.06881 32.464 1.39053 32.3826C0.671147 32.3013 0.0750846 31.7114 0.0134229 30.9792V30.491V23.4939C0.0134229 22.8604 0.0100672 22.227 0.00671147 21.5935C-0.00167787 20.0099 -0.0100672 18.4262 0.0339768 16.8426C0.116192 13.6898 1.61663 11.2897 4.35029 9.72347ZM3.07595 17.0257C3.03484 19.9954 5.48076 22.4565 8.48162 22.4565C11.8525 22.4565 14.0312 19.6903 13.949 17.107C14.0312 14.1983 11.5853 11.6761 8.56384 11.6761C5.54242 11.6761 3.09651 14.056 3.07595 17.0257Z" fill="black"/>
  </svg>,
  svgs_poplBlackIcon: ({ width, height, fill = "none" }) => <svg width={width} height={height} viewBox="0 0 28 28" fill={fill}>
    <rect width="28" height="28" rx="14" fill="black"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M18.7791 11.3339C17.713 11.4445 16.8558 12.2123 16.5793 13.3043C16.4846 13.6784 16.4846 14.2079 16.5793 14.582C16.7337 15.1918 17.0462 15.6794 17.5168 16.0446C18.6727 16.9417 20.3444 16.6359 21.1263 15.3843C22.0511 13.9038 21.3512 11.9188 19.732 11.4301C19.5588 11.3778 18.9987 11.2886 18.9776 11.3099C18.9756 11.312 18.8863 11.3227 18.7791 11.3339ZM9.561 11.3752C9.16511 11.4684 8.85004 11.6201 8.52854 11.8725C8.09708 12.2111 7.79249 12.6858 7.64009 13.2572C7.54636 13.6086 7.53306 13.9859 7.54101 16.0727L7.54859 18.067L7.65882 18.1818C7.76567 18.2931 7.77481 18.2969 7.95743 18.3053C8.17978 18.3156 8.29393 18.2674 8.38549 18.1246C8.44436 18.0329 8.44444 18.0312 8.44444 16.936V15.8393L8.52883 15.9219C8.80501 16.1922 9.19986 16.4104 9.57687 16.5012C9.91957 16.5836 10.426 16.5662 10.7684 16.4601C11.65 16.1869 12.2788 15.5103 12.5139 14.582C12.6086 14.2079 12.6086 13.6784 12.5139 13.3043C12.2789 12.3762 11.6515 11.701 10.7684 11.4258C10.5673 11.3631 10.4787 11.3518 10.1323 11.3442C9.84523 11.338 9.68136 11.3468 9.561 11.3752ZM15.3775 11.4563C14.4968 11.6531 13.7889 12.2964 13.5033 13.1595C13.3714 13.5582 13.3524 13.7977 13.3523 15.0683L13.3521 16.2206L13.4111 16.3125C13.5026 16.4553 13.6168 16.5035 13.8391 16.4932C14.0217 16.4847 14.0309 16.4809 14.1377 16.3697L14.248 16.2549L14.2611 14.9503C14.273 13.7695 14.2788 13.6328 14.3221 13.5104C14.4125 13.2556 14.5337 13.0508 14.7064 12.8615C14.9915 12.5489 15.3089 12.3863 15.728 12.3384C15.94 12.3141 15.962 12.3057 16.0491 12.215C16.1371 12.1233 16.1431 12.1058 16.1524 11.914C16.1637 11.6801 16.1333 11.5794 16.0213 11.4813C15.9538 11.4221 15.9214 11.4145 15.7455 11.4164C15.636 11.4176 15.4704 11.4356 15.3775 11.4563ZM19.5287 12.3173C19.9431 12.4633 20.2848 12.7677 20.4651 13.1513C20.6026 13.4438 20.6487 13.6428 20.6487 13.9431C20.6487 14.6911 20.2166 15.3192 19.5279 15.5721C19.3641 15.6322 19.2937 15.6421 19.0258 15.6426C18.7683 15.643 18.6849 15.6325 18.5454 15.5819C18.0313 15.3956 17.6854 15.0538 17.4891 14.5382C17.4216 14.3609 17.417 14.3231 17.417 13.9431C17.417 13.5632 17.4216 13.5254 17.4891 13.3481C17.6194 13.0059 17.823 12.7322 18.0988 12.5284C18.2422 12.4225 18.5545 12.2872 18.7317 12.2541C18.9538 12.2127 19.3127 12.2412 19.5287 12.3173ZM10.6059 12.3408C10.9985 12.4918 11.3268 12.7844 11.5054 13.1425C11.6425 13.4175 11.6903 13.6244 11.6903 13.9431C11.6903 14.2619 11.6425 14.4687 11.5054 14.7438C11.3267 15.1021 10.9978 15.3952 10.6059 15.5452C10.3694 15.6357 9.9625 15.6582 9.70454 15.5948C9.38858 15.5173 9.15844 15.3823 8.92238 15.1361C8.69031 14.894 8.557 14.6524 8.4804 14.3353C8.41886 14.0805 8.44197 13.6286 8.52914 13.3821C8.71921 12.8447 9.15504 12.4323 9.67816 12.2946C9.91887 12.2313 10.381 12.2543 10.6059 12.3408Z" fill="white"/>
  </svg>,

  svgs_connectWithMePreviewPhoneIcon: ({
    width = 20,
    height = 20,
    fill = "none",
  }) => (
    <svg width={width} height={height} viewBox="0 0 22 18">
      <path
        d="M12.8745 17.6666C17.6232 17.6666 21.5705 13.7193 21.5705 8.97053C21.5705 4.21328 17.6147 0.274474 12.8659 0.274474C8.42414 0.274474 4.71553 3.69322 4.2381 8.01567C4.65585 7.93894 5.26116 7.90484 5.71301 7.95599C6.18192 4.41789 9.18291 1.72382 12.8659 1.72382C16.8815 1.72382 20.1212 4.94647 20.1212 8.97053C20.1212 10.8462 19.4221 12.5513 18.2541 13.8216C17.4186 12.8241 15.4407 11.8692 12.8659 11.8692C12.0475 11.8692 11.2972 11.9715 10.6237 12.1335C10.726 12.5427 10.7772 12.9861 10.7772 13.4209C10.7772 14.7509 10.2912 15.9871 9.47278 16.9504C10.5214 17.4108 11.6724 17.6666 12.8745 17.6666ZM12.8659 10.4199C14.5029 10.4369 15.7902 9.03874 15.7902 7.20574C15.7902 5.48358 14.4943 4.05982 12.8659 4.05982C11.229 4.05982 9.92464 5.48358 9.94169 7.20574C9.95021 9.03874 11.2205 10.4028 12.8659 10.4199ZM5.27821 17.7604C7.62274 17.7604 9.60919 15.7995 9.60919 13.4294C9.60919 11.0508 7.65684 9.09842 5.27821 9.09842C2.90811 9.09842 0.947234 11.0593 0.947234 13.4294C0.947234 15.8165 2.90811 17.7604 5.27821 17.7604ZM2.56709 13.4294C2.56709 13.1139 2.78023 12.9093 3.08715 12.9093H4.75815V11.2383C4.75815 10.9314 4.96277 10.7183 5.27821 10.7183C5.59366 10.7183 5.79827 10.9314 5.79827 11.2383V12.9093H7.46928C7.7762 12.9093 7.98934 13.1139 7.98934 13.4294C7.98934 13.7448 7.7762 13.9495 7.46928 13.9495H5.79827V15.6205C5.79827 15.9359 5.59366 16.1405 5.27821 16.1405C4.96277 16.1405 4.75815 15.9359 4.75815 15.6205V13.9495H3.08715C2.78023 13.9495 2.56709 13.7448 2.56709 13.4294Z"
        fill={fill}
      />
    </svg>
  ),

  svgs_popIcon: ({ width = 16, height = 16, fill = "none" }) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M9.71348 21.6633C9.99328 20.4938 10.2731 19.3223 10.5436 18.1509C10.7189 17.4001 10.5436 17.1063 9.77131 16.861C9.21171 16.682 8.82652 16.8834 8.58029 17.5475C8.16153 18.6751 7.76701 19.812 7.36783 20.948C7.19902 21.4283 7.32959 21.82 7.77914 22.0737C7.92567 22.1572 8.07997 22.2262 8.23987 22.2798C8.77895 22.4552 9.51296 22.4766 9.71348 21.6633Z"
          fill="#828282"
        />
        <path
          d="M3.68619 18.3765C4.64123 17.6447 5.59317 16.9088 6.542 16.1689C7.1501 15.6961 7.19487 15.3556 6.75372 14.6767C6.43008 14.1851 6.00759 14.0993 5.39669 14.4603C4.36144 15.0768 3.3383 15.7138 2.31424 16.3443C1.88055 16.6119 1.73599 16.9971 1.92532 17.4784C1.98655 17.6354 2.06308 17.7859 2.15382 17.9279C2.4616 18.4026 3.0156 18.8792 3.68619 18.3765Z"
          fill="#828282"
        />
        <path
          d="M1.30497 11.9085C2.50562 11.9812 3.70658 12.0496 4.90785 12.1137C5.67823 12.1556 5.93378 11.9271 6.04383 11.1278C6.12218 10.5449 5.8573 10.2026 5.1606 10.0749C3.97705 9.85941 2.78884 9.66821 1.60156 9.47422C1.09792 9.39214 0.735113 9.58894 0.563503 10.0767C0.505358 10.235 0.463178 10.3987 0.437594 10.5654C0.358317 11.126 0.465574 11.8488 1.30497 11.9085Z"
          fill="#828282"
        />
        <path
          d="M3.62917 5.49367C4.50028 6.32374 5.37325 7.15008 6.24809 7.97269C6.80769 8.50151 7.15277 8.49405 7.75154 7.95217C8.1871 7.55672 8.20575 7.12397 7.75154 6.57743C6.98583 5.64943 6.19959 4.73728 5.41989 3.82421C5.08786 3.43715 4.68401 3.35321 4.23913 3.61529C4.09353 3.69974 3.95669 3.79847 3.83063 3.91001C3.41279 4.28774 3.0276 4.90889 3.62917 5.49367Z"
          fill="#828282"
        />
        <path
          d="M9.54015 1.96721C9.67321 3.16289 9.81093 4.35794 9.95332 5.55237C10.0466 6.31809 10.3115 6.53353 11.1182 6.50369C11.7058 6.48131 11.9986 6.1614 12.0052 5.45351C12.0154 4.25038 12.0005 3.04631 11.9884 1.84317C11.9884 1.33394 11.7282 1.00937 11.2189 0.923564C11.0529 0.895391 10.8846 0.883211 10.7162 0.88719C10.1501 0.904911 9.45621 1.13341 9.54015 1.96721Z"
          fill="#828282"
        />
        <path
          d="M16.0105 2.93633C15.3477 3.94237 14.6876 4.94964 14.0304 5.95816C13.6089 6.60356 13.676 6.94026 14.3102 7.43457C14.7766 7.79364 15.2056 7.73582 15.6644 7.19674C16.4432 6.27993 17.2024 5.34634 17.9644 4.4146C18.288 4.02009 18.2992 3.60785 17.9644 3.2152C17.8553 3.08688 17.7338 2.96973 17.6016 2.86545C17.1614 2.51663 16.4805 2.24616 16.0105 2.93633Z"
          fill="#828282"
        />
        <path
          d="M20.5729 8.06601C19.4276 8.43907 18.2842 8.81214 17.1426 9.1852C16.4104 9.42676 16.2519 9.73174 16.444 10.5161C16.583 11.0878 16.9551 11.3107 17.65 11.1755C18.8307 10.9451 20.0068 10.6896 21.1838 10.4378C21.6819 10.3314 21.9486 10.0153 21.9299 9.49951C21.9248 9.33118 21.9032 9.16375 21.8656 8.9996C21.7313 8.45306 21.3731 7.81885 20.5729 8.06601Z"
          fill="#828282"
        />
        <path
          d="M20.7523 14.9341C19.6331 14.4988 18.5108 14.0657 17.3854 13.6349C16.6654 13.3551 16.3501 13.4959 16.0022 14.2243C15.7495 14.7559 15.8968 15.1635 16.5199 15.4974C17.5812 16.0654 18.6538 16.6119 19.7245 17.1603C20.1787 17.3926 20.5844 17.3161 20.8969 16.9057C20.999 16.7719 21.0881 16.6285 21.1627 16.4776C21.4098 15.9674 21.5301 15.2474 20.7523 14.9341Z"
          fill="#828282"
        />
        <path
          d="M16.482 20.3136C16.8737 21.0541 16.316 21.5261 15.7984 21.7564C15.6441 21.824 15.4835 21.8762 15.319 21.9122C14.8153 22.0241 14.4562 21.8189 14.2595 21.3526C13.7931 20.2427 13.3268 19.1338 12.8847 18.0155C12.6236 17.3571 12.7747 16.9504 13.3109 16.7098C14.0468 16.3768 14.376 16.4757 14.7482 17.151"
          fill="#828282"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="22.2907"
            height="22.6637"
            fill="white"
            transform="matrix(1 0 0 -1 0 22.8953)"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  svgs_arrowDownSort: ({ width = 16, height = 16, fill = "none" }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill={fill}>
      <path
        d="M8 3.33325V12.6666"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 10L8 12.6667"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33334 10L8.00001 12.6667"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  svgs_editAccountDots: ({ width = 16, height = 16, fill = "#828282" }) => (
    <svg
      className="stop"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="stop"
        cx="8"
        cy="13"
        r="1"
        transform="rotate(-90 8 13)"
        fill={fill}
        stroke={fill}
      />
      <circle
        className="stop"
        cx="8"
        cy="8"
        r="1"
        transform="rotate(-90 8 8)"
        fill={fill}
        stroke={fill}
      />
      <circle
        className="stop"
        cx="8"
        cy="3"
        r="1"
        transform="rotate(-90 8 3)"
        fill={fill}
        stroke={fill}
      />
    </svg>
  ),
  svgs_settingsGear: ({ width = 16, height = 16, strokeFill = "#818181" }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.06944 3.73167C7.30611 2.75611 8.69389 2.75611 8.93056 3.73167C8.96607 3.87822 9.03568 4.01432 9.13373 4.12889C9.23178 4.24346 9.35549 4.33325 9.49481 4.39097C9.63412 4.44869 9.78509 4.4727 9.93544 4.46104C10.0858 4.44938 10.2312 4.40239 10.36 4.32389C11.2172 3.80167 12.1989 4.78278 11.6767
          5.64056C11.5983 5.76925 11.5514 5.91463 11.5397 6.06487C11.5281 6.21512 11.5521 6.36598 11.6097 6.50521C11.6674 6.64444 11.7571 6.7681 11.8715 6.86614C11.986 6.96418 12.1219 7.03384 12.2683 7.06944C13.2439 7.30611 13.2439 8.69389 12.2683 8.93056C12.1218 8.96607 11.9857 9.03568 11.8711 9.13373C11.7565
          9.23178 11.6667 9.35549 11.609 9.49481C11.5513 9.63412 11.5273 9.78509 11.539 9.93544C11.5506 10.0858 11.5976 10.2312 11.6761 10.36C12.1983 11.2172 11.2172 12.1989 10.3594 11.6767C10.2307 11.5983 10.0854 11.5514 9.93513 11.5397C9.78488 11.5281 9.63402 11.5521 9.49479 11.6097C9.35556 11.6674 9.2319 11.7571
          9.13386 11.8715C9.03582 11.986 8.96616 12.1219 8.93056 12.2683C8.69389 13.2439 7.30611 13.2439 7.06944 12.2683C7.03393 12.1218 6.96432 11.9857 6.86627 11.8711C6.76822 11.7565 6.64451 11.6667 6.50519 11.609C6.36588 11.5513 6.21491 11.5273 6.06456 11.539C5.91422 11.5506 5.76875 11.5976 5.64 11.6761C4.78278 12.1983
          3.80111 11.2172 4.32333 10.3594C4.40172 10.2307 4.44864 10.0854 4.46027 9.93513C4.4719 9.78488 4.44791 9.63402 4.39026 9.49479C4.33261 9.35556 4.24292 9.2319 4.12848 9.13386C4.01405 9.03582 3.87809 8.96616 3.73167 8.93056C2.75611 8.69389 2.75611 7.30611 3.73167
          7.06944C3.87822 7.03393 4.01432 6.96432 4.12889 6.86627C4.24346 6.76822 4.33325 6.64451 4.39097 6.50519C4.44869 6.36588 4.4727 6.21491 4.46104 6.06456C4.44938 5.91422 4.40239 5.76875 4.32389 5.64C3.80167 4.78278 4.78278 3.80111 5.64056 4.32333C6.19611 4.66111 6.91611 4.36222 7.06944 3.73167Z"
        stroke={strokeFill}
        strokeWidth={1}
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M8.00016 9.66536C8.92064 9.66536 9.66683 8.91917 9.66683 7.9987C9.66683 7.07822 8.92064 6.33203 8.00016 6.33203C7.07969 6.33203 6.3335 7.07822 6.3335 7.9987C6.3335 8.91917 7.07969 9.66536 8.00016 9.66536Z"
        stroke={strokeFill}
        strokeWidth={1}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  svgs_settings: ({ fill, width, height }) => (
    <svg
      height={height}
      width={width}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 42.5 42.5"
    >
      <g>
        <g>
          <path
            fill={fill}
            d="M28.4,24.5c-0.1-0.6-0.7-1-1.3-0.9l-1.9,0.2c-0.4-0.8-0.9-1.4-1.5-2.1l0.8-1.7c0.3-0.6,0.1-1.2-0.4-1.5
       l-2.4-1.5c-0.5-0.3-1.2-0.2-1.6,0.3L19,18.8c-0.9-0.3-1.8-0.4-2.7-0.4l-0.6-1.7c-0.2-0.6-0.8-0.9-1.4-0.7l-2.8,0.7
       c-0.6,0.1-1,0.7-0.9,1.3l0.2,1.7c-0.8,0.4-1.6,1-2.2,1.6L7,20.6c-0.6-0.3-1.2-0.1-1.5,0.5l-1.5,2.4c-0.3,0.5-0.2,1.2,0.3,1.6
       l1.3,1c-0.3,0.9-0.4,1.7-0.5,2.6l-1.6,0.6c-0.6,0.2-0.9,0.8-0.8,1.4l0.6,2.7c0.1,0.6,0.7,1,1.3,0.9L6.2,34c0.4,0.8,1,1.6,1.6,2.3
       l-0.7,1.5c-0.3,0.6-0.1,1.2,0.4,1.5l2.4,1.5c0.5,0.3,1.2,0.2,1.6-0.3l1-1.3c0.9,0.3,1.9,0.4,2.9,0.4l0.6,1.5
       c0.2,0.6,0.8,0.9,1.4,0.7l2.8-0.7c0.6-0.1,1-0.7,0.9-1.3L21,38.2c0.8-0.4,1.5-1,2.2-1.6l1.6,0.7c0.6,0.3,1.2,0.1,1.5-0.5l1.5-2.4
       c0.3-0.5,0.2-1.2-0.3-1.6l-1.5-1.1c0.2-0.8,0.4-1.6,0.4-2.4l1.8-0.6c0.6-0.2,0.9-0.8,0.8-1.4L28.4,24.5z M19.7,31.4
       c-1.4,2.2-4.3,2.9-6.5,1.6c-2.2-1.3-2.9-4.2-1.5-6.4c1.4-2.2,4.3-2.9,6.5-1.6C20.5,26.3,21.1,29.2,19.7,31.4z M39.8,8.2l-0.4-1.8
       C39.3,6,39,5.7,38.5,5.8L37.3,6c-0.3-0.5-0.6-1-1-1.4l0.6-1.1c0.2-0.4,0.1-0.8-0.3-1l-1.6-1c-0.3-0.2-0.8-0.1-1.1,0.2l-0.8,1
       c-0.6-0.2-1.2-0.3-1.8-0.3l-0.4-1.1c-0.1-0.4-0.5-0.6-0.9-0.5L28,1.1c-0.4,0.1-0.7,0.5-0.6,0.9l0.1,1.2c-0.5,0.3-1.1,0.6-1.5,1.1
       l-1-0.5c-0.4-0.2-0.8,0-1,0.3l-1,1.6c-0.2,0.3-0.1,0.8,0.2,1l0.9,0.7c-0.2,0.6-0.3,1.2-0.3,1.8l-1.1,0.4c-0.4,0.1-0.6,0.5-0.5,0.9
       l0.4,1.8c0.1,0.4,0.5,0.7,0.9,0.6l1.1-0.1c0.3,0.6,0.7,1.1,1.1,1.5l-0.5,1c-0.2,0.4-0.1,0.8,0.3,1l1.6,1c0.3,0.2,0.8,0.1,1.1-0.2
       l0.7-0.9c0.6,0.2,1.3,0.3,1.9,0.3l0.4,1c0.1,0.4,0.5,0.6,0.9,0.5l1.9-0.4c0.4-0.1,0.7-0.5,0.6-0.9l-0.1-1.2c0.5-0.3,1-0.7,1.5-1.1
       l1.1,0.5c0.4,0.2,0.8,0,1-0.3l1-1.6c0.2-0.3,0.1-0.8-0.2-1l-1-0.8c0.2-0.5,0.2-1.1,0.3-1.6l1.2-0.4C39.7,9,39.9,8.6,39.8,8.2z
        M33.6,11c-0.9,1.5-2.9,1.9-4.4,1c-1.5-0.9-1.9-2.8-1-4.3c0.9-1.5,2.9-1.9,4.4-1C34,7.6,34.5,9.5,33.6,11z"
          />
        </g>
      </g>
    </svg>
  ),
  svgs_filterIcon: ({
    width = 16, height = 16, fill = "none", strokeFill = "#828282",
  }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M19.25 4.75H4.75L9.31174 10.4522C9.59544 10.8068 9.75 11.2474 9.75 11.7016V18.25C9.75 18.8023 10.1977 19.25 10.75 19.25H13.25C13.8023 19.25 14.25 18.8023 14.25 18.25V11.7016C14.25 11.2474 14.4046 10.8068 14.6883 10.4522L19.25 4.75Z" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),

  svgs_triangleArrow: ({ width = 10, height = 6, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 6"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 0L10 6L0 6L5 0Z" fill={fill} />
    </svg>
  ),

  svgs_alert: ({ width = 16, height = 17, fill = "#EB5757" }) => (
    <svg width={width} height={height} viewBox="0 0 16 17" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.59246 2.93905C7.21781 1.85511 8.78222 1.85512 9.40757 2.93905L15.1762 12.9379C15.8012 14.0213 15.0193 15.375 13.7686 15.375H2.23143C0.980734 15.375 0.198875 14.0213 0.823875 12.9379L6.59246 2.93905ZM8.70605 10.3404C8.68646 10.8057 8.45136 11.0383 8.00074 11.0383C7.53544 11.0383 7.29299 10.8082 7.2734 10.3478L7.17054 7.35776C7.16074 7.12267 7.23176 6.93166 7.3836 6.78473C7.54034 6.6329 7.7436 6.55699 7.9934 6.55699C8.23829 6.55699 8.43911 6.6329 8.59585 6.78473C8.75258 6.93166 8.82605 7.12512 8.81625 7.3651L8.70605 10.3404ZM8.63258 13.1835C8.46115 13.3305 8.25054 13.4039 8.00074 13.4039C7.75095 13.4039 7.53789 13.328 7.36156 13.1762C7.18523 13.0244 7.09707 12.8284 7.09707 12.5885C7.09707 12.3436 7.18278 12.1452 7.35421 11.9934C7.53054 11.8416 7.74605 11.7657 8.00074 11.7657C8.25054 11.7657 8.46115 11.8416 8.63258 11.9934C8.80891 12.1452 8.89707 12.3436 8.89707 12.5885C8.89707 12.8333 8.80891 13.0317 8.63258 13.1835Z" fill={fill}/>
    </svg>
  ),

  svgs_viewAllArrow: () => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 9L7 6L4 3"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  svgs_playBtn: ({ width = "16", height = "16", fill = "#828282" }) => (
    <svg width={width} height={height} viewBox="-1 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM6.61126 10.9632C6.55174 10.9877 6.48878 11 6.42239 11C6.29419 11 6.19116 10.9521 6.11332 10.8564C6.03777 10.7607 6 10.6307 6 10.4663V5.53374C6 5.36933 6.03777 5.23926 6.11332 5.14356C6.19116 5.04785 6.29419 5 6.42239 5C6.48878 5 6.55174 5.01227 6.61126 5.03681C6.67308 5.06135 6.73947 5.09693 6.81044 5.14356L10.6188 7.50675C10.7585 7.59018 10.8569 7.66871 10.9141 7.74233C10.9714 7.81595 11 7.90184 11 8C11 8.10061 10.9714 8.18773 10.9141 8.26135C10.8569 8.33252 10.7585 8.40982 10.6188 8.49325L6.81044 10.8564C6.73947 10.9031 6.67308 10.9387 6.61126 10.9632Z" fill={fill}/>
    </svg>
  ),

  svgs_notFoundIcon: () => (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 25C22.7614 25 25 22.7614 25 20C25 17.2386 22.7614 15 20 15C17.2386 15 15 17.2386 15 20C15 22.7614 17.2386 25 20 25Z"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 26L24 24"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" stroke="#E0E0E0" />
    </svg>
  ),

  svgs_logoutIcon: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4H5.33333C4.97971 4 4.64057 4.15804 4.39052 4.43934C4.14048 4.72064 4 5.10218 4 5.5V14.5C4 14.8978 4.14048 15.2794 4.39052 15.5607C4.64057 15.842 4.97971 16 5.33333 16H10"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10H16.4987M16.4987 10L13.9987 7.5M16.4987 10L13.9987 12.5"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  svgs_teamSettings: ({ strokeFill = "#828282", width = "20", height = "20" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.60417 3.5975C8.95917 2.13417 11.0408 2.13417 11.3958 3.5975C11.4491 3.81733 11.5535 4.02148 11.7006 4.19333C11.8477
4.36518 12.0332 4.49988 12.2422 4.58645C12.4512 4.67303 12.6776 4.70904 12.9032 4.69156C13.1287 4.67407 13.3469 4.60359 13.54
4.48583C14.8258 3.7025 16.2983 5.17417 15.515 6.46083C15.3974 6.65388 15.327 6.87195 15.3096 7.09731C15.2922 7.32267 15.3281 7.54897
15.4146 7.75782C15.5011 7.96666 15.6356 8.15215 15.8073 8.29921C15.9789 8.44627 16.1829 8.55075 16.4025 8.60417C17.8658 8.95917 17.8658
11.0408 16.4025 11.3958C16.1827 11.4491 15.9785 11.5535 15.8067 11.7006C15.6348 11.8477 15.5001 12.0332 15.4135 12.2422C15.327 12.4512
15.291 12.6776 15.3084 12.9032C15.3259 13.1287 15.3964 13.3469 15.5142 13.54C16.2975 14.8258 14.8258 16.2983 13.5392 15.515C13.3461 15.3974
13.1281 15.327 12.9027 15.3096C12.6773 15.2922 12.451 15.3281 12.2422 15.4146C12.0333 15.5011 11.8479 15.6356 11.7008 15.8073C11.5537 15.9789
11.4492 16.1829 11.3958 16.4025C11.0408 17.8658 8.95917 17.8658 8.60417 16.4025C8.5509 16.1827 8.44648 15.9785 8.29941 15.8067C8.15233 15.6348
7.96676 15.5001 7.75779 15.4135C7.54882 15.327 7.32236 15.291 7.09685 15.3084C6.87133 15.3259 6.65313 15.3964 6.46 15.5142C5.17417 16.2975 3.70167
14.8258 4.485 13.5392C4.60258 13.3461 4.67296 13.1281 4.6904 12.9027C4.70785 12.6773 4.67187 12.451 4.58539 12.2422C4.49892 12.0333 4.36438 11.8479
4.19273 11.7008C4.02107 11.5537 3.81714 11.4492 3.5975 11.3958C2.13417 11.0408 2.13417 8.95917 3.5975 8.60417C3.81733 8.5509 4.02148 8.44648
4.19333 8.29941C4.36518 8.15233 4.49988 7.96676 4.58645 7.75779C4.67303 7.54882 4.70904 7.32236 4.69156 7.09685C4.67407 6.87133 4.60359 6.65313
4.48583 6.46C3.7025 5.17417 5.17417 3.70167 6.46083 4.485C7.29417 4.99167 8.37417 4.54333 8.60417
3.5975Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929
12.5 10 12.5Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  svgs_paymentIcon: ({ fill = "#828282", width = "20", height = "20" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 4.16699H5C3.61929 4.16699 2.5 5.28628 2.5 6.66699V13.3337C2.5 14.7144 3.61929 15.8337 5 15.8337H15C16.3807 15.8337 17.5
14.7144 17.5 13.3337V6.66699C17.5 5.28628 16.3807 4.16699 15 4.16699Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 8.33301H17.5"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83325 12.5H5.84159"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16675 12.5H10.8334"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  svgs_question: ({ fill = "#828282", width = "20", height = "20" }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421
5.85786 17.5 10 17.5Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14.167V14.1753"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0004 11.25C9.98506 10.9795 10.058 10.7113 10.2083 10.4858C10.3586 10.2604 10.5781 10.0899 10.8337 9.99998C11.147
9.88019 11.4281 9.68934 11.655 9.44244C11.882 9.19554 12.0485 8.89933 12.1415 8.57713C12.2345 8.25494 12.2515 7.91555 12.191
7.5857C12.1306 7.25584 11.9944 6.94452 11.7932 6.67624C11.592 6.40796 11.3312 6.19005 11.0315 6.03966C10.7317 5.88927 10.4012
5.81051 10.0658 5.80958C9.7305 5.80865 9.39951 5.88557 9.09894 6.0343C8.79838 6.18302 8.53643 6.39948 8.33374
6.66664"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  svgs_support: ({ strokeFill = "#828282", width = "20", height = "20" }) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 14.1667V14.1751" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.0007 11.25C9.98531 10.9795 10.0583 10.7113 10.2086 10.4858C10.3589 10.2604 10.5784 10.0899 10.834 9.99998C11.1472 9.88019 11.4284 9.68934 11.6553 9.44244C11.8822 9.19554 12.0488 8.89933 12.1418 8.57713C12.2348 8.25494 12.2517 7.91555 12.1913 7.5857C12.1308 7.25584 11.9946 6.94452 11.7934 6.67624C11.5922 6.40796 11.3315 6.19005 11.0317 6.03966C10.732 5.88927 10.4014 5.81051 10.0661 5.80958C9.73074 5.80865 9.39976 5.88557 9.09919 6.0343C8.79862 6.18302 8.53668 6.39948 8.33398 6.66664" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),

  svgs_phoneEyeBrowIcon: ({ width = 145, height = 20, fill = "none" }) => (
    <svg width={width} height={height} fill={fill} viewBox="0 0 145 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.516 0H0C2.49419 0 4.51613 2.02194 4.51613 4.51613C4.17977 13.0429 10.8623 19.8833 19.5482 20L20 20H124.516L124.962 20C133.526 19.8833 140.211 13.0429 140 4.51613C140 2.02194 142.022 0 144.516 0Z"
        fill="#E0E0E0"
      />
    </svg>
  ),
  svgs_chevronLeft: ({ width = 30, height = 30, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6L8 10L12 14"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  bw_1: ({ }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.25 8C15.25 9.79493 13.7949 11.25 12 11.25C10.2051 11.25 8.75 9.79493 8.75 8C8.75 6.20507 10.2051 4.75 12 4.75C13.7949 4.75 15.25 6.20507 15.25 8Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.84723 19.25H17.1522C18.2941 19.25 19.1738 18.2681 18.6405 17.2584C17.8561 15.7731 16.0677 14 11.9997 14C7.93174 14 6.14339 15.7731 5.35897 17.2584C4.8257 18.2681 5.70531 19.25 6.84723 19.25Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  bw_2: ({ }) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4864 26.7002C20.601 26.7002 26.4642 20.8234 26.4642 13.7224C26.4642 6.60776 20.5874 0.731044 13.4864 0.731044C6.37176 0.731044 0.508642 6.60776 0.508642 13.7224C0.508642 20.8234 6.38536 26.7002 13.4864 26.7002ZM13.4864 24.8229C7.33761 24.8229 2.38593 19.8712 2.38593 13.7224C2.38593 7.56001 7.324 2.60833 13.4864 2.60833C19.6352 2.60833 24.5869 7.56001 24.6005 13.7224C24.6141 19.8712 19.6488 24.8229 13.4864 24.8229ZM18.6557 9.89981L19.4992 9.04279C19.8937 8.63469 19.9209 8.21298 19.5536 7.84568L19.3223 7.61442C18.9686 7.26073 18.5333 7.30154 18.1388 7.68244L17.2818 8.52586L18.6557 9.89981ZM9.2557 19.2726L17.9483 10.6072L16.5744 9.23324L7.89535 17.8987L7.14716 19.5447C7.02473 19.8304 7.2968 20.0616 7.54166 19.98L9.2557 19.2726Z"
        fill="#828282"
      />
    </svg>
  ),
  bw_3: ({ }) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99163 13.2005L4 16.5143C4 17.3348 4.66518 18 5.48571 18H18.1714C19.1813 18 20 17.1813 20 16.1714L15.293 10.8203C14.9052 10.3795 14.2229 10.366 13.818 10.7911L10 14.8L8.45803 13.1809C8.05667 12.7595 7.38161 12.7685 6.99163 13.2005Z"
        fill="#828282"
      />
      <circle cx="8.5" cy="9.5" r="1.5" fill="#828282" />
      <rect
        x="4"
        y="6"
        width="16"
        height="12"
        rx="2"
        stroke="#828282"
        strokeWidth="1.5"
      />
    </svg>
  ),

  svgs_closeIconImg: ({ width = 48, height = 48, fill = "none" }) => (
    <svg width={width} height={height} viewBox="0 0 48 48" fill={fill}>
      <g filter="url(#filter0_d)">
        <rect x="12" y="8" width="24" height="24" rx="12" fill="white" />
        <path
          d="M21 17L24 20M27 23L24 20M24 20L27 17M24 20L21 23"
          stroke="#828282"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  svgs_profileImageAdd: ({ width = 25, height = 25, fill = "none" }) => (
    <svg width={width} height={height} viewBox="0 0 25 25" fill={fill}>
      <path
        d="M12.5 24.4922C19.0391 24.4922 24.4531 19.0781 24.4531 12.5391C24.4531 6.01172 19.0273 0.585938 12.4883 0.585938C5.96094 0.585938 0.546875 6.01172 0.546875 12.5391C0.546875 19.0781 5.97266 24.4922 12.5 24.4922ZM12.5 16.5352C8.97266 16.5352 6.26562 17.7891 5.07031 19.1953C3.5 17.4375 2.55078 15.1055 2.55078 12.5391C2.55078 7.01953 6.95703 2.57812 12.4883 2.57812C18.0195 2.57812 22.4492 7.01953 22.4609 12.5391C22.4727 15.1172 21.5117 17.4492 19.9297 19.207C18.7461 17.8008 16.0273 16.5352 12.5 16.5352ZM12.5 14.543C14.75 14.5664 16.5195 12.6445 16.5195 10.125C16.5195 7.75781 14.75 5.78906 12.5 5.78906C10.25 5.78906 8.46875 7.75781 8.48047 10.125C8.49219 12.6445 10.25 14.5195 12.5 14.543Z"
        fill="#828282"
      />
    </svg>
  ),
  qrcodescreen_download: ({ width = 20, height = 20, fill = "#828282" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.25 10.2493L4.25 14.9159C4.25 15.2696 4.40804 15.6087 4.68934 15.8587C4.97064 16.1088 5.35218 16.2493 5.75 16.2493L14.75 16.2493C15.1478 16.2493 15.5294 16.1088 15.8107 15.8587C16.092 15.6087 16.25 15.2696 16.25 14.9159L16.25 10.2493"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.25 3.75073L10.25 12.2494M10.25 12.2494L12.75 9.74943M10.25 12.2494L7.75 9.74943"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  qrcodescreen_wallet: ({ width = 18, height = 16, fill = "#828282" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66536 2.66675C1.66536 2.29827 1.96355 2.00008 2.33203 2.00008H15.6654C16.0338 2.00008 16.332 2.29827 16.332 2.66675V3.44715C16.1235 3.37349 15.8991 3.33341 15.6654 3.33341H2.33203C2.09826 3.33341 1.87387 3.37349 1.66536 3.44715V2.66675ZM1.66536 5.33342C1.66536 4.96494 1.96355 4.66675 2.33203 4.66675H15.6654C16.0338 4.66675 16.332 4.96494 16.332 5.33342V6.11381C16.1235 6.04016 15.8991 6.00008 15.6654 6.00008H2.33203C2.09826 6.00008 1.87387 6.04016 1.66536 6.11381V5.33342ZM15.6654 7.33341C16.0338 7.33341 16.332 7.6316 16.332 8.00008V8.66675H12.9987C12.1814 8.66675 11.4347 9.12875 11.0694 9.85941L10.9287 10.1407C10.5627 10.8714 9.81603 11.3334 8.9987 11.3334C8.18136 11.3334 7.4347 10.8714 7.06936 10.1407L6.9287 9.85941C6.5627 9.12875 5.81603 8.66675 4.9987 8.66675H1.66536V8.00008C1.66536 7.6316 1.96355 7.33341 2.33203 7.33341H15.6654ZM0.332031 8.66675V8.00008V5.33342V2.66675C0.332031 1.56189 1.22717 0.666748 2.33203 0.666748H15.6654C16.7702 0.666748 17.6654 1.56189 17.6654 2.66675V5.33342V8.00008V8.66675V10.0001V13.3334C17.6654 14.4381 16.77 15.3334 15.6654 15.3334H2.33203C1.22736 15.3334 0.332031 14.4381 0.332031 13.3334V10.0001V8.66675Z"
        fill={fill}
      />
    </svg>
  ),
  qrcodescreen_share: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7775 11.8006C7.58274 11.8006 3.33462 13.4804 2.89025 15.6557C2.85174 15.8545 2.66873 15.9993 2.45478 16H2.3659C2.2597 15.9999 2.1577 15.9607 2.08151 15.8908C2.0212 15.8102 1.99288 15.7121 2.00152 15.6137C2.31614 10.704 6.5736 6.84886 11.7775 6.76141V4.59454C11.7758 4.48067 11.8241 4.3712 11.9109 4.29219L12.0886 4.12422C12.172 4.04472 12.2856 4 12.4041 4C12.5226 4 12.6362 4.04472 12.7196 4.12422L17.8653 8.98707C17.9513 9.06328 18 9.16967 18 9.28103C18 9.39238 17.9513 9.49878 17.8653 9.57498L12.7196 14.4378C12.6362 14.5173 12.5226 14.5621 12.4041 14.5621C12.2856 14.5621 12.172 14.5173 12.0886 14.4378L11.9109 14.2699C11.8241 14.1909 11.7758 14.0814 11.7775 13.9675V11.8006Z"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  qrcodescreen_mail: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 4.16675H4.16667C3.24619 4.16675 2.5 4.91294 2.5 5.83341V14.1667C2.5 15.0872 3.24619 15.8334 4.16667 15.8334H15.8333C16.7538 15.8334 17.5 15.0872 17.5 14.1667V5.83341C17.5 4.91294 16.7538 4.16675 15.8333 4.16675Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 5.83325L10 10.8333L17.5 5.83325"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  qrcodescreen_message: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16797 2.5H17.5013V9.16667H15.0013L11.668 10.8333V9.16667H9.16797V2.5Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5013 13.3334V16.6667C12.5013 16.8878 12.4135 17.0997 12.2572 17.256C12.1009 17.4123 11.889 17.5001 11.668 17.5001H5.0013C4.78029 17.5001 4.56833 17.4123 4.41205 17.256C4.25577 17.0997 4.16797 16.8878 4.16797 16.6667V5.00008C4.16797 4.77907 4.25577 4.56711 4.41205 4.41083C4.56833 4.25455 4.78029 4.16675 5.0013 4.16675H6.66797"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33203 15V15.0083"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  qrcodeescreen_airDrop: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" fill="white" />
      <path
        d="M1 10.7495C1 11.9433 1.23278 13.0692 1.69835 14.1272C2.16392 15.1851 2.80116 16.1102 3.61009 16.9022C3.74976 17.038 3.88361 17.0324 4.01164 16.8853L4.42192 16.4355C4.53831 16.311 4.5354 16.1837 4.41319 16.0536C3.72648 15.369 3.18235 14.5713 2.7808 13.6604C2.38506 12.7495 2.1872 11.7792 2.1872 10.7495C2.1872 9.70854 2.39088 8.7326 2.79825 7.82172C3.20563 6.90518 3.76722 6.09896 4.48303 5.40307C5.20466 4.70153 6.03686 4.15273 6.97963 3.7567C7.92241 3.36066 8.92919 3.16265 10 3.16265C11.0708 3.16265 12.0776 3.36066 13.0204 3.7567C13.9631 4.15273 14.7924 4.70153 15.5082 5.40307C16.2299 6.09896 16.7944 6.90518 17.2017 7.82172C17.6091 8.7326 17.8128 9.70854 17.8128 10.7495C17.8128 11.7792 17.612 12.7495 17.2105 13.6604C16.8089 14.5713 16.2706 15.3662 15.5955 16.0451C15.4675 16.1809 15.4617 16.311 15.5781 16.4355L15.9884 16.8853C16.1164 17.0324 16.2502 17.038 16.3899 16.9022C17.193 16.1102 17.8274 15.1851 18.2929 14.1272C18.7643 13.0692 19 11.9433 19 10.7495C19 9.55013 18.7672 8.42426 18.3016 7.37193C17.8361 6.31395 17.1901 5.38327 16.3637 4.57989C15.5373 3.77084 14.58 3.14002 13.4918 2.6874C12.4035 2.22913 11.2396 2 10 2C8.76043 2 7.59651 2.22913 6.50824 2.6874C5.41998 3.14002 4.46266 3.77084 3.63628 4.57989C2.80989 5.38327 2.16392 6.31395 1.69835 7.37193C1.23278 8.42426 1 9.55013 1 10.7495ZM3.54025 10.7495C3.54025 11.5756 3.69447 12.3563 4.00291 13.0918C4.31717 13.8216 4.74491 14.4694 5.28613 15.0352C5.4258 15.1823 5.56547 15.1823 5.70514 15.0352L6.11542 14.5939C6.23763 14.4808 6.23472 14.3506 6.10669 14.2035C5.68186 13.7453 5.34724 13.2219 5.10281 12.6335C4.85839 12.0395 4.73618 11.4115 4.73618 10.7495C4.73618 10.048 4.87294 9.38888 5.14646 8.7722C5.41998 8.15552 5.79825 7.61238 6.28128 7.1428C6.76431 6.67321 7.32299 6.30547 7.95732 6.03956C8.59166 5.76799 9.27255 5.63221 10 5.63221C10.7216 5.63221 11.3996 5.76799 12.0339 6.03956C12.6683 6.30547 13.227 6.67321 13.71 7.1428C14.1988 7.61238 14.58 8.15552 14.8535 8.7722C15.1271 9.38888 15.2638 10.048 15.2638 10.7495C15.2638 11.4115 15.1416 12.0395 14.8972 12.6335C14.6528 13.2219 14.3181 13.7424 13.8933 14.1951C13.7711 14.3365 13.7711 14.4694 13.8933 14.5939L14.3036 15.0352C14.4374 15.1823 14.5742 15.1823 14.7139 15.0352C15.2551 14.4694 15.6799 13.8216 15.9884 13.0918C16.3026 12.3563 16.4597 11.5756 16.4597 10.7495C16.4597 9.88959 16.291 9.08054 15.9534 8.32242C15.6217 7.56429 15.1591 6.89669 14.5655 6.31961C13.9719 5.74253 13.2823 5.28992 12.4966 4.96178C11.7168 4.63363 10.8846 4.46956 10 4.46956C9.1096 4.46956 8.27449 4.63363 7.49467 4.96178C6.71484 5.28992 6.02813 5.74253 5.43453 6.31961C4.84093 6.89669 4.37536 7.56429 4.03783 8.32242C3.70611 9.08054 3.54025 9.88959 3.54025 10.7495ZM6.0805 10.7495C6.0805 11.2022 6.15907 11.635 6.3162 12.048C6.47333 12.4553 6.69156 12.8259 6.9709 13.1597C7.09893 13.3125 7.23569 13.3125 7.38118 13.1597L7.80019 12.7354C7.91659 12.6166 7.92532 12.4836 7.82638 12.3365C7.65179 12.1159 7.51503 11.8726 7.4161 11.6067C7.32299 11.3351 7.27643 11.0494 7.27643 10.7495C7.27643 10.2686 7.39864 9.82735 7.64306 9.42566C7.89331 9.02397 8.22502 8.70431 8.63822 8.46669C9.05141 8.22341 9.50533 8.10177 10 8.10177C10.4947 8.10177 10.9486 8.22341 11.3618 8.46669C11.775 8.70431 12.1038 9.02397 12.3482 9.42566C12.5984 9.82735 12.7236 10.2686 12.7236 10.7495C12.7236 11.0494 12.6741 11.3351 12.5752 11.6067C12.4821 11.8726 12.3482 12.1159 12.1736 12.3365C12.0689 12.4836 12.0776 12.6194 12.1998 12.7439L12.6188 13.1597C12.7643 13.3181 12.9011 13.3181 13.0291 13.1597C13.3084 12.8259 13.5267 12.4553 13.6838 12.048C13.8409 11.635 13.9195 11.2022 13.9195 10.7495C13.9195 10.0537 13.742 9.41717 13.387 8.84009C13.032 8.26301 12.5577 7.80191 11.9641 7.4568C11.3763 7.11168 10.7216 6.93912 10 6.93912C9.27837 6.93912 8.62076 7.11168 8.02716 7.4568C7.43938 7.80191 6.96799 8.26301 6.613 8.84009C6.258 9.41717 6.0805 10.0537 6.0805 10.7495Z"
        fill="#828282"
      />
    </svg>
  ),
  brand_library: ({ width = 13, height = 16, fill = "#828282" }) => (
    <svg width={width} height={height} viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.78711 15.5H11.8183C12.0137 15.5 12.175 15.4343 12.3021 15.3029C12.434 15.1764 12.5 15.0158 12.5 14.8212C12.5 14.6606 12.4487 14.5219 12.3461 14.4051C12.2483 14.2883 12.131 14.1959 11.9942 14.1277C11.7108 13.9964 11.5079 13.792 11.3858 13.5146C11.2685 13.2421 11.244 12.9453 11.3125 12.6241C11.3858 12.3029 11.5666 12.0061 11.8549 11.7336C12.0455 11.573 12.1995 11.3929 12.3167 11.1934C12.434 10.9939 12.4927 10.719 12.4927 10.3686V2.80657C12.4927 2.05231 12.2972 1.48054 11.9062 1.09124C11.5202 0.69708 10.9508 0.5 10.1982 0.5H2.79444C2.04673 0.5 1.4774 0.69708 1.08644 1.09124C0.69548 1.48054 0.5 2.05231 0.5 2.80657V13.2226C0.5 13.9672 0.693036 14.5316 1.07911 14.9161C1.47007 15.3054 2.0394 15.5 2.78711 15.5ZM1.97343 10.865V2.92336C1.97343 2.61192 2.05162 2.37591 2.208 2.21533C2.36927 2.04988 2.61118 1.96715 2.93372 1.96715H10.0516C10.379 1.96715 10.6234 2.04988 10.7847 2.21533C10.9459 2.37591 11.0266 2.61192 11.0266 2.92336V10.1423C11.0266 10.4684 10.8555 10.6314 10.5134 10.6314H2.98503C2.78467 10.6314 2.59896 10.6533 2.42792 10.6971C2.26176 10.736 2.11026 10.792 1.97343 10.865ZM3.00703 14.1496C2.63073 14.1496 2.34728 14.0499 2.15669 13.8504C1.9661 13.6509 1.8708 13.3881 1.8708 13.062C1.8708 12.7506 1.97343 12.4951 2.17868 12.2956C2.38882 12.0912 2.6796 11.9891 3.05101 11.9891H9.91234C9.99053 11.9891 10.0614 11.9842 10.1249 11.9745C9.94899 12.3394 9.86836 12.7141 9.88302 13.0985C9.89768 13.483 9.99786 13.8333 10.1836 14.1496H3.00703ZM6.5 5.5L8 4.5L9.5 5.5V1.5H6.5V5.5Z" fill={fill}/>
    </svg>
  ),
  svgs_duplicate_connection_profile: ({
    width = 24,
    height = 24,
    fill = "none",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 21H21"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 21V7L13 3V21"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 21V11L13 7"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9V9.01"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12V12.01"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 15V15.01"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 18V18.01"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_right_arrow: ({ width = 24, height = 24, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.75 6.75L19.25 12L13.75 17.25"
        stroke="#141414"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 12H4.75"
        stroke="#141414"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_icm: ({ width = 24, height = 24, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2502 18.2508H7.75C6.64543 18.2508 5.75 17.3553 5.75 16.2508V6.75076C5.75 5.64619 6.64543 4.75076 7.75 4.75076H16.2502C17.3548 4.75076 18.2502 5.64619 18.2502 6.75076V16.2508C18.2502 17.3553 17.3548 18.2508 16.2502 18.2508Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.71429 8.57144H4"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.71429 12H4"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.71429 15.4286H4"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.57227 4.75V19.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="13.4286" cy="10" r="1.42857" fill="black" />
      <path
        d="M13.5 12C11.9108 12 10.5689 13.2105 10.1419 14.8688C9.98453 15.48 10.5117 16 11.1429 16H15.8571C16.4883 16 17.0155 15.48 16.8581 14.8688C16.4311 13.2105 15.0892 12 13.5 12Z"
        fill="black"
      />
    </svg>
  ),
  infoInsights: ({
    width = 24, height = 24, fill = "black",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none" xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="5.5" stroke={fill}/>
      <rect x="7.5" y="7" width="1" height="4" rx="0.5" fill={fill}/>
      <rect x="7.5" y="5" width="1" height="1" rx="0.5" fill={fill}/>
    </svg>

  ),
  svgs_personalModeIcon: ({ width = 16, height = 16, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.6665H4C2.89543 2.6665 2 3.56193 2 4.6665V11.3332C2 12.4377 2.89543 13.3332 4 13.3332H12C13.1046 13.3332 14 12.4377 14 11.3332V4.6665C14 3.56193 13.1046 2.6665 12 2.6665Z"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00033 8.00016C6.73671 8.00016 7.33366 7.40321 7.33366 6.66683C7.33366 5.93045 6.73671 5.3335 6.00033 5.3335C5.26395 5.3335 4.66699 5.93045 4.66699 6.66683C4.66699 7.40321 5.26395 8.00016 6.00033 8.00016Z"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5.3335H11.3333"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 8H11.3333"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66699 10.6665H11.3337"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_directOn: ({
    width = 20, height = 20, fill = "none", strokeFill = "#828282",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6663 10.0002V5.00016C16.6663 4.55814 16.4907 4.13421 16.1782 3.82165C15.8656 3.50909 15.4417 3.3335 14.9997 3.3335H4.99967C4.55765 3.3335 4.13372 3.50909 3.82116 3.82165C3.5086 4.13421 3.33301 4.55814 3.33301 5.00016V11.6668"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33301 15H17.4997"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 12.5L17.5 15L15 17.5"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_directOff: ({ width = 20, height = 20, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4163 6.83269L15.9163 8.14519V10.0002C15.9163 10.4144 16.2521 10.7502 16.6663 10.7502C17.0806 10.7502 17.4163 10.4144 17.4163 10.0002V6.83269ZM7.22494 15.7502L8.93923 14.2502H15.689L14.4693 13.0305C14.1765 12.7376 14.1765 12.2627 14.4693 11.9698C14.7622 11.6769 15.2371 11.6769 15.53 11.9698L18.03 14.4698C18.3229 14.7627 18.3229 15.2376 18.03 15.5305L15.53 18.0305C15.2371 18.3234 14.7622 18.3234 14.4693 18.0305C14.1765 17.7376 14.1765 17.2627 14.4693 16.9698L15.689 15.7502H7.22494ZM3.45228 12.4074C3.41344 12.4136 3.3736 12.4168 3.33301 12.4168C2.91879 12.4168 2.58301 12.081 2.58301 11.6668V5.00016C2.58301 4.35922 2.83762 3.74453 3.29083 3.29132C3.74405 2.83811 4.35873 2.5835 4.99967 2.5835H14.6796L12.9653 4.0835H4.99967C4.75656 4.0835 4.5234 4.18007 4.35149 4.35198C4.17958 4.52389 4.08301 4.75705 4.08301 5.00016V11.6668C4.08301 11.7421 4.07193 11.8147 4.05131 11.8832L3.45228 12.4074Z"
        fill="#828282"
      />
      <path
        d="M2 17L18 3"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_bellOn: ({
    width = 20, height = 16, fill = "#828282", strokeFill,
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 448 512"
      fill={strokeFill || fill}
    >
      <path d="M256 32V49.88C328.5 61.39 384 124.2 384 200V233.4C384 278.8 399.5 322.9 427.8 358.4L442.7 377C448.5 384.2 449.6 394.1 445.6 402.4C441.6 410.7 433.2 416 424 416H24C14.77 416 6.365 410.7 2.369 402.4C-1.628 394.1-.504 384.2 5.26 377L20.17 358.4C48.54 322.9 64 278.8 64 233.4V200C64 124.2 119.5 61.39 192 49.88V32C192 14.33 206.3 0 224 0C241.7 0 256 14.33 256 32V32zM216 96C158.6 96 112 142.6 112 200V233.4C112 281.3 98.12 328 72.31 368H375.7C349.9 328 336 281.3 336 233.4V200C336 142.6 289.4 96 232 96H216zM288 448C288 464.1 281.3 481.3 269.3 493.3C257.3 505.3 240.1 512 224 512C207 512 190.7 505.3 178.7 493.3C166.7 481.3 160 464.1 160 448H288z" />
    </svg>
  ),
  svgs_bellOff: ({ width = 20, height = 20, fill = "#828282" }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 640 512"
    >
      <path d="M183.6 118.6C206.5 82.58 244.1 56.84 288 49.88V32C288 14.33 302.3 .0003 320 .0003C337.7 .0003 352 14.33 352 32V49.88C424.5 61.39 480 124.2 480 200V233.4C480 278.8 495.5 322.9 523.8 358.4L538.7 377C543.1 383.5 545.4 392.2 542.6 400L630.8 469.1C641.2 477.3 643.1 492.4 634.9 502.8C626.7 513.2 611.6 515.1 601.2 506.9L9.196 42.89C-1.236 34.71-3.065 19.63 5.112 9.196C13.29-1.236 28.37-3.065 38.81 5.112L183.6 118.6zM221.7 148.4L450.7 327.1C438.4 298.2 432 266.1 432 233.4V200C432 142.6 385.4 96 328 96H312C273.3 96 239.6 117.1 221.7 148.4V148.4zM160 233.4V222.1L206.7 258.9C202.7 297.7 189.5 335.2 168.3 368H345.2L406.2 416H120C110.8 416 102.4 410.7 98.37 402.4C94.37 394.1 95.5 384.2 101.3 377L116.2 358.4C144.5 322.9 160 278.8 160 233.4V233.4zM384 448C384 464.1 377.3 481.3 365.3 493.3C353.3 505.3 336.1 512 320 512C303 512 286.7 505.3 274.7 493.3C262.7 481.3 256 464.1 256 448H384z" />
    </svg>
  ),
  svgs_clipboard: ({
    width = 20, height = 20, fill = "none", strokeFill = "#777777",
  }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M9 6.75H7.75C6.64543 6.75 5.75 7.64543 5.75 8.75V17.25C5.75 18.3546 6.64543 19.25 7.75 19.25H16.25C17.3546 19.25 18.25 18.3546 18.25 17.25V8.75C18.25 7.64543 17.3546 6.75 16.25 6.75H15" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 8.25H10C9.44772 8.25 9 7.80228 9 7.25V5.75C9 5.19772 9.44772 4.75 10 4.75H14C14.5523 4.75 15 5.19772 15 5.75V7.25C15 7.80228 14.5523 8.25 14 8.25Z" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.75 12.25H14.25" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.75 15.25H14.25" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  svgs_leadCaptureOn: ({
    width = 20, height = 20, fill = "none", strokeFill = "#828282",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.55995 4H15.44C15.5606 4.04329 15.6698 4.11427 15.7595 4.20748C15.8491 4.3007 15.9167 4.41369 15.9571 4.53779C15.9974 4.66189 16.0096 4.79382 15.9925 4.92346C15.9754 5.0531 15.9296 5.17701 15.8585 5.28571L11.6739 10V16L8.32614 13.4286V10L4.14149 5.28571C4.07042 5.17701 4.0246 5.0531 4.00752 4.92346C3.99044 4.79382 4.00256 4.66189 4.04295 4.53779C4.08334 4.41369 4.15093 4.3007 4.24055 4.20748C4.33016 4.11427 4.43942 4.04329 4.55995 4Z"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_leadCaptureOnSidebar: ({
    width = 14, height = 14, fill = "none", strokeFill = "#BDBDBD",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.55995 1H12.44C12.5606 1.04329 12.6698 1.11427 12.7595 1.20748C12.8491 1.3007 12.9167 1.41369 12.9571 1.53779C12.9974 1.66189 13.0096 1.79382 12.9925 1.92346C12.9754 2.0531 12.9296 2.17701 12.8585 2.28571L8.67386 7V13L5.32614 10.4286V7L1.14149 2.28571C1.07042 2.17701 1.0246 2.0531 1.00752 1.92346C0.990436 1.79382 1.00256 1.66189 1.04295 1.53779C1.08334 1.41369 1.15093 1.3007 1.24055 1.20748C1.33016 1.11427 1.43942 1.04329 1.55995 1Z"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_leadCaptureOff: ({ width = 20, height = 20, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9179 3.25H4.55995C4.47353 3.25 4.38776 3.26494 4.30642 3.29415C4.07603 3.3769 3.86878 3.512 3.69987 3.68771C3.53102 3.86334 3.40487 4.07493 3.32977 4.30567C3.25469 4.53637 3.23228 4.78108 3.26394 5.02142C3.29561 5.26178 3.38068 5.4926 3.51373 5.69611C3.53384 5.72687 3.55619 5.75611 3.58058 5.7836L6.8338 9.44857L7.9627 8.46078L4.75644 4.84872C4.75398 4.84139 4.75216 4.83362 4.75109 4.82549C4.74859 4.80655 4.75043 4.78742 4.75612 4.76991C4.75846 4.76274 4.76135 4.75609 4.76468 4.75H12.2036L13.9179 3.25ZM9.72821 13.5598L10.9239 14.4782V12.5136L12.4239 11.2011V16C12.4239 16.2856 12.2616 16.5465 12.0054 16.6727C11.7492 16.799 11.4435 16.7688 11.217 16.5948L8.57708 14.567L9.72821 13.5598Z"
        fill="#828282"
      />
      <path
        d="M2 17L18 3"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_businessModeOpt: ({ width = 16, height = 16, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 14H14"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33301 14V4.66667L8.66634 2V14"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.667 13.9998V7.33317L8.66699 4.6665"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6V6.00667"
        stroke="#828282"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8V8.00667"
        stroke="#828282"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10V10.0067"
        stroke="#828282"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12V12.0067"
        stroke="#828282"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_location: ({
    width = 12, height = 14, fill = "none", strokeFill = "#818181",
  }) => (
    <svg width={"auto"} height={height} viewBox="0 0 12 14" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1449_4773)">
        <path d="M11.2082 6.16732C11.2082 9.50065 5.99984 13.0423 5.99984 13.0423C5.99984 13.0423 0.791504 9.50065 0.791504 6.16732C0.791504 3.25065 3.23841 0.958984 5.99984 0.958984C8.76126 0.958984 11.2082 3.25065 11.2082 6.16732Z" stroke={strokeFill} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.875 6.16602C7.875 7.20155 7.03553 8.04102 6 8.04102C4.96447 8.04102 4.125 7.20155 4.125 6.16602C4.125 5.13048 4.96447 4.29102 6 4.29102C7.03553 4.29102 7.875 5.13048 7.875 6.16602Z" stroke={strokeFill} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1449_4773">
          <rect width={"auto"} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_unlock: ({ width = 12, height = 12, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8496 3.0212C10.7069 2.77403 10.5316 2.5444 10.3263 2.33911C9.70895 1.7218 8.8717 1.375 7.9987 1.375C7.12569 1.375 6.28845 1.7218 5.67114 2.33911C5.05383 2.95641 4.70703 3.79366 4.70703 4.66667V6.70833H4.66536C3.58381 6.70833 2.70703 7.58511 2.70703 8.66667V9.80667L3.95703 8.765V8.66667C3.95703 8.27547 4.27416 7.95833 4.66536 7.95833H4.92503L6.42503 6.70833H5.95703V4.66667C5.95703 4.12518 6.17213 3.60588 6.55502 3.22299C6.93791 2.8401 7.45721 2.625 7.9987 2.625C8.54018 2.625 9.05949 2.8401 9.44237 3.22299C9.6222 3.40282 9.76502 3.61274 9.86593 3.84092L10.8496 3.0212ZM6.97613 11.4559L8.95937 9.80322C9.16515 10.032 9.29036 10.3347 9.29036 10.6667C9.29036 11.38 8.71207 11.9583 7.9987 11.9583C7.58255 11.9583 7.21236 11.7615 6.97613 11.4559ZM4.67323 13.375H11.332C11.7232 13.375 12.0404 13.0579 12.0404 12.6667V8.66667C12.0404 8.27547 11.7232 7.95833 11.332 7.95833H11.1732L12.3391 6.98678C12.909 7.32917 13.2904 7.95339 13.2904 8.66667V12.6667C13.2904 13.7482 12.4136 14.625 11.332 14.625H4.66536C4.26077 14.625 3.88483 14.5023 3.57273 14.2921L4.67323 13.375ZM7.95703 10.6667C7.95703 10.6437 7.97569 10.625 7.9987 10.625C8.02171 10.625 8.04036 10.6437 8.04036 10.6667C8.04036 10.6897 8.02171 10.7083 7.9987 10.7083C7.97569 10.7083 7.95703 10.6897 7.95703 10.6667Z"
        fill="#828282"
      />
      <path
        d="M2 13L14 3"
        stroke="#828282"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_lock: ({
    width = 12, height = 12, fill = "none", strokeFill = "#828282",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 5.5H3.5C2.94772 5.5 2.5 5.94772 2.5 6.5V9.5C2.5 10.0523 2.94772 10.5 3.5 10.5H8.5C9.05228 10.5 9.5 10.0523 9.5 9.5V6.5C9.5 5.94772 9.05228 5.5 8.5 5.5Z"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 5.5V3.5C4 2.96957 4.21071 2.46086 4.58579 2.08579C4.96086 1.71071 5.46957 1.5 6 1.5C6.53043 1.5 7.03914 1.71071 7.41421 2.08579C7.78929 2.46086 8 2.96957 8 3.5V5.5"
        stroke={strokeFill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_integrationsSidebar: ({
    width = 16, height = 16, strokeFill = "#BDBDBD", fill = "none",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66675 4.66602H11.3334V8.66602C11.3334 9.19645 11.1227 9.70516 10.7476 10.0802C10.3726 10.4553 9.86385 10.666 9.33341 10.666H6.66675C6.13632 10.666 5.62761 10.4553 5.25253 10.0802C4.87746 9.70516 4.66675 9.19645 4.66675 8.66602V4.66602Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 2V4.66667"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 2V4.66667"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.666V11.9993C8 12.353 8.14048 12.6921 8.39052 12.9422C8.64057 13.1922 8.97971 13.3327 9.33333 13.3327H11.3333"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_zappier: ({ width = 36, height = 36, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5008 18.0085C22.5009 19.3064 22.2665 20.5936 21.809 21.8081C20.5941 22.2656 19.3065 22.5002 18.0082 22.5004H17.9924C16.6941 22.5006 15.4065 22.2663 14.1915 21.8087C13.7333 20.5939 13.4985 19.3063 13.4987 18.0079V17.9909C13.4987 16.6533 13.7441 15.3723 14.1887 14.1902C15.4039 13.732 16.692 13.4976 17.9907 13.4984H18.0054C19.3436 13.4984 20.6241 13.7439 21.8062 14.1902C22.2642 15.405 22.4986 16.6927 22.498 17.9909V18.0079H22.4996L22.5008 18.0085ZM35.7506 14.9995H25.2439L32.6726 7.57046C31.5044 5.92995 30.0703 4.49621 28.4294 3.32852L20.9997 10.7576V0.250558C20.0117 0.0843785 19.0117 0.000571016 18.0099 0H17.9907C16.9714 0 15.9732 0.0871013 15.0003 0.250558V10.7576L7.56888 3.32795C6.75047 3.91044 5.98234 4.56051 5.27254 5.27133L5.26915 5.27472C4.55939 5.98501 3.9099 6.7531 3.32743 7.57103L10.7589 14.9995H0.249988C0.249988 14.9995 0 16.9734 0 17.9938V18.0062C0 19.0266 0.0865333 20.0265 0.250558 20.9999H10.7594L3.32686 28.4278C4.49587 30.0681 5.9301 31.5021 7.57059 32.6709L15.0009 25.2424V35.75C15.9726 35.9129 16.9692 35.9989 17.9873 36H18.0127C19.0134 35.9991 20.0122 35.9155 20.9991 35.75V25.2424L28.43 32.6726C29.2485 32.0896 30.0172 31.4396 30.728 30.7292H30.7297C31.4392 30.0182 32.0884 29.2496 32.6709 28.4312L25.2423 21.0005H35.7511C35.914 20.0277 36 19.0311 36 18.013V17.987C36 16.9859 35.9163 15.9876 35.7511 15.0007L35.7506 14.9995Z"
        fill="#FF4A00"
      />
    </svg>
  ),
  svgs_zappier_custom: ({ width = 36, height = 36, fill = "none" }) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.1159 13.1127C15.6366 12.592 16.4808 12.592 17.0015 13.1127L18.8871 14.9983C19.4078 15.519 19.4078 16.3633 18.8871 16.884L15.7005 20.0706L8.06686 27.7043C7.54616 28.2249 6.70194 28.225 6.18124 27.7043L4.29562 25.8186C3.77492 25.2979 3.77492 24.4537 4.29562 23.933L11.9293 16.2993L15.1159 13.1127Z" fill="black"/>
      <path d="M16.0808 12.1479L4.29573 23.933C3.77503 24.4537 3.77503 25.2979 4.29573 25.8186L6.18135 27.7042C6.70205 28.2249 7.54627 28.2249 8.06697 27.7042L19.8521 15.9191M16.0808 12.1479L21.2663 6.96243C21.787 6.44173 22.6312 6.44173 23.1519 6.96243L25.0375 8.84805C25.5582 9.36875 25.5582 10.213 25.0375 10.7337L19.8521 15.9191M16.0808 12.1479L19.8521 15.9191" stroke="black" strokeWidth="2"/>
      <rect x="9.33325" y="5.33334" width="1.33333" height="2.66667" fill="black"/>
      <rect x="9.33325" y="9.33334" width="1.33333" height="2.66667" fill="black"/>
      <rect x="10.6666" y="8" width="2.66667" height="1.33333" fill="black"/>
      <rect x="6.66663" y="8" width="2.66667" height="1.33333" fill="black"/>
      <rect x="25.7778" y="15.5556" width="1.33333" height="2.66667" fill="black"/>
      <rect x="25.7778" y="19.5556" width="1.33333" height="2.66667" fill="black"/>
      <rect x="27.1112" y="18.2222" width="2.66667" height="1.33333" fill="black"/>
      <rect x="23.1112" y="18.2222" width="2.66667" height="1.33333" fill="black"/>
      <rect x="16" y="2.66666" width="1.33333" height="1.33333" fill="black"/>
      <rect x="16" y="5.33331" width="1.33333" height="1.33333" fill="black"/>
      <rect x="17.3333" y="3.99997" width="1.33333" height="1.33333" fill="black"/>
      <rect x="14.6666" y="3.99997" width="1.33333" height="1.33333" fill="black"/>
    </svg>
  ),
  svgs_zappier_small: () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8266_77425)">
        <path d="M7.50026 6.00283C7.50029 6.43545 7.42218 6.86452 7.26968 7.26938C6.86469 7.42188 6.43549 7.50005 6.00273 7.50014H5.99746C5.5647 7.5002 5.1355 7.42209 4.73051 7.26957C4.57776 6.86464 4.49951 6.43542 4.49955 6.00264V5.99698C4.49955 5.55111 4.58138 5.12408 4.72956 4.73005C5.13462 4.57732 5.56399 4.49921 5.99689 4.49948H6.00179C6.44786 4.49948 6.8747 4.5813 7.26874 4.73005C7.42141 5.13499 7.49953 5.56422 7.49932 5.99698V6.00264H7.49988L7.50026 6.00283ZM11.9169 4.99984H8.41465L10.8909 2.52349C10.5015 1.97665 10.0234 1.49874 9.47648 1.10951L6.99989 3.58586V0.0835192C6.67058 0.0281262 6.33723 0.000190339 6.0033 0H5.99689C5.65715 0 5.32439 0.0290338 5.00011 0.0835192V3.58586L2.52296 1.10932C2.25016 1.30348 1.99411 1.52017 1.75751 1.75711L1.75638 1.75824C1.5198 1.995 1.3033 2.25103 1.10914 2.52368L3.5863 4.99984H0.0833294C0.0833294 4.99984 0 5.65782 0 5.99793V6.00207C0 6.34218 0.0288444 6.67551 0.0835193 6.99997H3.58648L1.10896 9.47595C1.49862 10.0227 1.9767 10.5007 2.52353 10.8903L5.0003 8.41414V11.9167C5.3242 11.971 5.6564 11.9996 5.99576 12H6.00424C6.33779 11.9997 6.67074 11.9718 6.9997 11.9167V8.41414L9.47666 10.8909C9.7495 10.6965 10.0057 10.4799 10.2427 10.2431H10.2432C10.4797 10.0061 10.6961 9.74985 10.8903 9.47708L8.41409 7.00016H11.917C11.9713 6.67588 12 6.34369 12 6.00434V5.99566C12 5.66196 11.9721 5.32921 11.917 5.00022L11.9169 4.99984Z" fill="#FF4A00"/>
      </g>
      <defs>
        <clipPath id="clip0_8266_77425">
          <rect width="12" height="12" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_integration_success: ({
    width = 13, height = 12, fill = "#27AE60", strokeFill = "#fff",
  }) => (
    <svg width={width} height={height} viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width="12" height="12" rx="6" fill={fill} stroke={strokeFill} />
      <path d="M4.25 6L5.75 7.5L8.75 4.5" stroke="white" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_microSoftTeam: ({ width = 36, height = 36, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 3000 2000"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M2015.6,899.2c19.5,19.5,42.5,35,67.9,45.8c53,22.2,112.7,22.2,165.8,0c51.2-21.8,92-62.5,113.7-113.7
          c22.2-53,22.2-112.7,0-165.8c-21.8-51.2-62.5-92-113.7-113.7c-53-22.2-112.7-22.2-165.8,0c-51.2,21.8-92,62.5-113.7,113.7
          c-22.2,53-22.2,112.7,0,165.8C1980.6,856.6,1996.2,879.7,2015.6,899.2L2015.6,899.2z M1953.2,1097v642.1h107
          c36.8-0.2,73.4-3.6,109.5-10.4c36.3-6.4,71.3-18.6,103.7-36.2c30.6-16.6,57-40,77.3-68.2c21.3-31.3,32-68.6,30.5-106.5V1097H1953.2
          z M1606.4,827.8c28.4,0.2,56.6-5.5,82.8-16.7c51.2-21.8,91.9-62.5,113.6-113.7c22.2-53,22.2-112.7-0.1-165.8
          c-21.8-51.2-62.5-92-113.7-113.7c-26.2-11.2-54.4-16.9-82.9-16.7c-28.3-0.2-56.3,5.5-82.3,16.7c-19.4,8.3-25.5,19.1-52.2,32.1v329
          c26.8,13.1,32.8,23.8,52.2,32.1C1549.9,822.4,1578,828,1606.4,827.8L1606.4,827.8z M1471.6,1908.9c26.8,5.8,36.4,10.3,55.4,12.9
          c20.8,3,41.8,4.5,62.8,4.6c32.4-0.2,64.8-3.6,96.5-10.4c32.3-6.5,63.3-18.6,91.5-35.7c27.7-17,51-40.2,68.2-67.7
          c19-32.1,28.3-69.1,26.9-106.4v-743h-401.3V1908.9z M0,2113.7l1391.3,240.8V0L0,240.8V2113.7z"
          fill="#5558AF"
        />
      </g>
      <path
        d="M1016.7,722.4l-642.1,39.1v148.1l240.8-9.7v686.7l160.5,9.4V893.6l240.8-10.7V722.4z"
        fill="#FFFFFF"
      />
    </svg>
  ),
  svgs_microSoftAD: ({ width = 29, height = 28, fill = "none" }) => (
    <svg width={width} height={height} viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8266_76845)">
        <g clipPath="url(#clip1_8266_76845)">
          <path d="M9.83944 0.692931H18.1151L9.52409 26.2031C9.48016 26.3334 9.41623 26.456 9.3346 26.5666C9.25314 26.6773 9.1549 26.7743 9.04337 26.8545C8.93185 26.9346 8.80878 26.997 8.67803 27.039C8.54728 27.081 8.41093 27.1027 8.27388 27.1027H1.83334C1.62427 27.1027 1.418 27.053 1.23201 26.9571C1.04581 26.8614 0.885091 26.7226 0.763176 26.5522C0.641182 26.3819 0.561373 26.1849 0.530335 25.9776C0.49922 25.7703 0.518099 25.5585 0.584874 25.3599L8.58888 1.59183C8.63258 1.46156 8.69656 1.339 8.77837 1.22835C8.85983 1.11769 8.95842 1.02069 9.0696 0.940504C9.18112 0.860314 9.30418 0.797983 9.43494 0.755962C9.56569 0.713941 9.70204 0.69223 9.83909 0.69223V0.69258L9.83944 0.692931Z" fill="url(#paint0_linear_8266_76845)"/>
          <path d="M25.0972 27.103H17.6662C17.5834 27.103 17.5005 27.0953 17.4187 27.0796C17.3373 27.0642 17.2572 27.0411 17.1799 27.0106C17.1027 26.9801 17.0286 26.9423 16.9583 26.8982C16.8881 26.8538 16.8222 26.8029 16.7615 26.7462L8.32883 18.8582C8.23963 18.7748 8.17752 18.6664 8.15052 18.5472C8.12355 18.428 8.13304 18.3034 8.17775 18.1897C8.22246 18.076 8.30032 17.9784 8.40119 17.9096C8.50223 17.8409 8.62145 17.8042 8.74346 17.8042H21.8665L25.0965 27.1034L25.0972 27.103Z" fill="#0078D4"/>
          <path d="M18.145 0.692247L12.352 17.8049L21.8174 17.8028L25.0642 27.102H17.6612C17.5846 27.1013 17.508 27.0943 17.4325 27.0807C17.357 27.067 17.2829 27.0471 17.2109 27.0205C17.0665 26.9677 16.9321 26.8906 16.8137 26.7925L11.1213 21.4712L9.52781 26.1783C9.48656 26.2959 9.42992 26.4076 9.3593 26.5102C9.21775 26.7167 9.02414 26.8818 8.79817 26.9889C8.68566 27.0422 8.56656 27.0803 8.44401 27.102H1.83741C1.62624 27.1027 1.41787 27.0523 1.23013 26.955C1.04236 26.8577 0.880731 26.7166 0.758904 26.5435C0.637078 26.3705 0.558636 26.1706 0.530209 25.9608C0.501885 25.7509 0.524306 25.5373 0.595586 25.3379L8.58665 1.609C8.62826 1.47629 8.69084 1.35127 8.77195 1.23852C8.85271 1.12576 8.9513 1.02631 9.06318 0.944372C9.17505 0.862431 9.29951 0.7987 9.43132 0.755978C9.56312 0.713257 9.70122 0.691546 9.84001 0.692247H18.1454H18.145Z" fill="url(#paint1_linear_8266_76845)"/>
          <path d="M28.4151 25.3592C28.4819 25.5579 28.5007 25.7696 28.4699 25.9769C28.4389 26.1842 28.3592 26.3811 28.2374 26.5515C28.1155 26.7218 27.9548 26.8605 27.7687 26.9562C27.5827 27.052 27.3765 27.1019 27.1673 27.102H17.9438C18.1529 27.102 18.3592 27.0519 18.5455 26.9564C18.7315 26.8608 18.8923 26.7217 19.0143 26.5515C19.1364 26.3814 19.2161 26.1842 19.2472 25.9769C19.2783 25.7696 19.2594 25.5578 19.1927 25.3592L11.1883 1.59043C11.1002 1.3286 10.9323 1.10104 10.7083 0.939803C10.5971 0.859614 10.474 0.797633 10.3436 0.755612C10.2132 0.713591 10.0769 0.69223 9.94019 0.69223H19.1633C19.3003 0.69223 19.4363 0.713591 19.5671 0.755612C19.6975 0.797633 19.8206 0.859964 19.9321 0.939803C20.0433 1.01999 20.1415 1.11699 20.223 1.2273C20.3044 1.3376 20.368 1.46016 20.4121 1.59043L28.4165 25.3592H28.4151Z" fill="url(#paint2_linear_8266_76845)"/>
        </g>
      </g>
      <defs>
        <linearGradient id="paint0_linear_8266_76845" x1="12.8597" y1="2.6504" x2="4.23444" y2="28.0891" gradientUnits="userSpaceOnUse">
          <stop stopColor="#114A8B"/>
          <stop offset="1" stopColor="#0669BC"/>
        </linearGradient>
        <linearGradient id="paint1_linear_8266_76845" x1="15.5415" y1="14.5066" x2="13.5515" y2="15.1805" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.3"/>
          <stop offset="0.1" stopOpacity="0.2"/>
          <stop offset="0.3" stopOpacity="0.1"/>
          <stop offset="0.6" stopOpacity="0.1"/>
          <stop offset="1" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint2_linear_8266_76845" x1="14.4449" y1="1.90733" x2="23.9111" y2="27.0854" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3CCBF4"/>
          <stop offset="1" stopColor="#2892DF"/>
        </linearGradient>
        <clipPath id="clip0_8266_76845">
          <rect width="28" height="27.9999" fill="white" transform="translate(0.5 4.57764e-05)"/>
        </clipPath>
        <clipPath id="clip1_8266_76845">
          <rect width="28" height="26.4633" fill="white" transform="translate(0.500122 0.666718)"/>
        </clipPath>
      </defs>
    </svg>

  ),
  svgs_microSoftADGray: ({ width = 36, height = 36, fill = "#29AEF8" }) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5609_72942)">
        <path
          d="M6.03701 0.633071H11.2951L5.83682 16.8055C5.78077 16.9718 5.67396 17.1162 5.53146 17.2185C5.38896 17.3209 5.21794 17.3759 5.04251 17.3759H0.950513C0.817616 17.3758 0.686634 17.3442 0.568385 17.2835C0.450136 17.2229 0.348013 17.135 0.270452 17.027C0.192914 16.9191 0.142201 16.7943 0.122513 16.6628C0.102826 16.5314 0.114729 16.3972 0.157238 16.2712L5.2427 1.20328C5.29878 1.03705 5.40559 0.892596 5.54808 0.790259C5.69058 0.687922 5.86158 0.632855 6.03701 0.632812V0.633071Z"
          fill="#828282"
        />
        <path
          d="M13.6816 11.4688H5.34351C5.26598 11.4686 5.1902 11.4918 5.12606 11.5354C5.06191 11.5789 5.01239 11.6408 4.98394 11.7129C4.95549 11.7851 4.94943 11.8641 4.96657 11.9397C4.9837 12.0153 5.02322 12.084 5.07998 12.1369L10.4378 17.1378C10.5938 17.2833 10.7992 17.3642 11.0125 17.3642H15.7339L13.6816 11.4688Z"
          fill="#BDBDBD"
        />
        <path
          d="M12.7548 1.20224C12.6988 1.03625 12.5922 0.892008 12.4499 0.789849C12.3075 0.687691 12.1368 0.632765 11.9616 0.632813H6.10156C6.27672 0.632831 6.44746 0.687785 6.58974 0.789936C6.73202 0.892087 6.83868 1.03629 6.89471 1.20224L11.9803 16.2709C12.0229 16.3968 12.0348 16.5311 12.0152 16.6625C11.9956 16.794 11.9449 16.9189 11.8674 17.0269C11.7898 17.1349 11.6877 17.2229 11.5694 17.2836C11.4511 17.3443 11.3201 17.3759 11.1872 17.3759H17.0474C17.1803 17.3758 17.3113 17.344 17.4295 17.2833C17.5477 17.2226 17.6497 17.1346 17.7272 17.0267C17.8047 16.9187 17.8554 16.7939 17.8751 16.6624C17.8948 16.531 17.8829 16.3968 17.8404 16.2709L12.7548 1.20224Z"
          fill="#E0E0E0"
        />
      </g>
      <defs>
        <clipPath id="clip0_5609_72942">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_microSoftADBlue: ({ width = 36, height = 36, fill = "#29AEF8" }) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5609_72960)">
        <path
          d="M6.03701 0.633071H11.2951L5.83682 16.8055C5.78077 16.9718 5.67396 17.1162 5.53146 17.2185C5.38896 17.3209 5.21794 17.3759 5.04251 17.3759H0.950513C0.817616 17.3758 0.686634 17.3442 0.568385 17.2835C0.450136 17.2229 0.348013 17.135 0.270452 17.027C0.192914 16.9191 0.142201 16.7943 0.122513 16.6628C0.102826 16.5314 0.114729 16.3972 0.157238 16.2712L5.2427 1.20328C5.29878 1.03705 5.40559 0.892596 5.54808 0.790259C5.69058 0.687922 5.86158 0.632855 6.03701 0.632812V0.633071Z"
          fill="url(#paint0_linear_5609_72960)"
        />
        <path
          d="M13.6816 11.4688H5.34351C5.26598 11.4686 5.1902 11.4918 5.12606 11.5354C5.06191 11.5789 5.01239 11.6408 4.98394 11.7129C4.95549 11.7851 4.94943 11.8641 4.96657 11.9397C4.9837 12.0153 5.02322 12.084 5.07998 12.1369L10.4378 17.1378C10.5938 17.2833 10.7992 17.3642 11.0125 17.3642H15.7339L13.6816 11.4688Z"
          fill="#0078D4"
        />
        <path
          d="M6.03972 0.632818C5.86237 0.632152 5.68946 0.688204 5.54623 0.792789C5.403 0.897373 5.29696 1.04501 5.2436 1.21414L0.166277 16.2573C0.12095 16.3837 0.106724 16.5191 0.124802 16.6521C0.14288 16.7852 0.192731 16.9119 0.270138 17.0216C0.347545 17.1313 0.450231 17.2207 0.569512 17.2823C0.688793 17.344 0.821159 17.376 0.955416 17.3756H5.15313C5.30946 17.3477 5.45558 17.2787 5.57656 17.1759C5.69754 17.073 5.78904 16.9398 5.84172 16.79L6.85419 13.806L10.471 17.1793C10.6225 17.3047 10.8126 17.374 11.0093 17.3756H15.7131L13.65 11.4802L7.63609 11.4816L11.3168 0.632818H6.03972Z"
          fill="url(#paint1_linear_5609_72960)"
        />
        <path
          d="M12.7548 1.20224C12.6988 1.03625 12.5922 0.892008 12.4499 0.789849C12.3075 0.687691 12.1368 0.632765 11.9616 0.632813H6.10156C6.27672 0.632831 6.44746 0.687785 6.58974 0.789936C6.73202 0.892086 6.83868 1.03629 6.89471 1.20224L11.9803 16.2709C12.0229 16.3968 12.0348 16.5311 12.0152 16.6625C11.9956 16.794 11.9449 16.9189 11.8674 17.0269C11.7898 17.1349 11.6877 17.2229 11.5694 17.2836C11.4511 17.3443 11.3201 17.3759 11.1872 17.3759H17.0474C17.1803 17.3758 17.3113 17.344 17.4295 17.2833C17.5477 17.2226 17.6498 17.1346 17.7272 17.0267C17.8047 16.9187 17.8554 16.7939 17.8751 16.6624C17.8948 16.531 17.8829 16.3968 17.8404 16.2709L12.7548 1.20224Z"
          fill="url(#paint2_linear_5609_72960)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5609_72960"
          x1="7.95351"
          y1="1.87378"
          x2="2.49286"
          y2="18.0056"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#114A8B" />
          <stop offset="1" stopColor="#0669BC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5609_72960"
          x1="9.66193"
          y1="9.39141"
          x2="8.39887"
          y2="9.81842"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.3" />
          <stop offset="0.071" stopOpacity="0.2" />
          <stop offset="0.321" stopOpacity="0.1" />
          <stop offset="0.623" stopOpacity="0.05" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5609_72960"
          x1="8.96643"
          y1="1.40295"
          x2="14.9606"
          y2="17.3724"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3CCBF4" />
          <stop offset="1" stopColor="#2892DF" />
        </linearGradient>
        <clipPath id="clip0_5609_72960">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_microsoftDynamics: ({ width = 32, height = 32, fill = "none" }) => (
    <svg width={width} height={height} viewBox="0 0 32 32" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8266_76871)">
        <g clipPath="url(#clip1_8266_76871)">
          <g clipPath="url(#clip2_8266_76871)">
            <path d="M6.85712 31.2381L12.7943 14.1981L6.85712 10.3048V31.2381ZM25.6343 20.699V11.0248L6.85712 31.2381L25.6343 20.699ZM6.85712 0.761902V8.92762L19.1104 14.9371L24.8057 10.3048L6.85712 0.761902Z" fill="black"/>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_8266_76871">
          <rect width="32" height="32" fill="white"/>
        </clipPath>
        <clipPath id="clip1_8266_76871">
          <rect width="30.4762" height="30.4762" fill="white" transform="translate(0.761902 0.761902)"/>
        </clipPath>
        <clipPath id="clip2_8266_76871">
          <rect width="19.0476" height="30.4762" fill="white" transform="translate(6.85712 0.761902)"/>
        </clipPath>
      </defs>
    </svg>

  ),
  svgs_refreshIcon: ({
    width = 22, height = 22, fill = "none", strokeFill = "#828282",
  }) => (
    <svg
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1265 6.87348C14.2952 4.04217 9.70478 4.04217 6.87348 6.87348C4.04217 9.70478 4.04217 14.2952 6.87348 17.1265C9.70478 19.9578 14.2952 19.9578 17.1265 17.1265C17.7603 16.4927 18.2522 15.7708 18.6023 15.0001"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 19.25V15.75C19.25 15.1977 18.8023 14.75 18.25 14.75H14.75"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_gift: ({ width = 24, height = 24, strokeFill = "#828282" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.75 11.25H18.25V17.25C18.25 18.3546 17.3546 19.25 16.25 19.25H7.75C6.64543 19.25 5.75 18.3546 5.75 17.25V11.25Z"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 7.75H19.25V11.25H4.75V7.75Z"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 19V11.5"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 7.5L15.25 4.75"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 7.5L8.75 4.75"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_truck: () => (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2502 15.25H4.75V4.75H15.2502V15.25Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25 17.5C9.25 18.4665 8.4665 19.25 7.5 19.25C6.5335 19.25 5.75 18.4665 5.75 17.5C5.75 16.5335 6.5335 15.75 7.5 15.75C8.4665 15.75 9.25 16.5335 9.25 17.5Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.25 17.5C18.25 18.4665 17.4665 19.25 16.5 19.25C15.5335 19.25 14.75 18.4665 14.75 17.5C14.75 16.5335 15.5335 15.75 16.5 15.75C17.4665 15.75 18.25 16.5335 18.25 17.5Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2502 15.25H15.25V8.75H16.2502C17.9071 8.75 19.2502 10.0931 19.2502 11.75V15.25Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_addProfilesCsv: ({ width = 20, height = 20, fill = "#828282" }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 384 512"
    >
      <path d="M96 264C113.7 264 128 278.3 128 296V304C128 308.4 124.4 312 120 312C115.6 312 112 308.4 112 304V296C112 287.2 104.8 280 96 280H80C71.16 280 64 287.2 64 296V376C64 384.8 71.16 392 80 392H96C104.8 392 112 384.8 112 376V368C112 363.6 115.6 360 120 360C124.4 360 128 363.6 128 368V376C128 393.7 113.7 408 96 408H80C62.33 408 48 393.7 48 376V296C48 278.3 62.33 264 80 264H96zM160 302.4C160 281.2 177.2 264 198.4 264H216C220.4 264 224 267.6 224 272C224 276.4 220.4 280 216 280H198.4C186 280 176 290 176 302.4C176 310.4 180.3 317.8 187.3 321.8L212.7 336.3C224.6 343.1 232 355.9 232 369.6C232 390.8 214.8 408 193.6 408H168C163.6 408 160 404.4 160 400C160 395.6 163.6 392 168 392H193.6C205.1 392 216 381.1 216 369.6C216 361.6 211.7 354.2 204.7 350.2L179.3 335.7C167.4 328.9 160 316.1 160 302.4zM272 303.6C272 332.6 280.3 361.1 296 385.5C311.7 361.1 320 332.6 320 303.6V272C320 267.6 323.6 264 328 264C332.4 264 336 267.6 336 272V303.6C336 336.7 326.2 369.1 307.8 396.7L302.7 404.4C301.2 406.7 298.7 408 296 408C293.3 408 290.8 406.7 289.3 404.4L284.2 396.7C265.8 369.1 256 336.7 256 303.6V272C256 267.6 259.6 264 264 264C268.4 264 272 267.6 272 272V303.6zM204.1 0C216.8 0 229.1 5.057 238.1 14.06L369.9 145.9C378.9 154.9 384 167.2 384 179.9V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V64C0 28.65 28.65 0 64 0L204.1 0zM64 496H320C346.5 496 368 474.5 368 448V179.9C368 178.6 367.9 177.3 367.8 176H248C225.9 176 208 158.1 208 136V16.24C206.7 16.08 205.4 16 204.1 16H64C37.49 16 16 37.49 16 64V448C16 474.5 37.49 496 64 496V496zM226.7 25.37C225.9 24.5 224.1 23.68 224 22.93V136C224 149.3 234.7 160 248 160H361.1C360.3 159 359.5 158.1 358.6 157.3L226.7 25.37z" />
    </svg>
  ),
  svgs_addProfilesCsvBlue: ({ width = 20, height = 20 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 384 512"
      fill="#29AEF8"
    >
      <path d="M96 264C113.7 264 128 278.3 128 296V304C128 308.4 124.4 312 120 312C115.6 312 112 308.4 112 304V296C112 287.2 104.8 280 96 280H80C71.16 280 64 287.2 64 296V376C64 384.8 71.16 392 80 392H96C104.8 392 112 384.8 112 376V368C112 363.6 115.6 360 120 360C124.4 360 128 363.6 128 368V376C128 393.7 113.7 408 96 408H80C62.33 408 48 393.7 48 376V296C48 278.3 62.33 264 80 264H96zM160 302.4C160 281.2 177.2 264 198.4 264H216C220.4 264 224 267.6 224 272C224 276.4 220.4 280 216 280H198.4C186 280 176 290 176 302.4C176 310.4 180.3 317.8 187.3 321.8L212.7 336.3C224.6 343.1 232 355.9 232 369.6C232 390.8 214.8 408 193.6 408H168C163.6 408 160 404.4 160 400C160 395.6 163.6 392 168 392H193.6C205.1 392 216 381.1 216 369.6C216 361.6 211.7 354.2 204.7 350.2L179.3 335.7C167.4 328.9 160 316.1 160 302.4zM272 303.6C272 332.6 280.3 361.1 296 385.5C311.7 361.1 320 332.6 320 303.6V272C320 267.6 323.6 264 328 264C332.4 264 336 267.6 336 272V303.6C336 336.7 326.2 369.1 307.8 396.7L302.7 404.4C301.2 406.7 298.7 408 296 408C293.3 408 290.8 406.7 289.3 404.4L284.2 396.7C265.8 369.1 256 336.7 256 303.6V272C256 267.6 259.6 264 264 264C268.4 264 272 267.6 272 272V303.6zM204.1 0C216.8 0 229.1 5.057 238.1 14.06L369.9 145.9C378.9 154.9 384 167.2 384 179.9V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V64C0 28.65 28.65 0 64 0L204.1 0zM64 496H320C346.5 496 368 474.5 368 448V179.9C368 178.6 367.9 177.3 367.8 176H248C225.9 176 208 158.1 208 136V16.24C206.7 16.08 205.4 16 204.1 16H64C37.49 16 16 37.49 16 64V448C16 474.5 37.49 496 64 496V496zM226.7 25.37C225.9 24.5 224.1 23.68 224 22.93V136C224 149.3 234.7 160 248 160H361.1C360.3 159 359.5 158.1 358.6 157.3L226.7 25.37z" />
    </svg>
  ),
  svgs_building: ({ width = 20, height = 20, fill = "#7c7c7c" }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 5C4 4.44772 4.44772 4 5 4H13C13.5523 4 14 4.44772 14 5V20H4V5Z" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 11C14 10.4477 14.4477 10 15 10H19C19.5523 10 20 10.4477 20 11V20H14V11Z" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22 20H2" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.75 6.25C6.61193 6.25 6.5 6.36193 6.5 6.5V7.5C6.5 7.63807 6.61193 7.75 6.75 7.75H7.75C7.88807 7.75 8 7.63807 8 7.5V6.5C8 6.36193 7.88807 6.25 7.75 6.25H6.75Z" fill={fill}/>
      <path d="M10.25 6.25C10.1119 6.25 10 6.36193 10 6.5V7.5C10 7.63807 10.1119 7.75 10.25 7.75H11.25C11.3881 7.75 11.5 7.63807 11.5 7.5V6.5C11.5 6.36193 11.3881 6.25 11.25 6.25H10.25Z" fill={fill}/>
      <path d="M6.5 9.5C6.5 9.36193 6.61193 9.25 6.75 9.25H7.75C7.88807 9.25 8 9.36193 8 9.5V10.5C8 10.6381 7.88807 10.75 7.75 10.75H6.75C6.61193 10.75 6.5 10.6381 6.5 10.5V9.5Z" fill={fill}/>
      <path d="M10.25 9.25C10.1119 9.25 10 9.36193 10 9.5V10.5C10 10.6381 10.1119 10.75 10.25 10.75H11.25C11.3881 10.75 11.5 10.6381 11.5 10.5V9.5C11.5 9.36193 11.3881 9.25 11.25 9.25H10.25Z" fill={fill}/>
      <path d="M6.5 12.5C6.5 12.3619 6.61193 12.25 6.75 12.25H7.75C7.88807 12.25 8 12.3619 8 12.5V13.5C8 13.6381 7.88807 13.75 7.75 13.75H6.75C6.61193 13.75 6.5 13.6381 6.5 13.5V12.5Z" fill={fill}/>
      <path d="M10.25 12.25C10.1119 12.25 10 12.3619 10 12.5V13.5C10 13.6381 10.1119 13.75 10.25 13.75H11.25C11.3881 13.75 11.5 13.6381 11.5 13.5V12.5C11.5 12.3619 11.3881 12.25 11.25 12.25H10.25Z" fill={fill}/>
      <path d="M7.5 16.5C7.5 16.2239 7.72386 16 8 16H10C10.2761 16 10.5 16.2239 10.5 16.5V20H7.5V16.5Z" fill={fill}/>
      <path d="M16.25 12.5C16.25 12.3619 16.3619 12.25 16.5 12.25H17.5C17.6381 12.25 17.75 12.3619 17.75 12.5V13.5C17.75 13.6381 17.6381 13.75 17.5 13.75H16.5C16.3619 13.75 16.25 13.6381 16.25 13.5V12.5Z" fill={fill}/>
      <path d="M16.25 15.5C16.25 15.3619 16.3619 15.25 16.5 15.25H17.5C17.6381 15.25 17.75 15.3619 17.75 15.5V16.5C17.75 16.6381 17.6381 16.75 17.5 16.75H16.5C16.3619 16.75 16.25 16.6381 16.25 16.5V15.5Z" fill={fill}/>
    </svg>
  ),
  svgs_buildingBlue: ({ width = 20, height = 20 }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 5C4 4.44772 4.44772 4 5 4H13C13.5523 4 14 4.44772 14 5V20H4V5Z" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 11C14 10.4477 14.4477 10 15 10H19C19.5523 10 20 10.4477 20 11V20H14V11Z" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22 20H2" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.75 6.25C6.61193 6.25 6.5 6.36193 6.5 6.5V7.5C6.5 7.63807 6.61193 7.75 6.75 7.75H7.75C7.88807 7.75 8 7.63807 8 7.5V6.5C8 6.36193 7.88807 6.25 7.75 6.25H6.75Z" fill="#29AEF8"/>
      <path d="M10.25 6.25C10.1119 6.25 10 6.36193 10 6.5V7.5C10 7.63807 10.1119 7.75 10.25 7.75H11.25C11.3881 7.75 11.5 7.63807 11.5 7.5V6.5C11.5 6.36193 11.3881 6.25 11.25 6.25H10.25Z" fill="#29AEF8"/>
      <path d="M6.5 9.5C6.5 9.36193 6.61193 9.25 6.75 9.25H7.75C7.88807 9.25 8 9.36193 8 9.5V10.5C8 10.6381 7.88807 10.75 7.75 10.75H6.75C6.61193 10.75 6.5 10.6381 6.5 10.5V9.5Z" fill="#29AEF8"/>
      <path d="M10.25 9.25C10.1119 9.25 10 9.36193 10 9.5V10.5C10 10.6381 10.1119 10.75 10.25 10.75H11.25C11.3881 10.75 11.5 10.6381 11.5 10.5V9.5C11.5 9.36193 11.3881 9.25 11.25 9.25H10.25Z" fill="#29AEF8"/>
      <path d="M6.5 12.5C6.5 12.3619 6.61193 12.25 6.75 12.25H7.75C7.88807 12.25 8 12.3619 8 12.5V13.5C8 13.6381 7.88807 13.75 7.75 13.75H6.75C6.61193 13.75 6.5 13.6381 6.5 13.5V12.5Z" fill="#29AEF8"/>
      <path d="M10.25 12.25C10.1119 12.25 10 12.3619 10 12.5V13.5C10 13.6381 10.1119 13.75 10.25 13.75H11.25C11.3881 13.75 11.5 13.6381 11.5 13.5V12.5C11.5 12.3619 11.3881 12.25 11.25 12.25H10.25Z" fill="#29AEF8"/>
      <path d="M7.5 16.5C7.5 16.2239 7.72386 16 8 16H10C10.2761 16 10.5 16.2239 10.5 16.5V20H7.5V16.5Z" fill="#29AEF8"/>
      <path d="M16.25 12.5C16.25 12.3619 16.3619 12.25 16.5 12.25H17.5C17.6381 12.25 17.75 12.3619 17.75 12.5V13.5C17.75 13.6381 17.6381 13.75 17.5 13.75H16.5C16.3619 13.75 16.25 13.6381 16.25 13.5V12.5Z" fill="#29AEF8"/>
      <path d="M16.25 15.5C16.25 15.3619 16.3619 15.25 16.5 15.25H17.5C17.6381 15.25 17.75 15.3619 17.75 15.5V16.5C17.75 16.6381 17.6381 16.75 17.5 16.75H16.5C16.3619 16.75 16.25 16.6381 16.25 16.5V15.5Z" fill="#29AEF8"/>
    </svg>
  ),
  svgs_unassignedProfiles: ({
    width = 20,
    height = 20,
    fill = "white",
    strokeFill = "#828282",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3629_15550_svgs_unassignedProfiles)">
        <path
          d="M9.99959 9.16667C11.8405 9.16667 13.3329 7.67428 13.3329 5.83333C13.3329 3.99238 11.8405 2.5 9.99959 2.5C8.15864 2.5 6.66626 3.99238 6.66626 5.83333C6.66626 7.67428 8.15864 9.16667 9.99959 9.16667Z"
          stroke="#828282"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 17.5V15.8333C5 14.9493 5.35119 14.1014 5.97631 13.4763C6.60143 12.8512 7.44928 12.5 8.33333 12.5H11.6667C12.5507 12.5 13.3986 12.8512 14.0237 13.4763C14.6488 14.1014 15 14.9493 15 15.8333V17.5"
          stroke="#828282"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 16.5H6M6 16.5L3.5 14M6 16.5L3.5 19"
          stroke="#F7F7F7"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 16.5H6M6 16.5L3.5 14M6 16.5L3.5 19"
          stroke="#828282"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3629_15550_svgs_unassignedProfiles">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_unassignedProfilesBlue: ({
    width = 20,
    height = 20,
    fill = "white",
    strokeFill = "#29AEF8",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3629_15550_svgs_unassignedProfiles)">
        <path
          d="M9.99959 9.16667C11.8405 9.16667 13.3329 7.67428 13.3329 5.83333C13.3329 3.99238 11.8405 2.5 9.99959 2.5C8.15864 2.5 6.66626 3.99238 6.66626 5.83333C6.66626 7.67428 8.15864 9.16667 9.99959 9.16667Z"
          stroke="#29AEF8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 17.5V15.8333C5 14.9493 5.35119 14.1014 5.97631 13.4763C6.60143 12.8512 7.44928 12.5 8.33333 12.5H11.6667C12.5507 12.5 13.3986 12.8512 14.0237 13.4763C14.6488 14.1014 15 14.9493 15 15.8333V17.5"
          stroke="#29AEF8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 16.5H6M6 16.5L3.5 14M6 16.5L3.5 19"
          stroke="#F7F7F7"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 16.5H6M6 16.5L3.5 14M6 16.5L3.5 19"
          stroke="#29AEF8"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3629_15550_svgs_unassignedProfiles">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_addProfilesMsTeams: ({
    width = 24,
    height = 23,
    fill = "white",
    strokeFill = "#828282",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 23"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3629_15570_svgs_addProfilesMsTeams)">
        <path
          d="M16.7403 8.62481H22.9395C23.5252 8.62481 24 9.11393 24 9.71731V15.5346C24 17.7521 22.255 19.5498 20.1025 19.5498H20.0841C17.9316 19.5501 16.1863 17.7527 16.186 15.5352C16.186 15.5353 16.186 15.535 16.186 15.5352V9.19579C16.186 8.88044 16.4342 8.62481 16.7403 8.62481Z"
          fill="#E0E0E0"
        />
        <path
          d="M20.9302 7.4748C22.3174 7.4748 23.4419 6.31634 23.4419 4.8873C23.4419 3.45827 22.3174 2.2998 20.9302 2.2998C19.5431 2.2998 18.4186 3.45827 18.4186 4.8873C18.4186 6.31634 19.5431 7.4748 20.9302 7.4748Z"
          fill="#E0E0E0"
        />
        <path
          d="M13.1164 7.47501C15.12 7.47501 16.7443 5.80167 16.7443 3.7375C16.7443 1.67334 15.12 0 13.1164 0C11.1127 0 9.48847 1.67334 9.48847 3.7375C9.48847 5.80167 11.1127 7.47501 13.1164 7.47501Z"
          fill="#BDBDBD"
        />
        <path
          d="M17.9538 8.625H7.72085C7.14214 8.63976 6.68436 9.13453 6.69778 9.73073V16.3657C6.61697 19.9434 9.36455 22.9125 12.8373 23C16.3101 22.9125 19.0577 19.9434 18.9769 16.3657V9.73073C18.9903 9.13453 18.5325 8.63976 17.9538 8.625Z"
          fill="#BDBDBD"
        />
        <mask
          id="path-3-outside-1_3629_15570_svgs_addProfilesMsTeams"
          maskUnits="userSpaceOnUse"
          x="-1"
          y="4.1748"
          width="15"
          height="15"
          fill="black"
        >
          <rect fill="white" x="-1" y="4.1748" width="15" height="15" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.256 5.1748H1.02306C0.458048 5.1748 0 5.64669 0 6.22878V16.7708C0 17.3529 0.458037 17.8248 1.02306 17.8248H11.256C11.821 17.8248 12.2791 17.3529 12.2791 16.7708V6.22878C12.2791 5.64669 11.821 5.1748 11.256 5.1748ZM6.787 9.18724H8.83259V8.07404H3.44766V9.18724H5.48375V14.9257H6.787V9.18724Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.256 5.1748H1.02306C0.458048 5.1748 0 5.64669 0 6.22878V16.7708C0 17.3529 0.458037 17.8248 1.02306 17.8248H11.256C11.821 17.8248 12.2791 17.3529 12.2791 16.7708V6.22878C12.2791 5.64669 11.821 5.1748 11.256 5.1748ZM6.787 9.18724H8.83259V8.07404H3.44766V9.18724H5.48375V14.9257H6.787V9.18724Z"
          fill="#828282"
        />
        <path
          d="M8.83259 9.18724V10.1872H9.83259V9.18724H8.83259ZM6.787 9.18724V8.18724H5.787V9.18724H6.787ZM8.83259 8.07404H9.83259V7.07404H8.83259V8.07404ZM3.44766 8.07404V7.07404H2.44766V8.07404H3.44766ZM3.44766 9.18724H2.44766V10.1872H3.44766V9.18724ZM5.48375 9.18724H6.48375V8.18724H5.48375V9.18724ZM5.48375 14.9257H4.48375V15.9257H5.48375V14.9257ZM6.787 14.9257V15.9257H7.787V14.9257H6.787ZM1.02306 6.1748H11.256V4.1748H1.02306V6.1748ZM1 6.22878C1 6.20398 1.00884 6.18862 1.0172 6.18002C1.0214 6.17569 1.02428 6.17439 1.02431 6.17438C1.02433 6.17437 1.02422 6.17442 1.02399 6.17449C1.02376 6.17457 1.02347 6.17465 1.02316 6.17471C1.02241 6.17487 1.02224 6.1748 1.02306 6.1748V4.1748C-0.122083 4.1748 -1 5.12267 -1 6.22878H1ZM1 16.7708V6.22878H-1V16.7708H1ZM1.02306 16.8248C1.02224 16.8248 1.0224 16.8247 1.02316 16.8249C1.02347 16.825 1.02375 16.825 1.02398 16.8251C1.02421 16.8252 1.02432 16.8252 1.02431 16.8252C1.02427 16.8252 1.0214 16.8239 1.0172 16.8196C1.00885 16.811 1 16.7956 1 16.7708H-1C-1 17.8769 -0.1221 18.8248 1.02306 18.8248V16.8248ZM11.256 16.8248H1.02306V18.8248H11.256V16.8248ZM11.2791 16.7708C11.2791 16.7956 11.2702 16.811 11.2619 16.8196C11.2577 16.8239 11.2548 16.8252 11.2547 16.8252C11.2547 16.8252 11.2548 16.8252 11.2551 16.8251C11.2553 16.825 11.2556 16.825 11.2559 16.8249C11.2567 16.8247 11.2568 16.8248 11.256 16.8248V18.8248C12.4011 18.8248 13.2791 17.877 13.2791 16.7708H11.2791ZM11.2791 6.22878V16.7708H13.2791V6.22878H11.2791ZM11.256 6.1748C11.2568 6.1748 11.2567 6.17487 11.2559 6.17471C11.2556 6.17465 11.2553 6.17457 11.2551 6.17449C11.2548 6.17442 11.2547 6.17437 11.2547 6.17438C11.2548 6.17439 11.2577 6.17568 11.2619 6.18001C11.2702 6.18862 11.2791 6.20398 11.2791 6.22878H13.2791C13.2791 5.12268 12.4012 4.1748 11.256 4.1748V6.1748ZM8.83259 8.18724H6.787V10.1872H8.83259V8.18724ZM7.83259 8.07404V9.18724H9.83259V8.07404H7.83259ZM3.44766 9.07404H8.83259V7.07404H3.44766V9.07404ZM4.44766 9.18724V8.07404H2.44766V9.18724H4.44766ZM5.48375 8.18724H3.44766V10.1872H5.48375V8.18724ZM6.48375 14.9257V9.18724H4.48375V14.9257H6.48375ZM6.787 13.9257H5.48375V15.9257H6.787V13.9257ZM5.787 9.18724V14.9257H7.787V9.18724H5.787Z"
          fill="#F7F7F7"
          mask="url(#path-3-outside-1_3629_15570_svgs_addProfilesMsTeams)"
        />
      </g>
      <defs>
        <clipPath id="clip0_3629_15570_svgs_addProfilesMsTeams">
          <rect width="24" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_addProfilesMsTeamsBlue: ({
    width = 24,
    height = 23,
    fill = "white",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 23"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3629_15570_svgs_addProfilesMsTeamsBlue)">
        <path
          d="M16.7403 8.62481H22.9395C23.5252 8.62481 24 9.11393 24 9.71731V15.5346C24 17.7521 22.255 19.5498 20.1025 19.5498H20.0841C17.9316 19.5501 16.1863 17.7527 16.186 15.5352C16.186 15.5353 16.186 15.535 16.186 15.5352V9.19579C16.186 8.88044 16.4342 8.62481 16.7403 8.62481Z"
          fill="#29aef84d"
        />
        <path
          d="M20.9302 7.4748C22.3174 7.4748 23.4419 6.31634 23.4419 4.8873C23.4419 3.45827 22.3174 2.2998 20.9302 2.2998C19.5431 2.2998 18.4186 3.45827 18.4186 4.8873C18.4186 6.31634 19.5431 7.4748 20.9302 7.4748Z"
          fill="#29aef84d"
        />
        <path
          d="M13.1164 7.47501C15.12 7.47501 16.7443 5.80167 16.7443 3.7375C16.7443 1.67334 15.12 0 13.1164 0C11.1127 0 9.48847 1.67334 9.48847 3.7375C9.48847 5.80167 11.1127 7.47501 13.1164 7.47501Z"
          fill="#29aef880"
        />
        <path
          d="M17.9538 8.625H7.72085C7.14214 8.63976 6.68436 9.13453 6.69778 9.73073V16.3657C6.61697 19.9434 9.36455 22.9125 12.8373 23C16.3101 22.9125 19.0577 19.9434 18.9769 16.3657V9.73073C18.9903 9.13453 18.5325 8.63976 17.9538 8.625Z"
          fill="#29aef880"
        />
        <mask
          id="path-3-outside-1_3629_15570_svgs_addProfilesMsTeamsBlue"
          maskUnits="userSpaceOnUse"
          x="-1"
          y="4.1748"
          width="15"
          height="15"
          fill="black"
        >
          <rect fill="white" x="-1" y="4.1748" width="15" height="15" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.256 5.1748H1.02306C0.458048 5.1748 0 5.64669 0 6.22878V16.7708C0 17.3529 0.458037 17.8248 1.02306 17.8248H11.256C11.821 17.8248 12.2791 17.3529 12.2791 16.7708V6.22878C12.2791 5.64669 11.821 5.1748 11.256 5.1748ZM6.787 9.18724H8.83259V8.07404H3.44766V9.18724H5.48375V14.9257H6.787V9.18724Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.256 5.1748H1.02306C0.458048 5.1748 0 5.64669 0 6.22878V16.7708C0 17.3529 0.458037 17.8248 1.02306 17.8248H11.256C11.821 17.8248 12.2791 17.3529 12.2791 16.7708V6.22878C12.2791 5.64669 11.821 5.1748 11.256 5.1748ZM6.787 9.18724H8.83259V8.07404H3.44766V9.18724H5.48375V14.9257H6.787V9.18724Z"
          fill="#29AEF8"
        />
        <path
          d="M8.83259 9.18724V10.1872H9.83259V9.18724H8.83259ZM6.787 9.18724V8.18724H5.787V9.18724H6.787ZM8.83259 8.07404H9.83259V7.07404H8.83259V8.07404ZM3.44766 8.07404V7.07404H2.44766V8.07404H3.44766ZM3.44766 9.18724H2.44766V10.1872H3.44766V9.18724ZM5.48375 9.18724H6.48375V8.18724H5.48375V9.18724ZM5.48375 14.9257H4.48375V15.9257H5.48375V14.9257ZM6.787 14.9257V15.9257H7.787V14.9257H6.787ZM1.02306 6.1748H11.256V4.1748H1.02306V6.1748ZM1 6.22878C1 6.20398 1.00884 6.18862 1.0172 6.18002C1.0214 6.17569 1.02428 6.17439 1.02431 6.17438C1.02433 6.17437 1.02422 6.17442 1.02399 6.17449C1.02376 6.17457 1.02347 6.17465 1.02316 6.17471C1.02241 6.17487 1.02224 6.1748 1.02306 6.1748V4.1748C-0.122083 4.1748 -1 5.12267 -1 6.22878H1ZM1 16.7708V6.22878H-1V16.7708H1ZM1.02306 16.8248C1.02224 16.8248 1.0224 16.8247 1.02316 16.8249C1.02347 16.825 1.02375 16.825 1.02398 16.8251C1.02421 16.8252 1.02432 16.8252 1.02431 16.8252C1.02427 16.8252 1.0214 16.8239 1.0172 16.8196C1.00885 16.811 1 16.7956 1 16.7708H-1C-1 17.8769 -0.1221 18.8248 1.02306 18.8248V16.8248ZM11.256 16.8248H1.02306V18.8248H11.256V16.8248ZM11.2791 16.7708C11.2791 16.7956 11.2702 16.811 11.2619 16.8196C11.2577 16.8239 11.2548 16.8252 11.2547 16.8252C11.2547 16.8252 11.2548 16.8252 11.2551 16.8251C11.2553 16.825 11.2556 16.825 11.2559 16.8249C11.2567 16.8247 11.2568 16.8248 11.256 16.8248V18.8248C12.4011 18.8248 13.2791 17.877 13.2791 16.7708H11.2791ZM11.2791 6.22878V16.7708H13.2791V6.22878H11.2791ZM11.256 6.1748C11.2568 6.1748 11.2567 6.17487 11.2559 6.17471C11.2556 6.17465 11.2553 6.17457 11.2551 6.17449C11.2548 6.17442 11.2547 6.17437 11.2547 6.17438C11.2548 6.17439 11.2577 6.17568 11.2619 6.18001C11.2702 6.18862 11.2791 6.20398 11.2791 6.22878H13.2791C13.2791 5.12268 12.4012 4.1748 11.256 4.1748V6.1748ZM8.83259 8.18724H6.787V10.1872H8.83259V8.18724ZM7.83259 8.07404V9.18724H9.83259V8.07404H7.83259ZM3.44766 9.07404H8.83259V7.07404H3.44766V9.07404ZM4.44766 9.18724V8.07404H2.44766V9.18724H4.44766ZM5.48375 8.18724H3.44766V10.1872H5.48375V8.18724ZM6.48375 14.9257V9.18724H4.48375V14.9257H6.48375ZM6.787 13.9257H5.48375V15.9257H6.787V13.9257ZM5.787 9.18724V14.9257H7.787V9.18724H5.787Z"
          fill="#F7F7F7"
          mask="url(#path-3-outside-1_3629_15570_svgs_addProfilesMsTeamsBlue)"
        />
      </g>
      <defs>
        <clipPath id="clip0_3629_15570_svgs_addProfilesMsTeamsBlue">
          <rect width="24" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_integrationMsTeams: ({ width = 42, height = 42 }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3629_26605_svgs_integrationMsTeams)">
        <path
          d="M28.8081 17.375H38.3653C39.2682 17.375 40.0001 18.0768 40.0001 18.9425V27.289C40.0001 30.4707 37.31 33.05 33.9915 33.05H33.9631C30.6446 33.0504 27.9541 30.4715 27.9536 27.2898C27.9536 27.2896 27.9536 27.2893 27.9536 27.289V18.1942C27.9536 17.7418 28.3362 17.375 28.8081 17.375Z"
          fill="#5059C9"
        />
        <path
          d="M35.2676 15.7258C37.4061 15.7258 39.1397 14.0636 39.1397 12.0133C39.1397 9.96293 37.4061 8.30078 35.2676 8.30078C33.1291 8.30078 31.3955 9.96293 31.3955 12.0133C31.3955 14.0636 33.1291 15.7258 35.2676 15.7258Z"
          fill="#5059C9"
        />
        <path
          d="M23.221 15.725C26.3099 15.725 28.814 13.3241 28.814 10.3625C28.814 7.40088 26.3099 5 23.221 5C20.132 5 17.6279 7.40088 17.6279 10.3625C17.6279 13.3241 20.132 15.725 23.221 15.725Z"
          fill="#7B83EB"
        />
        <path
          d="M30.6784 17.375H14.9027C14.0105 17.3962 13.3047 18.1061 13.3254 18.9615V28.4812C13.2008 33.6145 17.4367 37.8744 22.7906 38C28.1444 37.8744 32.3803 33.6145 32.2557 28.4812V18.9615C32.2764 18.1061 31.5706 17.3962 30.6784 17.375Z"
          fill="#7B83EB"
        />
        <path
          opacity="0.1"
          d="M23.6512 17.375V30.7153C23.647 31.327 23.2603 31.8766 22.6703 32.1095C22.4825 32.1857 22.2806 32.225 22.0766 32.225H14.0829C13.971 31.9528 13.8677 31.6805 13.7817 31.4C13.4805 30.4533 13.3268 29.4692 13.3256 28.4795V18.959C13.305 18.1049 14.0096 17.3962 14.9003 17.375H23.6512Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M22.7908 17.375V31.5402C22.7908 31.7358 22.7498 31.9294 22.6703 32.1095C22.4274 32.6752 21.8542 33.0459 21.2161 33.05H14.4873C14.341 32.7777 14.2033 32.5055 14.0829 32.225C13.9624 31.9445 13.8677 31.6805 13.7817 31.4C13.4805 30.4534 13.3268 29.4692 13.3256 28.4795V18.959C13.305 18.1049 14.0096 17.3962 14.9003 17.375H22.7908Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M22.7908 17.375V29.8903C22.7842 30.7215 22.0831 31.3937 21.2161 31.4H13.7817C13.4805 30.4534 13.3268 29.4692 13.3256 28.4795V18.959C13.305 18.1049 14.0096 17.3962 14.9003 17.375H22.7908Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M21.9303 17.375V29.8903C21.9237 30.7215 21.2226 31.3937 20.3556 31.4H13.7817C13.4805 30.4534 13.3268 29.4692 13.3256 28.4795V18.959C13.305 18.1049 14.0096 17.3962 14.9003 17.375H21.9303Z"
          fill="black"
        />
        <path
          opacity="0.1"
          d="M23.6511 13.1093V15.7081C23.5048 15.7163 23.3671 15.7246 23.2209 15.7246C23.0746 15.7246 22.9369 15.7164 22.7906 15.7081C22.5002 15.6896 22.2121 15.6454 21.9302 15.5761C20.1877 15.1805 18.7482 14.0088 18.0581 12.4246C17.9393 12.1586 17.8471 11.8823 17.7827 11.5996H22.0764C22.9447 11.6028 23.6478 12.2768 23.6511 13.1093Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M22.7907 13.9355V15.7093C22.5002 15.6908 22.2122 15.6466 21.9302 15.5773C20.1878 15.1816 18.7482 14.01 18.0581 12.4258H21.216C22.0843 12.4289 22.7874 13.103 22.7907 13.9355Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M22.7907 13.9355V15.7093C22.5002 15.6908 22.2122 15.6466 21.9302 15.5773C20.1878 15.1816 18.7482 14.01 18.0581 12.4258H21.216C22.0843 12.4289 22.7874 13.103 22.7907 13.9355Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M21.9302 13.9355V15.5773C20.1877 15.1816 18.7482 14.01 18.0581 12.4258H20.3555C21.2238 12.4289 21.9269 13.103 21.9302 13.9355Z"
          fill="black"
        />
        <path
          d="M4.57722 12.4258H20.353C21.2241 12.4258 21.9302 13.1028 21.9302 13.938V29.0636C21.9302 29.8987 21.2241 30.5758 20.353 30.5758H4.57722C3.70614 30.5758 3 29.8987 3 29.0636V13.938C3 13.1028 3.70616 12.4258 4.57722 12.4258Z"
          fill="url(#paint0_linear_3629_26605)"
        />
        <path
          d="M16.6162 18.1812H13.4626V26.4147H11.4534V18.1812H8.31445V16.584H16.6162V18.1812Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3629_26605"
          x1="6.28857"
          y1="11.2442"
          x2="17.8783"
          y2="32.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A62C3" />
          <stop offset="0.5" stopColor="#4D55BD" />
          <stop offset="1" stopColor="#3940AB" />
        </linearGradient>
        <clipPath id="clip0_3629_26605_svgs_integrationMsTeams">
          <rect
            width="37"
            height="33"
            fill="white"
            transform="translate(3 5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_deviceRightArrow: () => (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 512"
    >
      <path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z" />
    </svg>
  ),
  svgs_deviceLeftArrow: () => (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 512"
    >
      <path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z" />
    </svg>
  ),
  svgs_reassign: ({ strokeFill = "#BDBDBD", width = "24", height = "24" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 4.75L8.75 7L11.25 9.25"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 19.25L15.25 17L12.75 14.75"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 7H13.25C16.5637 7 19.25 9.68629 19.25 13V13.25"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 17H10.75C7.43629 17 4.75 14.3137 4.75 11V10.75"
        stroke={strokeFill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_groupsIcon: ({
    width = 16, height = 16, strokeFill = "#BDBDBD", fill = "none",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99856 6.9102C9.23609 6.9102 10.2393 5.90699 10.2393 4.66946C10.2393 3.43193 9.23609 2.42871 7.99856 2.42871C6.76103 2.42871 5.75781 3.43193 5.75781 4.66946C5.75781 5.90699 6.76103 6.9102 7.99856 6.9102Z"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9199 3.54883C12.2931 3.64437 12.6238 3.86139 12.86 4.16567C13.0962 4.46996 13.2244 4.84419 13.2244 5.22939C13.2244 5.61458 13.0962 5.98882 12.86 6.2931C12.6238 6.59738 12.2931 6.8144 11.9199 6.90995"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.07812 3.54883C3.70497 3.64437 3.37423 3.86139 3.13804 4.16567C2.90185 4.46996 2.77365 4.84419 2.77365 5.22939C2.77365 5.61458 2.90185 5.98882 3.13804 6.2931C3.37423 6.59738 3.70497 6.8144 4.07812 6.90995"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.35742 13.0721V12.5919C4.35742 11.0008 5.75476 9.71094 7.47846 9.71094H8.51881C10.2425 9.71094 11.6398 11.0008 11.6398 12.5919V13.0721"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9984 13.0722V12.592C14.9984 11.64 14.4981 10.7958 13.727 10.2712C13.5169 10.1283 13.2867 10.0091 13.041 9.91797"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.999675 13.0722V12.592C0.999675 11.64 1.49996 10.7958 2.27109 10.2712C2.48118 10.1283 2.71137 10.0091 2.95703 9.91797"
        stroke={strokeFill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_templates: ({ width = 16, height = 16, fill = "#828282" }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44771 2 3 2Z" stroke={fill} strokeWidth="0.891039" strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="4" y="4" width="8" height="4" stroke={fill} strokeWidth="0.891039" strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="4" y="10" width="3" height="2" stroke={fill} strokeWidth="0.891039" strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="9" y="10" width="3" height="2" stroke={fill} strokeWidth="0.891039" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_filetype: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.7998 1.6001V4.8001C8.7998 5.01227 8.88409 5.21575 9.03412 5.36578C9.18415 5.51581 9.38763 5.6001 9.5998 5.6001H12.7998"
        stroke="#BDBDBD"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4288 14.4001H4.57162C4.2079 14.4001 3.85907 14.2503 3.60188 13.9835C3.34468 13.7168 3.2002 13.3551 3.2002 12.9779V3.02232C3.2002 2.64512 3.34468 2.28338 3.60188 2.01666C3.85907 1.74994 4.2079 1.6001 4.57162 1.6001H9.37162L12.8002 5.15565V12.9779C12.8002 13.3551 12.6557 13.7168 12.3985 13.9835C12.1413 14.2503 11.7925 14.4001 11.4288 14.4001Z"
        stroke="#BDBDBD"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_admin: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 8.75L18.25 4.75H5.75L9.75 8.75"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.25 14C17.25 16.8995 14.8995 19.25 12 19.25C9.10051 19.25 6.75 16.8995 6.75 14C6.75 11.1005 9.10051 8.75 12 8.75C14.8995 8.75 17.25 11.1005 17.25 14Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_store: ({ width = 16, height = 16, fill = "#BDBDBD" }) => (
    <svg width={width}
      height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 5L13.4444 12.1996C13.3717 12.7155 13.1762 13.1781 12.892 13.507C12.6078 13.8359 12.2528 14.0102 11.8889 13.9995H4.11111C3.74719 14.0102 3.39223 13.8359 3.108 13.507C2.82377 13.1781 2.62828 12.7155 2.55556 12.1996L1 5H15Z" stroke={fill} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 11C8.82843 11 9.5 10.3284 9.5 9.5C9.5 8.67157 8.82843 8 8 8C7.17157 8 6.5 8.67157 6.5 9.5C6.5 10.3284 7.17157 11 8 11Z" stroke={fill} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4 5L6 1" stroke={fill} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 5L10 1" stroke={fill} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_optionAddTag: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M7.25 8C7.80228 8 8.25 7.55228 8.25 7C8.25 6.44772 7.80228 6 7.25 6C6.69772 6 6.25 6.44772 6.25 7C6.25 7.55228 6.69772 8 7.25 8Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.25 5.47056V8.64852C3.25 9.09075 3.42541 9.51486 3.73835 9.8278L10.422 16.5115C10.5769 16.6664 10.7607 16.7892 10.9631 16.873C11.1654 16.9569 11.3823 17 11.6013 17C11.8203 17 12.0372 16.9569 12.2395 16.873C12.4419 16.7892 12.6257 16.6664 12.7806 16.5115L16.7615 12.5306C16.9164 12.3757 17.0392 12.1919 17.123 11.9895C17.2069 11.7872 17.25 11.5703 17.25 11.3513C17.25 11.1323 17.2069 10.9154 17.123 10.7131C17.0392 10.5107 16.9164 10.3269 16.7615 10.172L10.077 3.48835C9.7644 3.17582 9.34053 3.00017 8.89852 3H5.72056C5.06532 3 4.43693 3.26029 3.97361 3.72361C3.51029 4.18693 3.25 4.81532 3.25 5.47056V5.47056Z"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_optionDeleteTag: ({ strokeFill = "#828282" }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14552_58115)">
        <rect width="20" height="20" fill="none"/>
        <path d="M4.79175 6.45831L5.49271 14.5194C5.5676 15.3806 6.2886 16.0416 7.15311 16.0416H12.0137C12.8782 16.0416 13.5992 15.3806 13.6741 14.5194L14.3751 6.45831H4.79175Z" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.125 8.95831V13.5416" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.0417 8.95831V13.5416" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.29175 6.45831V5.62498C7.29175 4.70451 8.03794 3.95831 8.95841 3.95831H10.2084C11.1289 3.95831 11.8751 4.70451 11.8751 5.62498V6.45831" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.95825 6.45831H15.2083" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_14552_58115">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_optionReassing: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.37533 3.95801L7.29199 5.83301L9.37533 7.70801"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.625 16.042L12.7083 14.167L10.625 12.292"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.125 5.83301H11.0417C13.8031 5.83301 16.0417 8.07158 16.0417 10.833V11.0413"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8747 14.1663H8.95801C6.19658 14.1663 3.95801 11.9278 3.95801 9.16634V8.95801"
        stroke="#828282"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_exportBtnIcon: ({ width = 20, height = 20, fill = "none" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_639_2632)">
        <path
          d="M9.99935 9.16667C11.8403 9.16667 13.3327 7.67428 13.3327 5.83333C13.3327 3.99238 11.8403 2.5 9.99935 2.5C8.1584 2.5 6.66602 3.99238 6.66602 5.83333C6.66602 7.67428 8.1584 9.16667 9.99935 9.16667Z"
          stroke="#828282"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 17.5V15.8333C5 14.9493 5.35119 14.1014 5.97631 13.4763C6.60143 12.8512 7.44928 12.5 8.33333 12.5H11.6667C12.5507 12.5 13.3986 12.8512 14.0237 13.4763C14.6488 14.1014 15 14.9493 15 15.8333V17.5"
          stroke="#828282"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 16.5H19M19 16.5L16.5 14M19 16.5L16.5 19"
          stroke="#F7F7F7"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 16.5H19M19 16.5L16.5 14M19 16.5L16.5 19"
          stroke="#828282"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_639_2632">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_pardot: ({ width = 52, height = 52 }) => (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 1250 834"
      enableBackground="new 0 0 1250 834"
      xmlSpace="preserve"
    >
      <path
        fill="#FFFFFF"
        opacity="0"
        stroke="none"
        d="
 M865.000000,835.000000
   C576.701111,835.000000 288.902252,835.000000 1.051700,835.000000
   C1.051700,557.067749 1.051700,279.135529 1.051700,1.101634
   C417.549011,1.101634 834.098022,1.101634 1250.823486,1.101634
   C1250.823486,278.999908 1250.823486,556.999939 1250.823486,835.000000
   C1122.468628,835.000000 993.984314,835.000000 865.000000,835.000000
 M777.421814,378.057404
   C789.025940,377.635712 800.905640,378.678192 812.189392,376.554291
   C884.435547,362.955505 928.591919,289.985779 907.957153,219.201691
   C893.605103,169.969315 850.776062,133.947067 797.372253,130.183884
   C778.829346,128.877228 760.791443,131.941559 743.561279,139.030319
   C740.620178,140.240295 739.355774,139.683197 737.660217,137.101669
   C715.833496,103.869827 685.541199,86.962585 645.216919,88.912498
   C627.599365,89.764397 611.591064,94.985519 597.044434,104.654404
   C590.657227,108.899879 584.827759,113.984337 578.657349,118.755623
   C577.939697,117.897552 577.213013,116.994507 576.450867,116.122490
   C547.275574,82.742455 510.597656,70.128761 467.341980,78.392685
   C440.978516,83.429382 419.463440,97.530556 402.814606,118.749222
   C387.114746,138.758362 379.632538,161.787048 379.342896,186.927414
   C379.186584,200.494537 381.538635,214.000031 386.862579,226.689178
   C388.247192,229.989304 387.280243,231.276169 384.663818,233.430084
   C376.814545,239.891876 368.335999,246.064178 362.113464,253.938217
   C343.321442,277.717712 336.977203,305.005157 343.067719,334.806915
   C350.871094,372.990143 381.462860,403.036377 419.912628,409.072632
   C431.531403,410.896667 443.678528,409.354950 455.620789,409.354950
   C473.759705,450.102386 504.384491,474.470673 549.675049,475.684540
   C595.179871,476.904144 627.168701,454.100922 647.584717,413.907043
   C648.794128,414.326080 650.059998,414.684143 651.262085,415.192871
   C689.843079,431.521790 734.055115,419.866058 758.708801,385.994904
   C763.677551,379.168488 768.028381,375.056641 777.421814,378.057404
 M332.485168,611.000000
   C313.552460,609.734253 298.062225,616.275208 286.054016,632.428345
   C285.643005,627.326416 285.567352,623.228394 284.863190,619.241455
   C284.591400,617.702454 282.967834,615.278259 281.831787,615.203369
   C275.739532,614.801636 269.606812,615.013672 263.748840,615.013672
   C263.748840,678.834717 263.748840,742.154358 263.748840,805.673401
   C271.876801,805.673401 279.253632,805.673401 287.040161,805.673401
   C287.040161,781.803040 287.040161,758.255249 287.040161,734.505432
   C288.097992,734.782288 288.867920,734.763428 289.317749,735.133606
   C301.513489,745.171082 315.548523,748.431274 331.184296,748.166077
   C354.164642,747.776245 370.580902,737.077942 380.673096,717.323364
   C391.229065,696.660889 391.632263,674.426331 385.554749,652.402649
   C378.625153,627.291138 358.693848,609.638916 332.485168,611.000000
 M630.443054,659.076904
   C626.876404,674.432190 627.172424,689.807251 631.070374,704.988159
   C635.449036,722.040833 644.199097,736.018005 660.751160,743.947998
   C670.687866,748.708679 681.296509,748.178406 691.844971,747.970947
   C701.028198,747.790405 709.824585,745.792969 717.294067,740.220642
   C722.554016,736.296570 727.322571,731.713806 731.722839,727.930481
   C732.086792,732.482605 732.530396,738.030579 732.980957,743.665283
   C740.234985,743.665283 746.957581,743.665283 753.194824,743.665283
   C753.194824,683.694031 753.194824,624.052795 753.194824,564.379761
   C745.007874,564.379761 737.632141,564.379761 729.837158,564.379761
   C729.837158,584.950256 729.837158,605.144653 729.837158,625.665100
   C712.811768,612.412537 697.997925,608.027405 677.763672,611.100098
   C653.463623,614.790222 635.573975,634.463501 630.443054,659.076904
 M516.002686,725.229858
   C516.001770,718.230469 516.088745,711.229736 515.983032,704.231934
   C515.699463,685.462708 516.339233,666.606750 514.708557,647.951721
   C513.171997,630.374207 503.378754,617.383545 484.436005,612.989319
   C469.880249,609.612854 455.212982,609.806274 440.775665,613.256653
   C431.470306,615.480530 422.542267,619.119446 414.705566,625.247498
   C417.446564,630.078003 420.006958,634.590271 422.462646,638.917969
   C430.098206,636.110840 437.108032,632.367065 444.540680,631.096252
   C453.847168,629.504944 463.866028,628.099609 472.928589,629.892944
   C491.658752,633.599243 494.018433,646.158203 493.507111,664.000000
   C491.243011,664.000000 488.955383,664.020325 486.668213,663.996826
   C470.635773,663.831909 454.577850,663.476440 438.954956,668.019653
   C429.738770,670.699707 420.841675,673.913025 414.898743,682.272949
   C406.475281,694.122131 405.409271,707.221497 408.473602,720.835083
   C411.349823,733.612793 419.492950,742.465454 431.996307,745.655762
   C440.322327,747.780090 449.331940,748.021179 457.995178,747.760803
   C464.225983,747.573547 470.903625,746.211853 476.452179,743.483276
   C483.178497,740.175537 488.925812,734.876892 495.072205,730.457336
   C495.698486,734.350708 496.475677,739.182190 497.193237,743.643066
   C504.608887,743.643066 511.201538,743.643066 517.981323,743.643066
   C517.299255,737.574707 516.658691,731.876038 516.002686,725.229858
 M903.924500,639.713623
   C898.503540,631.281311 891.886780,624.045166 883.086609,619.024780
   C866.085266,609.325623 847.598816,609.124390 829.246338,612.286682
   C809.934937,615.614258 796.080688,627.644592 788.494080,645.432922
   C779.662781,666.139709 779.765320,687.696350 787.135681,708.939331
   C792.790466,725.237488 803.844238,736.782349 819.886902,743.455627
   C834.950745,749.721619 850.485291,749.158569 866.040649,746.400757
   C878.253235,744.235596 888.526550,737.925354 896.553528,728.652771
   C904.491211,719.483459 909.195923,708.640869 911.345886,696.511292
   C914.810303,676.965637 913.215637,658.266846 903.924500,639.713623
 M1003.000000,626.394348
   C1003.000000,622.652039 1003.000000,618.909790 1003.000000,614.778381
   C991.236694,614.778381 980.309814,614.778381 968.852600,614.778381
   C968.852600,601.660706 968.852600,588.941406 968.852600,575.072937
   C961.145874,577.868530 954.225403,580.238831 947.463989,582.999146
   C946.562561,583.367188 946.082275,585.706665 946.062866,587.142151
   C945.939331,596.258362 946.000061,605.376953 946.000061,614.515381
   C938.102966,615.535034 930.682068,616.493164 923.263306,617.451050
   C923.263306,622.323547 923.263306,626.915466 923.263306,632.088989
   C930.898071,632.088989 938.286255,632.088989 946.000000,632.088989
   C946.000000,634.813110 945.977661,636.952515 946.003357,639.091370
   C946.330872,666.340881 946.303345,693.602112 947.184143,720.833801
   C947.515442,731.079407 953.608154,738.858765 962.649841,743.829285
   C968.034058,746.789307 973.798035,748.400085 980.143677,748.075073
   C988.133301,747.665833 996.272522,748.808289 1004.051025,745.268311
   C1002.857666,739.735474 1001.703247,734.382935 1000.572876,729.142151
   C995.801941,729.449890 991.540039,729.922607 987.274109,729.962158
   C975.493042,730.071472 969.006104,723.525024 969.002380,711.724731
   C968.994446,686.909912 968.995667,662.095093 969.009827,637.280273
   C969.010742,635.665161 969.152527,634.050171 969.247070,632.047852
   C980.487488,632.047852 991.414612,632.047852 1002.678955,632.047852
   C1002.803284,630.230774 1002.901672,628.792786 1003.000000,626.394348
 M615.416565,631.000000
   C617.526978,631.000000 619.637390,631.000000 622.370178,631.000000
   C622.370178,624.008850 622.370178,617.667419 622.370178,611.358459
   C602.537598,609.114624 585.756104,613.647583 575.095703,633.257874
   C574.667053,627.699463 574.537964,623.235474 573.859863,618.856628
   C573.643555,617.460205 572.028137,615.247864 570.952759,615.187317
   C564.716003,614.835999 558.449341,615.015564 552.891846,615.015564
   C552.891846,658.438477 552.891846,701.101868 552.891846,743.707153
   C561.047180,743.707153 568.307129,743.707153 576.000000,743.707153
   C576.000000,741.624634 576.000000,739.829895 576.000000,738.035156
   C576.000000,717.543762 575.942261,697.052002 576.045715,676.561157
   C576.068115,672.126160 576.298706,667.628296 577.070312,663.272278
   C580.035217,646.532959 591.247437,629.319946 615.416565,631.000000
 z"
      />
      <path
        fill="#01A1E0"
        opacity="1.000000"
        stroke="none"
        d="
 M776.968994,378.030884
   C768.028381,375.056641 763.677551,379.168488 758.708801,385.994904
   C734.055115,419.866058 689.843079,431.521790 651.262085,415.192871
   C650.059998,414.684143 648.794128,414.326080 647.584717,413.907043
   C627.168701,454.100922 595.179871,476.904144 549.675049,475.684540
   C504.384491,474.470673 473.759705,450.102386 455.620789,409.354950
   C443.678528,409.354950 431.531403,410.896667 419.912628,409.072632
   C381.462860,403.036377 350.871094,372.990143 343.067719,334.806915
   C336.977203,305.005157 343.321442,277.717712 362.113464,253.938217
   C368.335999,246.064178 376.814545,239.891876 384.663818,233.430084
   C387.280243,231.276169 388.247192,229.989304 386.862579,226.689178
   C381.538635,214.000031 379.186584,200.494537 379.342896,186.927414
   C379.632538,161.787048 387.114746,138.758362 402.814606,118.749222
   C419.463440,97.530556 440.978516,83.429382 467.341980,78.392685
   C510.597656,70.128761 547.275574,82.742455 576.450867,116.122490
   C577.213013,116.994507 577.939697,117.897552 578.657349,118.755623
   C584.827759,113.984337 590.657227,108.899879 597.044434,104.654404
   C611.591064,94.985519 627.599365,89.764397 645.216919,88.912498
   C685.541199,86.962585 715.833496,103.869827 737.660217,137.101669
   C739.355774,139.683197 740.620178,140.240295 743.561279,139.030319
   C760.791443,131.941559 778.829346,128.877228 797.372253,130.183884
   C850.776062,133.947067 893.605103,169.969315 907.957153,219.201691
   C928.591919,289.985779 884.435547,362.955505 812.189392,376.554291
   C800.905640,378.678192 789.025940,377.635712 776.968994,378.030884
 M664.766418,232.546890
   C666.530151,223.871933 673.080750,224.400269 679.649231,225.302582
   C680.656738,222.456665 681.524963,220.004211 682.530518,217.163925
   C676.307861,214.653366 670.457214,214.866745 664.811768,217.302460
   C656.014160,221.098190 654.498779,229.601715 652.521484,238.057434
   C649.751099,238.057434 647.150085,238.057434 644.354919,238.057434
   C643.849182,241.026611 643.412964,243.587570 642.923523,246.461151
   C645.913940,246.737183 648.456299,246.971863 651.339355,247.237991
   C648.402649,263.204498 645.873474,278.802673 642.565857,294.234009
   C640.632812,303.252136 637.211975,304.839905 627.170410,303.176392
   C626.312561,305.832184 625.438049,308.539673 624.582947,311.187164
   C636.535034,316.168915 647.657166,311.682495 651.497498,300.264740
   C653.604431,294.000671 654.751526,287.386322 655.997009,280.865997
   C658.141235,269.640656 660.024109,258.365387 662.065857,246.833038
   C665.628418,246.833038 669.326538,247.848816 671.753113,246.528168
   C673.891174,245.364578 674.608521,241.590439 676.538147,237.829056
   C671.229187,237.829056 667.675659,237.829056 663.808167,237.829056
   C664.117554,235.918701 664.327148,234.624832 664.766418,232.546890
 M548.137878,245.715607
   C540.165466,257.991394 541.436096,276.011078 550.863831,284.375458
   C559.113708,291.694794 578.877686,292.659637 586.952148,285.953674
   C586.067078,283.629486 585.153259,281.229614 584.276367,278.926880
   C563.678833,283.653229 553.956909,279.514221 555.335388,266.414886
   C557.374268,266.414886 559.484436,266.409729 561.594604,266.415833
   C569.419983,266.438446 577.247375,266.561981 585.068604,266.392700
   C586.350403,266.364899 588.598389,265.190125 588.718323,264.315033
   C589.980469,255.104538 586.947449,240.840973 573.896667,237.719482
   C564.103271,235.377090 555.420166,237.220139 548.137878,245.715607
 M825.641968,266.396484
   C834.943542,266.396484 844.245117,266.396484 854.805359,266.396484
   C854.060730,260.496735 854.045166,254.953140 852.536072,249.851334
   C850.828491,244.078766 846.600647,239.932983 840.587341,238.019867
   C822.441040,232.246613 806.863525,245.666992 808.432861,265.736145
   C809.501099,279.395996 816.084778,288.050262 827.600159,289.659271
   C833.132202,290.432251 838.941528,290.260223 844.501404,289.548462
   C852.656799,288.504425 853.129028,287.200500 850.019226,279.706818
   C849.908203,279.439331 849.563538,279.268799 849.319397,279.062195
   C828.020752,283.225861 820.740967,280.213440 820.386230,266.690002
   C821.797791,266.593018 823.240356,266.493866 825.641968,266.396484
 M476.443726,249.087006
   C481.944092,248.070145 487.427307,246.352036 492.949219,246.217209
   C499.570343,246.055542 502.070190,250.030182 500.903839,256.103851
   C494.162201,256.748627 487.429657,256.641571 481.099823,258.185547
   C472.939911,260.175903 468.407837,267.714661 469.261658,275.599335
   C470.161133,283.906189 475.578766,289.621948 484.513672,289.816620
   C492.582367,289.992462 500.701996,288.840881 508.750732,287.872314
   C510.005310,287.721344 511.937866,285.446655 511.968689,284.117157
   C512.207947,273.796753 512.224792,263.462982 511.961639,253.142273
   C511.814850,247.383377 509.557739,242.460892 504.257629,239.421310
   C496.493683,234.968704 479.670807,236.266464 471.837646,242.292969
   C473.076294,244.549591 474.364380,246.896255 476.443726,249.087006
 M723.921570,266.265717
   C723.919312,264.432892 723.991882,262.596405 723.902954,260.767792
   C723.245972,247.256989 714.922180,237.816849 702.927917,236.935211
   C688.536133,235.877335 679.317200,242.719742 676.758972,257.096436
   C674.764282,268.306122 676.119507,279.052246 686.134888,286.289825
   C701.891602,297.676300 721.129639,287.775452 723.921570,266.265717
 M628.042114,287.686859
   C638.719910,279.596466 637.625854,267.225861 625.665039,261.417236
   C623.585083,260.407135 621.305542,259.815369 619.146240,258.959564
   C616.067505,257.739410 612.845764,256.738861 610.027405,255.067383
   C608.754700,254.312592 607.462402,252.014969 607.700134,250.690338
   C607.993164,249.057922 609.597351,247.162582 611.140320,246.388596
   C612.785828,245.563202 615.094543,245.499161 616.984680,245.833252
   C621.651978,246.658249 626.245483,247.901138 631.346191,249.087112
   C632.154663,246.754822 632.995667,244.328568 633.967834,241.523849
   C625.080994,236.726364 616.212952,234.816956 606.828613,238.186859
   C601.073181,240.253616 597.516418,244.492630 597.020325,250.837189
   C596.449280,258.140045 599.150208,262.609436 606.362305,265.579132
   C611.115967,267.536560 616.205994,268.720581 620.842163,270.896851
   C622.519775,271.684357 624.348816,274.424835 624.226868,276.140350
   C624.100952,277.911560 621.996033,280.217255 620.192383,281.018311
   C618.070007,281.961029 615.185425,282.153687 612.906494,281.579498
   C607.979004,280.337921 603.227051,278.399597 598.077820,276.634674
   C597.617981,277.752899 596.502930,279.381561 596.379028,281.082428
   C596.264343,282.658051 596.711853,285.201355 597.765930,285.790497
   C607.220337,291.074860 617.104980,292.634674 628.042114,287.686859
 M443.506500,290.693237
   C445.983215,290.424591 448.500031,290.350647 450.929138,289.850647
   C458.167694,288.360748 462.790253,282.883453 463.242676,275.521576
   C463.711639,267.890015 460.028595,263.387665 450.576874,259.944336
   C446.532959,258.471100 442.377106,257.191986 438.569183,255.243942
   C437.199615,254.543289 435.744995,251.927399 436.046844,250.566605
   C436.426025,248.857315 438.328522,247.079056 440.024261,246.192062
   C441.491638,245.424469 443.653687,245.509399 445.394501,245.832535
   C449.907013,246.670227 454.356506,247.847031 459.421173,249.025757
   C460.283936,246.822052 461.260040,244.328918 462.302307,241.666855
   C453.229156,236.622498 444.324249,234.841766 434.962921,238.233215
   C428.765869,240.478287 425.424927,245.305267 425.034241,251.911148
   C424.675568,257.975647 427.882446,262.638428 434.170624,265.388184
   C436.445679,266.383057 438.862885,267.050781 441.208252,267.887299
   C443.862366,268.833923 446.777527,269.392975 449.069000,270.897552
   C450.749969,272.001282 452.673553,274.440643 452.541412,276.132629
   C452.402588,277.910858 450.247864,280.260040 448.424072,280.995056
   C446.113129,281.926239 443.091278,282.106140 440.654419,281.496735
   C435.899139,280.307526 431.337280,278.344910 426.594543,276.666901
   C422.423737,283.505493 422.651550,285.006927 430.058380,287.855133
   C434.025330,289.380554 438.427643,289.773773 443.506500,290.693237
 M795.159363,246.143066
   C797.433105,246.504089 799.706787,246.865112 802.343201,247.283722
   C803.295593,244.494827 804.165833,241.946350 805.022644,239.437363
   C791.185425,233.831100 776.697205,236.893463 770.026184,246.480865
   C763.079712,256.464233 763.684753,274.020142 771.270874,282.595459
   C778.449585,290.710236 794.697632,293.041595 805.388672,287.185669
   C804.528748,284.682953 803.641113,282.099792 802.743958,279.488770
   C794.229919,281.386169 785.774048,283.611908 779.830444,275.656525
   C774.825928,268.958069 775.503357,261.081482 778.472046,253.725723
   C781.282227,246.762680 787.461853,245.466675 795.159363,246.143066
 M522.954102,261.500000
   C522.954102,270.620392 522.954102,279.740753 522.954102,288.902283
   C526.800659,288.902283 530.164124,288.902283 533.496338,288.902283
   C533.496338,264.687469 533.496338,240.941422 533.496338,216.897873
   C529.935486,216.897873 526.681519,216.897873 522.954102,216.897873
   C522.954102,231.597672 522.954102,246.048828 522.954102,261.500000
 M748.590393,238.891632
   C747.045227,239.816452 745.500061,240.741272 743.617371,241.868134
   C743.277832,240.478180 742.993896,239.315826 742.745789,238.300079
   C739.408020,238.300079 736.325500,238.300079 732.904785,238.300079
   C732.904785,246.939255 732.904846,255.239899 732.904846,263.540527
   C732.904846,271.986145 732.904785,280.431793 732.904785,289.051727
   C736.689880,289.051727 739.942566,289.051727 743.738647,289.051727
   C743.738647,286.960144 743.727539,285.175110 743.740601,283.390259
   C743.799011,275.399078 743.597473,267.394348 744.003113,259.420624
   C744.401733,251.583557 748.791626,247.219574 755.619629,246.987854
   C761.657043,246.782959 762.817627,245.448746 762.897522,237.383148
   C758.294312,237.790726 753.802673,238.188400 748.590393,238.891632
 z"
      />
      <path
        fill="#7F898F"
        opacity="1.000000"
        stroke="none"
        d="
 M332.977600,611.000000
   C358.693848,609.638916 378.625153,627.291138 385.554749,652.402649
   C391.632263,674.426331 391.229065,696.660889 380.673096,717.323364
   C370.580902,737.077942 354.164642,747.776245 331.184296,748.166077
   C315.548523,748.431274 301.513489,745.171082 289.317749,735.133606
   C288.867920,734.763428 288.097992,734.782288 287.040161,734.505432
   C287.040161,758.255249 287.040161,781.803040 287.040161,805.673401
   C279.253632,805.673401 271.876801,805.673401 263.748840,805.673401
   C263.748840,742.154358 263.748840,678.834717 263.748840,615.013672
   C269.606812,615.013672 275.739532,614.801636 281.831787,615.203369
   C282.967834,615.278259 284.591400,617.702454 284.863190,619.241455
   C285.567352,623.228394 285.643005,627.326416 286.054016,632.428345
   C298.062225,616.275208 313.552460,609.734253 332.977600,611.000000
 M365.997101,676.714478
   C365.328949,671.841858 364.952332,666.907837 363.940826,662.107544
   C360.100586,643.883057 347.623474,627.898499 325.773102,628.761414
   C303.496857,629.641174 287.974731,647.201965 287.113098,667.598816
   C286.522858,681.571167 286.865967,695.591064 287.133148,709.583191
   C287.177216,711.891479 288.549805,714.523132 290.079590,716.364746
   C291.930023,718.592468 294.541901,720.219604 296.927826,721.965088
   C306.297699,728.820068 316.883331,730.710388 328.288605,730.072815
   C339.558411,729.442810 348.321381,724.820312 355.103455,715.802307
   C363.663422,704.420227 365.333252,691.207336 365.997101,676.714478
 z"
      />
      <path
        fill="#7F898F"
        opacity="1.000000"
        stroke="none"
        d="
 M630.656982,658.710022
   C635.573975,634.463501 653.463623,614.790222 677.763672,611.100098
   C697.997925,608.027405 712.811768,612.412537 729.837158,625.665100
   C729.837158,605.144653 729.837158,584.950256 729.837158,564.379761
   C737.632141,564.379761 745.007874,564.379761 753.194824,564.379761
   C753.194824,624.052795 753.194824,683.694031 753.194824,743.665283
   C746.957581,743.665283 740.234985,743.665283 732.980957,743.665283
   C732.530396,738.030579 732.086792,732.482605 731.722839,727.930481
   C727.322571,731.713806 722.554016,736.296570 717.294067,740.220642
   C709.824585,745.792969 701.028198,747.790405 691.844971,747.970947
   C681.296509,748.178406 670.687866,748.708679 660.751160,743.947998
   C644.199097,736.018005 635.449036,722.040833 631.070374,704.988159
   C627.172424,689.807251 626.876404,674.432190 630.656982,658.710022
 M685.867493,629.001587
   C672.818726,630.614319 663.915894,638.067505 658.300720,649.453186
   C649.546448,667.203857 648.903503,686.167969 655.482422,704.164978
   C664.078674,727.680298 677.315552,732.841614 698.550171,729.542664
   C718.155151,726.496765 728.589478,711.840393 729.837830,691.847534
   C730.686462,678.255493 730.025085,664.567444 729.962463,650.922729
   C729.955994,649.511047 729.892456,647.674194 729.058594,646.767395
   C725.921692,643.356384 722.718689,639.905396 719.060242,637.094421
   C709.542786,629.781738 698.458557,628.084167 685.867493,629.001587
 z"
      />
      <path
        fill="#7F898F"
        opacity="1.000000"
        stroke="none"
        d="
 M516.010376,725.703613
   C516.658691,731.876038 517.299255,737.574707 517.981323,743.643066
   C511.201538,743.643066 504.608887,743.643066 497.193237,743.643066
   C496.475677,739.182190 495.698486,734.350708 495.072205,730.457336
   C488.925812,734.876892 483.178497,740.175537 476.452179,743.483276
   C470.903625,746.211853 464.225983,747.573547 457.995178,747.760803
   C449.331940,748.021179 440.322327,747.780090 431.996307,745.655762
   C419.492950,742.465454 411.349823,733.612793 408.473602,720.835083
   C405.409271,707.221497 406.475281,694.122131 414.898743,682.272949
   C420.841675,673.913025 429.738770,670.699707 438.954956,668.019653
   C454.577850,663.476440 470.635773,663.831909 486.668213,663.996826
   C488.955383,664.020325 491.243011,664.000000 493.507111,664.000000
   C494.018433,646.158203 491.658752,633.599243 472.928589,629.892944
   C463.866028,628.099609 453.847168,629.504944 444.540680,631.096252
   C437.108032,632.367065 430.098206,636.110840 422.462646,638.917969
   C420.006958,634.590271 417.446564,630.078003 414.705566,625.247498
   C422.542267,619.119446 431.470306,615.480530 440.775665,613.256653
   C455.212982,609.806274 469.880249,609.612854 484.436005,612.989319
   C503.378754,617.383545 513.171997,630.374207 514.708557,647.951721
   C516.339233,666.606750 515.699463,685.462708 515.983032,704.231934
   C516.088745,711.229736 516.001770,718.230469 516.010376,725.703613
 M493.556000,696.918152
   C493.556000,691.361023 493.556000,685.803894 493.556000,679.083618
   C479.667053,680.081299 466.108337,680.513245 452.717072,682.242310
   C445.862946,683.127258 439.085480,685.854248 434.868286,692.375732
   C429.703522,700.362671 429.766174,709.003113 432.425446,717.488586
   C434.053345,722.683105 437.793976,727.137939 443.697510,728.205200
   C448.994507,729.162781 454.431122,730.022095 459.780701,729.890503
   C476.845001,729.470581 493.344086,713.864441 493.556000,696.918152
 z"
      />
      <path
        fill="#7F898F"
        opacity="1.000000"
        stroke="none"
        d="
 M904.016602,640.075989
   C913.215637,658.266846 914.810303,676.965637 911.345886,696.511292
   C909.195923,708.640869 904.491211,719.483459 896.553528,728.652771
   C888.526550,737.925354 878.253235,744.235596 866.040649,746.400757
   C850.485291,749.158569 834.950745,749.721619 819.886902,743.455627
   C803.844238,736.782349 792.790466,725.237488 787.135681,708.939331
   C779.765320,687.696350 779.662781,666.139709 788.494080,645.432922
   C796.080688,627.644592 809.934937,615.614258 829.246338,612.286682
   C847.598816,609.124390 866.085266,609.325623 883.086609,619.024780
   C891.886780,624.045166 898.503540,631.281311 904.016602,640.075989
 M828.090088,632.426025
   C816.797607,637.576904 811.345947,647.422180 808.140808,658.538635
   C804.658203,670.617981 804.965027,683.129089 807.160461,695.366821
   C809.336426,707.496033 814.821350,718.112976 825.616821,725.030945
   C833.470032,730.063477 842.365906,730.202942 851.366211,730.064697
   C863.720093,729.875000 873.303711,724.656250 880.044983,714.586792
   C891.327393,697.734070 891.975708,679.194824 887.526184,660.139587
   C885.439819,651.204712 881.648010,642.878845 874.223816,637.144226
   C860.226868,626.332642 844.686584,626.966431 828.090088,632.426025
 z"
      />
      <path
        fill="#7F898F"
        opacity="1.000000"
        stroke="none"
        d="
 M1003.000000,626.874573
   C1002.901672,628.792786 1002.803284,630.230774 1002.678955,632.047852
   C991.414612,632.047852 980.487488,632.047852 969.247070,632.047852
   C969.152527,634.050171 969.010742,635.665161 969.009827,637.280273
   C968.995667,662.095093 968.994446,686.909912 969.002380,711.724731
   C969.006104,723.525024 975.493042,730.071472 987.274109,729.962158
   C991.540039,729.922607 995.801941,729.449890 1000.572876,729.142151
   C1001.703247,734.382935 1002.857666,739.735474 1004.051025,745.268311
   C996.272522,748.808289 988.133301,747.665833 980.143677,748.075073
   C973.798035,748.400085 968.034058,746.789307 962.649841,743.829285
   C953.608154,738.858765 947.515442,731.079407 947.184143,720.833801
   C946.303345,693.602112 946.330872,666.340881 946.003357,639.091370
   C945.977661,636.952515 946.000000,634.813110 946.000000,632.088989
   C938.286255,632.088989 930.898071,632.088989 923.263306,632.088989
   C923.263306,626.915466 923.263306,622.323547 923.263306,617.451050
   C930.682068,616.493164 938.102966,615.535034 946.000061,614.515381
   C946.000061,605.376953 945.939331,596.258362 946.062866,587.142151
   C946.082275,585.706665 946.562561,583.367188 947.463989,582.999146
   C954.225403,580.238831 961.145874,577.868530 968.852600,575.072937
   C968.852600,588.941406 968.852600,601.660706 968.852600,614.778381
   C980.309814,614.778381 991.236694,614.778381 1003.000000,614.778381
   C1003.000000,618.909790 1003.000000,622.652039 1003.000000,626.874573
 z"
      />
      <path
        fill="#7F898F"
        opacity="1.000000"
        stroke="none"
        d="
 M614.934937,631.000000
   C591.247437,629.319946 580.035217,646.532959 577.070312,663.272278
   C576.298706,667.628296 576.068115,672.126160 576.045715,676.561157
   C575.942261,697.052002 576.000000,717.543762 576.000000,738.035156
   C576.000000,739.829895 576.000000,741.624634 576.000000,743.707153
   C568.307129,743.707153 561.047180,743.707153 552.891846,743.707153
   C552.891846,701.101868 552.891846,658.438477 552.891846,615.015564
   C558.449341,615.015564 564.716003,614.835999 570.952759,615.187317
   C572.028137,615.247864 573.643555,617.460205 573.859863,618.856628
   C574.537964,623.235474 574.667053,627.699463 575.095703,633.257874
   C585.756104,613.647583 602.537598,609.114624 622.370178,611.358459
   C622.370178,617.667419 622.370178,624.008850 622.370178,631.000000
   C619.637390,631.000000 617.526978,631.000000 614.934937,631.000000
 z"
      />
      <path
        fill="#F9FDFE"
        opacity="1.000000"
        stroke="none"
        d="
 M664.651550,232.938934
   C664.327148,234.624832 664.117554,235.918701 663.808167,237.829056
   C667.675659,237.829056 671.229187,237.829056 676.538147,237.829056
   C674.608521,241.590439 673.891174,245.364578 671.753113,246.528168
   C669.326538,247.848816 665.628418,246.833038 662.065857,246.833038
   C660.024109,258.365387 658.141235,269.640656 655.997009,280.865997
   C654.751526,287.386322 653.604431,294.000671 651.497498,300.264740
   C647.657166,311.682495 636.535034,316.168915 624.582947,311.187164
   C625.438049,308.539673 626.312561,305.832184 627.170410,303.176392
   C637.211975,304.839905 640.632812,303.252136 642.565857,294.234009
   C645.873474,278.802673 648.402649,263.204498 651.339355,247.237991
   C648.456299,246.971863 645.913940,246.737183 642.923523,246.461151
   C643.412964,243.587570 643.849182,241.026611 644.354919,238.057434
   C647.150085,238.057434 649.751099,238.057434 652.521484,238.057434
   C654.498779,229.601715 656.014160,221.098190 664.811768,217.302460
   C670.457214,214.866745 676.307861,214.653366 682.530518,217.163925
   C681.524963,220.004211 680.656738,222.456665 679.649231,225.302582
   C673.080750,224.400269 666.530151,223.871933 664.651550,232.938934
 z"
      />
      <path
        fill="#F9FDFE"
        opacity="1.000000"
        stroke="none"
        d="
 M548.355591,245.425140
   C555.420166,237.220139 564.103271,235.377090 573.896667,237.719482
   C586.947449,240.840973 589.980469,255.104538 588.718323,264.315033
   C588.598389,265.190125 586.350403,266.364899 585.068604,266.392700
   C577.247375,266.561981 569.419983,266.438446 561.594604,266.415833
   C559.484436,266.409729 557.374268,266.414886 555.335388,266.414886
   C553.956909,279.514221 563.678833,283.653229 584.276367,278.926880
   C585.153259,281.229614 586.067078,283.629486 586.952148,285.953674
   C578.877686,292.659637 559.113708,291.694794 550.863831,284.375458
   C541.436096,276.011078 540.165466,257.991394 548.355591,245.425140
 M567.487061,258.063385
   C570.926880,258.063385 574.366760,258.063385 577.809875,258.063385
   C577.657471,250.314468 573.862671,246.032990 567.348206,245.811020
   C559.934143,245.558395 555.835571,249.544876 555.183838,258.063416
   C558.974976,258.063416 562.738403,258.063416 567.487061,258.063385
 z"
      />
      <path
        fill="#FAFDFE"
        opacity="1.000000"
        stroke="none"
        d="
 M825.162476,266.395630
   C823.240356,266.493866 821.797791,266.593018 820.386230,266.690002
   C820.740967,280.213440 828.020752,283.225861 849.323608,279.057617
   C849.563538,279.268799 849.908203,279.439331 850.019226,279.706818
   C853.129028,287.200500 852.656799,288.504425 844.501404,289.548462
   C838.941528,290.260223 833.132202,290.432251 827.600159,289.659271
   C816.084778,288.050262 809.501099,279.395996 808.432861,265.736145
   C806.863525,245.666992 822.441040,232.246613 840.587341,238.019867
   C846.600647,239.932983 850.828491,244.078766 852.536072,249.851334
   C854.045166,254.953140 854.060730,260.496735 854.805359,266.396484
   C844.245117,266.396484 834.943542,266.396484 825.162476,266.395630
 M842.767700,252.957855
   C839.462341,246.524933 835.176575,244.453888 828.635071,246.128357
   C823.836975,247.356537 820.846313,252.019455 821.164185,257.837646
   C828.563782,257.837646 835.964478,257.837646 843.566406,257.837646
   C843.331177,256.289124 843.135010,254.997833 842.767700,252.957855
 z"
      />
      <path
        fill="#FAFDFE"
        opacity="1.000000"
        stroke="none"
        d="
 M476.048096,249.164978
   C474.364380,246.896255 473.076294,244.549591 471.837646,242.292969
   C479.670807,236.266464 496.493683,234.968704 504.257629,239.421310
   C509.557739,242.460892 511.814850,247.383377 511.961639,253.142273
   C512.224792,263.462982 512.207947,273.796753 511.968689,284.117157
   C511.937866,285.446655 510.005310,287.721344 508.750732,287.872314
   C500.701996,288.840881 492.582367,289.992462 484.513672,289.816620
   C475.578766,289.621948 470.161133,283.906189 469.261658,275.599335
   C468.407837,267.714661 472.939911,260.175903 481.099823,258.185547
   C487.429657,256.641571 494.162201,256.748627 500.903839,256.103851
   C502.070190,250.030182 499.570343,246.055542 492.949219,246.217209
   C487.427307,246.352036 481.944092,248.070145 476.048096,249.164978
 M501.082581,280.575592
   C501.271729,276.295197 501.598511,272.012634 501.532501,267.736176
   C501.519470,266.893433 499.999451,265.369812 499.162506,265.361511
   C494.715027,265.317474 490.190796,265.233215 485.834808,265.984283
   C481.687408,266.699463 479.908844,270.033142 480.083252,274.146790
   C480.253693,278.168152 482.522217,280.919464 486.464935,281.208710
   C491.043488,281.544617 495.681915,281.064453 501.082581,280.575592
 z"
      />
      <path
        fill="#F9FDFE"
        opacity="1.000000"
        stroke="none"
        d="
 M723.899597,266.721375
   C721.129639,287.775452 701.891602,297.676300 686.134888,286.289825
   C676.119507,279.052246 674.764282,268.306122 676.758972,257.096436
   C679.317200,242.719742 688.536133,235.877335 702.927917,236.935211
   C714.922180,237.816849 723.245972,247.256989 723.902954,260.767792
   C723.991882,262.596405 723.919312,264.432892 723.899597,266.721375
 M712.353760,258.379791
   C711.930115,256.784241 711.623230,255.146210 711.061646,253.600739
   C709.085815,248.162384 705.917603,245.970398 700.204102,245.944931
   C694.575500,245.919846 690.079712,248.124237 689.299255,253.383163
   C688.302490,260.099426 688.302063,267.185638 689.291748,273.903259
   C690.062317,279.133270 694.774597,281.597260 700.104492,281.625641
   C705.400879,281.653839 709.473999,279.258118 710.895935,273.839478
   C712.129028,269.140472 712.051636,264.097534 712.353760,258.379791
 z"
      />
      <path
        fill="#F8FCFE"
        opacity="1.000000"
        stroke="none"
        d="
 M627.710815,287.866455
   C617.104980,292.634674 607.220337,291.074860 597.765930,285.790497
   C596.711853,285.201355 596.264343,282.658051 596.379028,281.082428
   C596.502930,279.381561 597.617981,277.752899 598.077820,276.634674
   C603.227051,278.399597 607.979004,280.337921 612.906494,281.579498
   C615.185425,282.153687 618.070007,281.961029 620.192383,281.018311
   C621.996033,280.217255 624.100952,277.911560 624.226868,276.140350
   C624.348816,274.424835 622.519775,271.684357 620.842163,270.896851
   C616.205994,268.720581 611.115967,267.536560 606.362305,265.579132
   C599.150208,262.609436 596.449280,258.140045 597.020325,250.837189
   C597.516418,244.492630 601.073181,240.253616 606.828613,238.186859
   C616.212952,234.816956 625.080994,236.726364 633.967834,241.523849
   C632.995667,244.328568 632.154663,246.754822 631.346191,249.087112
   C626.245483,247.901138 621.651978,246.658249 616.984680,245.833252
   C615.094543,245.499161 612.785828,245.563202 611.140320,246.388596
   C609.597351,247.162582 607.993164,249.057922 607.700134,250.690338
   C607.462402,252.014969 608.754700,254.312592 610.027405,255.067383
   C612.845764,256.738861 616.067505,257.739410 619.146240,258.959564
   C621.305542,259.815369 623.585083,260.407135 625.665039,261.417236
   C637.625854,267.225861 638.719910,279.596466 627.710815,287.866455
 z"
      />
      <path
        fill="#F8FCFE"
        opacity="1.000000"
        stroke="none"
        d="
 M443.070007,290.685577
   C438.427643,289.773773 434.025330,289.380554 430.058380,287.855133
   C422.651550,285.006927 422.423737,283.505493 426.594543,276.666901
   C431.337280,278.344910 435.899139,280.307526 440.654419,281.496735
   C443.091278,282.106140 446.113129,281.926239 448.424072,280.995056
   C450.247864,280.260040 452.402588,277.910858 452.541412,276.132629
   C452.673553,274.440643 450.749969,272.001282 449.069000,270.897552
   C446.777527,269.392975 443.862366,268.833923 441.208252,267.887299
   C438.862885,267.050781 436.445679,266.383057 434.170624,265.388184
   C427.882446,262.638428 424.675568,257.975647 425.034241,251.911148
   C425.424927,245.305267 428.765869,240.478287 434.962921,238.233215
   C444.324249,234.841766 453.229156,236.622498 462.302307,241.666855
   C461.260040,244.328918 460.283936,246.822052 459.421173,249.025757
   C454.356506,247.847031 449.907013,246.670227 445.394501,245.832535
   C443.653687,245.509399 441.491638,245.424469 440.024261,246.192062
   C438.328522,247.079056 436.426025,248.857315 436.046844,250.566605
   C435.744995,251.927399 437.199615,254.543289 438.569183,255.243942
   C442.377106,257.191986 446.532959,258.471100 450.576874,259.944336
   C460.028595,263.387665 463.711639,267.890015 463.242676,275.521576
   C462.790253,282.883453 458.167694,288.360748 450.929138,289.850647
   C448.500031,290.350647 445.983215,290.424591 443.070007,290.685577
 z"
      />
      <path
        fill="#FAFDFE"
        opacity="1.000000"
        stroke="none"
        d="
 M794.713501,246.115921
   C787.461853,245.466675 781.282227,246.762680 778.472046,253.725723
   C775.503357,261.081482 774.825928,268.958069 779.830444,275.656525
   C785.774048,283.611908 794.229919,281.386169 802.743958,279.488770
   C803.641113,282.099792 804.528748,284.682953 805.388672,287.185669
   C794.697632,293.041595 778.449585,290.710236 771.270874,282.595459
   C763.684753,274.020142 763.079712,256.464233 770.026184,246.480865
   C776.697205,236.893463 791.185425,233.831100 805.022644,239.437363
   C804.165833,241.946350 803.295593,244.494827 802.343201,247.283722
   C799.706787,246.865112 797.433105,246.504089 794.713501,246.115921
 z"
      />
      <path
        fill="#F8FCFE"
        opacity="1.000000"
        stroke="none"
        d="
 M522.954102,261.000000
   C522.954102,246.048828 522.954102,231.597672 522.954102,216.897873
   C526.681519,216.897873 529.935486,216.897873 533.496338,216.897873
   C533.496338,240.941422 533.496338,264.687469 533.496338,288.902283
   C530.164124,288.902283 526.800659,288.902283 522.954102,288.902283
   C522.954102,279.740753 522.954102,270.620392 522.954102,261.000000
 z"
      />
      <path
        fill="#F9FDFE"
        opacity="1.000000"
        stroke="none"
        d="
 M748.950684,238.738861
   C753.802673,238.188400 758.294312,237.790726 762.897522,237.383148
   C762.817627,245.448746 761.657043,246.782959 755.619629,246.987854
   C748.791626,247.219574 744.401733,251.583557 744.003113,259.420624
   C743.597473,267.394348 743.799011,275.399078 743.740601,283.390259
   C743.727539,285.175110 743.738647,286.960144 743.738647,289.051727
   C739.942566,289.051727 736.689880,289.051727 732.904785,289.051727
   C732.904785,280.431793 732.904846,271.986145 732.904846,263.540527
   C732.904846,255.239899 732.904785,246.939255 732.904785,238.300079
   C736.325500,238.300079 739.408020,238.300079 742.745789,238.300079
   C742.993896,239.315826 743.277832,240.478180 743.617371,241.868134
   C745.500061,240.741272 747.045227,239.816452 748.950684,238.738861
 z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
 M365.998322,677.178955
   C365.333252,691.207336 363.663422,704.420227 355.103455,715.802307
   C348.321381,724.820312 339.558411,729.442810 328.288605,730.072815
   C316.883331,730.710388 306.297699,728.820068 296.927826,721.965088
   C294.541901,720.219604 291.930023,718.592468 290.079590,716.364746
   C288.549805,714.523132 287.177216,711.891479 287.133148,709.583191
   C286.865967,695.591064 286.522858,681.571167 287.113098,667.598816
   C287.974731,647.201965 303.496857,629.641174 325.773102,628.761414
   C347.623474,627.898499 360.100586,643.883057 363.940826,662.107544
   C364.952332,666.907837 365.328949,671.841858 365.998322,677.178955
 z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
 M686.330688,629.000793
   C698.458557,628.084167 709.542786,629.781738 719.060242,637.094421
   C722.718689,639.905396 725.921692,643.356384 729.058594,646.767395
   C729.892456,647.674194 729.955994,649.511047 729.962463,650.922729
   C730.025085,664.567444 730.686462,678.255493 729.837830,691.847534
   C728.589478,711.840393 718.155151,726.496765 698.550171,729.542664
   C677.315552,732.841614 664.078674,727.680298 655.482422,704.164978
   C648.903503,686.167969 649.546448,667.203857 658.300720,649.453186
   C663.915894,638.067505 672.818726,630.614319 686.330688,629.000793
 z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
 M493.342316,697.319092
   C493.344086,713.864441 476.845001,729.470581 459.780701,729.890503
   C454.431122,730.022095 448.994507,729.162781 443.697510,728.205200
   C437.793976,727.137939 434.053345,722.683105 432.425446,717.488586
   C429.766174,709.003113 429.703522,700.362671 434.868286,692.375732
   C439.085480,685.854248 445.862946,683.127258 452.717072,682.242310
   C466.108337,680.513245 479.667053,680.081299 493.556000,679.083618
   C493.556000,685.803894 493.556000,691.361023 493.342316,697.319092
 z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
 M828.431274,632.241943
   C844.686584,626.966431 860.226868,626.332642 874.223816,637.144226
   C881.648010,642.878845 885.439819,651.204712 887.526184,660.139587
   C891.975708,679.194824 891.327393,697.734070 880.044983,714.586792
   C873.303711,724.656250 863.720093,729.875000 851.366211,730.064697
   C842.365906,730.202942 833.470032,730.063477 825.616821,725.030945
   C814.821350,718.112976 809.336426,707.496033 807.160461,695.366821
   C804.965027,683.129089 804.658203,670.617981 808.140808,658.538635
   C811.345947,647.422180 816.797607,637.576904 828.431274,632.241943
 z"
      />
      <path
        fill="#03A2E0"
        opacity="1.000000"
        stroke="none"
        d="
 M566.994507,258.063416
   C562.738403,258.063416 558.974976,258.063416 555.183838,258.063416
   C555.835571,249.544876 559.934143,245.558395 567.348206,245.811020
   C573.862671,246.032990 577.657471,250.314468 577.809875,258.063385
   C574.366760,258.063385 570.926880,258.063385 566.994507,258.063416
 z"
      />
      <path
        fill="#06A3E1"
        opacity="1.000000"
        stroke="none"
        d="
 M842.853271,253.332199
   C843.135010,254.997833 843.331177,256.289124 843.566406,257.837646
   C835.964478,257.837646 828.563782,257.837646 821.164185,257.837646
   C820.846313,252.019455 823.836975,247.356537 828.635071,246.128357
   C835.176575,244.453888 839.462341,246.524933 842.853271,253.332199
 z"
      />
      <path
        fill="#0AA5E1"
        opacity="1.000000"
        stroke="none"
        d="
 M500.688477,280.757019
   C495.681915,281.064453 491.043488,281.544617 486.464935,281.208710
   C482.522217,280.919464 480.253693,278.168152 480.083252,274.146790
   C479.908844,270.033142 481.687408,266.699463 485.834808,265.984283
   C490.190796,265.233215 494.715027,265.317474 499.162506,265.361511
   C499.999451,265.369812 501.519470,266.893433 501.532501,267.736176
   C501.598511,272.012634 501.271729,276.295197 500.688477,280.757019
 z"
      />
      <path
        fill="#04A2E0"
        opacity="1.000000"
        stroke="none"
        d="
 M712.453613,258.793213
   C712.051636,264.097534 712.129028,269.140472 710.895935,273.839478
   C709.473999,279.258118 705.400879,281.653839 700.104492,281.625641
   C694.774597,281.597260 690.062317,279.133270 689.291748,273.903259
   C688.302063,267.185638 688.302490,260.099426 689.299255,253.383163
   C690.079712,248.124237 694.575500,245.919846 700.204102,245.944931
   C705.917603,245.970398 709.085815,248.162384 711.061646,253.600739
   C711.623230,255.146210 711.930115,256.784241 712.453613,258.793213
 z"
      />
    </svg>
  ),
  svgs_newpardot: () => (
    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="72" height="72" rx="12" fill="#FFFFFF"/>
      <g clipPath="url(#clip0_6070_87827)">
        <path d="M32.6151 18.058C35.2862 15.2618 39.7182 15.1605 42.5144 17.8315C43.0369 18.3307 43.4788 18.9077 43.8249 19.5421C44.9189 19.0531 46.1045 18.8025 47.3029 18.8073C52.0965 18.8073 55.9825 22.6933 55.9825 27.4869C55.9825 32.2805 52.0966 36.1665 47.3029 36.1665C46.7343 36.1654 46.1673 36.1067 45.6106 35.9917C44.4967 37.9777 42.3988 39.2093 40.1218 39.2136C39.1701 39.2178 38.2305 38.9991 37.3787 38.5745C35.8227 42.2226 31.604 43.9186 27.9559 42.3628C26.1425 41.5892 24.7269 40.1044 24.0409 38.2563C23.59 38.3528 23.1304 38.4011 22.6693 38.3999C18.9468 38.3517 15.9681 35.2954 16.0162 31.5728C16.0465 29.212 17.31 27.039 19.3468 25.8448C18.9207 24.8707 18.7036 23.8179 18.7101 22.7546C18.7027 18.479 22.1628 15.0072 26.4382 15C28.8583 14.9959 31.1409 16.1238 32.608 18.0484" fill="#139CD8"/>
        <path d="M21.8061 29.496C21.7891 29.528 21.796 29.5674 21.8229 29.5917C21.9019 29.6396 21.9665 29.6875 22.0455 29.7353C22.4139 29.9286 22.8266 30.0219 23.2423 30.0059C24.0562 30.0059 24.566 29.575 24.566 28.8736V28.8569C24.566 28.2034 23.9915 27.9784 23.4483 27.8036L23.3884 27.7797C22.9886 27.6529 22.6392 27.5403 22.6392 27.2699V27.2531C22.6392 27.0305 22.8474 26.8534 23.1657 26.8534C23.5281 26.8581 23.8838 26.951 24.2023 27.1239C24.2354 27.1474 24.2812 27.1399 24.3051 27.1071V27.0904C24.3219 27.0425 24.4656 26.6762 24.4656 26.6428C24.4753 26.6075 24.4632 26.5697 24.4343 26.547C24.0773 26.3353 23.6694 26.2253 23.2543 26.2286H23.1753C22.426 26.2286 21.8993 26.6762 21.8993 27.3297V27.3464C21.8993 28.0334 22.4738 28.2561 23.0173 28.3998L23.0962 28.4308C23.496 28.5577 23.8312 28.6534 23.8312 28.9263V28.9431C23.8312 29.1993 23.6084 29.3908 23.2567 29.3908C22.8834 29.3942 22.5174 29.2884 22.2034 29.0867C22.1387 29.0555 22.1077 29.022 22.0766 29.0077C22.0435 28.9841 21.9976 28.9917 21.9736 29.0244V29.0411L21.8061 29.496Z" fill="white"/>
        <path d="M33.7711 29.496C33.7539 29.528 33.7608 29.5674 33.7877 29.5917C33.8669 29.6396 33.9313 29.6875 34.0105 29.7353C34.3789 29.9286 34.7915 30.0219 35.2071 30.0059C36.021 30.0059 36.531 29.575 36.531 28.8736V28.8569C36.531 28.2034 35.9565 27.9784 35.413 27.8036L35.3555 27.7797C34.9558 27.6529 34.6064 27.5403 34.6064 27.2699V27.2531C34.6064 27.0305 34.8145 26.8534 35.133 26.8534C35.4952 26.8581 35.851 26.951 36.1694 27.1239C36.2026 27.1474 36.2484 27.1399 36.2723 27.1071V27.0904C36.2891 27.0425 36.4328 26.6762 36.4328 26.6428C36.4425 26.6075 36.4304 26.5697 36.4016 26.547C36.0445 26.3354 35.6366 26.2254 35.2215 26.2286H35.1426C34.3932 26.2286 33.8668 26.6762 33.8668 27.3297V27.3464C33.8668 28.0334 34.4411 28.2561 34.9846 28.3998L35.0635 28.4308C35.4633 28.5577 35.7984 28.6534 35.7984 28.9263V28.9431C35.7984 29.1993 35.5759 29.3908 35.2239 29.3908C34.8508 29.3942 34.4846 29.2884 34.1707 29.0867C34.1062 29.0555 34.0749 29.022 34.0439 29.0077C34.0107 28.9841 33.9647 28.9916 33.9408 29.0244V29.0411L33.7711 29.496Z" fill="white"/>
        <path d="M42.6496 27.39C42.5875 27.1751 42.4842 26.9744 42.3456 26.7988C42.1989 26.6313 42.0197 26.4953 41.819 26.399C41.3486 26.2081 40.8221 26.2081 40.3517 26.399C40.1508 26.4952 39.9716 26.6313 39.8251 26.7988C39.6804 26.9704 39.5765 27.1725 39.521 27.39C39.394 27.8709 39.394 28.3765 39.521 28.8573C39.5831 29.0723 39.6863 29.273 39.8251 29.4486C39.9716 29.6161 40.1509 29.7521 40.3517 29.8483C40.8221 30.0394 41.3485 30.0394 41.819 29.8483C42.0232 29.758 42.2036 29.621 42.3456 29.4486C42.4903 29.2771 42.5942 29.075 42.6496 28.8573C42.7147 28.6179 42.747 28.3706 42.7453 28.1225C42.7482 27.8743 42.716 27.6268 42.6496 27.3876M41.9626 28.1225C41.979 28.4462 41.9016 28.7678 41.7401 29.0489C41.5929 29.2712 41.3349 29.3937 41.0698 29.3673C40.8064 29.384 40.5529 29.2636 40.3995 29.0489C40.1017 28.468 40.1017 27.7793 40.3995 27.1985C40.5464 26.9762 40.8045 26.8536 41.0698 26.88C41.3331 26.8632 41.5866 26.9836 41.7401 27.1985C41.9037 27.4787 41.981 27.8009 41.9626 28.1249" fill="white"/>
        <path d="M48.2543 29.2737C48.2462 29.2396 48.2122 29.2185 48.1779 29.2259C48.0748 29.2672 47.9682 29.2992 47.8596 29.3216C47.7383 29.3405 47.6159 29.351 47.4932 29.3527C47.2038 29.3693 46.9205 29.2653 46.7105 29.0655C46.4954 28.8016 46.3924 28.4639 46.4233 28.1248C46.4111 27.8075 46.5008 27.4946 46.6793 27.2319C46.8618 26.9981 47.1498 26.872 47.4454 26.8967C47.6881 26.8928 47.9301 26.9251 48.1634 26.9926C48.1982 26.999 48.2321 26.9784 48.2425 26.9446C48.307 26.7842 48.3549 26.6574 48.4173 26.4827C48.4266 26.4491 48.4075 26.414 48.374 26.4037C48.2241 26.3514 48.0694 26.3136 47.9122 26.2912C47.743 26.2712 47.5726 26.2609 47.4023 26.2601C47.1399 26.2554 46.8792 26.3044 46.6363 26.4037C46.4231 26.494 46.2325 26.6305 46.0786 26.8034C45.93 26.9772 45.8161 27.1779 45.7434 27.3946C45.6647 27.6316 45.6267 27.88 45.6309 28.1295C45.6089 28.6214 45.7681 29.1045 46.0786 29.4869C46.4347 29.847 46.9306 30.0333 47.4358 29.9965C47.7686 30.0005 48.0993 29.9411 48.4101 29.8218C48.4359 29.8047 48.4483 29.7731 48.4412 29.7429L48.2543 29.2737Z" fill="white"/>
        <path d="M51.7463 27.2637C51.686 27.0626 51.5823 26.8771 51.4422 26.7204C51.321 26.5755 51.1678 26.4608 50.9947 26.3852C50.7818 26.299 50.5541 26.2558 50.3244 26.2583C50.0618 26.2521 49.8009 26.3011 49.5584 26.4019C49.3551 26.494 49.1751 26.6306 49.0318 26.8017C48.8886 26.9818 48.7806 27.1872 48.7134 27.4073C48.648 27.6467 48.6159 27.894 48.6177 28.1422C48.6123 28.3918 48.6503 28.6405 48.7301 28.8771C48.7902 29.0994 48.9053 29.3027 49.0653 29.4684C49.2304 29.6316 49.4255 29.7617 49.6398 29.8514C49.9088 29.955 50.1973 29.9983 50.4849 29.9782C50.886 30.0022 51.2864 29.9257 51.6505 29.7556C51.6816 29.7388 51.6985 29.7246 51.6672 29.6431L51.5069 29.2122C51.5 29.1841 51.4714 29.1668 51.4431 29.1738C51.443 29.1738 51.4426 29.1739 51.4422 29.1741H51.4256C51.1237 29.304 50.7963 29.3636 50.468 29.3487C50.178 29.3607 49.8937 29.2643 49.671 29.0783C49.4847 28.8677 49.3878 28.5931 49.4004 28.3122H51.7151C51.7495 28.3136 51.7784 28.2868 51.7798 28.2524C51.7798 28.2524 51.7798 28.2524 51.7798 28.2524C51.8277 28.2357 51.9066 27.7737 51.7488 27.2638M49.4508 27.7425C49.4723 27.549 49.5378 27.3632 49.6422 27.1991C49.7822 26.9761 50.0329 26.8475 50.2956 26.864C50.5572 26.8535 50.8051 26.9807 50.9492 27.1991C51.0472 27.3639 51.1024 27.5507 51.1095 27.7425H49.4508Z" fill="white"/>
        <path d="M33.219 27.2637C33.1586 27.0626 33.0547 26.8771 32.9149 26.7204C32.7936 26.5755 32.6405 26.4608 32.4673 26.3852C32.2545 26.2989 32.0265 26.2558 31.797 26.2583C31.5344 26.2521 31.2735 26.3011 31.0311 26.4019C30.8278 26.494 30.6478 26.6306 30.5044 26.8017C30.3613 26.9818 30.2532 27.1873 30.1861 27.4073C30.1207 27.6468 30.0886 27.894 30.0903 28.1422C30.0849 28.3918 30.1229 28.6404 30.2028 28.8771C30.2626 29.0994 30.3777 29.3029 30.5379 29.4684C30.703 29.6316 30.8982 29.7617 31.1124 29.8514C31.3814 29.955 31.6699 29.9983 31.9574 29.9782C32.3584 30.0021 32.7591 29.9257 33.1232 29.7556C33.1543 29.7388 33.1711 29.7245 33.1399 29.6431L32.9603 29.217C32.9534 29.1888 32.9249 29.1716 32.8966 29.1786C32.8963 29.1786 32.8959 29.1786 32.8958 29.1788H32.8789C32.5771 29.3087 32.2498 29.3685 31.9214 29.3534C31.6313 29.3656 31.3472 29.2692 31.1243 29.083C30.9381 28.8725 30.8411 28.5978 30.8539 28.317H33.1686C33.2029 28.3184 33.2319 28.2916 33.2331 28.2573C33.2331 28.2572 33.2331 28.2572 33.2331 28.2572C33.2809 28.2404 33.36 27.7785 33.202 27.2686M30.9041 27.7472C30.9258 27.5539 30.9912 27.3681 31.0956 27.2039C31.2356 26.9808 31.4864 26.8522 31.7492 26.8687C32.0107 26.8582 32.2585 26.9854 32.4027 27.2039C32.5009 27.3687 32.5561 27.5556 32.5632 27.7472H30.9041Z" fill="white"/>
        <path d="M26.8396 27.6307C26.7438 27.6307 26.6312 27.6139 26.4734 27.6139C26.2793 27.6166 26.0864 27.6432 25.8989 27.6928C25.7272 27.7377 25.5649 27.8131 25.4201 27.9155C25.2765 28.0114 25.1608 28.1434 25.085 28.2985C25.0019 28.4616 24.9583 28.6421 24.9581 28.8251C24.9501 29.0074 24.9889 29.1886 25.0706 29.3518C25.1394 29.4974 25.2441 29.6235 25.3747 29.7179C25.5186 29.8186 25.6815 29.8893 25.8533 29.9261C26.0515 29.9738 26.2552 29.9955 26.459 29.9908C26.6944 29.9937 26.9294 29.9721 27.1603 29.9261C27.3829 29.8951 27.6701 29.8303 27.7517 29.8137C27.8063 29.8021 27.8599 29.7861 27.9119 29.7658C27.9461 29.7575 27.9673 29.7235 27.9598 29.6891V27.5684C27.9921 27.1907 27.8583 26.8175 27.5937 26.5463C27.2862 26.3163 26.9068 26.2034 26.5236 26.2279C26.3143 26.2257 26.1055 26.2474 25.9012 26.2926C25.6491 26.3369 25.4063 26.4233 25.1832 26.5487C25.1536 26.5714 25.1463 26.6129 25.1664 26.6445L25.3269 27.0922C25.3338 27.1203 25.3622 27.1376 25.3905 27.1306C25.3909 27.1306 25.3911 27.1305 25.3914 27.1304H25.4082C25.4202 27.1288 25.4313 27.1228 25.4393 27.1137C25.7512 26.9639 26.0915 26.8823 26.4376 26.8743C26.6393 26.8603 26.8405 26.9106 27.0119 27.018C27.1389 27.1137 27.2034 27.2573 27.2034 27.5758V27.6715L26.8372 27.6404M25.9275 29.268C25.8751 29.23 25.8319 29.1809 25.8007 29.1244C25.6576 28.8765 25.7109 28.562 25.9275 28.3751C26.1241 28.2418 26.3624 28.1847 26.5978 28.2147C26.8061 28.2153 27.0141 28.2314 27.2202 28.2626V29.3158C27.0149 29.3579 26.807 29.3842 26.5978 29.3949C26.3665 29.4297 26.1301 29.3849 25.9275 29.268Z" fill="white"/>
        <path d="M45.5102 26.4322C45.524 26.4038 45.5122 26.3696 45.4838 26.3556C45.3598 26.3166 45.2308 26.2948 45.1008 26.2911C44.8988 26.2706 44.6948 26.3036 44.5096 26.3868C44.3608 26.4505 44.2294 26.549 44.1266 26.6741V26.3868C44.1244 26.3522 44.0966 26.3245 44.0618 26.3221H43.4395C43.4049 26.3245 43.3773 26.3522 43.375 26.3868V29.848C43.3773 29.8828 43.4049 29.9104 43.4395 29.9128H44.0453C44.0799 29.9104 44.1075 29.8828 44.1098 29.848V28.1246C44.1061 27.9199 44.1329 27.7159 44.1889 27.519C44.2256 27.39 44.2978 27.274 44.397 27.1839C44.4763 27.1021 44.5752 27.042 44.6843 27.0091C44.7831 26.98 44.8853 26.9639 44.9884 26.9614C45.0746 26.9624 45.1605 26.9728 45.2444 26.9924C45.2833 26.9967 45.3185 26.969 45.3235 26.9302C45.3713 26.8177 45.4839 26.4993 45.515 26.4347" fill="white"/>
        <path d="M39.7953 24.8381L39.5726 24.7902C39.4677 24.7704 39.3612 24.76 39.2544 24.7591C38.8944 24.7334 38.5403 24.8612 38.2801 25.111C38.0271 25.4098 37.8665 25.7758 37.8182 26.1643L37.7871 26.3246H37.2605C37.2225 26.3259 37.19 26.3523 37.1814 26.3892L37.1024 26.868C37.0966 26.9049 37.1208 26.9397 37.1574 26.947H37.6936L37.1669 29.8337C37.1383 30.0295 37.0902 30.2219 37.0234 30.4083C36.9893 30.5283 36.9352 30.6418 36.8631 30.7434C36.8133 30.8183 36.74 30.8749 36.6547 30.9037C36.5673 30.9308 36.4755 30.9412 36.3844 30.935C36.3365 30.935 36.2575 30.9183 36.1928 30.9183C36.1482 30.9093 36.1054 30.893 36.066 30.8705C36.0357 30.8607 36.0025 30.8736 35.9869 30.9015C35.9703 30.9494 35.8267 31.3324 35.8122 31.3634C35.7948 31.3985 35.8087 31.4411 35.8433 31.4592C35.9113 31.4854 35.9809 31.5069 36.0517 31.5238C36.1615 31.5486 36.2742 31.559 36.3868 31.5549C36.5825 31.5585 36.7773 31.5261 36.9613 31.4592C37.1271 31.3935 37.2747 31.2895 37.3922 31.1552C37.5242 31.0057 37.6274 30.8326 37.6961 30.6453C37.7849 30.39 37.8546 30.1283 37.9044 29.8626L38.4311 26.9111H39.1873C39.2253 26.91 39.2578 26.8835 39.2665 26.8465L39.3454 26.3678C39.3513 26.3309 39.327 26.296 39.2904 26.2888H38.5315C38.5534 26.1089 38.5959 25.9322 38.6585 25.7621C38.6904 25.6698 38.7456 25.5875 38.8188 25.5227C38.8748 25.4698 38.9397 25.4268 39.0103 25.396C39.0944 25.3767 39.1803 25.3662 39.2665 25.3648C39.331 25.3648 39.4101 25.3816 39.458 25.3816C39.497 25.3849 39.5352 25.3955 39.5704 25.4127C39.6495 25.4294 39.6495 25.4127 39.6661 25.3816L39.841 24.9028C39.8577 24.8717 39.8098 24.855 39.7931 24.8382" fill="white"/>
        <path d="M29.4613 29.8509C29.4591 29.8856 29.4314 29.9132 29.3967 29.9157H28.7911C28.7563 29.9132 28.7288 29.8856 28.7266 29.8509V24.9103C28.7288 24.8757 28.7564 24.8481 28.7911 24.8457H29.3824C29.4171 24.8481 29.4446 24.8757 29.4469 24.9103V29.8556L29.4613 29.8509Z" fill="white"/>
        <path d="M17.2687 49.3598C17.1915 49.4364 17.1102 49.5088 17.0254 49.577V48.427H16V57.378H17.0283V54.0958C18.5084 55.7992 20.2145 55.6282 21.3183 54.9387C22.671 54.1017 23.2505 52.2971 22.7667 50.6314C22.0166 48.178 18.943 47.335 17.2687 49.3598ZM19.1488 54.4377C17.796 54.4377 16.9675 53.279 16.956 51.8307C16.9443 50.3824 18.0683 49.1858 19.4153 49.1743C20.7621 49.1628 21.828 50.3011 21.828 51.8248C21.8155 53.2774 20.6275 54.4446 19.175 54.4321H19.1748H19.1458L19.1488 54.4377Z" fill="#7D888E"/>
        <path d="M53.8415 46.3398V48.3676H55.9997V49.2945H53.8965C53.882 49.5175 53.8589 49.6797 53.8589 49.8738C53.8589 50.9399 53.8994 52.0087 53.8589 53.0602C53.7951 54.3145 54.4383 54.581 55.5968 54.3492C55.6951 54.3224 55.7918 54.2904 55.8865 54.2537C56.127 55.0387 55.9763 55.2762 55.1941 55.3747C53.5634 55.5686 52.7812 54.8792 52.7784 53.2312V49.3379L51.8516 49.2945V48.4254L52.7725 48.3676V46.3398H53.8415Z" fill="#7D888E"/>
        <path d="M32.5722 55.2524H31.5352V48.4278H32.552V50.0037C33.2673 48.9233 34.061 48.2338 35.3299 48.286V49.3491C33.2732 49.7344 32.5694 50.6062 32.5694 52.7382C32.5722 53.5521 32.5722 54.3806 32.5722 55.2524Z" fill="#7D888E"/>
        <path d="M41.694 45.585V49.5535C39.8866 47.9342 38.2527 47.8154 36.8681 49.0986C35.4836 50.3819 35.3618 52.6907 36.5323 54.194C37.0006 54.8005 37.6761 55.2129 38.4295 55.3528C39.7416 55.6165 40.77 55.1037 41.6883 53.9652V55.2311H42.6818V45.582H41.694V45.585ZM39.2057 54.4808C37.8531 54.4489 36.8046 53.2526 36.8335 51.7665C36.8625 50.2805 37.8734 49.1595 39.2465 49.1769C40.6196 49.1942 41.723 50.3732 41.7028 51.8795C41.6912 53.3133 40.5412 54.5097 39.2087 54.4808H39.2057Z" fill="#7D888E"/>
        <path d="M29.7417 50.4538C29.6808 49.4081 29.0378 48.7158 28.0355 48.4464C26.8023 48.1334 25.497 48.285 24.3684 48.8722L24.658 49.7208C25.8717 49.269 26.5147 49.1792 27.3084 49.2778C28.2007 49.3907 28.9915 50.2423 28.6873 51.2532L28.3745 51.1867C27.2158 50.9695 26.0715 50.8419 24.9679 51.3518C23.9264 51.7933 23.4403 52.9953 23.8817 54.0367C24.0371 54.403 24.2956 54.7161 24.626 54.9378C25.2026 55.3224 25.8946 55.4954 26.5843 55.4274C27.416 55.3638 28.193 54.9883 28.7597 54.3759L28.8089 55.245H29.7736C29.7736 55.0915 29.8111 54.9553 29.8082 54.8451C29.7996 53.3766 29.8285 51.9022 29.7417 50.4538ZM27.7632 54.289C26.9146 54.6974 26.0485 54.7581 25.2519 54.1674C24.7262 53.7385 24.648 52.9648 25.0767 52.4392C25.1551 52.3435 25.2472 52.2601 25.3502 52.1918C26.3192 51.7442 27.4206 51.675 28.4381 51.9977C28.6108 52.0768 28.7361 52.2324 28.777 52.4178C28.9246 53.1998 28.5022 53.9781 27.7661 54.2804L27.7632 54.289Z" fill="#7D888E"/>
        <path d="M47.7123 48.2173C45.7129 48.184 44.0649 49.778 44.0318 51.7774C43.9984 53.7769 45.5923 55.4249 47.5919 55.4582C49.5897 55.4914 51.237 53.8998 51.2724 51.9019V51.8787C51.3095 49.8985 49.7344 48.2631 47.7541 48.2261C47.7527 48.2261 47.7513 48.226 47.7501 48.226L47.7123 48.2173ZM47.7123 54.5002C46.3017 54.5002 45.1835 53.3097 45.1894 51.7976C45.1951 50.2854 46.2698 49.1587 47.7008 49.1702C49.1318 49.1819 50.2122 50.3522 50.2122 51.8324C50.2122 53.3126 49.1143 54.4946 47.7095 54.5002H47.7123Z" fill="#7D888E"/>
      </g>
      <defs>
        <clipPath id="clip0_6070_87827">
          <rect width="42" height="42" fill="white" transform="translate(15 15)"/>
        </clipPath>
      </defs>
    </svg>

  ),
  svgs_twoProfilesPlus: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M4.44567 8.24095C5.61678 8.24095 6.56615 7.29158 6.56615 6.12048C6.56615 4.94937 5.61678 4 4.44567 4C3.27456 4 2.3252 4.94937 2.3252 6.12048C2.3252 7.29158 3.27456 8.24095 4.44567 8.24095Z" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.15625 5.05859C8.50938 5.14901 8.82237 5.35438 9.04588 5.64233C9.26939 5.93028 9.39071 6.28443 9.39071 6.64895C9.39071 7.01347 9.26939 7.36762 9.04588 7.65557C8.82237 7.94352 8.50938 8.14889 8.15625 8.23931" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1 14.0713V13.6169C1 12.1112 2.32234 10.8906 3.95352 10.8906H4.93802C6.56921 10.8906 7.89154 12.1112 7.89154 13.6169V14.0713" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.0691 14.0708V13.6165C11.0691 12.7155 10.5957 11.9166 9.86592 11.4202C9.66711 11.285 9.44927 11.1722 9.2168 11.0859" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.25 4H13.25M15.25 4H13.25M13.25 4V2M13.25 4V6" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>,
  svgs_profilePlus: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path xmlns="http://www.w3.org/2000/svg" d="M8.66391 14.4399C12.1295 14.4399 15 11.5087 15 7.96995C15 4.43118 12.1229 1.5 8.65737 1.5C5.4272 1.5 2.72668 4.03724 2.37358 7.24884C2.70052 7.18208 3.16478 7.15537 3.51787 7.20211C3.86443 4.61813 6.01569 2.64176 8.65737 2.64176C11.5541 2.64176 13.8819 5.01207 13.8819 7.96995C13.8819 9.35876 13.3718 10.614 12.5218 11.5555C11.9071 10.821 10.4948 10.1266 8.65737 10.1266C8.08195 10.1266 7.54577 10.2001 7.0619 10.3202C7.13383 10.6207 7.17306 10.9479 7.17306 11.2684C7.17306 12.2699 6.80689 13.198 6.20532 13.9124C6.96382 14.253 7.80078 14.4399 8.66391 14.4399ZM8.65737 9.07165C9.85397 9.07833 10.7825 8.03672 10.7825 6.6813C10.7825 5.40601 9.84743 4.34438 8.65737 4.34438C7.47384 4.34438 6.52572 5.40601 6.53226 6.6813C6.5388 8.03672 7.47384 9.05829 8.65737 9.07165ZM3.15824 14.5C4.8714 14.5 6.31648 13.0378 6.31648 11.275C6.31648 9.50565 4.89102 8.05008 3.15824 8.05008C1.432 8.05008 0 9.50565 0 11.275C0 13.0444 1.432 14.5 3.15824 14.5ZM3.15824 13.2982C2.92284 13.2982 2.76591 13.1379 2.76591 12.8975V11.6757H1.56931C1.33391 11.6757 1.17698 11.5154 1.17698 11.275C1.17698 11.028 1.33391 10.8744 1.56931 10.8744H2.76591V9.65254C2.76591 9.41217 2.92284 9.25193 3.15824 9.25193C3.40017 9.25193 3.55057 9.41217 3.55057 9.65254V10.8744H4.74717C4.98256 10.8744 5.13949 11.028 5.13949 11.275C5.13949 11.5154 4.98256 11.6757 4.74717 11.6757H3.55057V12.8975C3.55057 13.1379 3.40017 13.2982 3.15824 13.2982Z" fill="#828282"/>
  </svg>,
  svgs_shirtWithTie: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M4.74112 0.875L3.24112 2.375H2.5C1.60254 2.375 0.875 3.10254 0.875 4V12C0.875 12.8975 1.60254 13.625 2.5 13.625H6.66551L7.27196 14.5347C7.6183 15.0542 8.3817 15.0542 8.72804 14.5347L9.33449 13.625H13.5C14.3975 13.625 15.125 12.8975 15.125 12V4C15.125 3.10254 14.3975 2.375 13.5 2.375H12.7589L11.2589 0.875H4.74112ZM12.7589 3.625L10 6.38388L9.5 5.88388L9.19841 6.18547L10.573 11.2258C10.6396 11.4699 10.5973 11.7308 10.4569 11.9414L10.1678 12.375H13.5C13.7071 12.375 13.875 12.2071 13.875 12V4C13.875 3.79289 13.7071 3.625 13.5 3.625H12.7589ZM5.83218 12.375L5.54309 11.9414C5.40274 11.7308 5.36039 11.4699 5.42696 11.2258L6.80159 6.18547L6.5 5.88388L6 6.38388L3.24112 3.625H2.5C2.29289 3.625 2.125 3.79289 2.125 4V12C2.125 12.2071 2.29289 12.375 2.5 12.375H5.83218ZM7.75888 5.375L7.38388 5L7.75888 4.625H8.24112L8.61612 5L8.24112 5.375H7.75888ZM8.24112 3.375H7.75888L6.50888 2.125H9.49112L8.24112 3.375ZM6.61612 4L5 2.38388L4.38388 3L6 4.61612L6.61612 4ZM9.38388 4L11 2.38388L11.6161 3L10 4.61612L9.38388 4ZM8.02263 6.625H7.97737L6.67783 11.39L8 13.3733L9.32217 11.39L8.02263 6.625Z" fill="#828282"/>
  </svg>,
  svgs_electricPlug: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M3.43604 4.47656H11.3334V9.21496C11.3334 9.84331 11.0838 10.4459 10.6394 10.8902C10.1951 11.3345 9.59252 11.5842 8.96416 11.5842H5.80523C5.17688 11.5842 4.57427 11.3345 4.12996 10.8902C3.68565 10.4459 3.43604 9.84331 3.43604 9.21496V4.47656Z" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.01562 1.31836V4.47729" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.75391 1.31836V4.47729" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.38477 11.5859V13.1654C7.38477 13.5843 7.55117 13.986 7.84738 14.2823C8.14359 14.5785 8.54533 14.7449 8.96423 14.7449H11.3334" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>,
  svgs_proText: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M3.57152 10.2524C5.03595 10.2524 6.22311 9.06525 6.22311 7.60081C6.22311 6.13638 5.03595 4.94922 3.57152 4.94922C2.10708 4.94922 0.919922 6.13638 0.919922 7.60081C0.919922 7.63407 0.920535 7.66719 0.921749 7.70016C0.920565 7.71431 0.919962 7.72862 0.919962 7.74305V11.7433C0.919962 12.0242 1.14767 12.2519 1.42856 12.2519C1.70945 12.2519 1.93716 12.0242 1.93716 11.7433V9.68898C2.38749 10.0419 2.955 10.2524 3.57152 10.2524ZM5.20562 7.6001C5.20562 8.50275 4.47388 9.23449 3.57122 9.23449C2.66857 9.23449 1.93683 8.50275 1.93683 7.6001C1.93683 6.69744 2.66857 5.9657 3.57122 5.9657C4.47388 5.9657 5.20562 6.69744 5.20562 7.6001Z" fill="#828282"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M12.4289 10.2524C13.8934 10.2524 15.0805 9.06525 15.0805 7.60081C15.0805 6.13638 13.8934 4.94922 12.4289 4.94922C10.9645 4.94922 9.77734 6.13638 9.77734 7.60081C9.77734 9.06525 10.9645 10.2524 12.4289 10.2524ZM14.0638 7.6001C14.0638 8.50275 13.332 9.23449 12.4294 9.23449C11.5267 9.23449 10.795 8.50275 10.795 7.6001C10.795 6.69744 11.5267 5.9657 12.4294 5.9657C13.332 5.9657 14.0638 6.69744 14.0638 7.6001Z" fill="#828282"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M9.00053 5.95703C8.32984 5.95703 7.78613 6.50073 7.78613 7.17143V9.74302C7.78613 10.0192 7.56228 10.243 7.28613 10.243C7.00999 10.243 6.78613 10.0192 6.78613 9.74302V7.17143C6.78613 5.94845 7.77755 4.95703 9.00053 4.95703H9.1434C9.41954 4.95703 9.6434 5.18089 9.6434 5.45703C9.6434 5.73317 9.41954 5.95703 9.1434 5.95703H9.00053Z" fill="#828282"/>
  </svg>,
  svgs_infinity: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path xmlns="http://www.w3.org/2000/svg" d="M8.00081 7.98172C7.18357 7.00605 5.17791 5.05469 3.69315 5.05469C1.83719 5.05469 0.929688 6.69912 0.929688 7.98172C0.929688 9.26433 1.67695 10.9473 3.69315 10.9473C5.3061 10.9473 7.23698 8.97024 8.00081 7.98172ZM8.00081 7.98172C8.81804 7.00605 10.8237 5.05469 12.3085 5.05469C14.1644 5.05469 15.0719 6.69912 15.0719 7.98172C15.0719 9.26433 14.3247 10.9473 12.3085 10.9473C10.6955 10.9473 8.76463 8.97024 8.00081 7.98172Z" stroke="#828282" strokeWidth="1.25001"/>
  </svg>,
  svgs_filter: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path xmlns="http://www.w3.org/2000/svg" d="M12.4002 3.19922H3.6002C3.37928 3.19922 3.2002 3.37831 3.2002 3.59922V4.63353C3.2002 4.73962 3.24234 4.84136 3.31735 4.91638L6.28304 7.88206C6.35805 7.95708 6.4002 8.05882 6.4002 8.1649V10.5992C6.4002 10.7251 6.45947 10.8437 6.5602 10.9192L8.9602 12.7192C9.22389 12.917 9.6002 12.7288 9.6002 12.3992V8.1649C9.6002 8.05882 9.64234 7.95708 9.71735 7.88206L12.683 4.91638C12.7581 4.84136 12.8002 4.73962 12.8002 4.63353V3.59922C12.8002 3.3783 12.6211 3.19922 12.4002 3.19922Z" stroke="#828282" strokeWidth="1.25" strokeLinejoin="round"/>
  </svg>,
  svgs_appleIcon: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path xmlns="http://www.w3.org/2000/svg" d="M10.2479 2.82248C10.7215 2.28057 11.0563 1.53737 11.0563 0.79418C11.0563 0.685798 11.0481 0.585157 11.0236 0.5C10.256 0.530966 9.33329 0.98772 8.778 1.60705C8.34521 2.07154 7.93691 2.82248 7.93691 3.56567C7.93691 3.68179 7.96141 3.79018 7.96957 3.82888C8.01857 3.83663 8.10023 3.84437 8.17372 3.84437C8.86783 3.84437 9.73342 3.41084 10.2479 2.82248ZM10.7868 4.00694C9.63543 4.00694 8.69634 4.67272 8.10023 4.67272C7.45512 4.67272 6.62219 4.04565 5.60961 4.04565C3.70695 4.04565 1.77979 5.53978 1.77979 8.34997C1.77979 10.1073 2.49022 11.9653 3.37214 13.1575C4.13158 14.1639 4.79302 15 5.74844 15C6.69569 15 7.11215 14.4039 8.28804 14.4039C9.48027 14.4039 9.74158 14.9845 10.7868 14.9845C11.8239 14.9845 12.518 14.0865 13.1631 13.1962C13.8981 12.1743 14.2002 11.1834 14.2084 11.1369C14.1512 11.1215 12.1669 10.355 12.1669 8.20288C12.1669 6.3449 13.7266 5.50881 13.8164 5.44688C12.7875 4.04565 11.2196 4.00694 10.7868 4.00694Z" fill="#828282"/>
  </svg>,
  svgs_analyticsIcon: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M3.7548 10H2.2452C1.83364 10 1.5 10.3298 1.5 10.7367V13.2633C1.5 13.6702 1.83364 14 2.2452 14H3.7548C4.16636 14 4.5 13.6702 4.5 13.2633V10.7367C4.5 10.3298 4.16636 10 3.7548 10Z" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.7548 6H7.2452C6.83364 6 6.5 6.32982 6.5 6.73667V13.2633C6.5 13.6702 6.83364 14 7.2452 14H8.7548C9.16636 14 9.5 13.6702 9.5 13.2633V6.73667C9.5 6.32982 9.16636 6 8.7548 6Z" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.7548 2H12.2452C11.8336 2 11.5 2.32982 11.5 2.73667V13.2633C11.5 13.6702 11.8336 14 12.2452 14H13.7548C14.1664 14 14.5 13.6702 14.5 13.2633V2.73667C14.5 2.32982 14.1664 2 13.7548 2Z" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>,
  svgs_signalIcon: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M8 8V8.00667" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.1211 5.87891C10.6834 6.44143 10.9994 7.20427 10.9994 7.99968C10.9994 8.79508 10.6834 9.55792 10.1211 10.1204" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.2432 3.75781C12.8003 4.31491 13.2422 4.97628 13.5437 5.70418C13.8453 6.43207 14.0004 7.21223 14.0004 8.0001C14.0004 8.78797 13.8453 9.56813 13.5437 10.296C13.2422 11.0239 12.8003 11.6853 12.2432 12.2424" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.87631 10.1204C5.31396 9.55792 4.99805 8.79508 4.99805 7.99968C4.99805 7.20427 5.31396 6.44143 5.87631 5.87891" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3.75337 12.2424C3.19625 11.6853 2.75431 11.0239 2.4528 10.296C2.15128 9.56813 1.99609 8.78797 1.99609 8.0001C1.99609 7.21223 2.15128 6.43207 2.4528 5.70418C2.75431 4.97628 3.19625 4.31491 3.75337 3.75781" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>,
  svgs_poplIcon: ({ width = 62, height = 32, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_701_2626)">
      <path fillRule="evenodd" clipRule="evenodd" d="M58.6376 12.6567C58.6376 16.1922 58.6376 19.7276 58.6376 23.2832C58.6376 23.464 58.6576 23.6649 58.6376 23.8457C58.5572 24.6492 57.9546 25.2116 57.1511 25.2116C56.3274 25.2116 55.7449 24.6693 55.6846 23.8457C55.6646 23.6046 55.6646 23.3836 55.6646 23.1426C55.6646 16.1118 55.6646 9.08106 55.6646 2.0503C55.6646 1.86951 55.6646 1.66863 55.6646 1.48784C55.7248 0.664239 56.3074 0.0616027 57.0707 0.0214269C57.8541 -0.0187488 58.5371 0.583888 58.6175 1.42758C58.6376 1.62846 58.6376 1.84942 58.6376 2.0503C58.6376 5.56568 58.6376 9.12124 58.6376 12.6567Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M16.5934 15.63C15.7297 9.90498 9.26136 6.71101 4.25947 9.62375C1.58779 11.1705 0.121371 13.5409 0.041019 16.6545C-0.0192447 18.8441 0.0209311 21.0337 0.0209311 23.2232C0.0209311 25.5334 0.0209311 27.8435 0.0209311 30.1335C0.0209311 30.2942 0.0209311 30.4549 0.0209311 30.6156C0.0811948 31.3387 0.663743 31.9213 1.36682 32.0017C2.02972 32.082 2.7328 31.6401 2.91359 30.9571C2.99394 30.6959 2.99394 30.4147 2.99394 30.1335C2.99394 28.1247 2.99394 26.136 2.99394 24.1272C2.99394 23.9464 2.99394 23.7455 2.99394 23.5647C2.99394 23.4241 3.0542 23.3438 3.19482 23.4442C3.35552 23.5447 3.49614 23.6652 3.65684 23.7656C5.46475 25.0512 7.49362 25.453 9.62294 25.1115C14.3838 24.3482 17.2362 19.9288 16.5934 15.63ZM8.29714 22.1988C5.36431 22.1988 2.97385 19.7681 3.01403 16.8353C3.03411 13.9025 5.42457 11.5522 8.37749 11.5522C11.3304 11.5522 13.7209 14.0431 13.6405 16.9157C13.7209 19.4668 11.5916 22.1988 8.29714 22.1988Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M53.6554 15.6095C52.7917 9.90452 46.3234 6.69046 41.3215 9.6032C38.6498 11.15 37.1834 13.5203 37.103 16.634C37.0428 18.8235 37.0829 21.0131 37.0829 23.2027C37.0829 25.5128 37.0829 27.8229 37.0829 30.1129C37.0829 30.2736 37.0829 30.4343 37.0829 30.595C37.1432 31.3182 37.7258 31.9008 38.4288 31.9811C39.0917 32.0615 39.7948 31.5994 39.9756 30.9365C40.0559 30.6754 40.0559 30.3942 40.0559 30.1129C40.0559 28.1041 40.0559 26.1154 40.0559 24.1067C40.0559 23.9259 40.0559 23.725 40.0559 23.5442C40.0559 23.3835 40.1363 23.3232 40.2769 23.4237C40.4577 23.5442 40.6184 23.6647 40.7791 23.7852C42.5669 25.0508 44.5757 25.4325 46.705 25.091C51.4458 24.3477 54.2983 19.9284 53.6554 15.6095ZM45.3592 22.1983C42.4263 22.2184 40.0359 19.7677 40.0559 16.8549C40.076 13.9221 42.4665 11.5718 45.4194 11.5718C48.3924 11.5718 50.7829 14.0627 50.7025 16.9152C50.7829 19.4664 48.6335 22.1983 45.3592 22.1983Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M23.2422 13.6601C23.5234 13.8409 23.5837 14.2226 23.4029 14.5038L23.1618 14.8453C22.981 15.1265 22.5993 15.1868 22.3181 15.006L19.6063 13.3186C19.325 13.1378 19.2648 12.7562 19.4456 12.4749L19.8272 11.8924C20.008 11.6112 20.3897 11.5509 20.6709 11.7317L23.2422 13.6601Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M21.9765 16.6938C22.2979 16.6537 22.5992 16.8947 22.6394 17.2161L22.6796 17.6179C22.7197 17.9393 22.4787 18.2406 22.1573 18.2808L19.0035 18.7629C18.6821 18.8031 18.3808 18.562 18.3406 18.2406L18.2602 17.5576C18.2201 17.2362 18.4611 16.9349 18.7825 16.8947L21.9765 16.6938Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M22.9205 19.8679C23.1415 19.6269 23.5231 19.6068 23.7642 19.8277L24.0655 20.109C24.3066 20.3299 24.3266 20.7116 24.1057 20.9527L22.0165 23.3632C21.7956 23.6043 21.4139 23.6243 21.1728 23.4034L20.6706 22.9213C20.4296 22.7003 20.4095 22.3186 20.6305 22.0776L22.9205 19.8679Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M25.7327 21.675C25.7528 21.3335 26.034 21.0924 26.3755 21.1125L26.7974 21.1326C27.1389 21.1527 27.3799 21.4339 27.3598 21.7754L27.2996 24.9694C27.2795 25.3109 26.9983 25.5519 26.6568 25.5318L25.9738 25.4917C25.6323 25.4716 25.3912 25.1903 25.4113 24.8488L25.7327 21.675Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M28.8463 21.3339C28.6454 21.0727 28.7057 20.6911 28.9869 20.4902L29.3284 20.2491C29.5896 20.0483 29.9712 20.1085 30.1721 20.3898L32.1407 22.9007C32.3416 23.1619 32.2813 23.5436 32.0001 23.7444L31.4376 24.1462C31.1765 24.3471 30.7948 24.2868 30.594 24.0056L28.8463 21.3339Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M31.1364 18.9439C30.815 18.8636 30.6141 18.5422 30.6945 18.2208L30.7949 17.819C30.8753 17.4976 31.1967 17.2967 31.5181 17.3771L34.6518 18.0199C34.9732 18.1003 35.1741 18.4217 35.0937 18.7431L34.933 19.4261C34.8527 19.7475 34.5313 19.9483 34.2099 19.868L31.1364 18.9439Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M31.3978 15.5889C31.0964 15.7296 30.7348 15.609 30.5942 15.3077L30.4134 14.926C30.2728 14.6247 30.3934 14.2631 30.6947 14.1225L33.5271 12.6561C33.8284 12.5155 34.19 12.636 34.3306 12.9373L34.6319 13.5601C34.7725 13.8614 34.652 14.223 34.3507 14.3636L31.3978 15.5889Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M29.4895 12.8567C29.3489 13.158 28.9873 13.2986 28.686 13.158L28.3043 12.9973C28.003 12.8567 27.8624 12.4951 28.003 12.1938L29.2083 9.24087C29.3489 8.93955 29.7105 8.79893 30.0118 8.93955L30.6546 9.22078C30.9559 9.3614 31.0966 9.70289 30.9559 10.0243L29.4895 12.8567Z" fill="black"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M26.2352 12.0738C26.3357 12.3952 26.1549 12.7367 25.8335 12.8171L25.4317 12.9376C25.1103 13.0381 24.7688 12.8573 24.6885 12.5359L23.664 9.52268C23.5636 9.20127 23.7443 8.85977 24.0658 8.77942L24.7286 8.57854C25.0501 8.4781 25.3916 8.6589 25.4719 8.9803L26.2352 12.0738Z" fill="black"/>
    </g>
    <defs>
      <clipPath id="clip0_701_2626">
        <rect width="61.8104" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>,
  svgs_circleCheck: ({ width = 33, height = 32, fill = "black" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={"none"} xmlns="http://www.w3.org/2000/svg">
    <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M16.9189 32C25.7555 32 32.9189 24.8366 32.9189 16C32.9189 7.16344 25.7555 0 16.9189 0C8.08239 0 0.918945 7.16344 0.918945 16C0.918945 24.8366 8.08239 32 16.9189 32ZM23.5044 13.4461C24.0657 12.8848 24.0657 11.9746 23.5044 11.4132C22.943 10.8518 22.0328 10.8518 21.4714 11.4132L14.9205 17.9642L12.4823 15.5261C11.9209 14.9647 11.0107 14.9647 10.4494 15.5261C9.88798 16.0874 9.88798 16.9976 10.4494 17.559L13.904 21.0136C14.1736 21.2832 14.5392 21.4347 14.9205 21.4347C15.3017 21.4347 15.6674 21.2832 15.9369 21.0136L23.5044 13.4461Z" fill={fill}/>
  </svg>,
  svgs_businessCardIcon: ({ width = 20, height = 20, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path xmlns="http://www.w3.org/2000/svg" d="M17.7442 7.92101C18.1299 7.92101 18.3337 7.70464 18.3337 7.3296V5.56259C18.3337 4.07685 17.5695 3.33398 16.0486 3.33398H14.2656C13.8872 3.33398 13.6762 3.53593 13.6762 3.91097C13.6762 4.28601 13.8872 4.49517 14.2656 4.49517H16.0267C16.7472 4.49517 17.162 4.87742 17.162 5.6275V7.3296C17.162 7.70464 17.3731 7.92101 17.7442 7.92101ZM2.24918 7.92101C2.63488 7.92101 2.83864 7.70464 2.83864 7.3296V5.6275C2.83864 4.87742 3.23889 4.49517 3.96662 4.49517H5.72774C6.11343 4.49517 6.32448 4.28601 6.32448 3.91097C6.32448 3.53593 6.11343 3.33398 5.72774 3.33398H3.95207C2.43111 3.33398 1.66699 4.07685 1.66699 5.56259V7.3296C1.66699 7.70464 1.87803 7.92101 2.24918 7.92101ZM5.84417 13.667H14.4095C14.9408 13.667 15.1809 13.4651 15.1809 12.9386V7.05553C15.1809 6.52904 14.9408 6.32709 14.4095 6.32709H5.84417C5.31293 6.32709 5.07278 6.52904 5.07278 7.05553V12.9386C5.07278 13.4651 5.31293 13.667 5.84417 13.667ZM6.24442 12.7294C6.09888 12.7294 6.02611 12.6645 6.02611 12.4986V7.5027C6.02611 7.33681 6.09888 7.26469 6.24442 7.26469H14.0093C14.1548 7.26469 14.2276 7.33681 14.2276 7.5027V12.4986C14.2276 12.6645 14.1548 12.7294 14.0093 12.7294H6.24442ZM7.26325 9.13268H11.8636C12.1037 9.13268 12.2638 8.97401 12.2638 8.75043C12.2638 8.51242 12.1037 8.35375 11.8636 8.35375H7.26325C7.0231 8.35375 6.87027 8.51242 6.87027 8.75043C6.87027 8.97401 7.0231 9.13268 7.26325 9.13268ZM7.26325 10.6833H10.4518C10.6846 10.6833 10.8447 10.5174 10.8447 10.2939C10.8447 10.0631 10.6846 9.89718 10.4518 9.89718H7.26325C7.0231 9.89718 6.87027 10.0631 6.87027 10.2939C6.87027 10.5174 7.0231 10.6833 7.26325 10.6833ZM3.95207 16.6673H5.72774C6.11343 16.6673 6.32448 16.4582 6.32448 16.0903C6.32448 15.7153 6.11343 15.5061 5.72774 15.5061H3.96662C3.23889 15.5061 2.83864 15.1239 2.83864 14.3738V12.6717C2.83864 12.2894 2.6276 12.0803 2.24918 12.0803C1.87076 12.0803 1.66699 12.2894 1.66699 12.6717V14.4315C1.66699 15.9244 2.43111 16.6673 3.95207 16.6673ZM14.2656 16.6673H16.0486C17.5695 16.6673 18.3337 15.9172 18.3337 14.4315V12.6717C18.3337 12.2894 18.1226 12.0803 17.7442 12.0803C17.3658 12.0803 17.162 12.2894 17.162 12.6717V14.3738C17.162 15.1239 16.7472 15.5061 16.0267 15.5061H14.2656C13.8872 15.5061 13.6762 15.7153 13.6762 16.0903C13.6762 16.4582 13.8872 16.6673 14.2656 16.6673Z" fill="#828282"/>
  </svg>,
  svgs_loadingIcon: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M7.62751 3.90417L6.99355 1.35407C6.92681 1.08912 6.6432 0.940091 6.37627 1.02289L5.82572 1.18848C5.55879 1.25471 5.40864 1.53622 5.49206 1.80116L6.3429 4.28503C6.40963 4.54998 6.69325 4.69901 6.96018 4.61621L7.29384 4.51686C7.56078 4.45062 7.71093 4.16912 7.62751 3.90417Z" fill="#828282"/>
    <path d="M10.3323 4.54892C10.2155 4.79731 9.91523 4.91322 9.66498 4.79731L9.348 4.66483C9.09775 4.54892 8.98097 4.25086 9.09775 4.00247L10.0987 1.56828C10.2155 1.3199 10.5158 1.20398 10.7661 1.3199L11.2999 1.55172C11.5502 1.66764 11.667 1.94914 11.5502 2.21409L10.3323 4.54892Z" fill="#828282"/>
    <path d="M5.27783 5.90745C5.42798 5.67562 5.37793 5.361 5.14437 5.21197L3.00892 3.62229C2.77535 3.47326 2.45837 3.52294 2.30822 3.75476L1.99124 4.23498C1.84109 4.46681 1.89114 4.78143 2.1247 4.93046L4.37694 6.32142C4.61051 6.47046 4.92749 6.42078 5.07764 6.18895L5.27783 5.90745Z" fill="#828282"/>
    <path d="M4.09004 7.71218C4.35697 7.67906 4.60721 7.87777 4.64058 8.14271L4.67395 8.4739C4.70731 8.73884 4.50712 8.98723 4.24018 9.02035L1.62092 9.41777C1.35399 9.45088 1.10374 9.25218 1.07037 8.98723L1.00364 8.42422C0.970272 8.15928 1.17047 7.91089 1.4374 7.87777L4.09004 7.71218Z" fill="#828282"/>
    <path d="M4.87166 10.3262C5.05518 10.1275 5.37216 10.1109 5.57236 10.2931L5.82261 10.5249C6.02281 10.7071 6.03949 11.0217 5.85597 11.2204L4.12092 13.2075C3.9374 13.4062 3.62042 13.4228 3.42022 13.2406L3.00314 12.8432C2.80294 12.661 2.78626 12.3464 2.96977 12.1477L4.87166 10.3262Z" fill="#828282"/>
    <path d="M7.20644 11.8197C7.22312 11.5382 7.45669 11.3395 7.7403 11.356L8.09065 11.3726C8.37426 11.3892 8.57446 11.621 8.55778 11.9025L8.50773 14.5354C8.49104 14.8169 8.25748 15.0156 7.97386 14.999L7.40663 14.9659C7.12302 14.9494 6.92282 14.7175 6.9395 14.436L7.20644 11.8197Z" fill="#828282"/>
    <path d="M9.79467 11.5375C9.62783 11.3223 9.67788 11.0077 9.91145 10.8421L10.1951 10.6434C10.4119 10.4778 10.7289 10.5274 10.8958 10.7593L12.5307 12.8292C12.6975 13.0444 12.6475 13.359 12.4139 13.5246L11.9468 13.8558C11.7299 14.0214 11.4129 13.9717 11.2461 13.7399L9.79467 11.5375Z" fill="#828282"/>
    <path d="M11.6987 9.56925C11.4318 9.50302 11.2649 9.23807 11.3317 8.97312L11.4151 8.64194C11.4818 8.377 11.7487 8.21141 12.0157 8.27764L14.6183 8.80753C14.8852 8.87377 15.052 9.13871 14.9853 9.40366L14.8518 9.96667C14.7851 10.2316 14.5182 10.3972 14.2512 10.331L11.6987 9.56925Z" fill="#828282"/>
    <path d="M11.9112 6.80262C11.661 6.91853 11.3607 6.81918 11.2439 6.57079L11.0937 6.25617C10.9769 6.00779 11.0771 5.70972 11.3273 5.59381L13.6796 4.38499C13.9299 4.26908 14.2302 4.36843 14.347 4.61682L14.5972 5.13015C14.714 5.37854 14.6139 5.6766 14.3636 5.79252L11.9112 6.80262Z" fill="#828282"/>
  </svg>,
  svgs_templateIcon: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M3 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44771 2 3 2Z" stroke="#828282" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="4" y="4" width="8" height="4" stroke="#828282" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="4" y="10" width="3" height="2" stroke="#828282" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="9" y="10" width="3" height="2" stroke="#828282" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>,
  svgs_clinkerIcon: ({ width = 16, height = 16, fill = "none" }) => <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M1.38086 11.7559C1.38086 12.0475 1.48112 12.2822 1.68164 12.46C1.88672 12.6331 2.16699 12.7197 2.52246 12.7197H5.33887C5.3571 13.1618 5.48014 13.5719 5.70801 13.9502C5.94043 14.333 6.2526 14.6406 6.64453 14.873C7.04102 15.11 7.49674 15.2285 8.01172 15.2285C8.53125 15.2285 8.98698 15.11 9.37891 14.873C9.77539 14.6406 10.0876 14.333 10.3154 13.9502C10.5479 13.5719 10.6732 13.1618 10.6914 12.7197H13.5078C13.8633 12.7197 14.1413 12.6331 14.3418 12.46C14.5469 12.2822 14.6494 12.0475 14.6494 11.7559C14.6494 11.5143 14.5856 11.2842 14.458 11.0654C14.3304 10.8421 14.1663 10.6279 13.9658 10.4229C13.7699 10.2178 13.5693 10.015 13.3643 9.81445C13.2093 9.65951 13.0863 9.45898 12.9951 9.21289C12.9085 8.9668 12.8424 8.69792 12.7969 8.40625C12.7559 8.11003 12.7194 7.80924 12.6875 7.50391C12.6829 7.30794 12.6738 7.11882 12.6602 6.93652C12.6465 6.74967 12.6305 6.56966 12.6123 6.39648C12.4118 6.47396 12.1908 6.53092 11.9492 6.56738C11.7122 6.59928 11.4867 6.59928 11.2725 6.56738C11.2907 6.72233 11.3044 6.88867 11.3135 7.06641C11.3271 7.23958 11.3363 7.42415 11.3408 7.62012C11.3545 7.94824 11.3818 8.25358 11.4229 8.53613C11.4639 8.81868 11.514 9.08073 11.5732 9.32227C11.6325 9.55924 11.7054 9.77344 11.792 9.96484C11.8786 10.1517 11.9811 10.3112 12.0996 10.4434C12.2135 10.571 12.3275 10.6963 12.4414 10.8193C12.5599 10.9378 12.667 11.0472 12.7627 11.1475C12.8584 11.2477 12.9359 11.3275 12.9951 11.3867V11.4688H3.01465V11.3867C3.07389 11.3275 3.15365 11.2477 3.25391 11.1475C3.35417 11.0472 3.46354 10.9378 3.58203 10.8193C3.70052 10.6963 3.81445 10.571 3.92383 10.4434C4.04232 10.3112 4.14486 10.1517 4.23145 9.96484C4.31803 9.77344 4.39095 9.55924 4.4502 9.32227C4.514 9.08073 4.56413 8.81868 4.60059 8.53613C4.6416 8.25358 4.67122 7.94824 4.68945 7.62012C4.7168 6.69954 4.81934 5.96582 4.99707 5.41895C5.17936 4.86751 5.41862 4.45736 5.71484 4.18848C6.01562 3.91504 6.35059 3.72819 6.71973 3.62793C6.80176 3.6097 6.86556 3.5778 6.91113 3.53223C6.96126 3.4821 6.98861 3.41146 6.99316 3.32031C7.01595 2.97396 7.11621 2.69368 7.29395 2.47949C7.47624 2.2653 7.71549 2.1582 8.01172 2.1582C8.13932 2.1582 8.24414 2.17415 8.32617 2.20605C8.38997 2.00098 8.47428 1.80729 8.5791 1.625C8.68392 1.43815 8.80697 1.26953 8.94824 1.11914C8.66113 0.973307 8.34896 0.900391 8.01172 0.900391C7.50586 0.900391 7.07292 1.05306 6.71289 1.3584C6.35286 1.66374 6.10905 2.04199 5.98145 2.49316C5.38444 2.70736 4.89681 3.04004 4.51855 3.49121C4.14486 3.94238 3.8623 4.50065 3.6709 5.16602C3.48405 5.83138 3.37695 6.59473 3.34961 7.45605C3.32227 7.77051 3.28581 8.07812 3.24023 8.37891C3.19466 8.67969 3.1263 8.9554 3.03516 9.20605C2.94857 9.45671 2.82552 9.65951 2.66602 9.81445C2.46094 10.015 2.25814 10.2178 2.05762 10.4229C1.86165 10.6279 1.69987 10.8421 1.57227 11.0654C1.44466 11.2842 1.38086 11.5143 1.38086 11.7559ZM6.63086 12.7197H9.39941C9.37207 13.1527 9.23079 13.4967 8.97559 13.752C8.72493 14.0072 8.40365 14.1348 8.01172 14.1348C7.62891 14.1348 7.30762 14.0072 7.04785 13.752C6.79264 13.4967 6.65365 13.1527 6.63086 12.7197ZM11.4365 5.68555C11.8604 5.68555 12.25 5.57845 12.6055 5.36426C12.9655 5.15007 13.2526 4.86296 13.4668 4.50293C13.681 4.1429 13.7881 3.7487 13.7881 3.32031C13.7881 2.88737 13.681 2.49316 13.4668 2.1377C13.2526 1.77767 12.9655 1.49056 12.6055 1.27637C12.25 1.06217 11.8604 0.955078 11.4365 0.955078C10.999 0.955078 10.6025 1.06217 10.2471 1.27637C9.8916 1.49056 9.60677 1.77767 9.39258 2.1377C9.17839 2.49316 9.07129 2.88737 9.07129 3.32031C9.07129 3.7487 9.17839 4.1429 9.39258 4.50293C9.60677 4.86296 9.8916 5.15007 10.2471 5.36426C10.6025 5.57845 10.999 5.68555 11.4365 5.68555Z" fill="#828282"/>
  </svg>,
  svgs_share: ({
    width = 24, height = 24, fill = "none", strokeFill = "#141414",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.25 7C19.25 8.24264 18.2426 9.25 17 9.25C15.7574 9.25 14.75 8.24264 14.75 7C14.75 5.75736 15.7574 4.75 17 4.75C18.2426 4.75 19.25 5.75736 19.25 7Z" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.25 12C9.25 13.2426 8.24264 14.25 7 14.25C5.75736 14.25 4.75 13.2426 4.75 12C4.75 10.7574 5.75736 9.75 7 9.75C8.24264 9.75 9.25 10.7574 9.25 12Z" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.25 17C19.25 18.2426 18.2426 19.25 17 19.25C15.7574 19.25 14.75 18.2426 14.75 17C14.75 15.7574 15.7574 14.75 17 14.75C18.2426 14.75 19.25 15.7574 19.25 17Z" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5 16L9 13.5" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5 8.5L9 11" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),

  svg_14freeTrial: ({ width = 16, height = 16, fill = "none" }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5896_87894_svg_14freeTrial)">
        <path d="M6.24396 1.45455V8H5.05824V2.60831H5.01989L3.48899 3.58629V2.49964L5.11577 1.45455H6.24396ZM7.60764 6.78551V5.84268L10.385 1.45455H11.1712V2.79688H10.6918L8.82213 5.75959V5.81072H12.6989V6.78551H7.60764ZM10.7302 8V6.49787L10.7429 6.07599V1.45455H11.8615V8H10.7302Z" fill="#828282"/>
        <path d="M1.90909 14H0.430398V9.63636H1.93892C2.37216 9.63636 2.74432 9.72372 3.0554 9.89844C3.3679 10.0717 3.60795 10.321 3.77557 10.6463C3.94318 10.9716 4.02699 11.3608 4.02699 11.8139C4.02699 12.2685 3.94247 12.6591 3.77344 12.9858C3.60582 13.3125 3.36364 13.5632 3.04688 13.7379C2.73153 13.9126 2.35227 14 1.90909 14ZM1.22088 13.3161H1.87074C2.17472 13.3161 2.42827 13.2607 2.63139 13.1499C2.83452 13.0376 2.98722 12.8707 3.08949 12.6491C3.19176 12.4261 3.2429 12.1477 3.2429 11.8139C3.2429 11.4801 3.19176 11.2031 3.08949 10.983C2.98722 10.7614 2.83594 10.5959 2.63565 10.4865C2.43679 10.3757 2.18963 10.3203 1.89418 10.3203H1.22088V13.3161ZM4.98405 14H4.1403L5.67652 9.63636H6.65237L8.19072 14H7.34697L6.18149 10.5312H6.1474L4.98405 14ZM5.01175 12.2891H7.31288V12.924H5.01175V12.2891ZM7.90187 9.63636H8.79462L9.8621 11.5668H9.90471L10.9722 9.63636H11.8649L10.2776 12.3722V14H9.48923V12.3722L7.90187 9.63636ZM14.6762 10.8359C14.6563 10.6499 14.5725 10.505 14.4248 10.4013C14.2785 10.2976 14.0882 10.2457 13.8538 10.2457C13.689 10.2457 13.5477 10.2706 13.4298 10.3203C13.3119 10.37 13.2217 10.4375 13.1592 10.5227C13.0967 10.608 13.0647 10.7053 13.0633 10.8146C13.0633 10.9055 13.0839 10.9844 13.1251 11.0511C13.1677 11.1179 13.2252 11.1747 13.2977 11.2216C13.3701 11.267 13.4504 11.3054 13.5384 11.3366C13.6265 11.3679 13.7153 11.3942 13.8048 11.4155L14.2139 11.5178C14.3786 11.5561 14.537 11.608 14.689 11.6733C14.8424 11.7386 14.9795 11.821 15.1002 11.9205C15.2224 12.0199 15.319 12.1399 15.39 12.2805C15.461 12.4212 15.4965 12.5859 15.4965 12.7749C15.4965 13.0305 15.4312 13.2557 15.3005 13.4503C15.1698 13.6435 14.9809 13.7947 14.7338 13.9041C14.488 14.0121 14.1904 14.0661 13.841 14.0661C13.5015 14.0661 13.2068 14.0135 12.9568 13.9084C12.7082 13.8033 12.5136 13.6499 12.373 13.4482C12.2338 13.2464 12.1585 13.0007 12.1471 12.7109H12.9248C12.9362 12.8629 12.983 12.9893 13.0654 13.0902C13.1478 13.1911 13.2551 13.2663 13.3872 13.3161C13.5207 13.3658 13.6698 13.3906 13.8346 13.3906C14.0065 13.3906 14.157 13.3651 14.2863 13.3139C14.417 13.2614 14.5193 13.1889 14.5931 13.0966C14.667 13.0028 14.7046 12.8935 14.7061 12.7685C14.7046 12.6548 14.6713 12.5611 14.6059 12.4872C14.5406 12.4119 14.4489 12.3494 14.3311 12.2997C14.2146 12.2486 14.0782 12.2031 13.922 12.1634L13.4255 12.0355C13.0661 11.9432 12.782 11.8033 12.5732 11.6158C12.3659 11.4268 12.2622 11.1761 12.2622 10.8636C12.2622 10.6065 12.3318 10.3814 12.471 10.1882C12.6116 9.99503 12.8026 9.84517 13.0441 9.73864C13.2856 9.63068 13.559 9.5767 13.8644 9.5767C14.1741 9.5767 14.4454 9.63068 14.6784 9.73864C14.9127 9.84517 15.0967 9.99361 15.2302 10.1839C15.3637 10.3729 15.4326 10.5902 15.4369 10.8359H14.6762Z" fill="#828282"/>
      </g>
      <defs>
        <clipPath id="clip0_5896_87894_svg_14freeTrial">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svg_30freeTrial: ({ width = 16, height = 16, fill = "none" }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5919_95384_svg_30freeTrial)">
        <path d="M4.93075 8.08949C4.47053 8.08949 4.06143 8.01065 3.70348 7.85298C3.34766 7.69531 3.06641 7.47585 2.85973 7.1946C2.65305 6.91335 2.54332 6.58842 2.53054 6.21982H3.73224C3.7429 6.39666 3.80149 6.55114 3.90803 6.68324C4.01456 6.81321 4.15625 6.91442 4.3331 6.98686C4.50994 7.0593 4.7081 7.09553 4.92756 7.09553C5.16193 7.09553 5.36967 7.05504 5.55078 6.97408C5.73189 6.89098 5.87358 6.77592 5.97585 6.62891C6.07813 6.48189 6.1282 6.3125 6.12607 6.12074C6.1282 5.92259 6.07706 5.74787 5.97266 5.59659C5.86825 5.44531 5.71697 5.32706 5.51882 5.24183C5.3228 5.15661 5.08629 5.11399 4.8093 5.11399H4.23082V4.19993H4.8093C5.03729 4.19993 5.23651 4.16051 5.40696 4.08168C5.57955 4.00284 5.71484 3.89205 5.81286 3.74929C5.91087 3.6044 5.95881 3.43714 5.95668 3.24751C5.95881 3.06214 5.91726 2.90128 5.83203 2.76491C5.74893 2.62642 5.63068 2.51882 5.47727 2.44212C5.32599 2.36541 5.14808 2.32706 4.94354 2.32706C4.74325 2.32706 4.55788 2.36328 4.38743 2.43572C4.21697 2.50817 4.07955 2.61151 3.97514 2.74574C3.87074 2.87784 3.81534 3.03551 3.80895 3.21875H2.66797C2.67649 2.85227 2.78196 2.53054 2.98438 2.25355C3.18892 1.97443 3.46165 1.7571 3.80256 1.60156C4.14347 1.44389 4.52592 1.36506 4.94993 1.36506C5.38672 1.36506 5.76598 1.44709 6.08771 1.61115C6.41158 1.77308 6.66193 1.99148 6.83878 2.26634C7.01563 2.54119 7.10405 2.84482 7.10405 3.1772C7.10618 3.54581 6.99751 3.85476 6.77805 4.10405C6.56072 4.35334 6.27521 4.51634 5.92152 4.59304V4.64418C6.38175 4.7081 6.73438 4.87855 6.9794 5.15554C7.22656 5.4304 7.34908 5.77237 7.34695 6.18146C7.34695 6.54794 7.24254 6.87607 7.03374 7.16584C6.82706 7.45348 6.54155 7.67933 6.1772 7.84339C5.81499 8.00746 5.3995 8.08949 4.93075 8.08949ZM10.6834 8.12464C10.1571 8.12464 9.70539 7.99148 9.32826 7.72514C8.95326 7.45668 8.66455 7.06996 8.46213 6.56499C8.26185 6.05788 8.16171 5.44744 8.16171 4.73366C8.16384 4.01989 8.26505 3.41264 8.46533 2.91193C8.66775 2.40909 8.95645 2.02557 9.33145 1.76136C9.70858 1.49716 10.1592 1.36506 10.6834 1.36506C11.2075 1.36506 11.6582 1.49716 12.0353 1.76136C12.4124 2.02557 12.7011 2.40909 12.9014 2.91193C13.1038 3.41477 13.205 4.02202 13.205 4.73366C13.205 5.44957 13.1038 6.06108 12.9014 6.56818C12.7011 7.07315 12.4124 7.45881 12.0353 7.72514C11.6603 7.99148 11.2096 8.12464 10.6834 8.12464ZM10.6834 7.12429C11.0925 7.12429 11.4153 6.92294 11.6518 6.52024C11.8904 6.11541 12.0097 5.51989 12.0097 4.73366C12.0097 4.21378 11.9554 3.77699 11.8467 3.4233C11.7381 3.0696 11.5846 2.80327 11.3865 2.62429C11.1883 2.44318 10.954 2.35263 10.6834 2.35263C10.2764 2.35263 9.95468 2.55504 9.71817 2.95987C9.48167 3.36257 9.36235 3.95384 9.36022 4.73366C9.35809 5.25568 9.41029 5.6946 9.51682 6.05043C9.62549 6.40625 9.7789 6.67472 9.97705 6.85582C10.1752 7.0348 10.4106 7.12429 10.6834 7.12429Z" fill="#828282"/>
        <path d="M3.90909 14H2.4304V9.63636H3.93892C4.37216 9.63636 4.74432 9.72372 5.0554 9.89844C5.3679 10.0717 5.60795 10.321 5.77557 10.6463C5.94318 10.9716 6.02699 11.3608 6.02699 11.8139C6.02699 12.2685 5.94247 12.6591 5.77344 12.9858C5.60582 13.3125 5.36364 13.5632 5.04688 13.7379C4.73153 13.9126 4.35227 14 3.90909 14ZM3.22088 13.3161H3.87074C4.17472 13.3161 4.42827 13.2607 4.63139 13.1499C4.83452 13.0376 4.98722 12.8707 5.08949 12.6491C5.19176 12.4261 5.2429 12.1477 5.2429 11.8139C5.2429 11.4801 5.19176 11.2031 5.08949 10.983C4.98722 10.7614 4.83594 10.5959 4.63565 10.4865C4.43679 10.3757 4.18963 10.3203 3.89418 10.3203H3.22088V13.3161ZM6.98405 14H6.1403L7.67652 9.63636H8.65237L10.1907 14H9.34697L8.18149 10.5312H8.1474L6.98405 14ZM7.01175 12.2891H9.31288V12.924H7.01175V12.2891ZM9.90187 9.63636H10.7946L11.8621 11.5668H11.9047L12.9722 9.63636H13.8649L12.2776 12.3722V14H11.4892V12.3722L9.90187 9.63636Z" fill="#828282"/>
      </g>
      <defs>
        <clipPath id="clip0_5919_95384_svg_30freeTrial">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  ),

  svg_allcard: () => (
    <svg width={32} height={32} viewBox="0 0 640 512" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5990_81725)">
        <path d="M63.1 464H348.5C360.7 482.8 376.5 499.1 394.8 512H64C28.65 512 0 483.3 0 448V224C0 188.7 28.65 160 64 160H448C471.8 160 492.5 172.9 503.5 192.2C501 192.1 498.5 192 496 192C469.8 192 444.9 197.7 422.6 208H64C55.16 208 48 215.2 48 224V448C48 456.8 55.16 464 64 464H63.1ZM440 80C453.3 80 464 90.75 464 104C464 117.3 453.3 128 440 128H71.1C58.74 128 47.1 117.3 47.1 104C47.1 90.75 58.74 80 71.1 80H440ZM392 0C405.3 0 416 10.75 416 24C416 37.25 405.3 48 392 48H255.55H119.1C106.7 48 95.1 37.25 95.1 24C95.1 10.75 106.7 0 119.1 0H392ZM640 368C640 447.5 575.5 512 496 512C416.5 512 352 447.5 352 368C352 288.5 416.5 224 496 224C575.5 224 640 288.5 640 368ZM528.6 416H463.4C442.4 416 424.5 429.7 418.3 448.7C438.5 468.1 465.8 480 496 480C526.2 480 553.5 468.1 573.7 448.7C567.5 429.7 549.6 416 528.6 416ZM496 288C469.5 288 448 309.5 448 336C448 362.5 469.5 384 496 384C522.5 384 544 362.5 544 336C544 309.5 522.5 288 496 288Z" fill="black"/>
      </g>
      <defs>
        <clipPath id="clip0_5990_81725">
          <rect width="640" height="512" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  ),
  svg_livecard: () => (
    <svg width={32} height={32} viewBox="0 0 640 372" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M63.1 314H348.5C360.7 332.8 376.5 349.1 394.8 362H64C28.65 362 0 333.3 0 298V74C0 38.7 28.65 10 64 10H448C471.8 10 492.5 22.9 503.5 42.2C501 42.1 498.5 42 496 42C469.8 42 444.9 47.7 422.6 58H64C55.16 58 48 65.2 48 74V298C48 306.8 55.16 314 64 314H63.1ZM640 218C640 297.5 575.5 362 496 362C416.5 362 352 297.5 352 218C352 138.5 416.5 74 496 74C575.5 74 640 138.5 640 218ZM528.6 266H463.4C442.4 266 424.5 279.7 418.3 298.7C438.5 318.1 465.8 330 496 330C526.2 330 553.5 318.1 573.7 298.7C567.5 279.7 549.6 266 528.6 266ZM496 138C469.5 138 448 159.5 448 186C448 212.5 469.5 234 496 234C522.5 234 544 212.5 544 186C544 159.5 522.5 138 496 138Z" fill="black"/>
    </svg>
  ),
  svg_proBadge: () => (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6070_88145)">
        <path d="M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5Z" fill="black"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M6.88 8.5025C6.88 9.29779 6.23529 9.9425 5.44 9.9425C5.07119 9.9425 4.73476 9.80385 4.48 9.57583V10.8238C4.48 10.9563 4.37255 11.0637 4.24 11.0637C4.10745 11.0637 4 10.9563 4 10.8238V8.58375C4 8.57582 4.00038 8.56798 4.00114 8.56024C4.00038 8.54109 4 8.52184 4 8.5025C4 7.70721 4.64471 7.0625 5.44 7.0625C6.23529 7.0625 6.88 7.70721 6.88 8.5025ZM6.40125 8.50375C6.40125 9.03394 5.97144 9.46375 5.44125 9.46375C4.91106 9.46375 4.48125 9.03394 4.48125 8.50375C4.48125 7.97356 4.91106 7.54375 5.44125 7.54375C5.97144 7.54375 6.40125 7.97356 6.40125 8.50375Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M10.397 9.9425C11.1923 9.9425 11.837 9.29779 11.837 8.5025C11.837 7.70721 11.1923 7.0625 10.397 7.0625C9.60174 7.0625 8.95703 7.70721 8.95703 8.5025C8.95703 9.29779 9.60174 9.9425 10.397 9.9425ZM10.3983 9.46375C10.9285 9.46375 11.3583 9.03394 11.3583 8.50375C11.3583 7.97356 10.9285 7.54375 10.3983 7.54375C9.86809 7.54375 9.43828 7.97356 9.43828 8.50375C9.43828 9.03394 9.86809 9.46375 10.3983 9.46375Z" fill="white"/>
        <path d="M7.51953 9.70078V8.26078C7.51953 7.73059 7.94934 7.30078 8.47953 7.30078H8.55953" stroke="white" strokeWidth="0.48" strokeLinecap="round"/>
      </g>
      <defs>
        <clipPath id="clip0_6070_88145">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_autoIntro: ({ width = 18, height = 18, strokeFill = "#BDBDBD" }) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.61719 10.3472C2.61719 11.2358 2.86051 11.9172 3.34717 12.3911C3.83382 12.8608 4.54053 13.0957 5.46729 13.0957H7.74609C8.32161 13.1592 8.89925 13.2565 9.479 13.3877C10.063 13.5189 10.6427 13.6818 11.2183 13.8765C11.7938 14.0711 12.3608 14.2975 12.9194 14.5557C13.4823 14.8096 14.0303 15.0973 14.5635 15.4189V14.105C14.043 13.7918 13.5098 13.5146 12.9639 13.2734C12.418 13.028 11.8573 12.8143 11.2817 12.6323C10.7104 12.4504 10.1265 12.3001 9.52979 12.1816C8.93311 12.0589 8.32796 11.9658 7.71436 11.9023H5.46729C4.87484 11.9023 4.44954 11.7817 4.19141 11.5405C3.9375 11.2993 3.81055 10.9015 3.81055 10.3472V9.39502C3.81055 8.83643 3.9375 8.43652 4.19141 8.19531C4.44954 7.9541 4.87484 7.8335 5.46729 7.8335H7.64453C8.27506 7.77002 8.8929 7.67692 9.49805 7.5542C10.1074 7.43148 10.702 7.28125 11.2817 7.10352C11.8615 6.92155 12.4264 6.70784 12.9766 6.4624C13.5267 6.21696 14.0557 5.93978 14.5635 5.63086V4.31055C14.0599 4.62793 13.5225 4.91781 12.9512 5.18018C12.3841 5.44255 11.8022 5.67318 11.2056 5.87207C10.6131 6.06673 10.0249 6.22966 9.44092 6.36084C8.86117 6.49202 8.30892 6.58512 7.78418 6.64014H5.46729C4.54053 6.64014 3.83382 6.87712 3.34717 7.35107C2.86051 7.8208 2.61719 8.50212 2.61719 9.39502V10.3472ZM8.91406 12.9243H7.78418L8.34277 15.7681C8.37663 15.9416 8.35124 16.077 8.2666 16.1743C8.1862 16.2759 8.07406 16.3267 7.93018 16.3267C7.79899 16.3267 7.69743 16.2928 7.62549 16.2251C7.55355 16.1574 7.48161 16.0495 7.40967 15.9014L5.95605 12.7974H4.74365L6.29248 16.2378C6.47868 16.644 6.70508 16.9487 6.97168 17.1519C7.23828 17.355 7.56413 17.4565 7.94922 17.4565C8.27506 17.4565 8.56283 17.3804 8.8125 17.228C9.06217 17.0757 9.24626 16.862 9.36475 16.5869C9.48324 16.3118 9.50439 15.9881 9.42822 15.6157L8.91406 12.9243ZM6.78125 7.16699V12.5752H7.97461V7.16699H6.78125ZM14.1763 14.6382C14.1763 14.9767 14.2482 15.2772 14.3921 15.5396C14.5402 15.8019 14.7454 16.005 15.0078 16.1489C15.2702 16.297 15.5706 16.3711 15.9092 16.3711C16.252 16.3711 16.5524 16.297 16.8105 16.1489C17.0729 16.005 17.276 15.8019 17.4199 15.5396C17.568 15.2772 17.6421 14.9767 17.6421 14.6382V5.05322C17.6421 4.71045 17.568 4.40999 17.4199 4.15186C17.276 3.89372 17.0729 3.69059 16.8105 3.54248C16.5524 3.39437 16.252 3.32031 15.9092 3.32031C15.5706 3.32031 15.2702 3.39437 15.0078 3.54248C14.7454 3.69059 14.5402 3.89372 14.3921 4.15186C14.2482 4.40999 14.1763 4.71045 14.1763 5.05322V14.6382ZM15.3696 14.6382V5.05322C15.3696 4.89242 15.4183 4.76335 15.5156 4.66602C15.6172 4.56445 15.7484 4.51367 15.9092 4.51367C16.07 4.51367 16.2012 4.56445 16.3027 4.66602C16.4043 4.76335 16.4551 4.89242 16.4551 5.05322V14.6382C16.4551 14.799 16.4043 14.9281 16.3027 15.0254C16.2012 15.127 16.07 15.1777 15.9092 15.1777C15.7484 15.1777 15.6172 15.127 15.5156 15.0254C15.4183 14.9281 15.3696 14.799 15.3696 14.6382Z" fill={strokeFill}/>
    </svg>
  ),
  svgs_unlock_icon: ({ width = 16, height = 16 }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.48828 14.8115H9.00293C9.54069 14.8115 9.94401 14.6725 10.2129 14.3945C10.4818 14.1211 10.6162 13.6904 10.6162 13.1025V8.16016C10.6162 7.58138 10.4818 7.15299 10.2129 6.875C9.94401 6.59701 9.54069 6.45801 9.00293 6.45801H2.48828C1.95052 6.45801 1.5472 6.59701 1.27832 6.875C1.00944 7.15299 0.875 7.58138 0.875 8.16016V13.1025C0.875 13.6904 1.00944 14.1211 1.27832 14.3945C1.5472 14.6725 1.95052 14.8115 2.48828 14.8115ZM2.80957 13.4512C2.65918 13.4512 2.54753 13.4124 2.47461 13.335C2.40625 13.262 2.37207 13.139 2.37207 12.9658V8.30371C2.37207 8.13053 2.40625 8.00749 2.47461 7.93457C2.54753 7.86165 2.65918 7.8252 2.80957 7.8252H8.68848C8.83431 7.8252 8.94141 7.86165 9.00977 7.93457C9.08268 8.00749 9.11914 8.13053 9.11914 8.30371V12.9658C9.11914 13.139 9.08268 13.262 9.00977 13.335C8.94141 13.4124 8.83431 13.4512 8.68848 13.4512H2.80957ZM7.94336 7.08691H9.38574V4.79688C9.38574 4.29102 9.48145 3.86263 9.67285 3.51172C9.86882 3.15625 10.1286 2.88737 10.4521 2.70508C10.7803 2.52279 11.1403 2.43164 11.5322 2.43164C11.9287 2.43164 12.2887 2.52279 12.6123 2.70508C12.9404 2.88737 13.2002 3.15625 13.3916 3.51172C13.583 3.86263 13.6787 4.29102 13.6787 4.79688V6.19824C13.6787 6.46712 13.7493 6.66992 13.8906 6.80664C14.0319 6.94336 14.2051 7.01172 14.4102 7.01172C14.6107 7.01172 14.7793 6.94564 14.916 6.81348C15.0527 6.67676 15.1211 6.47168 15.1211 6.19824V4.91309C15.1211 4.26595 15.0208 3.69857 14.8203 3.21094C14.6243 2.72331 14.3555 2.31999 14.0137 2.00098C13.6764 1.68197 13.2936 1.44271 12.8652 1.2832C12.4368 1.1237 11.9925 1.04395 11.5322 1.04395C11.0765 1.04395 10.6344 1.1237 10.2061 1.2832C9.77767 1.44271 9.39258 1.68197 9.05078 2.00098C8.71354 2.31999 8.44466 2.72331 8.24414 3.21094C8.04362 3.69857 7.94336 4.26595 7.94336 4.91309V7.08691Z" fill="#828282"/>
    </svg>
  ),
  svgs_lock_icon: ({ width = 13, height = 13 }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.50635 14.9385H11.4937C12.0698 14.9385 12.4995 14.7896 12.7827 14.4917C13.0708 14.1987 13.2148 13.7373 13.2148 13.1074V7.81201C13.2148 7.19189 13.0708 6.73291 12.7827 6.43506C12.4995 6.13721 12.0698 5.98828 11.4937 5.98828H4.50635C3.93018 5.98828 3.49805 6.13721 3.20996 6.43506C2.92676 6.73291 2.78516 7.19189 2.78516 7.81201V13.1074C2.78516 13.7373 2.92676 14.1987 3.20996 14.4917C3.49805 14.7896 3.93018 14.9385 4.50635 14.9385ZM4.85059 13.481C4.69434 13.481 4.57715 13.4395 4.49902 13.3564C4.4209 13.2783 4.38184 13.1465 4.38184 12.9609V7.96582C4.38184 7.78027 4.4209 7.64844 4.49902 7.57031C4.57715 7.49219 4.69434 7.45312 4.85059 7.45312H11.1567C11.313 7.45312 11.4277 7.49219 11.501 7.57031C11.5742 7.64844 11.6108 7.78027 11.6108 7.96582V12.9609C11.6108 13.1465 11.5742 13.2783 11.501 13.3564C11.4277 13.4395 11.313 13.481 11.1567 13.481H4.85059ZM4.14746 6.66211H5.7002V4.2085C5.7002 3.6665 5.80273 3.20752 6.00781 2.83154C6.21777 2.45068 6.49609 2.1626 6.84277 1.96729C7.19434 1.77197 7.58008 1.67432 8 1.67432C8.4248 1.67432 8.81055 1.77197 9.15723 1.96729C9.50391 2.1626 9.77979 2.45068 9.98486 2.83154C10.1948 3.20752 10.2998 3.6665 10.2998 4.2085V6.66211H11.8452V4.33301C11.8452 3.63965 11.7378 3.03174 11.5229 2.50928C11.313 1.98682 11.0249 1.55469 10.6587 1.21289C10.2974 0.871094 9.88477 0.614746 9.4209 0.443848C8.96191 0.272949 8.48828 0.1875 8 0.1875C7.50684 0.1875 7.03076 0.272949 6.57178 0.443848C6.11768 0.614746 5.70752 0.871094 5.34131 1.21289C4.9751 1.55469 4.68457 1.98682 4.46973 2.50928C4.25488 3.03174 4.14746 3.63965 4.14746 4.33301V6.66211Z" fill="#828282"/>
    </svg>
  ),
  svgs_template: ({ width = 16, height = 16, strokeFill = "#828282" }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44771 2 3 2Z" stroke={strokeFill} strokeWidth={1} strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="4" y="4" width="8" height="4" strokeWidth={0.8} stroke={strokeFill} strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="4" y="10" width="3" height="2" strokeWidth={0.8} stroke={strokeFill} strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="9" y="10" width="3" height="2" strokeWidth={0.8} stroke={strokeFill} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_removemeber: ({ width = 22, height = 22, strokeFill = "#EB5757" }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.25 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V19.25H15.25V12.75" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.75 19.25H19.25" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.75 9.25L19.25 7M19.25 7L16.75 4.75M19.25 7H13.75" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12Z" stroke={strokeFill} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),
  svgs_feature: ({ width = 20, height = 20, fill = "#828282" }) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.73242 17.7695C6.9375 17.7695 7.12793 17.7183 7.30371 17.6157C7.48438 17.5132 7.70166 17.3521 7.95557 17.1323L10.3213 15.0449H14.4009C15.0991 15.0449 15.6924 14.9155 16.1807 14.6567C16.6738 14.3931 17.0474 14.0171 17.3013 13.5288C17.5601 13.0356 17.6895 12.4448 17.6895 11.7563V6.35107C17.6895 5.6626 17.5601 5.07422 17.3013 4.58594C17.0474 4.09766 16.6738 3.72168 16.1807 3.45801C15.6924 3.19434 15.0991 3.0625 14.4009 3.0625H5.59717C4.90381 3.0625 4.31055 3.19434 3.81738 3.45801C3.3291 3.7168 2.95557 4.09277 2.69678 4.58594C2.43799 5.07422 2.30859 5.6626 2.30859 6.35107V11.7563C2.30859 12.4448 2.44043 13.0356 2.7041 13.5288C2.96777 14.022 3.33887 14.3979 3.81738 14.6567C4.30078 14.9155 4.87207 15.0449 5.53125 15.0449H5.80225V16.7148C5.80225 17.0371 5.88281 17.2935 6.04395 17.4839C6.20508 17.6743 6.43457 17.7695 6.73242 17.7695ZM7.09131 16.1289V14.166C7.09131 13.9561 7.04248 13.8071 6.94482 13.7192C6.85205 13.6265 6.70557 13.5801 6.50537 13.5801H5.65576C5.021 13.5801 4.5498 13.4214 4.24219 13.104C3.93457 12.7866 3.78076 12.3179 3.78076 11.6978V6.40967C3.78076 5.78955 3.93457 5.3208 4.24219 5.00342C4.5498 4.68604 5.021 4.52734 5.65576 4.52734H14.3423C14.9771 4.52734 15.4482 4.68604 15.7559 5.00342C16.0684 5.3208 16.2246 5.78955 16.2246 6.40967V11.6978C16.2246 12.3179 16.0684 12.7866 15.7559 13.104C15.4482 13.4214 14.9771 13.5801 14.3423 13.5801H10.2334C10.0137 13.5801 9.83789 13.6069 9.70605 13.6606C9.5791 13.7095 9.4375 13.812 9.28125 13.9683L7.09131 16.1289ZM9.99902 10.167C10.4092 10.167 10.6216 9.95459 10.6362 9.52979L10.7461 6.29248C10.7559 6.07764 10.6875 5.90186 10.541 5.76514C10.3945 5.62842 10.2114 5.56006 9.9917 5.56006C9.77197 5.56006 9.59131 5.62842 9.44971 5.76514C9.30811 5.89697 9.24219 6.07031 9.25195 6.28516L9.34717 9.53711C9.36182 9.95703 9.5791 10.167 9.99902 10.167ZM9.99902 12.4814C10.2334 12.4814 10.4312 12.4106 10.5923 12.269C10.7583 12.1226 10.8413 11.9346 10.8413 11.7051C10.8413 11.4805 10.7583 11.2949 10.5923 11.1484C10.4312 11.002 10.2334 10.9287 9.99902 10.9287C9.76465 10.9287 9.56689 11.002 9.40576 11.1484C9.24463 11.2949 9.16406 11.4805 9.16406 11.7051C9.16406 11.9297 9.24463 12.1152 9.40576 12.2617C9.57178 12.4082 9.76953 12.4814 9.99902 12.4814Z" fill={fill} />
    </svg>

  ),
  svgs_bullPassword: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.35938 19.1133C9.55729 19.2799 9.77344 19.3685 10.0078 19.3789C10.2422 19.3893 10.4505 19.3034 10.6328 19.1211L12.9141 16.8398C13.0911 16.6628 13.1771 16.4518 13.1719 16.207C13.1719 15.9622 13.0833 15.7539 12.9062 15.582L11.8828 14.5586L13.4297 13.0117C13.6068 12.8398 13.6927 12.6315 13.6875 12.3867C13.6875 12.1419 13.599 11.931 13.4219 11.7539L12.0469 10.3633C13.0312 9.85286 13.7865 9.19661 14.3125 8.39453C14.8438 7.58724 15.1094 6.69661 15.1094 5.72266C15.1094 5.01432 14.9766 4.35286 14.7109 3.73828C14.4505 3.1237 14.0859 2.58203 13.6172 2.11328C13.1484 1.64453 12.6042 1.27995 11.9844 1.01953C11.3698 0.753906 10.7083 0.621094 10 0.621094C9.28646 0.621094 8.61979 0.753906 8 1.01953C7.38542 1.27995 6.84375 1.64453 6.375 2.11328C5.90625 2.57682 5.53906 3.11849 5.27344 3.73828C5.01302 4.35286 4.88281 5.01432 4.88281 5.72266C4.88281 6.38932 5.0026 7.02474 5.24219 7.62891C5.48177 8.22786 5.82031 8.76432 6.25781 9.23828C6.70052 9.70703 7.22135 10.082 7.82031 10.3633V17.2461C7.82031 17.3867 7.84375 17.5326 7.89062 17.6836C7.94271 17.8398 8.03125 17.9727 8.15625 18.082L9.35938 19.1133ZM10 17.6289L9.21094 16.8477V9.25391C8.67448 9.13932 8.19271 8.91276 7.76562 8.57422C7.33854 8.23568 7 7.82161 6.75 7.33203C6.50521 6.83724 6.38281 6.30078 6.38281 5.72266C6.38281 5.0612 6.54427 4.45964 6.86719 3.91797C7.1901 3.37109 7.625 2.9362 8.17188 2.61328C8.71875 2.29036 9.32812 2.12891 10 2.12891C10.6667 2.12891 11.2708 2.29036 11.8125 2.61328C12.3594 2.9362 12.7943 3.37109 13.1172 3.91797C13.4401 4.45964 13.6016 5.0612 13.6016 5.72266C13.6016 6.29557 13.474 6.82943 13.2188 7.32422C12.9635 7.81901 12.6068 8.24089 12.1484 8.58984C11.6953 8.93359 11.1641 9.16536 10.5547 9.28516V11.0117L11.9219 12.3945L10.4844 13.8164V15.2852L11.4062 16.1992L10 17.6289ZM10 5.55859C10.3281 5.55859 10.6094 5.44141 10.8438 5.20703C11.0781 4.97266 11.1953 4.69401 11.1953 4.37109C11.1953 4.03776 11.0781 3.75651 10.8438 3.52734C10.6094 3.29297 10.3281 3.17578 10 3.17578C9.66667 3.17578 9.38542 3.29297 9.15625 3.52734C8.92708 3.75651 8.8125 4.03776 8.8125 4.37109C8.8125 4.69401 8.92708 4.97266 9.15625 5.20703C9.38542 5.44141 9.66667 5.55859 10 5.55859Z" fill="#828282"/>
    </svg>
  ),
  svgs_outlook: ({ width = 32, height = 31, fill = "none" }) => (
    <svg width={width} height={height} viewBox="0 0 32 31" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M27.6013 2H11.1176C10.7606 2 10.4182 2.14183 10.1657 2.39428C9.91325 2.64673 9.77142 2.98913 9.77142 3.34616V4.8764L19.0622 7.7528L28.9474 4.8764V3.34616C28.9474 2.98913 28.8056 2.64673 28.5531 2.39428C28.3007 2.14183 27.9583 2 27.6013 2Z" fill="#0364B8"/>
      <path d="M30.5294 16.7703C30.6699 16.3289 30.782 15.8789 30.865 15.4232C30.8649 15.3112 30.8353 15.2013 30.7793 15.1043C30.7233 15.0074 30.6427 14.9269 30.5457 14.8709L30.5333 14.8633L30.5294 14.8613L20.138 8.94172C20.0931 8.91263 20.0467 8.88606 19.9989 8.86214C19.8002 8.76347 19.5813 8.71213 19.3594 8.71213C19.1375 8.71213 18.9187 8.76347 18.7199 8.86214C18.6721 8.88573 18.6257 8.91198 18.5809 8.94076L8.1894 14.8623L8.18557 14.8642L8.17406 14.8709C8.07692 14.9268 7.99618 15.0072 7.93997 15.1042C7.88376 15.2011 7.85405 15.3111 7.85382 15.4232C7.93688 15.8789 8.04897 16.3289 8.1894 16.7703L19.2079 24.829L30.5294 16.7703Z" fill="#0A2767"/>
      <path d="M23.1946 4.8764H16.483L14.5453 7.7528L16.483 10.6292L23.1946 16.382H28.9474V10.6292L23.1946 4.8764Z" fill="#28A8EA"/>
      <path d="M9.77142 4.8764H16.483V10.6292H9.77142V4.8764Z" fill="#0078D4"/>
      <path d="M23.1946 4.8764H28.9474V10.6292H23.1946V4.8764Z" fill="#50D9FF"/>
      <path d="M23.1946 16.382L16.483 10.6292H9.77142V16.382L16.483 22.1348L26.8687 23.83L23.1946 16.382Z" fill="#0364B8"/>
      <path d="M16.483 10.6292H23.1946V16.382H16.483V10.6292Z" fill="#0078D4"/>
      <path d="M9.77142 16.382H16.483V22.1348H9.77142V16.382Z" fill="#064A8C"/>
      <path d="M23.1946 16.382H28.9474V22.1348H23.1946V16.382Z" fill="#0078D4"/>
      <path opacity="0.5" d="M19.5416 24.2614L8.2345 16.0157L8.7091 15.1816C8.7091 15.1816 19.0114 21.0494 19.1687 21.1376C19.233 21.1634 19.3019 21.1757 19.3712 21.1737C19.4405 21.1717 19.5086 21.1555 19.5713 21.1261L30.0539 15.1528L30.5295 15.986L19.5416 24.2614Z" fill="#0A2767"/>
      <path d="M30.5458 15.9764L30.5324 15.9841L30.5295 15.986L20.138 21.9057C19.9316 22.0387 19.6946 22.1166 19.4495 22.1319C19.2044 22.1472 18.9595 22.0993 18.7382 21.9929L22.3567 26.8454L30.2706 28.5684V28.5722C30.4547 28.439 30.6046 28.2641 30.7079 28.0617C30.8112 27.8594 30.8651 27.6354 30.8651 27.4082V15.4232C30.8651 15.5353 30.8356 15.6455 30.7796 15.7426C30.7235 15.8397 30.6429 15.9204 30.5458 15.9764Z" fill="#1490DF"/>
      <path opacity="0.05" d="M30.8651 27.4082V26.7006L21.2934 21.2469L20.138 21.9056C19.9316 22.0387 19.6946 22.1166 19.4495 22.1319C19.2044 22.1472 18.9595 22.0993 18.7382 21.9929L22.3567 26.8454L30.2706 28.5683V28.5722C30.4547 28.439 30.6046 28.2641 30.7079 28.0617C30.8112 27.8594 30.8651 27.6354 30.8651 27.4082Z" fill="black"/>
      <path opacity="0.1" d="M30.8171 27.7754L20.325 21.7992L20.138 21.9047C19.9317 22.0379 19.6947 22.116 19.4496 22.1314C19.2045 22.1469 18.9595 22.0992 18.7382 21.9929L22.3567 26.8454L30.2706 28.5684V28.5722C30.539 28.3778 30.732 28.0967 30.8171 27.7764V27.7754Z" fill="black"/>
      <path d="M8.18943 15.9889V15.9793H8.17984L8.15108 15.9601C8.05942 15.9039 7.98387 15.8249 7.93179 15.7308C7.87971 15.6367 7.85286 15.5307 7.85385 15.4232V27.4082C7.85359 27.5971 7.89062 27.7843 7.96281 27.9589C8.035 28.1335 8.14092 28.2921 8.27452 28.4257C8.40812 28.5593 8.56677 28.6653 8.74137 28.7374C8.91598 28.8096 9.10311 28.8467 9.29205 28.8464H29.4268C29.5466 28.8452 29.6658 28.8291 29.7816 28.7985C29.8417 28.788 29.8999 28.7686 29.9542 28.7409C29.9746 28.739 29.9942 28.7324 30.0117 28.7218C30.0902 28.6897 30.1643 28.6478 30.2322 28.5971C30.2514 28.5875 30.261 28.5875 30.2706 28.5684L8.18943 15.9889Z" fill="#28A8EA"/>
      <path opacity="0.1" d="M17.4418 23.7331V8.07209C17.4408 7.73343 17.3058 7.40893 17.0664 7.16947C16.8269 6.93 16.5024 6.79502 16.1637 6.79401H9.80018V13.9428L8.1894 14.8614L8.18461 14.8633L8.1731 14.87C8.076 14.926 7.99536 15.0067 7.93932 15.1038C7.88327 15.2009 7.85378 15.3111 7.85382 15.4232V25.0112H16.1637C16.5024 25.0102 16.8269 24.8752 17.0664 24.6358C17.3058 24.3963 17.4408 24.0718 17.4418 23.7331Z" fill="black"/>
      <path opacity="0.2" d="M16.483 24.6919V9.03087C16.482 8.69222 16.347 8.36772 16.1076 8.12825C15.8681 7.88878 15.5436 7.7538 15.2049 7.75279H9.80018V13.9428L8.1894 14.8613L8.18461 14.8633L8.1731 14.87C8.076 14.926 7.99536 15.0067 7.93932 15.1038C7.88327 15.2009 7.85378 15.3111 7.85382 15.4232V25.97H15.2049C15.5436 25.969 15.8681 25.834 16.1076 25.5945C16.347 25.3551 16.482 25.0306 16.483 24.6919Z" fill="black"/>
      <path opacity="0.2" d="M16.483 22.7743V9.03087C16.482 8.69222 16.347 8.36772 16.1076 8.12825C15.8681 7.88878 15.5436 7.7538 15.2049 7.75279H9.80018V13.9428L8.1894 14.8613L8.18461 14.8633L8.1731 14.87C8.076 14.926 7.99536 15.0067 7.93932 15.1038C7.88327 15.2009 7.85378 15.3111 7.85382 15.4232V24.0524H15.2049C15.5436 24.0514 15.8681 23.9164 16.1076 23.6769C16.347 23.4375 16.482 23.113 16.483 22.7743Z" fill="black"/>
      <path opacity="0.2" d="M15.5242 22.7743V9.03087C15.5232 8.69222 15.3882 8.36772 15.1488 8.12825C14.9093 7.88878 14.5848 7.7538 14.2461 7.75279H9.80018V13.9428L8.1894 14.8613L8.18461 14.8633L8.1731 14.87C8.076 14.926 7.99536 15.0067 7.93932 15.1038C7.88327 15.2009 7.85378 15.3111 7.85382 15.4232V24.0524H14.2461C14.5848 24.0514 14.9093 23.9164 15.1488 23.6769C15.3882 23.4375 15.5232 23.113 15.5242 22.7743Z" fill="black"/>
      <path d="M1.46149 7.75279H14.2461C14.5851 7.75279 14.9102 7.88745 15.1499 8.12713C15.3896 8.36682 15.5242 8.69191 15.5242 9.03087V21.8155C15.5242 22.1545 15.3896 22.4796 15.1499 22.7193C14.9102 22.9589 14.5851 23.0936 14.2461 23.0936H1.46149C1.12252 23.0936 0.797438 22.9589 0.557752 22.7193C0.318065 22.4796 0.183411 22.1545 0.183411 21.8155L0.183411 9.03087C0.183411 8.69191 0.318065 8.36682 0.557752 8.12713C0.797438 7.88745 1.12252 7.75279 1.46149 7.75279Z" fill="#0078D4"/>
      <path d="M3.89111 12.9955C4.23071 12.2717 4.77898 11.666 5.46546 11.2563C6.226 10.8209 7.09195 10.6039 7.96793 10.6292C8.77902 10.6116 9.57936 10.8172 10.2815 11.2237C10.9425 11.6173 11.4748 12.1946 11.8137 12.8853C12.1829 13.6465 12.3669 14.4843 12.3506 15.3302C12.3684 16.2138 12.1789 17.0892 11.7974 17.8864C11.4511 18.6016 10.9027 19.1996 10.2201 19.6064C9.49045 20.0258 8.65973 20.2371 7.81835 20.2172C6.98945 20.2369 6.171 20.029 5.45203 19.616C4.78581 19.2217 4.24723 18.6438 3.9007 17.9516C3.52896 17.2015 3.34253 16.3733 3.35706 15.5363C3.34098 14.6599 3.52356 13.7913 3.89111 12.9955ZM5.56901 17.0781C5.74993 17.5356 6.05676 17.9326 6.45398 18.2229C6.85874 18.5062 7.34363 18.6524 7.83753 18.64C8.36368 18.6604 8.88223 18.5093 9.31504 18.2095C9.70783 17.9193 10.0069 17.5203 10.1751 17.0618C10.3637 16.551 10.4567 16.0098 10.4493 15.4654C10.4551 14.9158 10.3676 14.3692 10.1904 13.8488C10.0341 13.3808 9.74572 12.9679 9.3601 12.6599C8.9387 12.345 8.42166 12.1848 7.89601 12.2064C7.39136 12.1937 6.89563 12.341 6.47987 12.6273C6.07485 12.9182 5.76093 13.3182 5.57476 13.7808C5.16292 14.8412 5.16052 16.017 5.56805 17.079L5.56901 17.0781Z" fill="white"/>
    </svg>

  ),
  svgs_cardIcon: () => (
    <svg width="24" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.5" y="4.58203" width="13" height="10.0437" rx="2" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M13.422 3.00243H2.58203V2.65039C2.58203 2.09811 3.02975 1.65039 3.58203 1.65039H12.422C12.9743 1.65039 13.422 2.09811 13.422 2.65039V3.00243Z" fill="#828282"/>
      <path d="M8 10.0938C8.82843 10.0938 9.5 9.42218 9.5 8.59375C9.5 7.76532 8.82843 7.09375 8 7.09375C7.17157 7.09375 6.5 7.76532 6.5 8.59375C6.5 9.42218 7.17157 10.0938 8 10.0938Z" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.98438 14.6242C4.98438 13.1978 6.1425 12.1133 7.57111 12.1133H8.43335C9.86197 12.1133 11.0201 13.1978 11.0201 14.6242" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_share_card: ({ width = 25, height = 16, fill = "#828282" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.42204 7.44047C6.0662 7.44047 2.6677 8.78426 2.31221 10.5245C2.2814 10.6836 2.13499 10.7994 1.96383 10.8H1.89273C1.80776 10.7999 1.72617 10.7685 1.66521 10.7126C1.61697 10.6481 1.59431 10.5696 1.60123 10.4909C1.85292
      6.56316 5.25889 3.47904 9.42204 3.40908V1.67559C9.42064 1.58449 9.45926 1.49691 9.52869 1.4337L9.67089 1.29932C9.73764 1.23572 9.8285 1.19995 9.92329 1.19995C10.0181 1.19995 10.1089 1.23572 10.1757 1.29932L14.2923 5.18961C14.361
      5.25057 14.4 5.33569 14.4 5.42477C14.4 5.51386 14.361 5.59897 14.2923 5.65994L10.1757 9.55022C10.1089 9.61382 10.0181 9.6496 9.92329 9.6496C9.8285 9.6496 9.73764 9.61382 9.67089 9.55022L9.52869 9.41584C9.45926 9.35263 9.42064 9.26506 9.42204 9.17396V7.44047Z"
        stroke={fill}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  svgs_pipedrive: ({ width = 30, height = 30, fill = "#192435" }) => (
    <svg width={width} height={height} fill={fill} id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156.15 156.15"><defs></defs><path fill="#192435" d="M142.8,0H13.35A13.36,13.36,0,0,0,0,13.36V142.8a13.35,13.35,0,0,0,13.35,13.35H142.8a13.35,13.35,0,0,0,13.35-13.35V13.36A13.36,13.36,0,0,0,142.8,0Z"/><path fill="#fff" fillRule="evenodd" d="M65.07,64.3C65.07,47.83,74,42,82.33,42c10.25,0,17.13,8.91,17.13,22.17C99.46,79.28,90.7,86,82.05,86,70.37,86,65.07,74.75,65.07,64.3ZM86.45,22.6c-12.18,0-19.23,5.52-22.63,9.33-.41-3.28-2.55-7.55-10.93-7.55H34.7V43.6h7.45c1.27,0,1.68.41,1.68,1.68V133H65.51V100.1c0-.89,0-1.72,0-2.46a28.74,28.74,0,0,0,20,7.46c21.19,0,36-17,36-41.25C121.45,39.18,107.38,22.6,86.45,22.6Z"/></svg>
  ),
  svgs_slack: () => (
    <svg width="30" height="30" viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M26.4001 78.2C26.4001 85.3 20.6001 91.1001 13.5001 91.1001C6.4001 91.1001 0.600098 85.3 0.600098 78.2C0.600098 71.1 6.4001 65.3 13.5001 65.3H26.4001V78.2Z" fill="#E01E5A"/>
      <path d="M32.8999 78.2C32.8999 71.1 38.6999 65.3 45.7999 65.3C52.8999 65.3 58.6999 71.1 58.6999 78.2V110.5C58.6999 117.6 52.8999 123.4 45.7999 123.4C38.6999 123.4 32.8999 117.6 32.8999 110.5V78.2Z" fill="#E01E5A"/>
      <path d="M45.7999 26.4001C38.6999 26.4001 32.8999 20.6001 32.8999 13.5001C32.8999 6.4001 38.6999 0.600098 45.7999 0.600098C52.8999 0.600098 58.6999 6.4001 58.6999 13.5001V26.4001H45.7999Z" fill="#36C5F0"/>
      <path d="M45.8001 32.9001C52.9001 32.9001 58.7001 38.7001 58.7001 45.8001C58.7001 52.9001 52.9001 58.7001 45.8001 58.7001H13.5001C6.4001 58.7001 0.600098 52.9001 0.600098 45.8001C0.600098 38.7001 6.4001 32.9001 13.5001 32.9001H45.8001Z" fill="#36C5F0"/>
      <path d="M97.6001 45.8001C97.6001 38.7001 103.4 32.9001 110.5 32.9001C117.6 32.9001 123.4 38.7001 123.4 45.8001C123.4 52.9001 117.6 58.7001 110.5 58.7001H97.6001V45.8001Z" fill="#2EB67D"/>
      <path d="M91.1003 45.8001C91.1003 52.9001 85.3003 58.7001 78.2003 58.7001C71.1003 58.7001 65.3003 52.9001 65.3003 45.8001V13.5001C65.3003 6.4001 71.1003 0.600098 78.2003 0.600098C85.3003 0.600098 91.1003 6.4001 91.1003 13.5001V45.8001Z" fill="#2EB67D"/>
      <path d="M78.2003 97.6001C85.3003 97.6001 91.1003 103.4 91.1003 110.5C91.1003 117.6 85.3003 123.4 78.2003 123.4C71.1003 123.4 65.3003 117.6 65.3003 110.5V97.6001H78.2003Z" fill="#ECB22E"/>
      <path d="M78.2003 91.1001C71.1003 91.1001 65.3003 85.3 65.3003 78.2C65.3003 71.1 71.1003 65.3 78.2003 65.3H110.5C117.6 65.3 123.4 71.1 123.4 78.2C123.4 85.3 117.6 91.1001 110.5 91.1001H78.2003Z" fill="#ECB22E"/>
    </svg>
  ),
  svgs_search_integrations: () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3333 22.6667C18.488 22.6667 22.6667 18.488 22.6667 13.3333C22.6667 8.17868 18.488 4 13.3333 4C8.17868 4 4 8.17868 4 13.3333C4 18.488 8.17868 22.6667 13.3333 22.6667Z" stroke="black" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M26.1822 26.1822L20 20" stroke="black" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_eventbrite_colored: ({ width = 33, height = 32 }) => (
    <svg width={width} height={height} viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10148_58435)">
        <path d="M16.5 32C25.3366 32 32.5 24.8366 32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16C0.5 24.8366 7.66344 32 16.5 32Z" fill="#F05537"/>
        <path d="M15.1838 10.3415C17.5959 9.80546 20.0082 10.7882 21.3482 12.6642L10.6872 15.0766C11.0446 12.7835 12.7717 10.8776 15.1838 10.3416V10.3415ZM21.4078 19.186C20.5739 20.407 19.2934 21.2706 17.8342 21.5981C15.4221 22.1341 12.9802 21.1515 11.6401 19.2456L22.3309 16.8333L24.0582 16.4462L27.3934 15.7018C27.3637 14.9871 27.2743 14.2723 27.1254 13.5875C25.7854 7.83996 19.9188 4.23671 14.0522 5.57671C8.1857 6.91671 4.52282 12.6345 5.8927 18.4117C7.26257 24.189 13.0993 27.7625 18.9658 26.4223C22.4203 25.6481 25.1004 23.3253 26.4703 20.3772L21.4078 19.186Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_10148_58435">
          <rect width="32" height="32" fill="white" transform="translate(0.5)"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_eventbrite: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9875_86241)">
        <path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#818181"/>
        <path d="M9.17788 6.46341C10.6855 6.12841 12.1931 6.74263 13.0306 7.91513L6.36749 9.42287C6.59085 7.98966 7.6703 6.79849 9.17788 6.46349V6.46341ZM13.0679 11.9912C12.5467 12.7544 11.7464 13.2941 10.8344 13.4988C9.32678 13.8338 7.80061 13.2197 6.96303 12.0285L13.6448 10.5208L14.7244 10.2789L16.8089 9.81365C16.7903 9.36693 16.7344 8.92021 16.6414 8.49216C15.8039 4.89998 12.1373 2.64794 8.47061 3.48544C4.80405 4.32294 2.51475 7.89654 3.37092 11.5073C4.2271 15.1181 7.87506 17.3515 11.5416 16.514C13.7007 16.0301 15.3758 14.5783 16.2319 12.7358L13.0679 11.9912Z" fill="#F7F7F7"/>
      </g>
      <defs>
        <clipPath id="clip0_9875_86241">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_sidebarAdminIcon: ({ strokeFill = "#818181" }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9937_53712)">
        <path d="M12.4646 6.94978C12.0741 6.55926 12.0741 5.92609 12.4646 5.53557L14.8348 3.16532C14.2794 2.8991 13.6572 2.75 13.0002 2.75C10.6529 2.75 8.75015 4.65279 8.75015 7C8.75015 7.65705 8.89926 8.27927 9.16547 8.83468L3.16421 14.8359C2.61193 15.3882 2.61193 16.2837 3.16421 16.8359C3.7165 17.3882 4.61193 17.3882 5.16421 16.8359L11.1655 10.8347C11.7209 11.1009 12.3431 11.25 13.0002 11.25C15.3474 11.25 17.2502 9.34721 17.2502 7C17.2502 6.35127 17.1048 5.73649 16.8449 5.18645L14.4802 7.55116C14.0897 7.94169 13.4565 7.94169 13.066 7.55117L12.4646 6.94978Z" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_9937_53712">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  ),
  svgs_forbid: ({ strokeFill = "#828282" }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7 7L17 17" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),

  svgs_logos: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.1369 17.169C15.653 17.169 15.2155 17.0795 14.8244 16.9005C14.4333 16.7182 14.1234 16.4547 13.8947 16.11C13.6693 15.7653 13.5566 15.3428 13.5566 14.8423C13.5566 14.4114 13.6395 14.0568 13.8052 13.7784C13.9709 13.5 14.1947 13.2795 14.4764 13.1171C14.7581 12.9547 15.073 12.8321 15.421 12.7492C15.769 12.6664 16.1236 12.6034 16.4849 12.5603C16.9423 12.5073 17.3135 12.4642 17.5985 12.4311C17.8836 12.3946 18.0907 12.3366 18.22 12.2571C18.3493 12.1775 18.4139 12.0483 18.4139 11.8693V11.8345C18.4139 11.4003 18.2913 11.0639 18.046 10.8252C17.804 10.5866 17.4428 10.4673 16.9622 10.4673C16.4617 10.4673 16.0673 10.5783 15.7789 10.8004C15.4939 11.0191 15.2967 11.2627 15.1873 11.5312L13.7903 11.213C13.956 10.749 14.198 10.3745 14.5162 10.0894C14.8377 9.80109 15.2072 9.59228 15.6248 9.46302C16.0424 9.33045 16.4816 9.26416 16.9423 9.26416C17.2472 9.26416 17.5704 9.30062 17.9118 9.37354C18.2565 9.44314 18.5779 9.5724 18.8762 9.76132C19.1779 9.95024 19.4248 10.2204 19.617 10.5717C19.8092 10.9197 19.9054 11.3721 19.9054 11.9289V17H18.4537V15.9559H18.394C18.2979 16.1482 18.1537 16.3371 17.9615 16.5227C17.7692 16.7083 17.5223 16.8624 17.2207 16.985C16.9191 17.1077 16.5578 17.169 16.1369 17.169ZM16.46 15.9758C16.871 15.9758 17.2224 15.8946 17.514 15.7322C17.809 15.5698 18.0327 15.3577 18.1852 15.0958C18.341 14.8307 18.4189 14.5473 18.4189 14.2457V13.2613C18.3658 13.3143 18.2631 13.3641 18.1106 13.4105C17.9615 13.4536 17.7908 13.4917 17.5985 13.5248C17.4063 13.5546 17.219 13.5828 17.0368 13.6093C16.8545 13.6325 16.702 13.6524 16.5794 13.669C16.291 13.7054 16.0275 13.7668 15.7889 13.8529C15.5536 13.9391 15.3646 14.0634 15.2221 14.2258C15.0829 14.3849 15.0133 14.597 15.0133 14.8622C15.0133 15.2301 15.1492 15.5085 15.421 15.6974C15.6928 15.883 16.0391 15.9758 16.46 15.9758Z" fill="#818181"/>
      <path d="M5.09162 17.0002H3.46094L7.125 6.81836H8.89986L12.5639 17.0002H10.9332L8.05469 8.66779H7.97514L5.09162 17.0002ZM5.36506 13.013H10.6548V14.3056H5.36506V13.013Z" fill="#818181"/>
    </svg>

  ),
  svgs_coverphoto: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.75 16L7.49619 12.5067C8.2749 11.5161 9.76453 11.4837 10.5856 12.4395L13 15.25M10.915 12.823C11.9522 11.5037 13.3973 9.63455 13.4914 9.51294C13.4947 9.50859 13.4979 9.50448 13.5013 9.50017C14.2815 8.51598 15.7663 8.48581 16.5856 9.43947L19 12.25M6.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25V6.75C19.25 5.64543 18.3546 4.75 17.25 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25Z" stroke="#818181" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),
  svgs_vb: ({ strokeFill = "#818181" }) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5 10L19.25 7.75V16.25L15.5 14M6.75 17.25H13.25C14.3546 17.25 15.25 16.3546 15.25 15.25V8.75C15.25 7.64543 14.3546 6.75 13.25 6.75H6.75C5.64543 6.75 4.75 7.64543 4.75 8.75V15.25C4.75 16.3546 5.64543 17.25 6.75 17.25Z" stroke={strokeFill} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),
  svgs_linkicon: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="9.75" y="6" width="4.5" height="4.5" rx="0.75" stroke="#818181" strokeWidth="1.5"/>
      <rect x="17.25" y="6" width="4.5" height="4.5" rx="0.75" stroke="#818181" strokeWidth="1.5"/>
      <rect x="2.25" y="6" width="4.5" height="4.5" rx="0.75" stroke="#818181" strokeWidth="1.5"/>
      <rect x="2.25" y="13.5" width="4.5" height="4.5" rx="0.75" stroke="#818181" strokeWidth="1.5"/>
      <rect x="9.75" y="13.5" width="4.5" height="4.5" rx="0.75" stroke="#818181" strokeWidth="1.5"/>
      <rect x="17.25" y="13.5" width="4.5" height="4.5" rx="0.75" stroke="#818181" strokeWidth="1.5"/>
    </svg>
  ),
  svgs_chain_link: ({ width = 16, height = 16, strokeFill = "#828282" }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.1667 8.83364L12.0001 8.0003C13.1047 6.89573 13.1047 5.10487 12.0001 4.0003C10.8955 2.89573 9.10465 2.89573 8.00008 4.0003L7.16675 4.83364" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.83339 7.16797L4.00006 8.0013C2.89549 9.10587 2.89549 10.8967 4.00006 12.0013C5.10463 13.1059 6.89549 13.1059 8.00006 12.0013L8.83339 11.168" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.5 6.5L6.5 9.5" stroke={strokeFill} stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  ),
  svgs_duplicate: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.41665 12.7083C4.61123 12.7083 3.95831 12.0554 3.95831 11.25V5.62498C3.95831 4.70451 4.70451 3.95831 5.62498 3.95831H11.25C12.0554 3.95831 12.7083 4.61123 12.7083 5.41665" stroke="#828282" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.29169 8.95835C7.29169 8.03788 8.03788 7.29169 8.95835 7.29169H14.375C15.2955 7.29169 16.0417 8.03788 16.0417 8.95835V14.375C16.0417 15.2955 15.2955 16.0417 14.375 16.0417H8.95835C8.03788 16.0417 7.29169 15.2955 7.29169 14.375V8.95835Z" stroke="#828282" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),
  svgs_email: ({
    width = 16, height = 16, strokeFill = "#BDBDBD", fill = "none",
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.6667 3.33313H3.33333C2.59695 3.33313 2 3.93008 2 4.66646V11.3331C2 12.0695 2.59695 12.6665 3.33333 12.6665H12.6667C13.403 12.6665 14 12.0695 14 11.3331V4.66646C14 3.93008 13.403 3.33313 12.6667 3.33313Z" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 4.66669L8 8.66669L14 4.66669" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_plusIcon: ({ strokeFill = "#828282" }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#F2F2F2"/>
      <g clipPath="url(#clip0_14486_9607)">
        <path d="M12 6.79169V17.2084" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.2084 12H6.79169" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_14486_9607">
          <rect width="16" height="16" fill="white" transform="translate(4 4)"/>
        </clipPath>
      </defs>
    </svg>

  ),
  svgs_person: ({ strokeFill = "#828282" }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14486_9610)">
        <rect width="24" height="24" fill="white"/>
        <path d="M15.25 8C15.25 9.79493 13.7949 11.25 12 11.25C10.2051 11.25 8.75 9.79493 8.75 8C8.75 6.20507 10.2051 4.75 12 4.75C13.7949 4.75 15.25 6.20507 15.25 8Z" stroke={strokeFill} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.84748 19.25H17.1525C18.2944 19.25 19.174 18.2681 18.6407 17.2584C17.8563 15.7731 16.068 14 12 14C7.93198 14 6.14364 15.7731 5.35921 17.2584C4.82594 18.2681 5.70556 19.25 6.84748 19.25Z" stroke={strokeFill} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_14486_9610">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_delete: ({ strokeFill = "#EB5757" }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14552_58115)">
        <rect width="20" height="20" fill="white"/>
        <path d="M4.79175 6.45831L5.49271 14.5194C5.5676 15.3806 6.2886 16.0416 7.15311 16.0416H12.0137C12.8782 16.0416 13.5992 15.3806 13.6741 14.5194L14.3751 6.45831H4.79175Z" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.125 8.95831V13.5416" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.0417 8.95831V13.5416" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.29175 6.45831V5.62498C7.29175 4.70451 8.03794 3.95831 8.95841 3.95831H10.2084C11.1289 3.95831 11.8751 4.70451 11.8751 5.62498V6.45831" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.95825 6.45831H15.2083" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_14552_58115">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_calculator: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 16V4C2.5 3.17157 3.17157 2.5 4 2.5H16C16.8284 2.5 17.5 3.17157 17.5 4V16C17.5 16.8284 16.8284 17.5 16 17.5H4C3.17157 17.5 2.5 16.8284 2.5 16Z" stroke="#818181" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5 5V10H15V5H5Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="5" y="12.5" width="3.75" height="2.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="11.25" y="12.5" width="3.75" height="2.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_copy: ({ strokeFill = "#828282" }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.41659 12.7083C4.61117 12.7083 3.95825 12.0554 3.95825 11.25V5.62498C3.95825 4.70451 4.70444 3.95831 5.62492 3.95831H11.2499C12.0553 3.95831 12.7083 4.61123 12.7083 5.41665" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.29175 8.95835C7.29175 8.03788 8.03794 7.29169 8.95841 7.29169H14.3751C15.2956 7.29169 16.0417 8.03788 16.0417 8.95835V14.375C16.0417 15.2955 15.2956 16.0417 14.3751 16.0417H8.95841C8.03794 16.0417 7.29175 15.2955 7.29175 14.375V8.95835Z" stroke={strokeFill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_home: ({ strokeFill = "#828282" }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.62516 16.0418H14.3752C15.2956 16.0418 16.0418 15.2956 16.0418 14.3752V8.12516L10.0002 3.9585L3.9585 8.12516V14.3752C3.9585 15.2956 4.70469 16.0418 5.62516 16.0418Z" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.12476 13.1242C8.12476 12.2037 8.87095 11.4575 9.79142 11.4575H10.2081C11.1286 11.4575 11.8748 12.2037 11.8748 13.1242V16.0409H8.12476V13.1242Z" stroke={strokeFill} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  viewall_right_arrow: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.99634 4L9.99634 8L5.99634 12" stroke="#828282" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_rec_template: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.91663 14.6666V5.33325C2.91663 4.22868 3.81206 3.33325 4.91663 3.33325H15.0833C16.1879 3.33325 17.0833 4.22868 17.0833 5.33325V14.6666C17.0833 15.7712 16.1879 16.6666 15.0833 16.6666H4.91663C3.81206 16.6666 2.91663 15.7712 2.91663 14.6666Z" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.41663 6.08325V8.91659C5.41663 9.05466 5.52856 9.16659 5.66663 9.16659H14.3333C14.4714 9.16659 14.5833 9.05466 14.5833 8.91659V6.08325C14.5833 5.94518 14.4714 5.83325 14.3333 5.83325H5.66663C5.52855 5.83325 5.41663 5.94518 5.41663 6.08325Z" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round"/>
      <rect x="5.41663" y="11.6667" width="3.33333" height="2.5" rx="0.25" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round"/>
      <rect x="11.25" y="11.6667" width="3.33333" height="2.5" rx="0.25" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>

  ),
  svgs_rec_request: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.95837 16.0418L7.50004 15.2085L15.2441 7.46437C15.5696 7.13894 15.5696 6.6113 15.2441 6.28586L13.7143 4.75604C13.3889 4.4306 12.8612 4.4306 12.5358 4.75604L4.79171 12.5001L3.95837 16.0418Z" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.0417 16.0417H11.4584" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),
  svgs_rec_event: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.95837 7.29167C3.95837 6.37119 4.70457 5.625 5.62504 5.625H14.375C15.2955 5.625 16.0417 6.37119 16.0417 7.29167V14.375C16.0417 15.2955 15.2955 16.0417 14.375 16.0417H5.62504C4.70457 16.0417 3.95837 15.2955 3.95837 14.375V7.29167Z" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.66663 3.95825V6.87492" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.3334 3.95825V6.87492" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.45837 8.95825H13.5417" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  ),
  svgs_rec_lead: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.625 6.04175H14.375V11.0417C14.375 11.7048 14.0984 12.3407 13.6062 12.8095C13.1139 13.2784 12.4462 13.5417 11.75 13.5417H8.25C7.55381 13.5417 6.88613 13.2784 6.39384 12.8095C5.90156 12.3407 5.625 11.7048 5.625 11.0417V6.04175Z" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.5 2.91675V5.41675" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.5 2.91675V5.41675" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 13.5417V14.4167C10 15.6594 11.0074 16.6667 12.25 16.6667H14.375" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>

  ),
  svgs_rec_unsynced: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="5.50757" width="14" height="11.0303" rx="2.5" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.99997 11.2348C10.8786 11.2348 11.5909 10.5225 11.5909 9.64389C11.5909 8.76525 10.8786 8.05298 9.99997 8.05298C9.12133 8.05298 8.40906 8.76525 8.40906 9.64389C8.40906 10.5225 9.12133 11.2348 9.99997 11.2348Z" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.81824 16.1137V15.5986C6.81824 14.243 8.03928 13.144 9.54551 13.144H10.4546C11.9608 13.144 13.1819 14.243 13.1819 15.5986V16.1137" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15.7273 3.59852L15.6767 3.54794C15.3016 3.17287 14.7929 2.96216 14.2625 2.96216H5.7375C5.20706 2.96216 4.69835 3.17287 4.32328 3.54794L4.27271 3.59852" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  svgs_syncedicon: () => (
    <svg style={{ minWidth: 18, minHeight: 18 }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_26_2806)">
        <path d="M6.77776 2.72773H10.7214L6.62761 14.8571C6.58558 14.9817 6.50547 15.0901 6.3986 15.1668C6.29172 15.2436 6.16346 15.2848 6.03188 15.2848H2.96288C2.86321 15.2848 2.76498 15.2611 2.67629 15.2156C2.5876 15.1701 2.51101 15.1041 2.45284 15.0232C2.39469 14.9423 2.35665 14.8486 2.34189 14.75C2.32712 14.6515 2.33605 14.5508 2.36793 14.4564L6.18203 3.15539C6.22409 3.03072 6.30419 2.92238 6.41106 2.84562C6.51793 2.76887 6.64618 2.72757 6.77776 2.72754V2.72773Z" fill="#828282"/>
        <path d="M12.5112 10.8501H6.25764C6.19948 10.85 6.14265 10.8674 6.09454 10.9001C6.04643 10.9327 6.00929 10.9791 5.98795 11.0332C5.96662 11.0873 5.96208 11.1466 5.97492 11.2033C5.98777 11.26 6.01742 11.3116 6.05999 11.3512L10.0783 15.1019C10.1953 15.211 10.3494 15.2717 10.5094 15.2717H14.0504L12.5112 10.8501Z" fill="#BDBDBD"/>
        <path d="M11.8176 3.15461C11.7756 3.03012 11.6956 2.92194 11.5889 2.84532C11.4821 2.7687 11.354 2.7275 11.2226 2.72754H6.82764C6.959 2.72755 7.08706 2.76877 7.19377 2.84538C7.30048 2.92199 7.38048 3.03015 7.4225 3.15461L11.2367 14.4561C11.2686 14.5505 11.2776 14.6512 11.2629 14.7498C11.2481 14.8485 11.2101 14.9421 11.152 15.0231C11.0938 15.1041 11.0172 15.1701 10.9285 15.2156C10.8398 15.2611 10.7415 15.2849 10.6418 15.2848H15.037C15.1367 15.2848 15.2349 15.261 15.3236 15.2154C15.4122 15.1699 15.4888 15.1039 15.5469 15.0229C15.605 14.942 15.643 14.8483 15.6578 14.7498C15.6725 14.6512 15.6636 14.5505 15.6318 14.4561L11.8176 3.15461Z" fill="#E0E0E0"/>
      </g>
      <defs>
        <clipPath id="clip0_26_2806">
          <rect width="13.5" height="13.5" fill="white" transform="translate(2.25 2.25293)"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_rec_admin: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 9.25C11.6569 9.25 13 7.90685 13 6.25C13 4.59315 11.6569 3.25 10 3.25C8.34315 3.25 7 4.59315 7 6.25C7 7.90685 8.34315 9.25 10 9.25Z" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.75 16.75C4.75 14.2647 6.76472 12.25 9.25 12.25H10.75C13.2353 12.25 15.25 14.2647 15.25 16.75" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_rec_finish: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12Z" stroke="#29AEF8" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.75 12.75L10.1837 13.6744C10.5275 14.407 11.5536 14.4492 11.9564 13.7473L14.25 9.75" stroke="#29AEF8" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  svgs_googleWorkspaceColored: ({ width = 28, height = 28 }) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1816_googleWorkspace)">
        <g clipPath="url(#clip1_1816_googleWorkspace)">
          <path d="M19.774 10.2216C19.774 9.40171 19.7075 8.80342 19.5635 8.18298H10.2014V11.8834H15.6967C15.586 12.8031 14.9877 14.188 13.6582 15.1186L13.6395 15.2425L16.5996 17.5357L16.8047 17.5561C18.6882 15.8166 19.774 13.2573 19.774 10.2216Z" fill="#4285F4"/>
          <path d="M10.2013 19.9714C12.8935 19.9714 15.1537 19.085 16.8046 17.5561L13.658 15.1186C12.816 15.7058 11.6859 16.1157 10.2013 16.1157C7.56442 16.1157 5.32641 14.3763 4.52861 11.9721L4.41168 11.982L1.33371 14.3641L1.29346 14.476C2.93319 17.7333 6.30132 19.9714 10.2013 19.9714Z" fill="#34A853"/>
          <path d="M4.52873 11.9721C4.31823 11.3517 4.1964 10.6869 4.1964 10C4.1964 9.31305 4.31823 8.64831 4.51766 8.02788L4.51208 7.89574L1.39554 5.4754L1.29357 5.5239C0.617763 6.8756 0.22998 8.39351 0.22998 10C0.22998 11.6065 0.617763 13.1243 1.29357 14.476L4.52873 11.9721Z" fill="#FBBC05"/>
          <path d="M10.2013 3.88416C12.0737 3.88416 13.3367 4.69295 14.0569 5.36884L16.871 2.62114C15.1427 1.01463 12.8935 0.0285645 10.2013 0.0285645C6.30132 0.0285645 2.93319 2.26658 1.29346 5.52389L4.51754 8.02786C5.32641 5.62364 7.56442 3.88416 10.2013 3.88416Z" fill="#EB4335"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1816_googleWorkspace">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
        <clipPath id="clip1_1816_googleWorkspace">
          <rect width="19.544" height="20" fill="white" transform="translate(0.22998)"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_googleWorkspaceGrey: ({ width = 28, height = 28 }) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1816_googleWorkspaceGrey)">
        <g clipPath="url(#clip1_1816_googleWorkspaceGrey)">
          <path d="M19.774 10.2216C19.774 9.40171 19.7075 8.80342 19.5635 8.18298H10.2014V11.8834H15.6967C15.586 12.8031 14.9877 14.188 13.6582 15.1186L13.6395 15.2425L16.5996 17.5357L16.8047 17.5561C18.6882 15.8166 19.774 13.2573 19.774 10.2216Z" fill="#9B9B9B"/>
          <path d="M10.2013 19.9714C12.8935 19.9714 15.1537 19.085 16.8046 17.5561L13.658 15.1186C12.816 15.7058 11.6859 16.1157 10.2013 16.1157C7.56442 16.1157 5.32641 14.3763 4.52861 11.9721L4.41168 11.982L1.33371 14.3641L1.29346 14.476C2.93319 17.7333 6.30132 19.9714 10.2013 19.9714Z" fill="#6E6E6E"/>
          <path d="M4.52873 11.9721C4.31823 11.3517 4.1964 10.6869 4.1964 10C4.1964 9.31305 4.31823 8.64831 4.51766 8.02788L4.51208 7.89574L1.39554 5.4754L1.29357 5.5239C0.617763 6.8756 0.22998 8.39351 0.22998 10C0.22998 11.6065 0.617763 13.1243 1.29357 14.476L4.52873 11.9721Z" fill="#808080"/>
          <path d="M10.2013 3.88416C12.0737 3.88416 13.3367 4.69295 14.0569 5.36884L16.871 2.62114C15.1427 1.01463 12.8935 0.0285645 10.2013 0.0285645C6.30132 0.0285645 2.93319 2.26658 1.29346 5.52389L4.51754 8.02786C5.32641 5.62364 7.56442 3.88416 10.2013 3.88416Z" fill="#909090"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1816_googleWorkspaceGrey">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
        <clipPath id="clip1_1816_googleWorkspaceGrey">
          <rect width="19.544" height="20" fill="white" transform="translate(0.22998)"/>
        </clipPath>
      </defs>
    </svg>

  ),
  svgs_rec_linkedin: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2923_1528)">
        <path d="M5.61905 2.5H14.381C16.1048 2.5 17.5 3.89519 17.5 5.61905V14.381C17.5 16.1048 16.1048 17.5 14.381 17.5H5.61905C3.89519 17.5 2.5 16.1048 2.5 14.381V5.61905C2.5 3.89519 3.89519 2.5 5.61905 2.5Z" fill="#29AEF8" stroke="#29AEF8"/>
        <path d="M5.17952 8.32692H7.28981V14.9882H5.17952V8.32692ZM6.23525 5.01172C6.47729 5.01172 6.71389 5.08215 6.91513 5.21409C7.11636 5.34604 7.27318 5.53357 7.36575 5.75297C7.45833 5.97237 7.48249 6.21377 7.43518 6.44664C7.38788 6.67952 7.27123 6.89339 7.1 7.06122C6.92877 7.22904 6.71065 7.34327 6.47323 7.38946C6.23581 7.43564 5.98977 7.41171 5.76622 7.32068C5.54267 7.22966 5.35166 7.07563 5.21735 6.87809C5.08305 6.68054 5.01149 6.44836 5.01172 6.21091C5.01203 5.89276 5.14107 5.58774 5.37049 5.36288C5.59992 5.13802 5.91095 5.01172 6.23525 5.01172Z" fill="white"/>
        <path d="M8.3999 8.37178H10.4253V9.28015H10.4533C10.7356 8.76011 11.4239 8.21168 12.4518 8.21168C14.5915 8.20714 14.9881 9.57765 14.9881 11.3547V14.9881H12.8753V11.7691C12.8753 11.0027 12.8613 10.0159 11.7774 10.0159C10.6936 10.0159 10.5093 10.8516 10.5093 11.7191V14.9881H8.3999V8.37178Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_2923_1528">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_crm_connect: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.75 7.25H17.25V13.25C17.25 14.0456 16.9181 14.8087 16.3274 15.3713C15.7366 15.9339 14.9354 16.25 14.1 16.25H9.9C9.06457 16.25 8.26335 15.9339 7.67261 15.3713C7.08187 14.8087 6.75 14.0456 6.75 13.25V7.25Z" stroke="#29AEF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 3.5V6.5" stroke="#29AEF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 3.5V6.5" stroke="#29AEF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 16.25V17.75C12 18.9926 13.0074 20 14.25 20H17.25" stroke="#29AEF8" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  svgs_workdayColored: ({ width = 20, height = 20 }) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3897_26796_workdayColored)">
        <mask id="mask0_3897_26796" style={{ maskType: "luminance", maskUnits: "userSpaceOnUse" }} x="0" y="0" width="21" height="20">
          <path d="M20.051 0H0.0510254V20H20.051V0Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_3897_26796_workdayColored)">
          <path fillRule="evenodd" clipRule="evenodd" d="M2.91932 9.79688H4.28998C4.48432 9.79688 4.65298 9.92748 4.69732 10.1123L6.54015 17.5581C6.56548 17.5585 8.57049 10.1182 8.57049 10.1182C8.62149 9.92889 8.79715 9.79688 8.99815 9.79688H11.1215C11.3122 9.79688 11.4788 9.92213 11.5273 10.1018L13.547 17.59C13.6217 17.543 15.4048 10.1123 15.4048 10.1123C15.4493 9.92748 15.618 9.79688 15.8121 9.79688H17.182C17.4568 9.79688 17.6577 10.0501 17.5882 10.3092L15.0748 19.6955C15.0272 19.8741 14.8628 19.9993 14.6738 20.001L12.6008 19.9978C12.4105 19.9975 12.2447 19.8738 12.196 19.6946C11.8417 18.3938 10.0952 11.8151 10.0952 11.8151C10.0952 11.8151 8.26048 18.3936 7.90632 19.6946C7.85748 19.8738 7.69165 19.9975 7.50149 19.9978L5.42832 20.001C5.23949 19.9993 5.07515 19.8741 5.02732 19.6955L2.51382 10.3083C2.44448 10.0495 2.64482 9.79688 2.91932 9.79688Z" fill="#005CB9"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M16.605 7.04082C16.6935 7.04082 16.7835 7.02877 16.873 7.00358C17.403 6.85412 17.7128 6.29853 17.5651 5.76258C17.5436 5.6847 17.521 5.60713 17.4971 5.53032C16.4725 2.22248 13.4791 0 10.0488 0C6.62264 0 3.63047 2.21888 2.6033 5.52135C2.58064 5.59393 2.55881 5.66772 2.53814 5.74188C2.38781 6.2772 2.6953 6.83423 3.2248 6.98597C3.75364 7.13783 4.30481 6.82685 4.45497 6.29153C4.47064 6.23617 4.48664 6.18127 4.50364 6.12667C5.26881 3.66697 7.49714 2.01488 10.0488 2.01488C12.6036 2.01488 14.8328 3.66962 15.5956 6.1326C15.6131 6.18922 15.63 6.24627 15.6458 6.30365C15.7686 6.74908 16.169 7.04082 16.605 7.04082Z" fill="#F38B00"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3897_26796">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_bambooHrColored: ({ width = 20, height = 20 }) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3897_26696_bambooHrColored)">
        <path fillRule="evenodd" clipRule="evenodd" d="M11.6925 14.1021C10.4009 14.1021 9.30806 13.0837 9.30806 11.7199C9.30806 10.3551 10.2296 9.23425 11.7156 9.23425C13.2018 9.23425 14.0775 10.436 14.0775 11.6946C14.0775 13.064 13.1511 14.1021 11.6925 14.1021ZM7.88487 9.58369L7.42844 8.0885C7.15625 7.30206 7.07562 6.84925 6.30825 6.03909C6.04524 5.76104 5.05052 5.14956 5.17417 5.28305C6.43494 6.64412 7.07962 8.29275 7.32819 8.75075C7.09962 8.47331 6.83206 8.2245 6.52663 7.91444C6.26638 7.6505 5.9948 7.41244 5.73674 7.25312C5.56695 7.14794 5.4716 7.08981 5.29905 7.00063C4.5224 6.59706 3.76944 6.35281 3.48031 6.28056C3.1272 6.19258 2.77933 6.16982 2.77933 6.16982C2.77933 6.16982 3.90477 7.11994 4.38706 7.72494C4.86936 8.32969 5.36149 8.87162 5.90529 9.09338C6.44913 9.31519 6.63825 9.3785 7.06613 9.44344C7.43494 9.49912 7.88487 9.58369 7.88487 9.58369ZM11.7958 8.25894C10.6058 8.25894 9.96756 8.66737 9.52031 9.11156L9.39819 9.2395L9.39787 5.25076H8.36963V11.7786C8.36963 13.7874 9.91681 15.039 11.6922 15.039C13.6481 15.039 15.1285 13.534 15.1285 11.5992C15.1288 9.803 13.5844 8.25894 11.7958 8.25894ZM20 10.0001C20 15.5228 15.5228 20 10.0001 20C4.47749 20 0 15.5228 0 10.0001C0 4.47749 4.47719 0 9.99988 0C15.5225 0 20 4.47719 20 10.0001Z" fill="#73C41D"/>
      </g>
      <defs>
        <clipPath id="clip0_3897_26696_bambooHrColored">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_workdayGrey: ({ width = 20, height = 20 }) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3897_26700_workdayGrey)">
        <mask id="mask0_3897_26700_workdayGrey" style={{ maskType: "luminance", maskUnits: "userSpaceOnUse" }} x="0" y="0" width="21" height="20">
          <path d="M20.051 0H0.0510254V20H20.051V0Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_3897_26700_workdayGrey)">
          <path fillRule="evenodd" clipRule="evenodd" d="M2.91932 9.79688H4.28998C4.48432 9.79688 4.65298 9.92748 4.69732 10.1123L6.54015 17.5581C6.56548 17.5585 8.57049 10.1182 8.57049 10.1182C8.62149 9.92889 8.79715 9.79688 8.99815 9.79688H11.1215C11.3122 9.79688 11.4788 9.92213 11.5273 10.1018L13.547 17.59C13.6217 17.543 15.4048 10.1123 15.4048 10.1123C15.4493 9.92748 15.618 9.79688 15.8121 9.79688H17.182C17.4568 9.79688 17.6577 10.0501 17.5882 10.3092L15.0748 19.6955C15.0272 19.8741 14.8628 19.9993 14.6738 20.001L12.6008 19.9978C12.4105 19.9975 12.2447 19.8738 12.196 19.6946C11.8417 18.3938 10.0952 11.8151 10.0952 11.8151C10.0952 11.8151 8.26048 18.3936 7.90632 19.6946C7.85748 19.8738 7.69165 19.9975 7.50149 19.9978L5.42832 20.001C5.23949 19.9993 5.07515 19.8741 5.02732 19.6955L2.51382 10.3083C2.44448 10.0495 2.64482 9.79688 2.91932 9.79688Z" fill="#818181"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M16.605 7.04082C16.6935 7.04082 16.7835 7.02877 16.873 7.00358C17.403 6.85412 17.7128 6.29853 17.5651 5.76258C17.5436 5.6847 17.521 5.60713 17.4971 5.53032C16.4725 2.22248 13.4791 0 10.0488 0C6.62264 0 3.63047 2.21888 2.6033 5.52135C2.58064 5.59393 2.55881 5.66772 2.53814 5.74188C2.38781 6.2772 2.6953 6.83423 3.2248 6.98597C3.75364 7.13783 4.30481 6.82685 4.45497 6.29153C4.47064 6.23617 4.48664 6.18127 4.50364 6.12667C5.26881 3.66697 7.49714 2.01488 10.0488 2.01488C12.6036 2.01488 14.8328 3.66962 15.5956 6.1326C15.6131 6.18922 15.63 6.24627 15.6458 6.30365C15.7686 6.74908 16.169 7.04082 16.605 7.04082Z" fill="#818181"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3897_26700_workdayGrey">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_bambooHrGrey: ({ width = 20, height = 20 }) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3897_26683_bambooHrGrey)">
        <path fillRule="evenodd" clipRule="evenodd" d="M11.6925 14.1021C10.4009 14.1021 9.30806 13.0837 9.30806 11.7199C9.30806 10.3551 10.2296 9.23425 11.7156 9.23425C13.2018 9.23425 14.0775 10.436 14.0775 11.6946C14.0775 13.064 13.1511 14.1021 11.6925 14.1021ZM7.88487 9.58369L7.42844 8.0885C7.15625 7.30206 7.07562 6.84925 6.30825 6.03909C6.04524 5.76104 5.05052 5.14956 5.17417 5.28305C6.43494 6.64412 7.07962 8.29275 7.32819 8.75075C7.09962 8.47331 6.83206 8.2245 6.52663 7.91444C6.26638 7.6505 5.9948 7.41244 5.73674 7.25312C5.56695 7.14794 5.4716 7.08981 5.29905 7.00063C4.5224 6.59706 3.76944 6.35281 3.48031 6.28056C3.1272 6.19258 2.77933 6.16982 2.77933 6.16982C2.77933 6.16982 3.90477 7.11994 4.38706 7.72494C4.86936 8.32969 5.36149 8.87162 5.90529 9.09338C6.44913 9.31519 6.63825 9.3785 7.06613 9.44344C7.43494 9.49912 7.88487 9.58369 7.88487 9.58369ZM11.7958 8.25894C10.6058 8.25894 9.96756 8.66737 9.52031 9.11156L9.39819 9.2395L9.39787 5.25076H8.36963V11.7786C8.36963 13.7874 9.91681 15.039 11.6922 15.039C13.6481 15.039 15.1285 13.534 15.1285 11.5992C15.1288 9.803 13.5844 8.25894 11.7958 8.25894ZM20 10.0001C20 15.5228 15.5228 20 10.0001 20C4.47749 20 0 15.5228 0 10.0001C0 4.47749 4.47719 0 9.99988 0C15.5225 0 20 4.47719 20 10.0001Z" fill="#818181"/>
      </g>
      <defs>
        <clipPath id="clip0_3897_26683_bambooHrGrey">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),

  svgs_integrationsConnect: ({ width = 20, height = 20 }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.75 7.25H17.25V13.25C17.25 14.0456 16.9181 14.8087 16.3274 15.3713C15.7366 15.9339 14.9354 16.25 14.1 16.25H9.9C9.06457 16.25 8.26335 15.9339 7.67261 15.3713C7.08187 14.8087 6.75 14.0456 6.75 13.25V7.25Z" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 3.5V6.5" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 3.5V6.5" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 16.25V17.75C12 18.9926 13.0074 20 14.25 20H17.25" stroke="#29AEF8" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>

  ),

  svgs_singleProfile: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2039_19974_singleProfile)">
        <path d="M7.9987 7.33333C9.47146 7.33333 10.6654 6.13943 10.6654 4.66667C10.6654 3.19391 9.47146 2 7.9987 2C6.52594 2 5.33203 3.19391 5.33203 4.66667C5.33203 6.13943 6.52594 7.33333 7.9987 7.33333Z" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4 14V12.6667C4 11.9594 4.28095 11.2811 4.78105 10.781C5.28115 10.281 5.95942 10 6.66667 10H9.33333C10.0406 10 10.7189 10.281 11.219 10.781C11.719 11.2811 12 11.9594 12 12.6667V14" stroke="#828282" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_2039_19974_singleProfile">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  svgs_monday: ({ width = 32, height = 32 }) => (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4351_18523)">
        <path d="M3.98073 25.1861C2.54056 25.1892 1.21009 24.4172 0.498219 23.1652C-0.203393 21.921 -0.16132 20.3912 0.607617 19.1874L7.77929 7.92542C8.52657 6.69317 9.87906 5.9583 11.3195 6.00183C12.759 6.03633 14.0683 6.84338 14.7458 8.11383C15.4144 9.37799 15.3308 10.8989 14.5301 12.0856L7.36297 23.3475C6.62429 24.4986 5.34841 25.1921 3.98073 25.1861Z" fill="#F62B54"/>
        <path d="M16.2821 25.1856C14.8356 25.1856 13.5046 24.4122 12.8056 23.1693C12.1056 21.9284 12.1477 20.4025 12.915 19.2021L20.073 7.96595C20.8095 6.71602 22.166 5.96389 23.6163 6.00134C25.075 6.03324 26.3969 6.84917 27.0654 8.12549C27.7294 9.4018 27.6322 10.9319 26.8071 12.1155L19.6506 23.3516C18.9143 24.4977 17.6443 25.1891 16.2821 25.1856Z" fill="#FFCC00"/>
        <path d="M28.3084 25.2802C30.3475 25.2802 32.0006 23.6618 32.0006 21.6655C32.0006 19.6691 30.3475 18.0508 28.3084 18.0508C26.2693 18.0508 24.6162 19.6691 24.6162 21.6655C24.6162 23.6618 26.2693 25.2802 28.3084 25.2802Z" fill="#00CA72"/>
      </g>
      <defs>
        <clipPath id="clip0_4351_18523">
          <rect width="32" height="19.5" fill="white" transform="translate(0 6)"/>
        </clipPath>
      </defs>
    </svg>
  ),
};
